/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	// load lib like Google Analytics ...

	__webpack_require__(14).load();

	var dependencies = ['gettext', 'ngAnimate', 'ngRoute', 'ngSanitize', 'ngMessages', 'ngclipboard', 'ngCookies', 'credit-cards', 'mm.iban', __webpack_require__(15).name, __webpack_require__(166).name, __webpack_require__(167).name, __webpack_require__(186).name, __webpack_require__(189).name, __webpack_require__(195).name, __webpack_require__(197).name, __webpack_require__(198).name, __webpack_require__(199).name, __webpack_require__(200).name, __webpack_require__(202).name, __webpack_require__(204).name, __webpack_require__(205).name, __webpack_require__(208).name, __webpack_require__(213).name, __webpack_require__(215).name, __webpack_require__(217).name, __webpack_require__(219).name, __webpack_require__(221).name, __webpack_require__(225).name, __webpack_require__(231).name, __webpack_require__(233).name, __webpack_require__(239).name, __webpack_require__(241).name, __webpack_require__(243).name, __webpack_require__(246).name, 'ngIntercom', 'ui.bootstrap', 'ui.router', 'ui.select', 'ui.grid', 'ui.grid.selection'];

	var t2gApp = angular.module('t2g', dependencies);

	t2gApp.config(["$httpProvider", "$stateProvider", "$urlRouterProvider", "$urlServiceProvider", "uiSelectConfig", "$intercomProvider", "$compileProvider", "settings", "$locationProvider", function ($httpProvider, $stateProvider, $urlRouterProvider, $urlServiceProvider, uiSelectConfig, $intercomProvider, $compileProvider, settings, $locationProvider) {
	  uiSelectConfig.resetSearchInput = true;
	  uiSelectConfig.appendToBody = true;

	  $locationProvider.hashPrefix('');
	  $urlServiceProvider.config.strictMode(false);

	  $urlRouterProvider.otherwise('/private/main');

	  $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|webcal):/);

	  $stateProvider.state('private', {
	    url: '/private',
	    abstract: true,
	    template: '<div class="inner-view-container" ui-view></div>',
	    resolve: {
	      session: ["UserSessionDA", function session(UserSessionDA) {
	        return UserSessionDA.ping();
	      }],
	      subscription: ["SubscriptionDA", "SubscriptionState", function subscription(SubscriptionDA, SubscriptionState) {
	        return SubscriptionDA.get().then(function (response) {
	          if (response.trialDaysLeft === 0) {
	            SubscriptionState.setShouldSubscribe(true);
	          }

	          return response;
	        });
	      }]
	    }
	  }).state('private.main', {
	    url: '/main',
	    controller: 'MainCtrl',
	    templateUrl: 'app/PrivateView.html?v=4.5.6',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      industryResolve: ["Industry", function industryResolve(Industry) {
	        return Industry.query({}).$promise;
	      }],
	      countryResolve: ["CountryConfig", function countryResolve(CountryConfig) {
	        return CountryConfig.getCountries();
	      }],
	      resourceResolve: ["$q", "ObjectModel", function resourceResolve($q, ObjectModel) {
	        var deffered = $q.defer();

	        ObjectModel.get(function (error, response) {
	          if (error) {
	            deffered.reject(error);
	          } else {
	            deffered.resolve(response);
	          }
	        });

	        return deffered.promise;
	      }],
	      industrySpecificResolve: ["IndustrySpecific", function industrySpecificResolve(IndustrySpecific) {
	        return IndustrySpecific.getLabels();
	      }],
	      customers: ["CustomerDA", function customers(CustomerDA) {
	        return CustomerDA.list();
	      }]
	    }
	  });

	  // disable json cache in IE
	  if (!$httpProvider.defaults.headers.get) {
	    $httpProvider.defaults.headers.get = {};
	  }

	  $httpProvider.interceptors.push(["$q", "$window", "UserSession", "settings", function ($q, $window, UserSession, settings) {
	    /**
	     * Redirect to login page with current URL as next parameter
	     * Prevents multiple simultaneous redirects
	     */
	    function redirectToLogin() {
	      if ($window.__redirectingToLogin) return;
	      $window.__redirectingToLogin = true;

	      var next = encodeURIComponent($window.location.href);
	      // Use the configured login_url from settings and append the next parameter
	      var loginUrl = settings.login_url;
	      $window.location.assign(loginUrl + '?next=' + next);
	    }

	    return {
	      request: function request(config) {
	        return config || $q.when(config);
	      },
	      requestError: function requestError(rejection) {
	        return $q.reject(rejection);
	      },
	      response: function response(_response) {
	        return _response || $q.when(_response);
	      },
	      responseError: function responseError(rejection) {
	        if (rejection.status === 401) {
	          redirectToLogin();
	          return $q.reject(rejection); // Still reject to stop the promise chain
	        }

	        return $q.reject(rejection);
	      }
	    };
	  }]);

	  $intercomProvider.appID(settings.INTERCOM_APP_ID);
	  $intercomProvider.asyncLoading(true);
	}]);

	t2gApp.run(["$anchorScroll", "$location", "$rootScope", "$trace", "$state", "$window", "$transitions", "gettextCatalog", "LocalStorage", "settings", "uibDatepickerPopupConfig", "languageSwitch", "$intercom", "SubscriptionState", function ($anchorScroll, $location, $rootScope, $trace, $state, $window, $transitions, gettextCatalog, LocalStorage, settings, uibDatepickerPopupConfig, languageSwitch, $intercom, SubscriptionState) {
	  languageSwitch.init().then(function () {
	    uibDatepickerPopupConfig.closeText = gettextCatalog.getString('Close');
	    uibDatepickerPopupConfig.currentText = gettextCatalog.getString('Today');
	  });

	  $rootScope.mandant = settings.mandant;

	  $transitions.onStart({}, function () {
	    $rootScope.isViewLoading = true;
	    $window.ga && $window.ga('send', 'pageview', $location.path());
	    $anchorScroll();
	    NProgress.start();
	  });

	  $transitions.onSuccess({}, function (transition) {
	    var toState = transition.to().name;
	    var fromState = transition.from().name;

	    $rootScope.isViewLoading = false;
	    NProgress.done();

	    if (fromState === 'private.main.customerProfile') {
	      LocalStorage.remove('openAppointment');
	    }

	    if (toState === 'private.main') {
	      $state.go('private.main.calendar');
	    }

	    $rootScope.currentState = toState.replace('private.main.', '');
	  });

	  $transitions.onError({}, function (transition) {
	    console.error(transition.error());
	  });

	  if (settings.INTERCOM_APP_ID) {
	    var user = LocalStorage.get('UserSession');
	    var intercomSettings = {
	      alignment: 'left',
	      horizontal_padding: 9
	    };

	    if (user) {
	      intercomSettings.email = user.email;
	      intercomSettings.name = user.firstname + ' ' + user.lastname;
	      intercomSettings.user_hash = user.user_hash;
	    }

	    $intercom.boot(intercomSettings);
	  }
	}]);

	t2gApp.controller('MainCtrl', ["$location", "$rootScope", "$scope", "$state", "$stateParams", "$timeout", "$window", "$uibModal", "$cookies", "AppointmentDA", "AppointmentModel", "Booking", "BookingDA", "CalendarDA", "ModalService", "countryResolve", "CustomerModel", "gettextCatalog", "industryResolve", "IndustrySpecific", "industrySpecificResolve", "io", "Message", "Notification", "OfficeModel", "officeResolve", "resourceResolve", "UserSession", "settings", "subscription", function ($location, $rootScope, $scope, $state, $stateParams, $timeout, $window, $uibModal, $cookies, AppointmentDA, AppointmentModel, Booking, BookingDA, CalendarDA, ModalService, countryResolve, CustomerModel, gettextCatalog, industryResolve, IndustrySpecific, industrySpecificResolve, io, Message, Notification, OfficeModel, officeResolve, resourceResolve, UserSession, settings, subscription) {
	  $scope.industries = industryResolve;
	  $scope.office = officeResolve;
	  $scope.countries = countryResolve;
	  $scope.isViewLoading = false;
	  $scope.uncheckedSteps = 4;
	  $scope.showFirstSteps = false;
	  $scope.currentUser = UserSession.get();
	  $scope.unprocessedMessages = 0;
	  $scope.bookings = [];
	  $scope.loadingAccept = false;
	  $scope.loadingDecline = false;
	  $scope.showOverlay = false;
	  $scope.showValidation = false;
	  $scope.overlayLoading = false;
	  $scope.showChoosePricemodel = false;
	  $scope.showBooking = false; // hide booking info alert
	  $scope.bookingMinimized = false;
	  $scope.subscription = subscription;
	  $scope.labels = {
	    customer: gettextCatalog.getString(industrySpecificResolve.customer.toLowerCase()),
	    customers: gettextCatalog.getString(industrySpecificResolve.customers.toLowerCase())
	  };

	  if (settings.showUserlane && window.Userlane) {
	    // initialize Userlane
	    window.Userlane('init', settings.USERLANE_APP_ID);

	    if ($scope.currentUser._id) {
	      // identify the current user
	      window.Userlane('user', $scope.currentUser._id);
	    }
	  }

	  var allowedRoles = {
	    admin: ['admin'],
	    manager: ['admin', 'manager'],
	    employee: ['admin', 'manager', 'employee'],
	    viewer: ['admin', 'manager', 'employee', 'viewer']
	  };

	  if (angular.isDefined($scope.office.settings.acceptBooking) && $scope.office.settings.acceptBooking === 0) {
	    $scope.showBooking = false;
	  }

	  // load industry specific labels
	  var loadLabels = function loadLabels() {
	    IndustrySpecific.getLabels().then(function (labels) {
	      $scope.labels.customer = gettextCatalog.getString(labels.customer);
	      $scope.labels.customers = gettextCatalog.getString(labels.customers);
	    });
	  };

	  var setNotProcessedBookingsCount = function setNotProcessedBookingsCount() {
	    var notProcessedBookings = $scope.bookings.filter(function (booking) {
	      return !booking.processed;
	    });

	    $scope.$broadcast('updateBookingsBadge', notProcessedBookings.length);
	  };

	  $scope.$on('setBookingsProcessed', function () {
	    $scope.bookings.forEach(function (booking) {
	      booking.processed = true;
	    });

	    setNotProcessedBookingsCount();
	  });

	  var loadBookings = function loadBookings() {
	    BookingDA.getAll().then(function (bookingResponse) {
	      $scope.bookings = bookingResponse.bookings || []; // all office bookings for all period of time (including declined)

	      setNotProcessedBookingsCount();

	      var declineBookingId = $cookies.get('declineBookingId');

	      if (!declineBookingId) return; // do nothing if declineBookingId is not set in the cookies

	      var declineBooking = declineBookingId && $scope.bookings.filter(function (booking) {
	        return booking._id === declineBookingId;
	      })[0];

	      if (!declineBooking) {
	        // clear bookingId from cookies if it not exists
	        $cookies.remove('declineBookingId');

	        return Notification.addErrorMessage(gettextCatalog.getString('This booking is not exists'));
	      }

	      $scope.openRelatedAppointment(declineBooking);
	    });
	  };

	  $scope.startDeclineBooking = function (declineBooking, openedAppointmentModal) {
	    var openAppointment = _.get(declineBooking, 'appointments[0]');

	    if (declineBooking.declined || !openAppointment) {
	      // clear bookingId from cookies if it was already declined
	      $cookies.remove('declineBookingId');

	      return Notification.addErrorMessage(gettextCatalog.getString('This booking has already been declined'));
	    }

	    var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');

	    if ($stateParams.date !== appointmentDate && !openedAppointmentModal) {
	      $state.go('private.main.calendar', {
	        date: appointmentDate
	      });
	    }

	    var appointmentModal = openedAppointmentModal || ModalService.openAppointmentModal(openAppointment);

	    // declined booking should be first in the list
	    $scope.bookings.sort(function (a, b) {
	      if (a === declineBooking) return -1;
	      if (b === declineBooking) return 1;

	      return new Date(b.bookedAt) - new Date(a.bookedAt);
	    });

	    $scope.askDeclineReason().then(function (isConfirmPresses) {
	      // clear bookingId from cookies on any user action
	      $cookies.remove('declineBookingId');

	      if (!isConfirmPresses) return;

	      CalendarDA.removeAppointment(openAppointment._id);
	      appointmentModal.close();

	      loadBookings();
	    });
	  };

	  $scope.openRelatedAppointment = function (declineBooking) {
	    var openAppointment = _.get(declineBooking, 'appointments[0]');

	    if (declineBooking.declined || !openAppointment) {
	      // clear bookingId from cookies if it was already declined
	      $cookies.remove('declineBookingId');

	      return Notification.addErrorMessage(gettextCatalog.getString('This booking has already been declined'));
	    }

	    var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');

	    if ($stateParams.date !== appointmentDate) {
	      $state.go('private.main.calendar', {
	        date: appointmentDate
	      });
	    }

	    var appointmentModal = ModalService.openAppointmentModal(openAppointment);

	    appointmentModal.closed.then(function () {
	      // clear bookingId from cookies on appointment edit pop up close
	      $cookies.remove('declineBookingId');
	    });
	  };

	  // check if name, industry and country code are filled. If not, show overlay
	  if (!$scope.office.name || !$scope.office.profile.industry || !$scope.office.address.countryCode) {
	    $scope.showOverlay = true;
	  } else {
	    $scope.showOverlay = false;
	  }

	  // save overlay form (office name, industry and country ...) to database
	  $scope.saveOverlayForm = function () {
	    $scope.showValidation = true;
	    $scope.overlayLoading = true;

	    if ($scope.OverlayForm.$valid) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage({ text: error });
	        } else {
	          loadLabels();
	          $scope.overlayLoading = false;
	          $scope.showOverlay = false;
	          $state.go('private.main.firstSteps');
	          Notification.addSuccessMessage(gettextCatalog.getString('Saved successfully'));
	        }
	      });
	    } else {
	      $scope.overlayLoading = false;
	    }
	  };

	  // UserLike stuff
	  $window.userlike = {
	    nostate: false
	  };

	  $window.userlikeData = {};

	  if ($scope.currentUser._id) {
	    $scope.user = UserSession.get();

	    // set UserLike data
	    $window.userlikeData = {
	      user: {
	        name: $scope.currentUser.firstname + ' ' + $scope.currentUser.lastname,
	        email: $scope.currentUser.email
	      },
	      custom: {
	        nutzerId: $scope.currentUser._id,
	        dienstleisterId: $scope.office._id,
	        dienstleister: $scope.office.name,
	        branche: $scope.office.profile.industry,
	        profil: 'https://www.termin2go.com/termin/unbekannt/unbekannt/' + $scope.office.slug,
	        email: $scope.office.profile.contacts.email,
	        tel: $scope.office.profile.contacts.phone,
	        account: $scope.office.billing.account
	      }
	    };

	    if ($window.userlikeUpdateAPI) {
	      $window.userlikeUpdateAPI();
	    }
	  }

	  $scope.checkRole = function (minimumRole) {
	    var role = _.get($scope.user, 'role');
	    var authorized = false;

	    if (role && allowedRoles[minimumRole].indexOf(role) !== -1) {
	      authorized = true;
	    }

	    return authorized;
	  };

	  $scope.disableClick = function () {
	    return false;
	  };

	  /**
	   * accept booking
	   */
	  $scope.accept = function () {
	    var lastBooking = $scope.bookings[0];
	    $scope.loadingAccept = true;

	    BookingDA.accept(lastBooking).then(function (response) {
	      $scope.bookings.splice(0, 1);
	      $scope.loadingAccept = false;
	      Notification.addSuccessMessage(gettextCatalog.getString('Booking accepted'));
	      CalendarDA.editAppointment(response.appointments);

	      _.forEach(response.appointments, function (appointment) {
	        if (appointment.customer && appointment.customer._id) {
	          CustomerModel.updateCache(appointment.customer, function () {
	            console.log('update cache: ' + appointment.customer._id);
	          });
	        }
	      });
	    }).catch(function (error) {
	      $scope.loadingAccept = false;
	      Notification.addErrorMessage(gettextCatalog.getString('Cant accept booking (Error: {{error}})', { error: error }));
	      loadBookings();
	    });
	  };

	  /**
	   * confirm booking
	   */
	  $scope.confirm = function () {
	    var lastBooking = $scope.bookings[0];
	    $scope.loadingAccept = true;

	    BookingDA.confirm(lastBooking).then(function (response) {
	      $scope.bookings.splice(0, 1);
	      $scope.loadingAccept = false;
	      CalendarDA.editAppointment(response.appointments);

	      _.forEach(response.appointments, function (appointment) {
	        if (appointment.customer && appointment.customer._id) {
	          CustomerModel.updateCache(appointment.customer, function () {
	            console.log('update cache: ' + appointment.customer._id);
	          });
	        }
	      });
	    }).catch(function (error) {
	      $scope.loadingAccept = false;
	      Notification.addErrorMessage(error);
	      loadBookings();
	    });
	  };

	  /**
	   * decline the booking
	   */
	  $scope.decline = function (reasonText) {
	    var lastBooking = $scope.bookings[0];
	    $scope.loadingDecline = true;

	    if (reasonText) {
	      lastBooking.note = reasonText;
	    }

	    if (lastBooking.newWidget) {
	      BookingDA.decline(lastBooking).then(function (response) {
	        _.forEach(lastBooking.appointments, function (appointmentId) {
	          CalendarDA.removeAppointment(appointmentId);
	        });
	        $scope.bookings.splice(0, 1);
	        $scope.$broadcast('Booking:decline', response);
	        Notification.addSuccessMessage(gettextCatalog.getString('Please make sure that you always keep your appointments updated and that changes only occur in exceptional cases. Thank you.'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Your booking has been canceled and the client informed.'));
	        $scope.loadingDecline = false;
	      }, function () {
	        $scope.loadingDecline = false;
	        Notification.addErrorMessage(gettextCatalog.getString('Cant decline booking'));
	      });
	    } else {
	      var booking = new Booking(lastBooking);

	      booking.$decline({}, function (response) {
	        _.forEach(lastBooking.appointments, function (appointmentId) {
	          CalendarDA.removeAppointment(appointmentId);
	        });
	        $scope.bookings.splice(0, 1);
	        $scope.$broadcast('Booking:decline', response);
	        Notification.addSuccessMessage(gettextCatalog.getString('Please make sure that you always keep your appointments updated and that changes only occur in exceptional cases. Thank you.'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Your booking has been canceled and the client informed.'));
	        $scope.loadingDecline = false;
	      }, function () {
	        $scope.loadingDecline = false;
	        Notification.addErrorMessage(gettextCatalog.getString('Cant decline booking'));
	      });
	    }
	  };

	  /**
	   * reload bookings on update
	   */
	  $scope.$on('Booking:delete', function () {
	    loadBookings();
	  });

	  /**
	   * show decline pop up on related appointment remove try
	   */
	  $scope.$on('Booking:showDeclineModal', function (event, data) {
	    var bookingToDecline = $scope.bookings.filter(function (booking) {
	      return _.get(booking, 'appointments[0]._id') === data.appointmentId;
	    })[0];

	    $scope.startDeclineBooking(bookingToDecline, data.appointmentModal);
	  });

	  $scope.askDeclineReason = function () {
	    var modalInstance = $uibModal.open({
	      animation: true,
	      templateUrl: 'app/declineModal.html?v=4.5.6',
	      controller: 'DeclineReasonModal',
	      size: 'sm'
	    });

	    return modalInstance.result.then(function (reasonText) {
	      $scope.decline(reasonText);

	      return true;
	    }, function (dismiss) {
	      return false;
	    });
	  };

	  /**
	   * add new booking, if socket emit new booking
	   */
	  io.on('Booking:save', function (booking) {
	    $scope.bookings.push(booking);

	    setNotProcessedBookingsCount();

	    $scope.$broadcast('Booking:save', booking);
	  });

	  /**
	   * socket event. appointment will be added to scope if dates matches with current date
	   */
	  io.on('Appointment:save', function (appointments) {
	    appointments = AppointmentDA.transformResponse(appointments);

	    CalendarDA.insertAppointment(appointments);
	  });

	  /**
	   * socket event. appointment will be updated on scope if dates matches with current date
	   */
	  io.on('Appointment:update', function (appointments) {
	    appointments = AppointmentDA.transformResponse(appointments);

	    CalendarDA.editAppointment(appointments);
	  });

	  /**
	   * socket event. appointment will be deleted on scope if dates matches with current date
	   */
	  io.on('Appointment:delete', function (appointmentId) {
	    CalendarDA.removeAppointment(appointmentId);
	  });

	  /**
	   * remove event listeners
	   */
	  $scope.$on('$destroy', function () {
	    io.off();
	  });

	  loadBookings();
	}]);

	Date.prototype.getDayKey = function () {
	  var year = this.getFullYear();
	  var month = this.getMonth() + 1;
	  var day = this.getDate();

	  return year + '-' + ('0' + month).slice(-2) + '-' + ('0' + day).slice(-2);
	};

	Array.prototype.move = function (old_index, new_index) {
	  if (new_index >= this.length) {
	    var k = new_index - this.length;
	    while (k-- + 1) {
	      this.push(undefined);
	    }
	  }
	  this.splice(new_index, 0, this.splice(old_index, 1)[0]);
	  return this;
	};

	if (!Element.prototype.matches) {
	  Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
	    var matches = (this.document || this.ownerDocument).querySelectorAll(s),
	        i = matches.length;
	    while (--i >= 0 && matches.item(i) !== this) {}
	    return i > -1;
	  };
	}

	t2gApp.controller('DeclineReasonModal', ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
	  $scope.isSubmitted = false;

	  $scope.isDeclineReasonInvalid = function () {
	    return !$scope.declineReason || $scope.declineReason.length < 5;
	  };

	  $scope.decline = function () {
	    $scope.isSubmitted = true;

	    if ($scope.isDeclineReasonInvalid()) return;

	    $uibModalInstance.close($scope.declineReason);
	  };

	  $scope.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	}]);

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.modelService', ['ngFileUpload', __webpack_require__(2).name, __webpack_require__(3).name, __webpack_require__(4).name, __webpack_require__(6).name]);

	module.exports = angularModule;

	angularModule.factory('ObjectModel', ["$rootScope", "gettextCatalog", "Object", "ObjectCache", "AppointmentCache", "ResourceDA", "Upload", "UserSession", function ($rootScope, gettextCatalog, Object, ObjectCache, AppointmentCache, ResourceDA, Upload, UserSession) {
	  return {
	    get: function get(callback) {
	      var cachedObjects = ObjectCache.get('objects');

	      if (typeof cachedObjects === 'undefined') {
	        Object.query({ officeId: UserSession.getOffice() }, {}, function (response) {
	          if (angular.isArray(response)) {
	            ObjectCache.put('objects', response);

	            callback(null, response);
	          } else {
	            callback('Error: cant load object data');
	          }
	        });
	      } else {
	        callback(null, cachedObjects);
	      }
	    },
	    getOne: function getOne(resourceId, callback) {
	      Object.getOne({ objectId: resourceId, officeId: UserSession.getOffice() }, function (response) {
	        callback(null, response);
	      }, function (error) {
	        callback('cant getOne resource: ' + error);
	      });
	    },
	    save: function save(object, callback) {
	      object.office = UserSession.getOffice();

	      object.$save(function (response) {
	        // refresh cache
	        var cachedObject = ObjectCache.get('objects') || [];

	        cachedObject.push(response);
	        ObjectCache.remove('objects');
	        ObjectCache.put('objects', cachedObject);

	        // clear appointment cache
	        AppointmentCache.removeAll();

	        ResourceDA.clearCache();

	        // inform observers
	        $rootScope.$broadcast('Object:save', response);
	        callback(null, response);
	      }, function (error) {
	        callback(error);
	      });
	    },
	    update: function update(object, callback) {
	      if (object instanceof Object) {
	        object = new Object(object);
	      }

	      object.office = UserSession.getOffice();

	      object.$update(function (response) {
	        // refresh cache
	        var cachedObject = ObjectCache.get('objects');

	        if (cachedObject) {
	          for (var i = 0, objectsLen = cachedObject.length; i < objectsLen; i++) {
	            if (cachedObject[i]._id === response._id) {
	              cachedObject[i] = response;
	              break;
	            }
	          }

	          ObjectCache.remove('objects');
	          ObjectCache.put('objects', cachedObject);
	        }

	        ResourceDA.clearCache();

	        // inform observers
	        $rootScope.$broadcast('Object:edit', response);
	        callback(null, response);
	      }, function (error) {
	        callback(error);
	      });
	    },
	    uploadImage: function uploadImage(files, object, callback) {
	      Upload.upload({
	        url: '/api/office/' + object.office + '/objects/' + object._id + '/imageUpload',
	        data: angular.toJson(object),
	        file: files[0]
	      }).success(function (response) {
	        var cachedObjects = ObjectCache.get('objects') || [];
	        var cachedObjectIndex = -1;

	        for (var i = 0, objectsLen = cachedObjects.length; i < objectsLen; i++) {
	          if (cachedObjects[i]._id === response._id) {
	            cachedObjectIndex = i;
	            break;
	          }
	        }

	        if (cachedObjectIndex > -1) {
	          cachedObjects[cachedObjectIndex] = response;
	        } else {
	          cachedObjects.push(response);
	        }

	        // clear cache ...
	        ObjectCache.remove('objects');

	        // ... and write back data
	        ObjectCache.put('objects', cachedObjects);

	        // inform observers
	        $rootScope.$broadcast('Object:edit', response);
	        callback(null, response);
	      }).error(function (error) {
	        callback(error);
	      });
	    },
	    delete: function _delete(object, callback) {
	      if (object instanceof Object) {
	        object = new Object(object);
	      }

	      object.$delete(function (response) {
	        // refresh cache
	        var cachedObject = ObjectCache.get('objects');

	        if (cachedObject) {
	          for (var i = 0; i < cachedObject.length; i++) {
	            if (cachedObject[i]._id == response._id) {
	              cachedObject.splice(i, 1);
	              break;
	            }
	          }

	          ObjectCache.remove('objects');
	          ObjectCache.put('objects', cachedObject);
	        }

	        ResourceDA.clearCache();

	        // inform observers
	        $rootScope.$broadcast('Object:delete', response);
	        callback(null, response);
	      }, function (error) {
	        var openAppointments = _.get(error, 'data.error.open_appointments');
	        var errorText;

	        if (openAppointments) {
	          errorText = gettextCatalog.getPlural(openAppointments, 'One open appointment in future for this resource. Please delete the appointment first.', '{{$count}} open appointments in future for this resource. Please delete this appointments first.', {});
	          callback({ text: errorText });
	        } else {
	          callback(error);
	        }
	      });
	    }
	  };
	}]);

	angularModule.factory('CustomerModel', ["$rootScope", "Customer", "CustomerDA", "CustomerCache", "UserSession", function ($rootScope, Customer, CustomerDA, CustomerCache, UserSession) {
	  return {
	    get: function get(callback) {
	      var cachedCustomer = CustomerCache.get('customers');

	      if (typeof cachedCustomer === 'undefined') {
	        CustomerDA.get().then(function (customers) {
	          CustomerCache.put('customers', customers);
	          callback(null, customers);
	        }, function () {
	          callback('Error: cant load customer data');
	        });
	      } else {
	        callback(null, cachedCustomer);
	      }
	    },
	    getOne: function getOne(customerId, callback) {
	      CustomerDA.get(customerId).then(function (customers) {
	        CustomerCache.put('customers', customers);
	        callback(null, customers);
	      }, function () {
	        callback('Error: cant load customer data');
	      });
	    },
	    getAppointments: function getAppointments(customer, callback) {
	      Customer.getAppointments({ customerId: customer._id, officeId: UserSession.getOffice() }, function (response) {
	        if (response instanceof Array) {
	          callback(null, response);
	        } else {
	          callback('Error: cant load customer appointments');
	        }
	      });
	    },
	    clearCache: function clearCache() {
	      CustomerCache.remove('customers');
	      CustomerDA.clearCache();
	    },
	    updateCustomers: function updateCustomers(newCustomers) {
	      var cachedCustomer = CustomerCache.get('customers') || [];

	      cachedCustomer = cachedCustomer.concat(newCustomers);
	      CustomerCache.remove('customers');
	      CustomerCache.put('customers', cachedCustomer);

	      CustomerDA.updateCustomers(newCustomers);
	    },
	    save: function save(customer, callback) {
	      if (customer instanceof Object) {
	        customer = new Customer(customer);
	      }

	      customer.customerAt = UserSession.getOffice();

	      customer.$save(function (response) {
	        // refresh cache
	        var cachedCustomer = CustomerCache.get('customers');

	        if (response.birthday) {
	          response.birthday = new Date(response.birthday);
	        }

	        if (angular.isArray(cachedCustomer)) {
	          cachedCustomer.unshift(response);
	          CustomerCache.remove('customers');
	          CustomerCache.put('customers', cachedCustomer);
	        }

	        // inform observers
	        $rootScope.$broadcast('Customer:save', response);
	        callback(null, response);
	      }, function (error) {
	        callback('cant insert new customer: ' + error);
	      });
	    },
	    update: function update(customer, callback) {
	      if (customer instanceof Object) {
	        customer = new Customer(customer);
	      }
	      customer.$update(function (response) {
	        // refresh cache
	        var cachedCustomer = CustomerCache.get('customers') || [];

	        if (response.birthday) {
	          response.birthday = new Date(response.birthday);
	        }

	        for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
	          if (cachedCustomer[i]._id == response._id) {
	            cachedCustomer[i] = response;
	            break;
	          }
	        }

	        CustomerCache.remove('customers');
	        CustomerCache.put('customers', cachedCustomer);

	        // inform observers
	        $rootScope.$broadcast('Customer:edit', response);

	        callback(null, response);
	      }, function (error) {
	        callback('cant insert new customer: ' + error);
	      });
	    },
	    updateCache: function updateCache(customer, callback) {
	      var updated = false;
	      var cachedCustomer = CustomerCache.get('customers') || [];

	      for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
	        if (cachedCustomer[i]._id == customer._id) {
	          cachedCustomer[i] = customer;
	          updated = true;
	          break;
	        }
	      }

	      if (!updated) {
	        cachedCustomer.push(customer);
	      }

	      CustomerCache.remove('customers');
	      CustomerCache.put('customers', cachedCustomer);

	      // inform observers
	      $rootScope.$broadcast('Customer:edit', customer);

	      callback(null);
	    },
	    delete: function _delete(customer, callback) {
	      if (customer instanceof Object) {
	        customer = new Customer(customer);
	      }

	      customer.$delete(function (response) {
	        // refresh cache
	        var cachedCustomer = CustomerCache.get('customers');

	        console.log('#1');
	        console.log(cachedCustomer);

	        if (angular.isArray(cachedCustomer)) {
	          for (var i = 0, customerLen = cachedCustomer.length; i < customerLen; i++) {
	            if (cachedCustomer[i]._id == response._id) {
	              console.log('found');
	              cachedCustomer.splice(i, 1);
	              break;
	            } else {
	              console.log('not found');
	            }
	          }
	        }

	        CustomerCache.remove('customers');
	        CustomerCache.put('customers', cachedCustomer);

	        // inform observers
	        $rootScope.$broadcast('Customer:delete', response);
	        callback(null, response);
	      }, function (error) {
	        callback('cant delete new customer: ' + error);
	      });
	    }
	  };
	}]);

	angularModule.factory('AccountModel', ["$timeout", "Account", "UserSession", "LocalStorage", "settings", function ($timeout, Account, UserSession, LocalStorage, settings) {
	  return {
	    changePassword: function changePassword(account, callback) {
	      if (account instanceof Object) {
	        account = new Account(account);
	      }

	      account.$changePassword(function (response) {
	        callback(null, response);
	      });
	    },
	    logout: function logout(account) {
	      if (account instanceof Object) {
	        account = new Account(account);
	      }

	      LocalStorage.remove('countryConfig');
	      LocalStorage.remove('openDay');

	      UserSession.clean();

	      $timeout(function () {
	        account.$logout(function () {
	          window.location = settings.login;
	        });
	      });
	    }
	  };
	}]);

	angularModule.factory('OfficeModel', ["$rootScope", "Office", "OfficeCache", "UserSession", function ($rootScope, Office, OfficeCache, UserSession) {
	  return {
	    get: function get(callback) {
	      var cachedOffice = OfficeCache.get('office');

	      if (typeof cachedOffice === 'undefined') {
	        Office.get({ officeId: UserSession.getOffice() }, {}, function (response) {
	          if (response instanceof Object) {
	            OfficeCache.put('office', response);

	            var userSession = UserSession.get();

	            if (response.billing) {
	              userSession.account = response.billing.account;
	            }

	            UserSession.set(userSession, function () {
	              callback(null, response);
	            });
	          } else {
	            callback('Error: cant load office data');
	          }
	        });
	      } else {
	        callback(null, cachedOffice);
	      }
	    },
	    removeLogo: function removeLogo(office, callback) {
	      Office.removeLogo(function (response) {
	        callback(null, response);
	      }, function (error) {
	        callback('cant remove profile logo: ' + error);
	      });
	    },
	    update: function update(office, callback) {
	      Office.update({ officeId: UserSession.getOffice() }, office, function (response) {
	        OfficeCache.remove('office');
	        OfficeCache.put('office', response);
	        $rootScope.$broadcast('Office:update', response);
	        callback(null, response);
	      }, function (error) {
	        callback('cant update office data: ' + error);
	      });
	    }
	  };
	}]);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.customer', []);

	module.exports = angularModule;

	angularModule.factory('CustomerResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/customer/:customerId/:subResource';

	  var resource = $resource(resourceUrl, {}, {
	    delete: { method: 'delete' },
	    get: { method: 'get', isArray: false },
	    insert: { method: 'post' },
	    update: { method: 'put', params: { customerId: '@_id' } },
	    getAppointments: { method: 'get', params: { subResource: 'appointments' }, isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('CustomerDA', ["$q", "CustomerResource", function ($q, CustomerResource) {
	  var customerCache = [];
	  var filteredCustomerCache = [];

	  return {
	    get: get,
	    clearCache: clearCache,
	    updateCustomers: updateCustomers,
	    getAppointments: getAppointments,
	    getFiltered: getFiltered,
	    insert: insert,
	    list: list,
	    remove: remove,
	    setFiltered: setFiltered,
	    update: update
	  };

	  /**
	   * get one customer profile
	   * @param {String} customerId
	   * @returns {Promise}
	   */
	  function get(customerId) {
	    var params = {
	      customerId: customerId
	    };

	    return CustomerResource.get(params).$promise.then(function (response) {
	      return response.customer;
	    });
	  }

	  /**
	   * clear customers cache
	   */
	  function clearCache() {
	    customerCache = [];
	  }

	  /**
	   * update customers cache
	   */
	  function updateCustomers(newCustomers) {
	    customerCache = customerCache.concat(newCustomers);
	  }

	  /**
	   * get all appointments of a customer
	   * @param {String} customerId
	   * @returns {Promise}
	   */
	  function getAppointments(customerId, start, end) {
	    var params = {
	      customerId: customerId
	    };

	    if (start && end && moment(start).isValid() && moment(end).isValid()) {
	      params.start = moment(start).format('YYYY-MM-DD');
	      params.end = moment(end).format('YYYY-MM-DD');
	    }

	    return CustomerResource.getAppointments(params).$promise.then(function (response) {
	      return response.appointments;
	    });
	  }

	  /**
	   * get filtered customer list
	   * @returns {Array}
	   */
	  function getFiltered() {
	    return filteredCustomerCache;
	  }

	  /**
	   * save customer
	   * @param {Object} customer object
	   * @returns {Promise}
	   */
	  function insert(customer) {
	    return CustomerResource.insert(customer).$promise.then(function (response) {
	      customerCache.push(response.customer);
	      return response.customer;
	    });
	  }

	  /**
	   * get list of all customers
	   * @returns {Promise}
	   */
	  function list() {
	    if (customerCache.length > 0) {
	      return $q.when(customerCache);
	    } else {
	      return CustomerResource.get().$promise.then(function (response) {
	        customerCache = response.customers;
	        return response.customers;
	      });
	    }
	  }

	  /**
	   * remove a customer
	   * @param {String} customerId
	   * @returns {Promise}
	   */
	  function remove(customerId) {
	    return CustomerResource.delete({ customerId: customerId }).$promise.then(function () {
	      _.remove(customerCache, { _id: customerId });
	      return true;
	    });
	  }

	  /**
	   * set filtered customer list
	   * @param filteredCustomer
	   */
	  function setFiltered(filteredCustomer) {
	    filteredCustomerCache = filteredCustomer;
	  }

	  /**
	   * update a customer
	   * @param {Object} customer object
	   * @returns {Promise}
	   */
	  function update(customer) {
	    return CustomerResource.update(customer).$promise.then(function (response) {
	      var cachedCustomerIndex = _.findIndex(customerCache, { _id: customer._id });

	      if (response.customer.birthday) {
	        response.customer.birthday = new Date(response.customer.birthday);
	      }

	      customerCache[cachedCustomerIndex] = response.customer;

	      console.log(response.customer);
	      return response.customer;
	    });
	  }
	}]);

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.cacheService', []);

	module.exports = angularModule;

	angularModule.factory('AppointmentCache', ["$cacheFactory", function ($cacheFactory) {
	  var Cache = $cacheFactory('AppointmentCache', { capacity: 35 });
	  return Cache;
	}]);

	angularModule.factory('OpeningHoursCache', ["$cacheFactory", function ($cacheFactory) {
	  var Cache = $cacheFactory('OpeningHoursCache', { capacity: 5 });
	  return Cache;
	}]);

	angularModule.factory('CustomerCache', ["$cacheFactory", function ($cacheFactory) {
	  var Cache = $cacheFactory('CustomerCache', { capacity: 5 });
	  return Cache;
	}]);

	angularModule.factory('ObjectCache', ["$cacheFactory", function ($cacheFactory) {
	  var Cache = $cacheFactory('ObjectCache', { capacity: 10 });
	  return Cache;
	}]);

	angularModule.factory('OfficeCache', ["$cacheFactory", function ($cacheFactory) {
	  var Cache = $cacheFactory('OfficeCache', { capacity: 5 });
	  return Cache;
	}]);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.RESTService', ['ngResource', __webpack_require__(5).name]);

	module.exports = angularModule;

	angularModule.factory('Customer', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/customers';

	  var resource = $resource(resourceUrl + '/:customerId/:subResource', { customerId: '@_id', officeId: '@customerAt' }, {
	    delete: { method: 'DELETE' },
	    update: { method: 'PUT' },
	    getOne: { method: 'GET', isArray: false },
	    getAppointments: { method: 'GET', isArray: true, params: { subResource: 'appointments' } }
	  });

	  return resource;
	}]);

	angularModule.factory('Object', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/objects/:objectId/:action';

	  var resource = $resource(resourceUrl, { objectId: '@_id', officeId: '@office' }, {
	    delete: { method: 'DELETE' },
	    update: { method: 'PUT' },
	    getOne: { method: 'GET', isArray: false },
	    generateCalendarAddress: { method: 'GET', params: { action: 'generateCalendarAddress' } }
	  });

	  return resource;
	}]);

	angularModule.factory('Appointment', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/appointment';

	  var resource = $resource(resourceUrl + '/:appointmentId', { appointmentId: '@_id' }, {
	    save: { method: 'POST', isArray: true },
	    update: { method: 'PUT', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('Account', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/user/:action';

	  var resource = $resource(resourceUrl, {}, {
	    changePassword: { method: 'POST', params: { action: 'changePassword' } },
	    logout: { method: 'GET', params: { action: 'logout' } },
	    ping: { method: 'GET', params: { action: 'ping' } }
	  });

	  return resource;
	}]);

	angularModule.factory('Office', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/:embeddedDocument';

	  var resource = $resource(resourceUrl, {}, {
	    update: { method: 'PUT' },
	    deleteImage: { method: 'DELETE' },
	    removeLogo: { method: 'DELETE', url: settings.apiBase + '/api/v2/office/removeLogo' }
	  });

	  return resource;
	}]);

	angularModule.factory('Industry', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/industry';

	  var resource = $resource(resourceUrl, {}, {});

	  return resource;
	}]);

	angularModule.factory('Booking', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/booking/:bookingId/:action';

	  var resource = $resource(resourceUrl, { bookingId: '@_id', officeId: '@officeId' }, {
	    accept: { method: 'POST', params: { action: 'accept' } },
	    decline: { method: 'POST', params: { action: 'decline' } }
	  });

	  return resource;
	}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.userSessionService', []);

	module.exports = angularModule;

	var STORAGE_KEY = 'UserSession';

	angularModule.factory('UserSession', ["localStorageService", "$timeout", function (localStorageService, $timeout) {
	  var _isLoggedIn = false;
	  var _user;

	  var saveUserToSession = function saveUserToSession() {
	    localStorageService.set(STORAGE_KEY, _user);
	  };

	  return {
	    isLoggedIn: function isLoggedIn() {
	      return _isLoggedIn;
	    },
	    setLoggedIn: function setLoggedIn() {
	      _isLoggedIn = true;
	    },
	    hasRole: function hasRole(roleName) {
	      return _user.roles.indexOf(roleName) > -1;
	    },
	    clean: function clean() {
	      localStorageService.remove(STORAGE_KEY);
	    },
	    getOffice: function getOffice() {
	      return _user ? _user.office : undefined;
	    },
	    get: function get() {
	      // get from session if empty store on session
	      _user = _user || localStorageService.get(STORAGE_KEY);
	      return _user;
	    },
	    set: function set(user, callback) {
	      _user = user || _user;
	      saveUserToSession();

	      if (callback) {
	        $timeout(function () {
	          callback();
	        }, 400);
	      }
	    },
	    qSet: function qSet(user) {
	      _user = user || _user;
	      saveUserToSession();
	      return $timeout(angular.noop, 250);
	    }
	  };
	}]);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.sessionStorage', ['LocalStorageModule']);

	module.exports = angularModule;

	angularModule.config(["localStorageServiceProvider", function (localStorageServiceProvider) {
	  localStorageServiceProvider.setPrefix('t2g').setStorageType('localStorage').setNotify(true, true);
	}]);

	angularModule.factory('LocalStorage', ["$window", "localStorageService", function ($window, localStorageService) {
	  return {
	    get: get,
	    set: set,
	    remove: remove
	  };

	  function get(key) {
	    return localStorageService.get(key);
	  }

	  function set(key, value) {
	    localStorageService.set(key, value);
	  }

	  function remove(key) {
	    localStorageService.remove(key);
	  }
	}]);

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.languageSwitch', ['gettext', __webpack_require__(8).name, __webpack_require__(9).name, __webpack_require__(5).name]);

	module.exports = angularModule;

	angularModule.factory('languageSwitch', ["gettextCatalog", "Notification", "UserModel", "UserSession", "settings", function (gettextCatalog, Notification, UserModel, UserSession, settings) {
	  return {
	    set: set,
	    init: init
	  };

	  function set(languageCode, doNotUpdateUser) {
	    gettextCatalog.setCurrentLanguage(languageCode);

	    if (!doNotUpdateUser) {
	      var user = UserSession.get();
	      var userUpdate = {
	        _id: user._id,
	        language: languageCode
	      };

	      UserModel.update(userUpdate, function (error) {
	        if (error) {
	          Notification.addErrorMessage({ text: error });
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('User settings updated'));
	        }
	      });
	    }

	    return gettextCatalog.loadRemote('/i18n/' + languageCode + '.json?v=4.5.6').then(function () {
	      _.forEach(settings.availableLanguages, function (lang) {
	        var i18nOverwrite = _.get(settings, 'i18nOverwrite.' + lang);
	        if (i18nOverwrite) {
	          gettextCatalog.setStrings(lang, i18nOverwrite);
	        }
	      });
	      return true;
	    });
	  }

	  function init() {
	    var user = UserSession.get();

	    // check for browser language
	    if (user && user.language) {
	      return set(user.language, true);
	    } else {
	      return set(settings.defaultLanguage, true);
	    }
	  }
	}]);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.user', []);

	module.exports = angularModule;

	angularModule.factory('UserResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/users';

	  var resource = $resource(resourceUrl + '/:userId', { userId: '@_id', officeId: '@workingAt' }, {
	    delete: { method: 'DELETE' },
	    update: { method: 'PUT' },
	    getOne: { method: 'GET', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('UserCache', ["$cacheFactory", function ($cacheFactory) {
	  return $cacheFactory('UserCache', { capacity: 20 });
	}]);

	angularModule.factory('UserModel', ["$rootScope", "UserResource", "UserCache", "UserSession", function ($rootScope, UserResource, UserCache, UserSession) {
	  return {
	    get: function get(callback) {
	      var cachedObjects = UserCache.get('users');
	      var officeId = UserSession.getOffice();

	      if (typeof cachedObjects === 'undefined') {
	        UserResource.query({ officeId: officeId }, function (response) {
	          if (response instanceof Array) {
	            UserCache.put('users', response);

	            callback(null, response);
	          } else {
	            callback('Error: cant load object data');
	          }
	        });
	      } else {
	        callback(null, cachedObjects);
	      }
	    },
	    save: function save(user, callback) {
	      if (user instanceof Object) {
	        user = new UserResource(user);
	      }

	      user.workingAt = UserSession.getOffice();

	      user.$save(function (response) {
	        // refresh cache
	        delete response.password;
	        var cachedObjects = UserCache.get('users');
	        cachedObjects.push(response);
	        UserCache.remove('users');
	        UserCache.put('users', cachedObjects);

	        // inform observers
	        $rootScope.$broadcast('User:save', response);
	        callback(null, response);
	      }, function (error) {
	        callback(error.data);
	      });
	    },
	    update: function update(user, callback) {
	      user.$update(function (response) {
	        var cachedObjects = UserCache.get('users');

	        for (var i = 0; i < cachedObjects.length; i++) {
	          if (cachedObjects[i]._id == cachedObjects._id) {
	            cachedObjects[i] = cachedObjects;
	            break;
	          }
	        }

	        UserCache.remove('users');
	        UserCache.put('users', cachedObjects);

	        // inform observers
	        $rootScope.$broadcast('User:edit', response);
	        callback(null, response);
	      }, function (error) {
	        callback(error.data);
	      });
	    },
	    delete: function _delete(user, callback) {
	      if (user instanceof Object) {
	        user = new UserResource(user);
	      }

	      user.$delete(function (response) {
	        var cachedObjects = UserCache.get('users');

	        for (var i = 0; i < cachedObjects.length; i++) {
	          if (cachedObjects[i]._id == cachedObjects._id) {
	            cachedObjects.splice(i, 1);
	            break;
	          }
	        }

	        UserCache.remove('users');
	        UserCache.put('users', cachedObjects);

	        // inform observers
	        $rootScope.$broadcast('User:delete', user);
	        callback(null, user);
	      }, function (error) {
	        callback(error.data);
	      });
	    }
	  };
	}]);

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(10);

	var angularModule = angular.module('t2g.common.services.notificationService', ['gettext', 'toastr']);

	module.exports = angularModule;

	angularModule.config(["toastrConfig", function (toastrConfig) {
	  angular.extend(toastrConfig, {
	    autoDismiss: false,
	    containerId: 'toast-container',
	    maxOpened: 0,
	    newestOnTop: true,
	    positionClass: 'toast-bottom-left',
	    target: 'body',
	    closeButton: false,
	    timeOut: 4000,
	    allowHtml: false
	  });
	}]);

	angularModule.factory('Notification', ["gettextCatalog", "toastr", function (gettextCatalog, toastr) {
	  return {
	    addErrorMessage: function addErrorMessage(message) {
	      if (_.isObject(message)) {
	        toastr.error(gettextCatalog.getString('An unknown error occured (Error: {{error}})', {
	          error: message.text
	        }));
	      } else {
	        toastr.error(message);
	      }
	    },
	    addSuccessMessage: function addSuccessMessage(message) {
	      toastr.success(message);
	    },
	    addInfoMessage: function addInfoMessage(message) {
	      toastr.info(message);
	    }
	  };
	}]);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(11);
	module.exports = 'toastr';



/***/ }),
/* 11 */
/***/ (function(module, exports) {

	(function() {
	  'use strict';

	  angular.module('toastr', [])
	    .factory('toastr', toastr);

	  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];

	  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
	    var container;
	    var index = 0;
	    var toasts = [];

	    var previousToastMessage = '';
	    var openToasts = {};

	    var containerDefer = $q.defer();

	    var toast = {
	      active: active,
	      clear: clear,
	      error: error,
	      info: info,
	      remove: remove,
	      success: success,
	      warning: warning,
	      refreshTimer: refreshTimer
	    };

	    return toast;

	    /* Public API */
	    function active() {
	      return toasts.length;
	    }

	    function clear(toast) {
	      // Bit of a hack, I will remove this soon with a BC
	      if (arguments.length === 1 && !toast) { return; }

	      if (toast) {
	        remove(toast.toastId);
	      } else {
	        for (var i = 0; i < toasts.length; i++) {
	          remove(toasts[i].toastId);
	        }
	      }
	    }

	    function error(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.error;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function info(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.info;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function success(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.success;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function warning(message, title, optionsOverride) {
	      var type = _getOptions().iconClasses.warning;
	      return _buildNotification(type, message, title, optionsOverride);
	    }

	    function refreshTimer(toast, newTime) {
	      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
	          toast.scope.refreshTimer(newTime);
	      }
	    }

	    function remove(toastId, wasClicked) {
	      var toast = findToast(toastId);

	      if (toast && ! toast.deleting) { // Avoid clicking when fading out
	        toast.deleting = true;
	        toast.isOpened = false;
	        $animate.leave(toast.el).then(function() {
	          if (toast.scope.options.onHidden) {
	            toast.scope.options.onHidden(!!wasClicked, toast);
	          }
	          toast.scope.$destroy();
	          var index = toasts.indexOf(toast);
	          delete openToasts[toast.scope.message];
	          toasts.splice(index, 1);
	          var maxOpened = toastrConfig.maxOpened;
	          if (maxOpened && toasts.length >= maxOpened) {
	            toasts[maxOpened - 1].open.resolve();
	          }
	          if (lastToast()) {
	            container.remove();
	            container = null;
	            containerDefer = $q.defer();
	          }
	        });
	      }

	      function findToast(toastId) {
	        for (var i = 0; i < toasts.length; i++) {
	          if (toasts[i].toastId === toastId) {
	            return toasts[i];
	          }
	        }
	      }

	      function lastToast() {
	        return !toasts.length;
	      }
	    }

	    /* Internal functions */
	    function _buildNotification(type, message, title, optionsOverride) {
	      if (angular.isObject(title)) {
	        optionsOverride = title;
	        title = null;
	      }

	      return _notify({
	        iconClass: type,
	        message: message,
	        optionsOverride: optionsOverride,
	        title: title
	      });
	    }

	    function _getOptions() {
	      return angular.extend({}, toastrConfig);
	    }

	    function _createOrGetContainer(options) {
	      if(container) { return containerDefer.promise; }

	      container = angular.element('<div></div>');
	      container.attr('id', options.containerId);
	      container.addClass(options.positionClass);
	      container.css({'pointer-events': 'auto'});

	      var target = angular.element(document.querySelector(options.target));

	      if ( ! target || ! target.length) {
	        throw 'Target for toasts doesn\'t exist';
	      }

	      $animate.enter(container, target).then(function() {
	        containerDefer.resolve();
	      });

	      return containerDefer.promise;
	    }

	    function _notify(map) {
	      var options = _getOptions();

	      if (shouldExit()) { return; }

	      var newToast = createToast();

	      toasts.push(newToast);

	      if (ifMaxOpenedAndAutoDismiss()) {
	        var oldToasts = toasts.slice(0, (toasts.length - options.maxOpened));
	        for (var i = 0, len = oldToasts.length; i < len; i++) {
	          remove(oldToasts[i].toastId);
	        }
	      }

	      if (maxOpenedNotReached()) {
	        newToast.open.resolve();
	      }

	      newToast.open.promise.then(function() {
	        _createOrGetContainer(options).then(function() {
	          newToast.isOpened = true;
	          if (options.newestOnTop) {
	            $animate.enter(newToast.el, container).then(function() {
	              newToast.scope.init();
	            });
	          } else {
	            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
	            $animate.enter(newToast.el, container, sibling).then(function() {
	              newToast.scope.init();
	            });
	          }
	        });
	      });

	      return newToast;

	      function ifMaxOpenedAndAutoDismiss() {
	        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
	      }

	      function createScope(toast, map, options) {
	        if (options.allowHtml) {
	          toast.scope.allowHtml = true;
	          toast.scope.title = $sce.trustAsHtml(map.title);
	          toast.scope.message = $sce.trustAsHtml(map.message);
	        } else {
	          toast.scope.title = map.title;
	          toast.scope.message = map.message;
	        }

	        toast.scope.toastType = toast.iconClass;
	        toast.scope.toastId = toast.toastId;
	        toast.scope.extraData = options.extraData;

	        toast.scope.options = {
	          extendedTimeOut: options.extendedTimeOut,
	          messageClass: options.messageClass,
	          onHidden: options.onHidden,
	          onShown: generateEvent('onShown'),
	          onTap: generateEvent('onTap'),
	          progressBar: options.progressBar,
	          tapToDismiss: options.tapToDismiss,
	          timeOut: options.timeOut,
	          titleClass: options.titleClass,
	          toastClass: options.toastClass
	        };

	        if (options.closeButton) {
	          toast.scope.options.closeHtml = options.closeHtml;
	        }

	        function generateEvent(event) {
	          if (options[event]) {
	            return function() {
	              options[event](toast);
	            };
	          }
	        }
	      }

	      function createToast() {
	        var newToast = {
	          toastId: index++,
	          isOpened: false,
	          scope: $rootScope.$new(),
	          open: $q.defer()
	        };
	        newToast.iconClass = map.iconClass;
	        if (map.optionsOverride) {
	          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
	          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
	        }

	        createScope(newToast, map, options);

	        newToast.el = createToastEl(newToast.scope);

	        return newToast;

	        function cleanOptionsOverride(options) {
	          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop',
	                            'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
	          for (var i = 0, l = badOptions.length; i < l; i++) {
	            delete options[badOptions[i]];
	          }

	          return options;
	        }
	      }

	      function createToastEl(scope) {
	        var angularDomEl = angular.element('<div toast></div>'),
	          $compile = $injector.get('$compile');
	        return $compile(angularDomEl)(scope);
	      }

	      function maxOpenedNotReached() {
	        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
	      }

	      function shouldExit() {
	        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
	        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];

	        if (isDuplicateOfLast || isDuplicateOpen) {
	          return true;
	        }

	        previousToastMessage = map.message;
	        openToasts[map.message] = true;

	        return false;
	      }
	    }
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .constant('toastrConfig', {
	      allowHtml: false,
	      autoDismiss: false,
	      closeButton: false,
	      closeHtml: '<button>&times;</button>',
	      containerId: 'toast-container',
	      extendedTimeOut: 1000,
	      iconClasses: {
	        error: 'toast-error',
	        info: 'toast-info',
	        success: 'toast-success',
	        warning: 'toast-warning'
	      },
	      maxOpened: 0,
	      messageClass: 'toast-message',
	      newestOnTop: true,
	      onHidden: null,
	      onShown: null,
	      onTap: null,
	      positionClass: 'toast-top-right',
	      preventDuplicates: false,
	      preventOpenDuplicates: false,
	      progressBar: false,
	      tapToDismiss: true,
	      target: 'body',
	      templates: {
	        toast: 'directives/toast/toast.html',
	        progressbar: 'directives/progressbar/progressbar.html'
	      },
	      timeOut: 5000,
	      titleClass: 'toast-title',
	      toastClass: 'toast'
	    });
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .directive('progressBar', progressBar);

	  progressBar.$inject = ['toastrConfig'];

	  function progressBar(toastrConfig) {
	    return {
	      require: '^toast',
	      templateUrl: function() {
	        return toastrConfig.templates.progressbar;
	      },
	      link: linkFunction
	    };

	    function linkFunction(scope, element, attrs, toastCtrl) {
	      var intervalId, currentTimeOut, hideTime;

	      toastCtrl.progressBar = scope;

	      scope.start = function(duration) {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }

	        currentTimeOut = parseFloat(duration);
	        hideTime = new Date().getTime() + currentTimeOut;
	        intervalId = setInterval(updateProgress, 10);
	      };

	      scope.stop = function() {
	        if (intervalId) {
	          clearInterval(intervalId);
	        }
	      };

	      function updateProgress() {
	        var percentage = ((hideTime - (new Date().getTime())) / currentTimeOut) * 100;
	        element.css('width', percentage + '%');
	      }

	      scope.$on('$destroy', function() {
	        // Failsafe stop
	        clearInterval(intervalId);
	      });
	    }
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .controller('ToastController', ToastController);

	  function ToastController() {
	    this.progressBar = null;

	    this.startProgressBar = function(duration) {
	      if (this.progressBar) {
	        this.progressBar.start(duration);
	      }
	    };

	    this.stopProgressBar = function() {
	      if (this.progressBar) {
	        this.progressBar.stop();
	      }
	    };
	  }
	}());

	(function() {
	  'use strict';

	  angular.module('toastr')
	    .directive('toast', toast);

	  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];

	  function toast($injector, $interval, toastrConfig, toastr) {
	    return {
	      templateUrl: function() {
	        return toastrConfig.templates.toast;
	      },
	      controller: 'ToastController',
	      link: toastLinkFunction
	    };

	    function toastLinkFunction(scope, element, attrs, toastCtrl) {
	      var timeout;

	      scope.toastClass = scope.options.toastClass;
	      scope.titleClass = scope.options.titleClass;
	      scope.messageClass = scope.options.messageClass;
	      scope.progressBar = scope.options.progressBar;

	      if (wantsCloseButton()) {
	        var button = angular.element(scope.options.closeHtml),
	          $compile = $injector.get('$compile');
	        button.addClass('toast-close-button');
	        button.attr('ng-click', 'close(true, $event)');
	        $compile(button)(scope);
	        element.children().prepend(button);
	      }

	      scope.init = function() {
	        if (scope.options.timeOut) {
	          timeout = createTimeout(scope.options.timeOut);
	        }
	        if (scope.options.onShown) {
	          scope.options.onShown();
	        }
	      };

	      element.on('mouseenter', function() {
	        hideAndStopProgressBar();
	        if (timeout) {
	          $interval.cancel(timeout);
	        }
	      });

	      scope.tapToast = function () {
	        if (angular.isFunction(scope.options.onTap)) {
	          scope.options.onTap();
	        }
	        if (scope.options.tapToDismiss) {
	          scope.close(true);
	        }
	      };

	      scope.close = function (wasClicked, $event) {
	        if ($event && angular.isFunction($event.stopPropagation)) {
	          $event.stopPropagation();
	        }
	        toastr.remove(scope.toastId, wasClicked);
	      };
	      
	      scope.refreshTimer = function(newTime) {
	        if (timeout) {
	          $interval.cancel(timeout);
	          timeout = createTimeout(newTime || scope.options.timeOut);
	        }
	      };

	      element.on('mouseleave', function() {
	        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) { return; }
	        scope.$apply(function() {
	          scope.progressBar = scope.options.progressBar;
	        });
	        timeout = createTimeout(scope.options.extendedTimeOut);
	      });

	      function createTimeout(time) {
	        toastCtrl.startProgressBar(time);
	        return $interval(function() {
	          toastCtrl.stopProgressBar();
	          toastr.remove(scope.toastId);
	        }, time, 1);
	      }

	      function hideAndStopProgressBar() {
	        scope.progressBar = false;
	        toastCtrl.stopProgressBar();
	      }

	      function wantsCloseButton() {
	        return scope.options.closeHtml;
	      }
	    }
	  }
	}());

	angular.module("toastr").run(["$templateCache", function($templateCache) {$templateCache.put("directives/progressbar/progressbar.html","<div class=\"toast-progress\"></div>\n");
	$templateCache.put("directives/toast/toast.html","<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");}]);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var settingsModule = angular.module('t2g.common.settings', []);

	module.exports = settingsModule;

	var settings = {
	  titlePrefix: 'Sanasearch',
	  titleSeperator: '»',
	  apiBase: '',
	  mandant: 'coachfrog',
	  modules: {
	    invoice: true,
	    tarif590: true
	  },
	  billwerk: {
	    key: '576a51a314a9ff0728fe006c',
	    products: {
	      chf: {
	        basic: '58eb818e796508112c52bc9c',
	        premium_monthly: '58eb7ec9675ecb0e607526bd',
	        premium_yearly: '58eb7eff796508112c52b85c',
	        employee: '58eb81c9675ecb0e60752ba3',
	        sms: '58f6841614a9ff1434b12755'
	      },
	      eur: {
	        basic: '58eb829c796508112c52be28',
	        premium_monthly: '58eb824b675ecb0e60752c37',
	        premium_yearly: '58eb8282796508112c52be05',
	        employee: '58eb82d5675ecb0e60752d04',
	        sms: '58f6842714a9ff138069f6d3'
	      }
	    },
	    bearer: {
	      creditCard: 'Stripe',
	      payPal: 'PayPal',
	      directDebit: 'Debit:FakePSP',
	      invoice: 'InvoicePayment',
	      none: 'None:None'
	    }
	  },
	  paymentMethods: {
	    at: ['payPal', 'creditCard', 'invoice'],
	    de: ['payPal', 'creditCard', 'invoice'],
	    ch: ['payPal', 'creditCard', 'invoice']
	  },
	  invoiceFolder: '/api/v2/payment/',
	  defaultLanguage: 'de',
	  login: 'https://admin.sanasearch.ch/',
	  login_url: 'https://www.sanasearch.ch/en/konto/login/',
	  settingsForm: __webpack_require__(13),
	  cancellation: {
	    redirect: 'https://www.sanasearch.ch'
	  },
	  calendar: {
	    contextMenu: {
	      appointment: true,
	      course: false,
	      private: true,
	      abort: true
	    }
	  },
	  i18nOverwrite: {
	    de: {}
	  },
	  availableLanguages: ['de'],
	  INTERCOM_APP_ID: 'hsklpp46',
	  showUserlane: true,
	  USERLANE_APP_ID: 32752
	};

	// overwrite i18n
	settings.i18nOverwrite.de['services'] = 'Angebote';
	settings.i18nOverwrite.de['Services'] = 'Angebote';
	settings.i18nOverwrite.de['Service'] = 'Angebot';
	settings.i18nOverwrite.de['Add service'] = 'Angebot hinzufügen';
	settings.i18nOverwrite.de['Do you realy want to delete that service?'] = 'Wollen Sie dieses Angebot wirklich löschen?';
	settings.i18nOverwrite.de['Enter services'] = 'Angebot hinzufügen';
	settings.i18nOverwrite.de['Service "{{name}}" deleted'] = 'Angebot "{{name}}" wurde gelöscht';
	settings.i18nOverwrite.de['Service "{{name}}" saved'] = 'Angebot "{{name}}" wurde gespeichert';
	settings.i18nOverwrite.de['Service groups'] = 'Angebotsgruppen';
	settings.i18nOverwrite.de['There should be at least one service group'] = 'Es muss mindestens eine Gruppe bestehen bleiben.';
	settings.i18nOverwrite.de['service edited'] = 'Angebot geändert';
	settings.i18nOverwrite.de['service group "{{name}}" deleted'] = 'Angebotsgruppe "{{name}}" wurde gelöscht';
	settings.i18nOverwrite.de['service groups saved'] = 'Angebotsgruppe wurde gespeichert';
	settings.i18nOverwrite.de['Service resource match'] = 'Angebote Mitarbeitern zuordnen';
	settings.i18nOverwrite.de['Add appointment or customer'] = 'Termin oder Klient hinzufügen';
	settings.i18nOverwrite.de['- Choose a Service -'] = '- Wählen Sie ein Angebot - ';
	settings.i18nOverwrite.de['The bookable appointments interval will adopt to booked service length.'] = 'Der Abstand zwischen buchbaren Terminen passt sich der Dauer des gebuchten Angebotes an.';

	settings.i18nOverwrite.de['Add customers'] = 'Klienten hinzufügen';
	settings.i18nOverwrite.de['Cant add customer (Error: {{error}})'] = 'Klient konnte nicht angelegt werden (Error: {{error}})';
	settings.i18nOverwrite.de['Cant delete customer (Error: {{error}})'] = 'Klient konnte nicht gelöscht werden (Error: {{error}})';
	settings.i18nOverwrite.de['Cant update customer (Error: {{error}})'] = 'Klient konnte nicht aktualisiert werden (Error: {{error}})';
	settings.i18nOverwrite.de['Customer'] = 'Klient';
	settings.i18nOverwrite.de['Customers'] = 'Klienten';
	settings.i18nOverwrite.de['customer'] = 'Klient';
	settings.i18nOverwrite.de['customers'] = 'Klienten';
	settings.i18nOverwrite.de['Customer profile'] = 'Klientenprofil';
	settings.i18nOverwrite.de['Do you really want to delete that customer?'] = 'Wollen Sie wirklich diesen Klienten löschen?';
	settings.i18nOverwrite.de['Download customer list (*.csv file)'] = 'Klientenliste herunterladen (*.csv file)';
	settings.i18nOverwrite.de['Export customer data'] = 'Klientenprofile exportieren';
	settings.i18nOverwrite.de['Export billing data'] = 'Rechnungen exportieren';
	settings.i18nOverwrite.de['Month'] = 'Monat';
	settings.i18nOverwrite.de['Year'] = 'Jahr';
	settings.i18nOverwrite.de['Whole year'] = 'Ganzes Jahr';
	settings.i18nOverwrite.de['Invoice type'] = 'Rechnungstyp';
	settings.i18nOverwrite.de['Download invoice list (*.csv file)'] = 'Rechnungsliste herunterladen (*.csv file)';
	settings.i18nOverwrite.de['Download invoices as PDF (*.zip file)'] = 'Rechnungen als PDF herunterladen (*.zip file)';
	settings.i18nOverwrite.de['Download customer invoices (*.csv file)'] = 'Rechnungen dieses Klienten herunterladen (*.csv file)';
	settings.i18nOverwrite.de['Download customer invoices as PDF (*.zip file)'] = 'Rechnungen dieses Klienten als PDF herunterladen (*.zip file)';
	settings.i18nOverwrite.de['New Customer'] = 'Neuer Klient';
	settings.i18nOverwrite.de['Reach more customers'] = 'Mehr Klienten erreichen';
	settings.i18nOverwrite.de['Send notifications mails to customer about appointment changes (change start date, remove)'] = 'den Klienten über die Terminänderung (Änderung Startzeit, Löschen) informieren';
	settings.i18nOverwrite.de['notify customer via email'] = 'Klienten über Änderung benachrichtigen';
	settings.i18nOverwrite.de['How can customers book an appointment in short notice.'] = 'Wie kurzfristig können Klienten einen Termin bei Ihnen buchen?';
	settings.i18nOverwrite.de['Add Customer'] = 'Klient hinzufügen';
	settings.i18nOverwrite.de['Customers ({{CustomerListCtrl.customers.length}})'] = 'Klienten ({{CustomerListCtrl.customers.length}})';

	settings.i18nOverwrite.de['Close'] = 'Schliessen';
	settings.i18nOverwrite.de['Sanasearch Profile'] = 'Sanasearch Profil';

	settings.i18nOverwrite.de['Termin2go calendar'] = 'Sanasearch Calendar';
	settings.i18nOverwrite.de['Termin2go field'] = 'Sanasearch Feld';

	settings.i18nOverwrite.de['Global Email address'] = 'E-Mail Adresse';

	settingsModule.constant('settings', settings);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  active: 'booking',
	  booking: {
	    appBookable: false,
	    coursesBookable: false,
	    maxServices: false,
	    dynamicSlotLength: false,
	    slotLength: true,
	    appointmentPause: true,
	    currency: false,
	    minLeadtime: true,
	    bookAdvance: true,
	    cancelLimit: false,
	    acceptBooking: false,
	    serviceGroupCollapsing: false,
	    disablePriceColumn: false,
	    disableEmployeeChooser: false,
	    showBookAdditionalBtn: false
	  },
	  email: {
	    showCustomLogo: false,
	    globalMailAddressEnabled: true,
	    employeeMailAddressEnabled: false,
	    sendAppointmentChangeNotificationMails: true
	  },
	  reminder: {
	    smsSenderName: false,
	    reminderMail: true,
	    reminderMailTime: true,
	    reminderSMS: true,
	    reminderSMSTime: true
	  },
	  accounting: {
	    zsrNumber: true,
	    glnNumber: true,
	    taxNumber: true,
	    iban: true,
	    bank: true,
	    accountHolder: true,
	    bic: true,
	    paymentPeriod: true
	  },
	  billingAddress: {
	    companyName: true,
	    firstname: true,
	    lastname: true,
	    city: true,
	    street: true,
	    number: true,
	    postal: true,
	    country: true,
	    countryCode: true,
	    telephone: true,
	    fax: true
	  }
	};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	  load: function load() {}
	};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common', [__webpack_require__(16).name, __webpack_require__(111).name, __webpack_require__(138).name, __webpack_require__(150).name, __webpack_require__(165).name]);

	module.exports = angularModule;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access', [__webpack_require__(17).name, __webpack_require__(18).name, __webpack_require__(19).name, __webpack_require__(20).name, __webpack_require__(21).name, __webpack_require__(2).name, __webpack_require__(22).name, __webpack_require__(23).name, __webpack_require__(24).name, __webpack_require__(25).name, __webpack_require__(26).name, __webpack_require__(27).name, __webpack_require__(28).name, __webpack_require__(104).name, __webpack_require__(105).name, __webpack_require__(106).name, __webpack_require__(107).name, __webpack_require__(108).name, __webpack_require__(8).name, __webpack_require__(109).name, __webpack_require__(110).name]);

	module.exports = angularModule;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.accounting', []);

	module.exports = angularModule;

	angularModule.factory('AccountingResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/accounting/:subResource0/:subResource1';

	  var resource = $resource(resourceUrl, {}, {
	    createInvoice: { method: 'POST', isArray: false, params: { subResource0: 'invoice' } },
	    updateInvoice: { method: 'PUT', isArray: false, params: { subResource0: 'invoice' } },
	    getForCustomer: { method: 'GET', isArray: false, params: { subResource0: 'customer' } },
	    removeInvoice: { method: 'DELETE', isArray: false, params: { subResource0: 'invoice' } }
	  });

	  return resource;
	}]);

	angularModule.factory('AccountingDA', ["AccountingResource", function (AccountingResource) {
	  return {
	    createInvoice: createInvoice,
	    updateInvoice: updateInvoice,
	    removeInvoice: removeInvoice,
	    getForCustomer: getForCustomer
	  };

	  function removeInvoice(invoiceId) {
	    return AccountingResource.removeInvoice({ subResource1: invoiceId }).$promise;
	  }

	  function getForCustomer(customerId) {
	    return AccountingResource.getForCustomer({ subResource1: customerId }).$promise.then(function (response) {
	      return response.invoices;
	    });
	  }

	  function createInvoice(invoice) {
	    return AccountingResource.createInvoice(invoice).$promise;
	  }

	  function updateInvoice(invoiceId, invoice) {
	    return AccountingResource.updateInvoice({ subResource1: invoiceId }, invoice).$promise;
	  }
	}]);

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.appointment', []);

	module.exports = angularModule;

	angularModule.factory('AppointmentResource', ["$resource", "settings", function ($resource, settings) {
	  // /appointment/:appointmentId/participants/:customerId

	  var resourceUrl = settings.apiBase + '/api/v2/appointment/:appointmentId/:subResource1/:subResource2';

	  return $resource(resourceUrl, {}, {
	    get: { method: 'get' },
	    insert: { method: 'post' },
	    remove: { method: 'delete' },
	    removeSynced: { method: 'delete', params: { appointmentId: 'sync' } },
	    getSyncedAndUnlinked: { method: 'get', params: { appointmentId: 'sync' } },
	    removeSyncedAndUnlinked: { method: 'delete', params: { appointmentId: 'sync' } },
	    getGoogleSyncedAndUnlinked: { method: 'get', params: { appointmentId: 'sync-google' } },
	    removeGoogleSyncedAndUnlinked: { method: 'delete', params: { appointmentId: 'sync-google' } },
	    update: { method: 'put', params: { appointmentId: '@_id' } },
	    addParticipant: { method: 'post', params: { subResource1: 'participants' } },
	    removeParticipant: { method: 'delete', params: { subResource1: 'participants' } }
	  });
	}]);

	angularModule.factory('AppointmentDA', ["$q", "AppointmentResource", "CalendarDA", "gettextCatalog", "Notification", function ($q, AppointmentResource, CalendarDA, gettextCatalog, Notification) {
	  return {
	    addParticipant: addParticipant,
	    removeParticipant: removeParticipant,
	    get: get,
	    insert: insert,
	    remove: remove,
	    removeSyncedViaICal: removeSyncedViaICal,
	    getSyncedAndUnlinked: getSyncedAndUnlinked,
	    removeSyncedAndUnlinked: removeSyncedAndUnlinked,
	    getGoogleSyncedAndUnlinked: getGoogleSyncedAndUnlinked,
	    removeGoogleSyncedAndUnlinked: removeGoogleSyncedAndUnlinked,
	    update: update,
	    transformResponse: transformResponse
	  };

	  /**
	   * parse appointment start and end als date times
	   * @param {Object} response
	   * @returns {Object}
	   */
	  function transformResponse(response) {
	    var appointments = response.appointments || response.appointment || response;

	    _.map(appointments, function (appointment) {
	      appointment.start = new Date(appointment.start);
	      appointment.end = new Date(appointment.end);
	      appointment.preparationStart = appointment.preparationStart ? new Date(appointment.preparationStart) : appointment.start;
	      appointment.followUpEnd = appointment.followUpEnd ? new Date(appointment.followUpEnd) : appointment.end;
	      return appointment;
	    });

	    return appointments;
	  }

	  /**
	   * add a participant to a course appointment
	   *
	   * @param {String} appointmentId
	   * @param {String} customerId
	   * @returns {promise}
	   */
	  function addParticipant(appointmentId, customerId) {
	    return AppointmentResource.addParticipant({ appointmentId: appointmentId }, { participant: customerId }).$promise.then(transformResponse).then(function (updatedAppointment) {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));
	      return CalendarDA.editAppointment(updatedAppointment);
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
	    });
	  }

	  /**
	   * remove a participant to a course appointment
	   *
	   * @param {String} appointmentId
	   * @param {String} customerId
	   * @returns {promise}
	   */
	  function removeParticipant(appointmentId, customerId) {
	    return AppointmentResource.removeParticipant({
	      appointmentId: appointmentId,
	      subResource2: customerId
	    }).$promise.then(transformResponse).then(function (updatedAppointment) {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));
	      return CalendarDA.editAppointment(updatedAppointment);
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
	    });
	  }

	  /**
	   * get an appointment
	   * @param {String} appointmentId
	   * @returns {Object}
	   */
	  function get(appointmentId) {
	    return AppointmentResource.get({ appointmentId: appointmentId }).$promise.then(function (response) {
	      var appointment = response.appointment;
	      appointment.start = new Date(appointment.start);
	      appointment.end = new Date(appointment.end);
	      appointment.preparationStart = new Date(appointment.preparationStart);
	      appointment.followUpEnd = new Date(appointment.followUpEnd);
	      return appointment;
	    });
	  }

	  /**
	   * save appointment
	   * @param appointment
	   * @returns {Object}
	   */
	  function insert(appointment) {
	    return AppointmentResource.insert(appointment).$promise.then(transformResponse).then(function (insertedAppointment) {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointment saved'));
	      return CalendarDA.insertAppointment(insertedAppointment);
	    }).then(function (insertedAppointments) {
	      var firstAppointment = insertedAppointments[0];

	      //        if (firstAppointment && firstAppointment.customerNotified) {
	      //          Notification.addSuccessMessage(
	      //            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
	      //              customerEmail: firstAppointment.customer.email,
	      //            }),
	      //          );
	      //        }

	      return insertedAppointments;
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant save appointment'));
	    });
	  }

	  /**
	   * delete an appointment
	   *
	   * @param {String} appointmentId
	   * @param {Boolean} sendNotification
	   * @param {Object} appointment
	   * @returns {Object}
	   */
	  function remove(appointmentId, sendNotification, appointment) {
	    return AppointmentResource.remove({
	      appointmentId: appointmentId,
	      sendNotification: sendNotification === true ? 'true' : false
	    }).$promise.then(function () {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointment deleted'));

	      //        if (sendNotification) {
	      //          Notification.addSuccessMessage(
	      //            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
	      //              customerEmail: _.get(appointment, 'customer.email'),
	      //            }),
	      //          );
	      //        }

	      if (appointment.seriesId) return CalendarDA.removeAppointment(appointmentId);
	      return CalendarDA.removeAppointmentGroup(appointment._id);
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant delete appointment'));
	    });
	  }

	  /**
	   * delete all synced appointments related to sync calendar
	   *
	   * @param {String} employeeId
	   * @param {String} syncId
	   * @returns {Object}
	   */
	  function removeSyncedViaICal(employeeId, syncId) {
	    return AppointmentResource.removeSynced({ subResource1: employeeId, subResource2: syncId }).$promise.then(function () {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointments deleted'));

	      return { success: true };
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant delete appointments'));

	      return { success: false };
	    });
	  }

	  /**
	   * get all synced appointments but not binded with any sync calendar
	   *
	   * @param {String} employeeId
	   * @returns {Object}
	   */
	  function getSyncedAndUnlinked(employeeId) {
	    return AppointmentResource.getSyncedAndUnlinked({
	      subResource1: employeeId,
	      subResource2: 'unlinked'
	    }).$promise.then(function (appointments) {
	      return appointments;
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant get appointments'));

	      return { success: false };
	    });
	  }

	  /**
	   * get all synced appointments but not binded with any sync calendar
	   *
	   * @param {String} employeeId
	   * @returns {Object}
	   */
	  function removeSyncedAndUnlinked(employeeId) {
	    return AppointmentResource.removeSyncedAndUnlinked({
	      subResource1: employeeId,
	      subResource2: 'unlinked'
	    }).$promise.then(function (appointments) {
	      return appointments;
	    }).catch(function (err) {
	      console.log(err);
	      Notification.addErrorMessage(gettextCatalog.getString('Cant remove appointments'));

	      return { success: false };
	    });
	  }

	  /**
	   * get all synced appointments but not binded with any Google sync calendar
	   *
	   * @param {String} officeId
	   * @returns {Object}
	   */
	  function getGoogleSyncedAndUnlinked(officeId) {
	    return AppointmentResource.getGoogleSyncedAndUnlinked({
	      subResource1: officeId,
	      subResource2: 'unlinked'
	    }).$promise.then(function (appointments) {
	      return appointments;
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant get appointments'));

	      return { success: false };
	    });
	  }

	  /**
	   * get all synced appointments but not binded with any Google sync calendar
	   *
	   * @param {String} officeId
	   * @returns {Object}
	   */
	  function removeGoogleSyncedAndUnlinked(officeId) {
	    return AppointmentResource.removeGoogleSyncedAndUnlinked({
	      subResource1: officeId,
	      subResource2: 'unlinked'
	    }).$promise.then(function (appointments) {
	      return appointments;
	    }).catch(function (err) {
	      console.log(err);
	      Notification.addErrorMessage(gettextCatalog.getString('Cant remove appointments'));

	      return { success: false };
	    });
	  }

	  /**
	   * update an appointment
	   *
	   * @param {Object} appointment
	   * @param {Boolean} sendNotification
	   * @returns {Object}
	   */
	  function update(appointment, sendNotification) {
	    return AppointmentResource.update(appointment).$promise.then(transformResponse).then(function (updatedAppointment) {
	      Notification.addSuccessMessage(gettextCatalog.getString('Appointment updated'));

	      CalendarDA.removeAppointmentGroup(appointment._id);

	      //        if (sendNotification) {
	      //          Notification.addSuccessMessage(
	      //            gettextCatalog.getString('Notification email send to {{customerEmail}}', {
	      //              customerEmail: _.get(appointment, 'customer.email'),
	      //            }),
	      //          );
	      //        }

	      return CalendarDA.editAppointment(updatedAppointment);
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update appointment'));
	    });
	  }
	}]);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.billing', ['ngResource', __webpack_require__(1).name, __webpack_require__(6).name, __webpack_require__(5).name]);

	module.exports = angularModule;

	var STORAGE_KEY = 'billing';

	angularModule.factory('BillingResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/billing/:subResource';

	  var resource = $resource(resourceUrl, {}, {
	    subscribe: { method: 'PUT' },
	    getSMSCredit: { method: 'GET', isArray: false, params: { subResource: 'smsCredit' } }
	  });

	  return resource;
	}]);

	angularModule.factory('Billing', ["$q", "$http", "$rootScope", "$timeout", "localStorageService", "BillingResource", "ObjectModel", "OfficeModel", "OfficeDA", "UserSession", "settings", function ($q, $http, $rootScope, $timeout, localStorageService, BillingResource, ObjectModel, OfficeModel, OfficeDA, UserSession, settings) {
	  return {
	    purge: function purge() {
	      var deferred = $q.defer();

	      localStorageService.remove(STORAGE_KEY);

	      $timeout(function () {
	        deferred.resolve();
	      }, 100);

	      return deferred.promise;
	    },
	    get: function get() {
	      var deferred = $q.defer();

	      if (localStorageService.get(STORAGE_KEY)) {
	        deferred.resolve(localStorageService.get(STORAGE_KEY));
	      } else {
	        BillingResource.get({ officeId: UserSession.getOffice() }).$promise.then(function (response) {
	          localStorageService.set(STORAGE_KEY, response);
	          deferred.resolve(localStorageService.get(STORAGE_KEY));
	        }, function (error) {
	          deferred.reject(error);
	        });
	      }

	      return deferred.promise;
	    },
	    subscribe: function subscribe(subscription) {
	      var deferred = $q.defer();

	      BillingResource.subscribe({ officeId: UserSession.getOffice() }, subscription).$promise.then(function (response) {
	        localStorageService.set(STORAGE_KEY, response);
	        deferred.resolve(localStorageService.get(STORAGE_KEY));
	      }, function (error) {
	        deferred.reject(error);
	      });

	      return deferred.promise;
	    },
	    calculate: function calculate(callback) {
	      ObjectModel.get(function (error, employees) {
	        if (error) {
	          callback(error);
	        } else {
	          OfficeDA.get().then(function (office) {
	            var services = 0;

	            for (var i = 0, groupLen = office.serviceGroups.length; i < groupLen; i++) {
	              if (!office.serviceGroups.intern) {
	                services += office.serviceGroups[i].services.length;
	              }
	            }

	            var request = {
	              url: settings.apiBase + '/api/v2/billing/calculatePrice',
	              method: 'GET',
	              params: {
	                employees: employees.length,
	                services: services,
	                currency: office.settings.currency,
	                office: office._id
	              }
	            };

	            $http(request).then(function (data) {
	              data.employees = employees.length;
	              data.services = services;
	              callback(null, data);
	            }).catch(function (data) {
	              callback(data);
	            });
	          }).catch(function (error) {
	            callback(error);
	          });
	        }
	      });
	    },
	    getPlan: function getPlan() {
	      var deferred = $q.defer();

	      if (localStorageService.get(STORAGE_KEY)) {
	        deferred.resolve(localStorageService.get(STORAGE_KEY).plan);
	      } else {
	        this.get().then(function (billing) {
	          deferred.resolve(billing.plan);
	        }, function (error) {
	          deferred.reject(error);
	        });
	      }

	      return deferred.promise;
	    },
	    getSMSCredit: function getSMSCredit() {
	      return BillingResource.getSMSCredit({ officeId: UserSession.getOffice() }).$promise;
	    }
	  };
	}]);

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.booking', []);

	module.exports = angularModule;

	angularModule.factory('BookingResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/booking/:id/:action';

	  var resource = $resource(resourceUrl, {}, {
	    accept: { method: 'POST', isArray: false, params: { action: 'accept', id: '@_id' } },
	    confirm: { method: 'POST', isArray: false, params: { action: 'confirm', id: '@_id' } },
	    decline: { method: 'POST', isArray: false, params: { action: 'decline', id: '@_id' } },
	    setProcessed: {
	      method: 'POST',
	      isArray: false,
	      params: { action: 'set-processed', id: null }
	    },
	    getAll: { method: 'GET', isArray: false, params: { action: 'all' } },
	    get: { method: 'GET', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('BookingDA', ["BookingResource", "UserSession", function (BookingResource, UserSession) {
	  return {
	    getAll: function getAll() {
	      return BookingResource.getAll({ id: UserSession.getOffice() }).$promise;
	    },
	    setProcessed: function setProcessed(booking) {
	      return BookingResource.setProcessed({
	        officeId: booking.officeId,
	        bookingIds: booking.ids
	      }).$promise;
	    },
	    getUnprocessed: function getUnprocessed() {
	      return BookingResource.get({ id: UserSession.getOffice() }).$promise;
	    },
	    accept: function accept(booking) {
	      return BookingResource.accept(booking).$promise;
	    },
	    confirm: function confirm(booking) {
	      return BookingResource.confirm(booking).$promise;
	    },
	    decline: function decline(booking) {
	      return BookingResource.decline(booking).$promise;
	    }
	  };
	}]);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.countryConfig', ['ngResource', __webpack_require__(1).name, __webpack_require__(6).name]);

	module.exports = angularModule;

	var STORAGE_KEY = 'countryConfig';

	var countries = [{ code: 'DE', label: 'Deutschland', currency: 'EUR', language: ['de-DE'] }, { code: 'CH', label: 'Schweiz', currency: 'CHF', language: ['de-CH'] }, { code: 'AT', label: 'Österreich', currency: 'EUR', language: ['de-DE'] }, { code: 'LI', label: 'Liechtenstein', currency: 'CHF', language: ['de-CH'] }, { code: 'LU', label: 'Luxemburg', currency: 'EUR', language: ['de-DE'] }, { code: 'ES', label: 'Spanien', currency: 'EUR', language: ['de-DE'] }];

	angularModule.factory('CountryConfigResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/countryConfig/:countryCode';

	  var resource = $resource(resourceUrl, {}, {});

	  return resource;
	}]);

	angularModule.factory('CountryConfig', ["$q", "$timeout", "localStorageService", "CountryConfigResource", "OfficeDA", function ($q, $timeout, localStorageService, CountryConfigResource, OfficeDA) {
	  return {
	    get: get,
	    getCountries: getCountries,
	    getCountryByCode: getCountryByCode
	  };

	  function getCountryByCode(countryCode) {
	    countryCode = countryCode.toUpperCase();

	    return get().then(function (countries) {
	      return _.find(countries, { code: countryCode });
	    });
	  }

	  function get() {
	    var countryConfig = localStorageService.get(STORAGE_KEY);

	    if (!countryConfig) {
	      return OfficeDA.get().then(function (office) {
	        return CountryConfigResource.get({ countryCode: office.address.countryCode }).$promise;
	      }).then(function (response) {
	        // add holidayKey to each holiday
	        angular.forEach(response.holidays, function (days, year) {
	          angular.forEach(response.holidays[year], function (holiday, date) {
	            holiday.date = new Date(holiday.date);
	            response.holidays[year][date].key = holiday.date.getDayKey();
	          });
	        });

	        localStorageService.set(STORAGE_KEY, response);

	        return response;
	      });
	    } else {
	      return $q.when(countryConfig);
	    }
	  }

	  function getCountries() {
	    return $q.when(countries);
	  }
	}]);

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.google-sync', []);

	module.exports = angularModule;

	angularModule.factory('GoogleSyncResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/google-sync/:office';

	  var resource = $resource(resourceUrl, {}, {
	    get: { method: 'get' },
	    update: { method: 'PUT' }
	  });

	  return resource;
	}]);

	angularModule.factory('GoogleSyncDA', ["$q", "GoogleSyncResource", "LoadingIndicatorService", function ($q, GoogleSyncResource, LoadingIndicatorService) {
	  return {
	    getCalendarList: getCalendarList,
	    update: update,
	    revokeAccess: revokeAccess
	  };

	  function getCalendarList() {
	    LoadingIndicatorService.show();

	    return GoogleSyncResource.get().$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return response.data;
	    });
	  }

	  function update(sync) {
	    LoadingIndicatorService.show();

	    return GoogleSyncResource.update(sync).$promise.then(function (savedSync) {
	      LoadingIndicatorService.hide();
	      return savedSync;
	    }, function (error) {
	      LoadingIndicatorService.hide();
	      return $q.reject(error);
	    });
	  }

	  function revokeAccess() {
	    LoadingIndicatorService.show();

	    return GoogleSyncResource.delete().$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    });
	  }
	}]);

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.caldav-sync', []);

	module.exports = angularModule;

	angularModule.factory('CalDavResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/calendarApi/:action/:provider/:user';

	  var resource = $resource(resourceUrl, {}, {
	    getList: { method: 'GET', params: { action: 'list' } },
	    getServices: { method: 'GET', params: { action: 'bookingtypes' } },
	    linkService: { method: 'POST', params: { action: 'link', provider: 'upsert' } },
	    unlinkService: { method: 'POST', params: { action: 'link', provider: 'delete' } },
	    registerCalDav: { method: 'POST', params: { action: 'register', provider: 'caldav' } },
	    delete: { method: 'POST', params: { action: 'caldav', provider: 'delete' } },
	    discover: { method: 'GET', isArray: true, params: { action: 'discover' } },
	    sync: { method: 'GET', params: { action: 'sync' } },
	    getDiscoveredCalendars: {
	      method: 'GET',
	      isArray: true,
	      params: { action: 'discovered-calendars' }
	    },
	    removeCalendars: { method: 'POST', params: { action: 'calendar', provider: 'delete' } }
	  });

	  return resource;
	}]);

	angularModule.factory('CalDavDA', ["$q", "CalDavResource", "LoadingIndicatorService", function ($q, CalDavResource, LoadingIndicatorService) {
	  return {
	    getList: getList,
	    getServices: getServices,
	    linkService: linkService,
	    unlinkService: unlinkService,
	    registerCalDav: registerCalDav,
	    disconnectProvider: disconnectProvider,
	    discoverProvider: discoverProvider,
	    sync: sync,
	    getDiscoveredCalendars: getDiscoveredCalendars,
	    removeCalendars: removeCalendars
	  };

	  function getList() {
	    LoadingIndicatorService.show();

	    return CalDavResource.getList().$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return response.data;
	    });
	  }

	  function getServices() {
	    LoadingIndicatorService.show();

	    return CalDavResource.getServices().$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return response.data;
	    });
	  }

	  function registerCalDav(body) {
	    LoadingIndicatorService.show();

	    return CalDavResource.registerCalDav(body).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response.data);
	    });
	  }

	  function linkService(serviceId, calendarName) {
	    LoadingIndicatorService.show();

	    return CalDavResource.linkService({
	      service_id: serviceId,
	      calendar_name: calendarName
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response.data);
	    });
	  }

	  function unlinkService(serviceId) {
	    LoadingIndicatorService.show();

	    return CalDavResource.unlinkService({
	      service_id: serviceId
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response.data);
	    });
	  }

	  function disconnectProvider(providerName) {
	    LoadingIndicatorService.show();

	    return CalDavResource.delete({
	      provider_name: providerName
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response.data);
	    });
	  }

	  function discoverProvider(providerName) {
	    LoadingIndicatorService.show();

	    return CalDavResource.discover({
	      provider: providerName
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response);
	    });
	  }

	  function sync(providerName) {
	    LoadingIndicatorService.show();

	    return CalDavResource.sync({
	      provider: providerName || 'syncall'
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response);
	    });
	  }

	  function getDiscoveredCalendars(providerName) {
	    LoadingIndicatorService.show();

	    return CalDavResource.getDiscoveredCalendars({
	      provider: providerName
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response);
	    });
	  }

	  function removeCalendars(calendarsURLs) {
	    LoadingIndicatorService.show();

	    return CalDavResource.removeCalendars({
	      calendars: calendarsURLs
	    }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    }, function (response) {
	      LoadingIndicatorService.hide();
	      return $q.reject(response);
	    });
	  }
	}]);

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.mail', ['ngResource']);

	module.exports = angularModule;

	angularModule.factory('MailResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/mail/:templateName';

	  var resource = $resource(resourceUrl, {}, {
	    get: { method: 'GET', isArray: false },
	    update: { method: 'PATCH' },
	    remove: { method: 'DELETE' },
	    verifySMTP: { method: 'POST', params: { templateName: 'smtp' } }
	  });

	  return resource;
	}]);

	angularModule.factory('MailDA', ["localStorageService", "settings", "MailResource", function (localStorageService, settings, MailResource) {
	  return {
	    get: get,
	    update: update,
	    remove: remove,
	    verifySMTP: verifySMTP
	  };

	  function get(templateName) {
	    return MailResource.get({ templateName: templateName }).$promise.then(function (response) {
	      return response.mailTemplate;
	    });
	  }

	  function update(template) {
	    return MailResource.update(template).$promise;
	  }

	  function remove(template) {
	    return MailResource.remove({ templateName: template }).$promise;
	  }

	  function verifySMTP(options) {
	    return MailResource.verifySMTP(options).$promise;
	  }
	}]);

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.messages', []);

	module.exports = angularModule;

	angularModule.factory('MessageResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/office/:officeId/message/:messageId';

	  var resource = $resource(resourceUrl, { messageId: '@_id', officeId: '@office' }, {
	    getAll: { method: 'GET', isArray: false },
	    getOne: { method: 'GET', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('Message', ["$q", "MessageResource", "UserSession", function ($q, MessageResource, UserSession) {
	  return {
	    get: function get(box) {
	      var deferred = $q.defer();

	      MessageResource.getAll({ box: box, officeId: UserSession.getOffice() }).$promise.then(function (response) {
	        deferred.resolve(response.messages);
	      }, function (error) {
	        deferred.reject(error);
	      });
	      return deferred.promise;
	    },
	    getOne: function getOne(messageId) {
	      var deferred = $q.defer();

	      MessageResource.getOne({
	        messageId: messageId,
	        officeId: UserSession.getOffice()
	      }).$promise.then(function (response) {
	        deferred.resolve(response.message);
	      }, function (error) {
	        deferred.reject(error);
	      });

	      return deferred.promise;
	    },
	    delete: function _delete(message) {
	      var message = new MessageResource(message);

	      return message.$delete();
	    }
	  };
	}]);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.payment', []);

	module.exports = angularModule;

	angularModule.factory('PaymentResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/payment/:action/:subaction';

	  var resource = $resource(resourceUrl, {}, {
	    getAll: { method: 'GET', isArray: false, params: {} },
	    getClientToken: { method: 'GET', isArray: false, params: { action: 'clientToken' } },
	    transactionSale: { method: 'POST', params: { action: 'transaction', subaction: 'sale' } }
	  });

	  return resource;
	}]);

	angularModule.factory('PaymentDA', ["$q", "settings", "UserSession", "PaymentResource", function ($q, settings, UserSession, PaymentResource) {
	  var officeId = UserSession.getOffice();

	  return {
	    getClientToken: function getClientToken() {
	      return PaymentResource.getClientToken().$promise;
	    },
	    transactionSale: function transactionSale(data) {
	      return PaymentResource.transactionSale(data).$promise;
	    },
	    getAll: function getAll() {
	      return PaymentResource.getAll({ action: officeId }).$promise;
	    },
	    getInvoiceFilePath: function getInvoiceFilePath(paymentId) {
	      return settings.invoiceFolder + officeId + '/' + paymentId;
	    }
	  };
	}]);

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.shiftPlanning', []);

	module.exports = angularModule;

	angularModule.factory('ShiftPlanningResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/shiftPlanning/:resourceId';

	  var resource = $resource(resourceUrl, {}, {
	    get: { method: 'get' },
	    update: { method: 'put', params: { resourceId: '@resource' } }
	  });

	  return resource;
	}]);

	angularModule.factory('ShiftPlanningDA', ["ShiftPlanningResource", "LoadingIndicatorService", function (ShiftPlanningResource, LoadingIndicatorService) {
	  return {
	    get: get,
	    update: update
	  };

	  function get(resourceId, date) {
	    LoadingIndicatorService.show();
	    return ShiftPlanningResource.get({ resourceId: resourceId, date: date }).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    });
	  }

	  function update(shift) {
	    LoadingIndicatorService.show();
	    return ShiftPlanningResource.update(shift).$promise.then(function (response) {
	      LoadingIndicatorService.hide();
	      return response;
	    });
	  }
	}]);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _regenerator = __webpack_require__(29);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(32);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var angularModule = angular.module('t2g.common.data-access.soft-plus-sync', []);

	module.exports = angularModule;

	angularModule.factory('SoftPlusSyncDA', ["$http", "settings", "$q", "LoadingIndicatorService", "UserSession", function ($http, settings, $q, LoadingIndicatorService, UserSession) {
	  /**
	   * check if SoftPLUS user is syncing
	   */
	  var isSyncing = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
	      var office, _ref2, data;

	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;

	              LoadingIndicatorService.show();
	              office = UserSession.getOffice();
	              _context.next = 5;
	              return $http.get(settings.apiBase + ('/api/v2/soft-plus/' + office));

	            case 5:
	              _ref2 = _context.sent;
	              data = _ref2.data;


	              LoadingIndicatorService.hide();
	              return _context.abrupt('return', data);

	            case 11:
	              _context.prev = 11;
	              _context.t0 = _context['catch'](0);

	              LoadingIndicatorService.hide();
	              return _context.abrupt('return', _context.t0);

	            case 15:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 11]]);
	    }));

	    return function isSyncing() {
	      return _ref.apply(this, arguments);
	    };
	  }();

	  /**
	   * save new SoftPLUS user for syncing
	   * @param {*} softPlusCredentials
	   */
	  var sync = function () {
	    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref3) {
	      var companyGln = _ref3.companyGln;

	      var office, request, _ref5, data;

	      return _regenerator2.default.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;

	              LoadingIndicatorService.show();
	              office = UserSession.getOffice();
	              request = { companyGln: companyGln };
	              _context2.next = 6;
	              return $http.post(settings.apiBase + ('/api/v2/soft-plus/' + office), request);

	            case 6:
	              _ref5 = _context2.sent;
	              data = _ref5.data;


	              LoadingIndicatorService.hide();
	              return _context2.abrupt('return', data);

	            case 12:
	              _context2.prev = 12;
	              _context2.t0 = _context2['catch'](0);

	              LoadingIndicatorService.hide();
	              return _context2.abrupt('return', $q.reject(_context2.t0));

	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 12]]);
	    }));

	    return function sync(_x) {
	      return _ref4.apply(this, arguments);
	    };
	  }();

	  /**
	   * remove SoftPLUS user from syncing
	   */
	  var removeSync = function () {
	    var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	      var office, _ref7, data;

	      return _regenerator2.default.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;

	              LoadingIndicatorService.show();
	              office = UserSession.getOffice();
	              _context3.next = 5;
	              return $http.delete(settings.apiBase + ('/api/v2/soft-plus/' + office));

	            case 5:
	              _ref7 = _context3.sent;
	              data = _ref7.data;


	              LoadingIndicatorService.hide();
	              return _context3.abrupt('return', data);

	            case 11:
	              _context3.prev = 11;
	              _context3.t0 = _context3['catch'](0);

	              LoadingIndicatorService.hide();
	              throw _context3.t0;

	            case 15:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 11]]);
	    }));

	    return function removeSync() {
	      return _ref6.apply(this, arguments);
	    };
	  }();

	  /**
	   * sync SoftPLUS appointments
	   */
	  var syncSoftPLusAppointments = function () {
	    var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	      var office, _ref9, data;

	      return _regenerator2.default.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;

	              LoadingIndicatorService.show();
	              office = UserSession.getOffice();
	              _context4.next = 5;
	              return $http.get(settings.apiBase + ('/api/v2/soft-plus/sync-from-soft-plus-single/' + office));

	            case 5:
	              _ref9 = _context4.sent;
	              data = _ref9.data;


	              LoadingIndicatorService.hide();
	              return _context4.abrupt('return', data);

	            case 11:
	              _context4.prev = 11;
	              _context4.t0 = _context4['catch'](0);

	              LoadingIndicatorService.hide();
	              throw _context4.t0;

	            case 15:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined, [[0, 11]]);
	    }));

	    return function syncSoftPLusAppointments() {
	      return _ref8.apply(this, arguments);
	    };
	  }();

	  return {
	    sync: sync,
	    removeSync: removeSync,
	    isSyncing: isSyncing,
	    syncSoftPLusAppointments: syncSoftPLusAppointments
	  };
	}]);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(30);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g = (function() { return this })() || Function("return this")();

	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;

	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;

	module.exports = __webpack_require__(31);

	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	!(function(global) {
	  "use strict";

	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }

	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);

	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);

	    return generator;
	  }
	  runtime.wrap = wrap;

	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }

	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";

	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};

	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}

	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };

	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }

	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";

	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }

	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };

	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };

	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };

	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }

	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }

	    var previousPromise;

	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }

	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }

	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }

	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;

	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );

	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };

	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;

	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }

	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }

	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }

	      context.method = method;
	      context.arg = arg;

	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }

	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;

	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }

	          context.dispatchException(context.arg);

	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }

	        state = GenStateExecuting;

	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;

	          if (record.arg === ContinueSentinel) {
	            continue;
	          }

	          return {
	            value: record.arg,
	            done: context.done
	          };

	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }

	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;

	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);

	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }

	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }

	      return ContinueSentinel;
	    }

	    var record = tryCatch(method, delegate.iterator, context.arg);

	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    var info = record.arg;

	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }

	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;

	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;

	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }

	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }

	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }

	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);

	  Gp[toStringTagSymbol] = "Generator";

	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };

	  Gp.toString = function() {
	    return "[object Generator]";
	  };

	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };

	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }

	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }

	    this.tryEntries.push(entry);
	  }

	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }

	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }

	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();

	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }

	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };

	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }

	      if (typeof iterable.next === "function") {
	        return iterable;
	      }

	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }

	          next.value = undefined;
	          next.done = true;

	          return next;
	        };

	        return next.next = next;
	      }
	    }

	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;

	  function doneResult() {
	    return { value: undefined, done: true };
	  }

	  Context.prototype = {
	    constructor: Context,

	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;

	      this.method = "next";
	      this.arg = undefined;

	      this.tryEntries.forEach(resetTryEntry);

	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },

	    stop: function() {
	      this.done = true;

	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }

	      return this.rval;
	    },

	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }

	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;

	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }

	        return !! caught;
	      }

	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;

	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }

	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");

	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }

	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }

	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },

	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }

	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }

	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;

	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }

	      return this.complete(record);
	    },

	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }

	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }

	      return ContinueSentinel;
	    },

	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },

	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }

	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },

	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };

	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }

	      return ContinueSentinel;
	    }
	  };
	})(
	  // In sloppy mode, unbound `this` refers to the global object, fallback to
	  // Function constructor if we're in global strict mode. That is sadly a form
	  // of indirect eval which violates Content Security Policy.
	  (function() { return this })() || Function("return this")()
	);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	exports.__esModule = true;

	var _promise = __webpack_require__(33);

	var _promise2 = _interopRequireDefault(_promise);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	exports.default = function (fn) {
	  return function () {
	    var gen = fn.apply(this, arguments);
	    return new _promise2.default(function (resolve, reject) {
	      function step(key, arg) {
	        try {
	          var info = gen[key](arg);
	          var value = info.value;
	        } catch (error) {
	          reject(error);
	          return;
	        }

	        if (info.done) {
	          resolve(value);
	        } else {
	          return _promise2.default.resolve(value).then(function (value) {
	            step("next", value);
	          }, function (err) {
	            step("throw", err);
	          });
	        }
	      }

	      return step("next");
	    });
	  };
	};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(34), __esModule: true };

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(35);
	__webpack_require__(36);
	__webpack_require__(80);
	__webpack_require__(84);
	__webpack_require__(102);
	__webpack_require__(103);
	module.exports = __webpack_require__(44).Promise;


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(37)(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(40)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var defined = __webpack_require__(39);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(41);
	var $export = __webpack_require__(42);
	var redefine = __webpack_require__(58);
	var hide = __webpack_require__(47);
	var Iterators = __webpack_require__(59);
	var $iterCreate = __webpack_require__(60);
	var setToStringTag = __webpack_require__(76);
	var getPrototypeOf = __webpack_require__(78);
	var ITERATOR = __webpack_require__(77)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(43);
	var core = __webpack_require__(44);
	var ctx = __webpack_require__(45);
	var hide = __webpack_require__(47);
	var has = __webpack_require__(57);
	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 44 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(46);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(48);
	var createDesc = __webpack_require__(56);
	module.exports = __webpack_require__(52) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(49);
	var IE8_DOM_DEFINE = __webpack_require__(51);
	var toPrimitive = __webpack_require__(55);
	var dP = Object.defineProperty;

	exports.f = __webpack_require__(52) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(52) && !__webpack_require__(53)(function () {
	  return Object.defineProperty(__webpack_require__(54)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(53)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50);
	var document = __webpack_require__(43).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(50);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(47);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(61);
	var descriptor = __webpack_require__(56);
	var setToStringTag = __webpack_require__(76);
	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(47)(IteratorPrototype, __webpack_require__(77)('iterator'), function () { return this; });

	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(49);
	var dPs = __webpack_require__(62);
	var enumBugKeys = __webpack_require__(74);
	var IE_PROTO = __webpack_require__(71)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(54)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(75).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};

	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(48);
	var anObject = __webpack_require__(49);
	var getKeys = __webpack_require__(63);

	module.exports = __webpack_require__(52) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(64);
	var enumBugKeys = __webpack_require__(74);

	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(57);
	var toIObject = __webpack_require__(65);
	var arrayIndexOf = __webpack_require__(68)(false);
	var IE_PROTO = __webpack_require__(71)('IE_PROTO');

	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(66);
	var defined = __webpack_require__(39);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(67);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports) {

	var toString = {}.toString;

	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(65);
	var toLength = __webpack_require__(69);
	var toAbsoluteIndex = __webpack_require__(70);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(38);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(38);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(72)('keys');
	var uid = __webpack_require__(73);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(44);
	var global = __webpack_require__(43);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(41) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 73 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(43).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(48).f;
	var has = __webpack_require__(57);
	var TAG = __webpack_require__(77)('toStringTag');

	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(72)('wks');
	var uid = __webpack_require__(73);
	var Symbol = __webpack_require__(43).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};

	$exports.store = store;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(57);
	var toObject = __webpack_require__(79);
	var IE_PROTO = __webpack_require__(71)('IE_PROTO');
	var ObjectProto = Object.prototype;

	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(39);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(81);
	var global = __webpack_require__(43);
	var hide = __webpack_require__(47);
	var Iterators = __webpack_require__(59);
	var TO_STRING_TAG = __webpack_require__(77)('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(82);
	var step = __webpack_require__(83);
	var Iterators = __webpack_require__(59);
	var toIObject = __webpack_require__(65);

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(40)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;

	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(41);
	var global = __webpack_require__(43);
	var ctx = __webpack_require__(45);
	var classof = __webpack_require__(85);
	var $export = __webpack_require__(42);
	var isObject = __webpack_require__(50);
	var aFunction = __webpack_require__(46);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var speciesConstructor = __webpack_require__(91);
	var task = __webpack_require__(92).set;
	var microtask = __webpack_require__(94)();
	var newPromiseCapabilityModule = __webpack_require__(95);
	var perform = __webpack_require__(96);
	var userAgent = __webpack_require__(97);
	var promiseResolve = __webpack_require__(98);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(77)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(99)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(76)($Promise, PROMISE);
	__webpack_require__(100)(PROMISE);
	Wrapper = __webpack_require__(44)[PROMISE];

	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(101)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(67);
	var TAG = __webpack_require__(77)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(45);
	var call = __webpack_require__(88);
	var isArrayIter = __webpack_require__(89);
	var anObject = __webpack_require__(49);
	var toLength = __webpack_require__(69);
	var getIterFn = __webpack_require__(90);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(49);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(59);
	var ITERATOR = __webpack_require__(77)('iterator');
	var ArrayProto = Array.prototype;

	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(85);
	var ITERATOR = __webpack_require__(77)('iterator');
	var Iterators = __webpack_require__(59);
	module.exports = __webpack_require__(44).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(49);
	var aFunction = __webpack_require__(46);
	var SPECIES = __webpack_require__(77)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(45);
	var invoke = __webpack_require__(93);
	var html = __webpack_require__(75);
	var cel = __webpack_require__(54);
	var global = __webpack_require__(43);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(67)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(43);
	var macrotask = __webpack_require__(92).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(67)(process) == 'process';

	module.exports = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(46);

	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}

	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(43);
	var navigator = global.navigator;

	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(49);
	var isObject = __webpack_require__(50);
	var newPromiseCapability = __webpack_require__(95);

	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var hide = __webpack_require__(47);
	module.exports = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else hide(target, key, src[key]);
	  } return target;
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(43);
	var core = __webpack_require__(44);
	var dP = __webpack_require__(48);
	var DESCRIPTORS = __webpack_require__(52);
	var SPECIES = __webpack_require__(77)('species');

	module.exports = function (KEY) {
	  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(77)('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(42);
	var core = __webpack_require__(44);
	var global = __webpack_require__(43);
	var speciesConstructor = __webpack_require__(91);
	var promiseResolve = __webpack_require__(98);

	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(42);
	var newPromiseCapability = __webpack_require__(95);
	var perform = __webpack_require__(96);

	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.statistic', []);

	module.exports = angularModule;

	angularModule.factory('StatisticResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/statistic/:kpi';

	  var resource = $resource(resourceUrl, {}, {});

	  return resource;
	}]);

	angularModule.factory('StatisticDA', ["StatisticResource", function (StatisticResource) {
	  return {
	    getSales: function getSales(start, end, resolution) {
	      return StatisticResource.get({ kpi: 'sales', start: start, end: end, resolution: resolution }).$promise;
	    }
	  };
	}]);

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.subscription', ['ngResource', __webpack_require__(1).name, __webpack_require__(6).name, __webpack_require__(5).name]);

	module.exports = angularModule;

	angularModule.factory('SubscriptionResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/subscription/:subResource1/:subResource2/:subResource3';

	  var resource = $resource(resourceUrl, {}, {
	    getPrice: { method: 'GET', isArray: false, params: { subResource1: 'prices' } },
	    getCustomerToken: {
	      method: 'GET',
	      isArray: false,
	      params: { subResource1: 'billwerk', subResource2: 'customerToken' }
	    },
	    upDownGrade: { method: 'POST', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('SubscriptionDA', ["localStorageService", "settings", "SubscriptionResource", function (localStorageService, settings, SubscriptionResource) {
	  return {
	    get: get,
	    getPrice: getPrice,
	    getCustomerToken: getCustomerToken,
	    upDownGrade: upDownGrade
	  };

	  function get() {
	    return SubscriptionResource.get().$promise.then(function (response) {
	      var subscription = response.subscription;
	      var onlyBasicFunctions = false;

	      if (subscription.empty && subscription.trialDaysLeft === 0) {
	        onlyBasicFunctions = true;
	      } else {
	        onlyBasicFunctions = subscription.package === 'basic';
	      }

	      subscription.onlyBasicFunctions = onlyBasicFunctions;

	      return subscription;
	    });
	  }

	  function getPrice(countryCode, employees) {
	    return SubscriptionResource.getPrice({
	      subResource2: countryCode,
	      subResource3: employees
	    }).$promise.then(function (response) {
	      return response.prices;
	    });
	  }

	  function getCustomerToken() {
	    return SubscriptionResource.getCustomerToken().$promise.then(function (response) {
	      return response.customerToken;
	    });
	  }

	  function upDownGrade(upDownGradeDate) {
	    return SubscriptionResource.upDownGrade(upDownGradeDate).$promise.then(function (response) {
	      return response.upDownGrade;
	    });
	  }
	}]);

/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.sync', []);

	module.exports = angularModule;

	angularModule.factory('SyncResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/sync/:resource/:sync';

	  var resource = $resource(resourceUrl, {}, {
	    insert: { method: 'POST' },
	    update: { method: 'PUT' },
	    runSync: { method: 'POST' },
	    get: { method: 'GET', isArray: false },
	    delete: { method: 'delete' }
	  });

	  return resource;
	}]);

	angularModule.factory('SyncDA', ["$q", "SyncResource", function ($q, SyncResource) {
	  return {
	    get: function get(resource) {
	      return SyncResource.get({ resource: resource }).$promise;
	    },
	    insert: function insert(resource, sync) {
	      return SyncResource.insert({ resource: resource }, sync).$promise;
	    },
	    delete: function _delete(resource, syncId) {
	      return SyncResource.delete({ resource: resource, sync: syncId }).$promise;
	    },
	    update: function update(resource, syncId, sync) {
	      return SyncResource.update({ resource: resource, sync: syncId }, sync).$promise;
	    },
	    runSync: function runSync(resource, syncId) {
	      return SyncResource.runSync({ resource: resource, sync: syncId }, null).$promise.then(function (response) {
	        return response;
	      }, function (response) {
	        return $q.reject(response);
	      });
	    }
	  };
	}]);

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.resource', []);

	module.exports = angularModule;

	angularModule.factory('ResourceResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/resource/:resourceId';

	  var resource = $resource(resourceUrl, {}, {
	    insert: { method: 'post' },
	    remove: { method: 'delete' },
	    list: { method: 'get' },
	    get: { method: 'get' },
	    update: { method: 'put', params: { resourceId: '@_id' } },
	    refreshCalendarAddress: { method: 'post', params: { resourceId: 'refreshCalendarAddress' } }
	  });

	  return resource;
	}]);

	angularModule.factory('ResourceDA', ["$q", "ResourceResource", function ($q, ResourceResource) {
	  var resourceCache = [];

	  return {
	    clearCache: clearCache,
	    get: get,
	    insert: insert,
	    list: list,
	    remove: remove,
	    update: update,
	    refreshCalendarAddress: refreshCalendarAddress
	  };

	  function refreshCalendarAddress(resourceId) {
	    return ResourceResource.refreshCalendarAddress({ resourceId: resourceId }).$promise.then(function (response) {
	      _.remove(resourceCache, { _id: resourceId });
	      resourceCache.push(response.resource);
	      return response.resource;
	    });
	  }

	  function clearCache() {
	    resourceCache = [];
	  }

	  function get(resourceId) {
	    return ResourceResource.get({ resourceId: resourceId }).$promise;
	  }

	  function insert(resource) {
	    return ResourceResource.insert(resource).$promise.then(function (response) {
	      resourceCache.push(response.resource);
	      return response.resource;
	    });
	  }

	  function list(type) {
	    var filter = {};

	    if (type) {
	      filter.type = type;
	    }

	    if (resourceCache.length > 0) {
	      return $q.when({
	        resources: _.filter(resourceCache, filter)
	      });
	    } else {
	      return ResourceResource.list().$promise.then(function (response) {
	        resourceCache = response.resources;
	        return {
	          resources: _.filter(response.resources, filter)
	        };
	      });
	    }
	  }

	  function remove(resourceId) {
	    return ResourceResource.remove({ resourceId: resourceId }).$promise.then(function () {
	      _.remove(resourceCache, { _id: resourceId });
	      return true;
	    });
	  }

	  function update(resource) {
	    return ResourceResource.update(resource).$promise;
	  }
	}]);

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.office', ['ngResource', __webpack_require__(3).name, __webpack_require__(6).name, __webpack_require__(5).name]);

	module.exports = angularModule;

	angularModule.factory('OfficeResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/office/:officeId/:embeddedDocument';

	  var resource = $resource(resourceUrl, {}, {
	    update: { method: 'PUT' },
	    deleteImage: { method: 'DELETE' }
	  });

	  return resource;
	}]);

	angularModule.factory('OfficeDA', ["$q", "$rootScope", "gettextCatalog", "OfficeResource", "OfficeCache", "UserSession", function ($q, $rootScope, gettextCatalog, OfficeResource, OfficeCache, UserSession) {
	  return {
	    get: get,
	    update: update
	  };

	  function get() {
	    var cachedOffice = OfficeCache.get('office');

	    if (cachedOffice === undefined) {
	      return OfficeResource.get({ officeId: UserSession.getOffice() }).$promise.then(function (response) {
	        var userSession = UserSession.get();

	        OfficeCache.put('office', response);

	        if (response.billing) {
	          userSession.account = response.billing.account;
	        }

	        UserSession.set(userSession);

	        return response;
	      }).catch(function (error) {
	        return $q.reject('cant load office data: ' + error);
	      });
	    } else {
	      return $q.when(cachedOffice);
	    }
	  }

	  function update(office) {
	    return OfficeResource.update({ officeId: UserSession.getOffice() }, office).$promise.then(function (response) {
	      OfficeCache.remove('office');
	      OfficeCache.put('office', response);
	      $rootScope.$broadcast('Office:update', response);

	      return response;
	    }).catch(function (error) {
	      return $q.reject('cant update office data: ' + error);
	    });
	  }
	}]);

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.user-session', []);

	module.exports = angularModule;

	angularModule.factory('UserSessionResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/user/:resource';

	  var resource = $resource(resourceUrl, {}, {
	    ping: { method: 'GET', params: { resource: 'ping' } }
	  });

	  return resource;
	}]);

	angularModule.factory('UserSessionDA', ["UserSession", "UserSessionResource", function (UserSession, UserSessionResource) {
	  return {
	    ping: ping
	  };

	  function ping() {
	    return UserSessionResource.ping().$promise.then(function (response) {
	      return UserSession.qSet(response.session);
	    });
	  }
	}]);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.tarif590', []);

	module.exports = angularModule;

	angularModule.factory('Tarif590Resource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/tarif590';

	  var resource = $resource(resourceUrl, {}, {
	    list: { method: 'GET', isArray: false }
	  });

	  return resource;
	}]);

	angularModule.factory('Tarif590DA', ["$q", "Tarif590Resource", function ($q, Tarif590Resource) {
	  var services;

	  return {
	    list: function list() {
	      if (services) {
	        return $q.when(services);
	      } else {
	        return Tarif590Resource.list().$promise.then(function (response) {
	          services = response.services;
	          return services;
	        });
	      }
	    }
	  };
	}]);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives', [__webpack_require__(112).name, __webpack_require__(113).name, __webpack_require__(114).name, __webpack_require__(115).name, __webpack_require__(116).name, __webpack_require__(117).name, __webpack_require__(118).name, __webpack_require__(119).name, __webpack_require__(120).name, __webpack_require__(121).name,
	// require('./moneyMaskDirective').name,
	__webpack_require__(122).name, __webpack_require__(123).name, __webpack_require__(124).name, __webpack_require__(125).name, __webpack_require__(126).name, __webpack_require__(127).name, __webpack_require__(128).name, __webpack_require__(129).name, __webpack_require__(130).name, __webpack_require__(131).name, __webpack_require__(132).name, __webpack_require__(133).name, __webpack_require__(134).name, __webpack_require__(135).name, __webpack_require__(136).name, __webpack_require__(137).name]);

	module.exports = angularModule;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.auto-expand', []);

	module.exports = angularModule;

	angularModule.directive('autoExpand', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $element.on('keydown', function () {
	        $element[0].style.cssText = 'height:' + Math.max($element[0].scrollHeight, 62) + 'px';
	      });
	    }
	  };
	});

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.autoFillFixDirective', []);

	module.exports = angularModule;

	angularModule.directive('autoFillFix', function () {
	  return {
	    restrict: 'A',
	    priority: 10,
	    link: function link($scope, element, attrs) {
	      element.on('submit', function (ev) {
	        $('input[ng-model]', element).each(function (index, item) {
	          if (angular.element(this).attr('type') !== 'checkbox' && angular.element(this).attr('type') !== 'radio') {
	            angular.element(this).controller('ngModel').$setViewValue($(this).val());
	          }
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.capitalizeDirective', []);

	module.exports = angularModule;

	angularModule.directive('capitalize', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link($scope, $element, $attributes, ngModel) {
	      var capitalize = function capitalize(inputValue) {
	        var capitalized = inputValue.toUpperCase();

	        if (capitalized !== inputValue) {
	          ngModel.$setViewValue(capitalized);
	          ngModel.$render(capitalized);
	        }

	        return capitalized;
	      };

	      if (ngModel) {
	        ngModel.$parsers.push(capitalize);
	      }
	    }
	  };
	});

	angularModule.directive('capitalizeFirst', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link($scope, $element, $attributes, ngModel) {
	      var capitalize = function capitalize(inputValue) {
	        if (!inputValue) return;

	        var capitalized = inputValue.charAt(0).toUpperCase() + inputValue.substring(1);

	        if (capitalized !== inputValue) {
	          ngModel.$setViewValue(capitalized);
	          ngModel.$render();
	        }

	        return capitalized;
	      };

	      ngModel.$parsers.push(capitalize);
	      capitalize($scope[$attributes.ngModel]); // capitalize initial value
	    }
	  };
	});

/***/ }),
/* 115 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.colorpicker', []);

	module.exports = angularModule;

	angularModule.directive('colorpicker', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'E',
	    require: '?ngModel',
	    replace: true,
	    scope: {
	      parentModel: '=ngModel',
	      disablePicker: '=disable'
	    },
	    template: '<div class="input-group"><input type="text" class="form-control" name="foreground" id="foreground" ng-model="parentModel" ng-disabled="disablePicker"><span class="input-group-addon"><i></i></span></div>',
	    link: function link($scope, $element, $attributes, $ngModel) {
	      $element.colorpicker().on('changeColor', function (event) {
	        $scope.ngModel = event.color.toHex();
	        $ngModel.$setViewValue($scope.ngModel);
	      });

	      $timeout(function () {
	        if ($ngModel.$modelValue) {
	          $element.colorpicker('setValue', $ngModel.$modelValue);
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.confirmButtonDirective', ['gettext']);

	module.exports = angularModule;

	angularModule.directive('confirmButton', ["$compile", "gettextCatalog", function ($compile, gettextCatalog) {
	  return {
	    restrict: 'E',
	    replace: true,
	    scope: {
	      action: '&',
	      message: '@',
	      placement: '@'
	    },
	    link: function link($scope, $element) {
	      var settings = {
	        action: $scope.action,
	        placement: $scope.placement || 'top',
	        message: $scope.message || gettextCatalog.getString('realy?'),
	        yes: gettextCatalog.getString('yes'),
	        no: gettextCatalog.getString('no')
	      };

	      /**
	       * hide the popover
	       */
	      var hidePopover = function hidePopover() {
	        $element.popover('hide');
	      };

	      $element.popover({
	        title: gettextCatalog.getString('warning'),
	        trigger: 'click',
	        placement: settings.placement,
	        container: $element,
	        html: true,
	        content: $compile('<p class="deletebutton-message">' + settings.message + '</p><p class="deletebutton-message"><button class="btn btn-danger" ng-click="confirm()">' + settings.yes + '</button><button class="btn" ng-click="deny()">' + settings.no + '</button></p>')($scope)
	      }).on('click', '.popover', function (event) {
	        event.stopPropagation();
	        event.preventDefault();
	      });

	      /**
	       * close the popover if messages was denied
	       */
	      $scope.deny = function () {
	        hidePopover();
	      };

	      /**
	       * run action if message was confirmed
	       */
	      $scope.confirm = function () {
	        hidePopover();

	        if (settings.action) {
	          $scope.$eval(settings.action);
	        }
	      };

	      /**
	       * GC
	       */
	      $scope.$on('$destroy', function () {
	        $element.off();
	      });
	    }
	  };
	}]);

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.fab', []);
	var SHOW_CLASS = 'show';

	module.exports = angularModule;

	angularModule.directive('fabContainer', ["$interval", function ($interval) {
	  return {
	    restrict: 'E',
	    controller: ["$scope", function controller($scope) {
	      var fabItems = $scope.fabItems = [];

	      this.addFabItem = function (fabItem) {
	        fabItems.push(fabItem);
	      };
	    }],
	    link: function link($scope, $element, $attributes) {
	      var show = false;
	      var fixedOnXS = $element.hasClass('floating-button--fixed-on-xs');
	      var isMobile = $element.css('position') === 'fixed';
	      var reverse = !fixedOnXS || fixedOnXS && isMobile;

	      var handleClick = function handleClick() {
	        var index = 0;
	        var len = $scope.fabItems.length;
	        var items = reverse ? $scope.fabItems.reverse() : $scope.fabItems;
	        var fn = function fn() {
	          if (len > 1) {
	            items[index++].toggleItem();
	          }
	        };

	        if (show) {
	          angular.forEach(items, function (item) {
	            item.toggleItem();
	          });
	        } else {
	          $interval(fn, 75, len, true);
	        }

	        show = !show;
	      };

	      $element.on('click', handleClick);

	      $scope.$on('$destroy', function () {
	        $element.off('click');
	      });
	    }
	  };
	}]);

	angularModule.directive('fabItem', function () {
	  return {
	    restrict: 'E',
	    require: '^fabContainer',
	    scope: {},
	    link: function link($scope, $element, $attributes, fabContainerController) {
	      fabContainerController.addFabItem($scope);

	      $scope.toggleItem = function () {
	        $element.toggleClass(SHOW_CLASS);
	      };
	    }
	  };
	});

/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.fakeClick', []);

	module.exports = angularModule;

	angularModule.directive('fakeClick', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      $element.on('click', function () {
	        $($attributes.fakeClick).click();
	      });

	      $scope.$on('$destroy', function () {
	        $element.off();
	      });
	    }
	  };
	});

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.focusDirective', []);

	module.exports = angularModule;

	angularModule.directive('focus', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $timeout(function () {
	        $element.focus();
	      }, 1);
	    }
	  };
	}]);

/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.horizontalFixed', []);

	module.exports = angularModule;

	angularModule.directive('horizontalFixed', function HorizontalFixedDirective() {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      $attributes.$observe('horizontalFixed', function (selector) {
	        var elSelector = window;

	        $(elSelector).scroll(function (event) {
	          $element.css({
	            left: $(this).scrollLeft()
	          });
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.menu', []);

	module.exports = angularModule;

	angularModule.run(["$templateCache", function ($templateCache) {
	  $templateCache.put('MenuPartial.html', '<div class="menu">' + '<ul class="menu-items">' + '<li class="menu-item" data-ng-repeat="item in items" data-ng-class="{\'menu-item--seperator\': item.seperator}">' + '<button class="menu-item__action waves" type="button" data-ng-click="invokeAction($event, item)">' + '<span class="menu-item__action__icon" data-ng-class="item.icon"></span>' + '{{item.label}}' + '</button>' + '</li>' + '</ul>' + '</div>');
	}]);

	angularModule.factory('menuState', function () {
	  var currentMenu = null;

	  return {
	    setCurrentMenu: function setCurrentMenu(menu) {
	      currentMenu = menu;
	    },
	    getCurrentMenu: function getCurrentMenu() {
	      return currentMenu;
	    }
	  };
	});

	angularModule.directive('menu', ["$templateCache", "$timeout", "$compile", "$document", "$rootScope", "menuState", "AppointmentDragAndResizeState", function ($templateCache, $timeout, $compile, $document, $rootScope, menuState, AppointmentDragAndResizeState) {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      var menuTemplate = $templateCache.get('MenuPartial.html');
	      var menuElement;
	      var body = document.querySelector('body');
	      var options = $scope.$eval($attributes.menu);
	      var metaData = $scope.$eval($attributes.menuMetaData);
	      var isOpen = false;
	      var originalEvent = null;
	      var offset = 15;
	      $scope.items = options.items;

	      $scope.invokeAction = function ($event, item) {
	        if (item.action) {
	          item.action($event, originalEvent, metaData);
	        }
	        $scope.removeMenu();
	        $event.stopPropagation();
	      };

	      // send event to close all open context menus
	      $document.on('click contextmenu', function (event) {
	        if (!event.target.matches('.menu-item__action')) {
	          closeOpenMenu();
	        }
	      });

	      $element.on(options.event, function (event) {
	        if (!isOpen) {
	          closeOpenMenu();
	          originalEvent = event;
	          showMenu(event);
	          event.preventDefault();
	          event.stopPropagation();
	        }
	      });

	      // clean up listeners
	      $scope.$on('$destroy', function () {
	        $scope.removeMenu();
	        $element.off(options.event);
	        $document.off('contextmenu');
	      });

	      $scope.removeMenu = function () {
	        if (menuElement) {
	          menuElement.remove();
	          isOpen = false;
	          menuState.setCurrentMenu(null);
	        }
	      };

	      function closeOpenMenu() {
	        var currentMenu = menuState.getCurrentMenu();

	        if (currentMenu) {
	          currentMenu.removeMenu();
	        }
	      }

	      /**
	       * show context menu at given position
	       * @param {Number} x
	       * @param {Number} y
	       */
	      function showMenu(event) {
	        var menuSize;
	        var x;
	        var y;
	        var distanceX;
	        var distanceY;
	        var menuHeight;
	        var menuWidth;
	        var left;
	        var top;

	        if (!AppointmentDragAndResizeState.isActive()) {
	          // check opening direction
	          menuElement = $compile(menuTemplate)($scope);
	          $scope.$digest();
	          body.appendChild(menuElement[0]);
	          menuSize = menuElement[0].getBoundingClientRect();

	          x = event.clientX;
	          y = event.clientY;
	          menuWidth = menuSize.width;
	          menuHeight = menuSize.height;
	          distanceX = window.innerWidth - x - offset;
	          distanceY = window.innerHeight - y - offset;

	          if (distanceX < menuWidth) {
	            left = x - menuWidth;
	          } else {
	            left = x;
	          }

	          if (distanceY < menuHeight) {
	            top = y - menuHeight;
	          } else {
	            top = y;
	          }

	          menuElement.css('left', left + 'px');
	          menuElement.css('top', top + 'px');

	          isOpen = true;
	          menuState.setCurrentMenu($scope);
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';

	var navigationModule = angular.module('t2g.common.directives.navigation', []);

	module.exports = navigationModule;

	var allowedRoles = {
	  admin: ['admin'],
	  manager: ['admin', 'manager'],
	  employee: ['admin', 'manager', 'employee'],
	  viewer: ['admin', 'manager', 'employee', 'viewer']
	};

	navigationModule.directive('navigation', ["$document", "$compile", "navigationSettings", function ($document, $compile, navigationSettings) {
	  return {
	    restrict: 'E',
	    template: '' + '<div class="navbar-offcanvas" off-canvas>' + '   <a href="https://www.sanasearch.ch/de/mein-profil/"><div class="navbar-logo"></div></a>' + '   <ul class="navbar-offcanvas-nav">' + '       <li data-ng-repeat="topItem in navigation" data-ng-class="{\'nav-item-notification\': topItem.notification, \'nav-item-highlight\': topItem.highlight}">' + '           <navigation-item href="#" role="button">' + '               <i class="{{::topItem.icon}}"></i>{{::topItem.label}}' + '           </navigation-item>' + '       </li>' + '   </ul>' + '</div>',
	    controller: ["$scope", "$element", "$interpolate", function controller($scope, $element, $interpolate) {
	      function enrichNavigationItem(item) {
	        if (/{{.*}}/.test(item.label)) {
	          item.label = $interpolate(item.label)($scope);
	        }

	        if (item.notification) {
	          item.notification = $scope.$eval(item.notification);
	        }

	        return item;
	      }

	      _.map(navigationSettings, function (navigationSettingsItem) {
	        navigationSettingsItem = enrichNavigationItem(navigationSettingsItem);

	        if (navigationSettingsItem.subMenu) {
	          _.map(navigationSettingsItem.subMenu, enrichNavigationItem);
	        }

	        return navigationSettingsItem;
	      });

	      $scope.navigation = navigationSettings;

	      $scope.checkRole = function (minimumRole) {
	        var role = _.get($scope.user, 'role');
	        var authorized = false;

	        if (role && allowedRoles[minimumRole].indexOf(role) !== -1) {
	          authorized = true;
	        }

	        return authorized;
	      };
	    }],
	    link: function link($scope, $element) {}
	  };
	}]);

	navigationModule.directive('navigationItem', ["$state", "$transitions", function ($state, $transitions) {
	  return {
	    restrict: 'E',
	    replace: true,
	    transclude: true,
	    template: '<a ng-transclude></a>',
	    link: function link($scope, $element) {
	      var subMenuContainer;
	      var subMenuList;
	      var bookingsBadge;

	      if ($scope.topItem.role && !$scope.checkRole($scope.topItem.role) || $scope.topItem.show && !$scope.$eval($scope.topItem.show)) {
	        $element.remove();
	        return;
	      }

	      if ($state.current.name.indexOf($scope.topItem.state) > -1) {
	        $element[0].classList.add('active');
	      }

	      if ($scope.topItem.state === 'private.main.booking') {
	        // generate badge for not processed bookings count
	        bookingsBadge = document.createElement('span');
	        bookingsBadge.setAttribute('class', 'badge');
	        $element[0].parentNode.appendChild(bookingsBadge);

	        // update number in the badge on updateBookingsBadge event
	        $scope.$on('updateBookingsBadge', function (event, notProcessedBookings) {
	          bookingsBadge.innerText = notProcessedBookings > 9 ? '9+' : notProcessedBookings || '';
	        });
	      }

	      if ($scope.topItem.subMenu) {
	        $element.addClass('has-submenu');
	        $element[0].href = '#';

	        // generate sub menu
	        subMenuContainer = document.createElement('div');
	        subMenuContainer.setAttribute('class', 'navbar-submenu-wrapper');
	        subMenuList = document.createElement('ul');

	        _.forEach($scope.topItem.subMenu, function (subMenuItem) {
	          if (subMenuItem.role && !$scope.checkRole(subMenuItem.role)) {
	            return;
	          }

	          var subMenuListItem = document.createElement('li');
	          var subMenuItemLink = document.createElement('a');
	          var subMenuItemText = document.createTextNode(subMenuItem.label);

	          if (subMenuItem.notification) {
	            subMenuListItem.classList.add('nav-item-notification');
	          }

	          if ($state.current.name.indexOf(subMenuItem.state) > -1) {
	            $element[0].classList.add('active');
	          }

	          subMenuItemLink.href = $state.href(subMenuItem.state, subMenuItem.stateParams, {
	            inherit: false
	          });
	          subMenuItemLink.appendChild(subMenuItemText);
	          subMenuListItem.appendChild(subMenuItemLink);
	          subMenuList.appendChild(subMenuListItem);
	        });

	        subMenuContainer.appendChild(subMenuList);
	        $element[0].parentNode.appendChild(subMenuContainer);
	      } else if ($scope.topItem.state) {
	        if ($scope.topItem.state !== 'private.main.calendar') {
	          $element[0].href = $state.href($scope.topItem.state, $scope.topItem.stateParams, {
	            inherit: false
	          });
	        } else {
	          $element[0].href = '#/private/main/calendar';
	        }
	      }

	      _.forEach($scope.topItem.attributes, function (value, key) {
	        $element[0].setAttribute(key, value);
	      });

	      $element.on('click', function (event) {
	        if ($('.navbar').is(':visible') || !_.get($scope, 'topItem.subMenu.length')) {
	          return;
	        }

	        if ($(subMenuContainer).hasClass('in')) {
	          $(subMenuContainer).removeClass('in');
	          $('body').removeClass('nav-open');
	        } else {
	          $('.in').removeClass('in');
	          $(subMenuContainer).addClass('in');
	          $('body').addClass('nav-open');
	        }

	        event.stopPropagation();

	        if ($scope.topItem.subMenu) {
	          event.preventDefault();
	        }
	      });

	      $transitions.onSuccess({}, function (transition) {
	        var toState = transition.to().name || '';
	        var activeItemIndex = _.findIndex($scope.topItem.subMenu, function (subMenuItem) {
	          return toState.indexOf(subMenuItem.state) > -1;
	        });

	        if (activeItemIndex > -1 || toState.indexOf($scope.topItem.state) > -1) {
	          $element[0].classList.add('active');
	        } else {
	          $element[0].classList.remove('active');
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.numberInput', []);

	module.exports = angularModule;

	angularModule.directive('numberInput', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link($scope, $element, $attributes, $ngModelController) {
	      $ngModelController.$parsers.push(function (inputValue) {
	        var transformedInput = inputValue.replace(/[^0-9\.]+/g, '');

	        if (transformedInput != inputValue) {
	          $ngModelController.$setViewValue(transformedInput);
	          $ngModelController.$render();
	        }

	        return transformedInput;
	      });
	    }
	  };
	});

/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.offCanvas', []);

	module.exports = angularModule;

	angularModule.directive('offCanvas', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      var subMenus = $element.find('.has-submenu');

	      $(function () {
	        $('.has-submenu').click(function (event) {
	          // submenu is always open on mobile devices
	          if ($('.navbar').is(':visible')) {
	            return;
	          }

	          var $that = $(this);
	          var target = $that.data('target');

	          if ($(target).hasClass('in')) {
	            $(target).removeClass('in');
	            $('body').removeClass('nav-open');
	          } else {
	            $('.in').removeClass('in');
	            $(target).addClass('in');
	            $('body').addClass('nav-open');
	          }

	          event.stopPropagation();
	          event.preventDefault();
	        });

	        // if mouse will be clicked outside navigation, close submenu
	        $(document).click(function () {
	          $element.find('.in').removeClass('in');
	          $('body').removeClass('nav-open');
	        });

	        // handle navigation on mobile devices
	        $('.navbar-menu-toggle').click(function (event) {
	          $('body').toggleClass('nav-open');

	          event.stopPropagation();
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.onEnterDirective', []);

	module.exports = angularModule;

	angularModule.directive('onEnter', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element, $attributes) {
	      $element.bind('keydown keypress', function (event) {
	        if (event.which === 13) {
	          $scope.$apply(function () {
	            $scope.$eval($attributes.onEnter);
	          });

	          event.preventDefault();
	        }
	      });
	    }
	  };
	});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.onResize', []);

	module.exports = angularModule;

	angularModule.directive('onResize', ["$window", function ($window) {
	  return {
	    link: function link($scope) {
	      var wait = 250;

	      function onResize() {
	        $scope.$broadcast('t2g:window:resize');
	      }

	      function cleanUp() {
	        angular.element($window).off('resize', onResize);
	      }

	      angular.element($window).on('resize', $window._.debounce(onResize, wait));

	      $scope.$on('$destroy', cleanUp);
	    }
	  };
	}]);

/***/ }),
/* 127 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.onScrollDirective', []);

	module.exports = angularModule;

	angularModule.directive('onScroll', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $(window).on('scroll', function () {
	        if ($(window).scrollTop() > 0) {
	          $element.addClass('shadow');
	        } else {
	          $element.removeClass('shadow');
	        }
	      });

	      $scope.$on('$destroy', function () {
	        $element.off();
	      });
	    }
	  };
	});

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.pwCheck', []);

	module.exports = angularModule;

	angularModule.directive('pwCheck', function () {
	  return {
	    require: 'ngModel',
	    link: function link(scope, elem, attrs, ngModel) {
	      var firstPassword = '#' + attrs.pwCheck;
	      elem.add(firstPassword).on('keyup', function () {
	        scope.$apply(function () {
	          var v = elem.val() === $(firstPassword).val();
	          ngModel.$setValidity('pwmatch', v);
	        });
	      });
	    }
	  };
	});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.priceInputDirective', []);

	module.exports = angularModule;

	angularModule.directive('priceInput', function () {
	  return {
	    restrict: 'A',
	    require: 'ngModel',
	    link: function link($scope, $element, $attributes, ngModelController) {
	      ngModelController.$parsers.push(function (data) {
	        var floatyValue = data.toString().trim().replace(',', '.').replace(/[^\d.,]/g, '');
	        var floatValue = parseFloat(floatyValue);
	        var stringValue = !isNaN(floatValue) ? floatyValue : '';
	        var modelValue = !isNaN(floatValue) ? floatValue : undefined;

	        ngModelController.$setViewValue(stringValue);
	        ngModelController.$commitViewValue();
	        ngModelController.$render();

	        return modelValue;
	      });
	    }
	  };
	});

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.radioButtonDirective', []);

	module.exports = angularModule;

	angularModule.directive('radio', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    link: function link($scope, $element, $attributes, ngModel) {
	      var value = $attributes.radio;

	      $timeout(function () {
	        if (ngModel.$modelValue === value) {
	          $element.addClass('button--secondary');
	        }
	      });

	      $element.on('click', function () {
	        $('.btn-group .button').each(function () {
	          $(this).removeClass('button--secondary');
	        });

	        $element.addClass('button--secondary');

	        if (ngModel) {
	          $scope.$apply(function () {
	            ngModel.$setViewValue(value);
	          });
	        }
	      });
	    }
	  };
	}]);

/***/ }),
/* 131 */
/***/ (function(module, exports) {

	'use strict';

	var stateTitleModule = angular.module('t2g.common.directives.stateTitle', []);

	module.exports = stateTitleModule;

	stateTitleModule.directive('stateTitle', ["$transitions", "gettextCatalog", "settings", function ($transitions, gettextCatalog, settings) {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $transitions.onSuccess({}, function (transition) {
	        var titleParts = [settings.titlePrefix];
	        var toState = transition.to();

	        if (toState.title) {
	          titleParts.push(settings.titleSeperator);
	          titleParts.push(gettextCatalog.getString(toState.title));
	        }
	        $element.html(titleParts.join(' '));
	      });
	    }
	  };
	}]);

/***/ }),
/* 132 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.tablinkDirective', []);

	module.exports = angularModule;

	angularModule.directive('tablink', function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      $element.click(function (e) {
	        e.preventDefault();
	        $(this).tab('show');
	      });
	    }
	  };
	});

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.timePickerDirective', []);

	module.exports = angularModule;

	angularModule.directive('timepicker', ["$filter", function TimePickerDirective($filter) {
	  return {
	    restrict: 'E',
	    require: '?ngModel',
	    replace: true,
	    scope: {
	      ngModel: '=model',
	      start: '@',
	      end: '@',
	      step: '@',
	      dateTime: '='
	    },
	    template: '<input class="form-control control input-small" type="text" maxlength="5" size="5" ng-model="ngModel">',
	    link: function link($scope, $element, $attributes, $ngModel) {
	      var step = parseInt($scope.step, 10) || 15;
	      var start = $scope.start || '06:00';
	      var end = $scope.end || '22:00';

	      $scope.$watch('ngModel', function (newValue, oldValue) {
	        if ((newValue === undefined || newValue === '') && oldValue) {
	          $scope.ngModel = oldValue;
	        }
	      });

	      if ($ngModel) {
	        // initial: modelValue -> viewValue
	        $ngModel.$formatters.push(function (model) {
	          var view;
	          if (angular.isUndefined(model)) {
	            return;
	          }

	          if ($scope.dateTime) {
	            view = moment(model).format('HH:mm');
	          } else {
	            view = $filter('time')(model, 'mm-to-hh:mm');
	          }

	          return view;
	        });

	        // viewValue -> modelValue
	        $ngModel.$parsers.push(function (view) {
	          var timeParts = view.split(':');
	          var timePartsLen = timeParts.length;

	          if (timePartsLen === 2 && timeParts[0].length > 0 && timeParts[1].length > 0) {
	            var hours = parseInt(timeParts[0], 10);
	            var minutes = parseInt(timeParts[1], 10);

	            if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
	              $ngModel.$setValidity('time', false);
	            } else {
	              $ngModel.$setValidity('time', true);
	            }

	            if ($scope.dateTime) {
	              var newDateTime = $scope.ngModel;
	              newDateTime.setHours(hours);
	              newDateTime.setMinutes(minutes);
	              return newDateTime;
	            } else {
	              return hours * 60 + minutes;
	            }
	          } else {
	            $ngModel.$setValidity('time', false);
	          }
	        });
	      }

	      $element.timepicker({
	        timeFormat: 'H:i',
	        step: step,
	        minTime: start,
	        maxTime: end,
	        appendTo: $element.parent(),
	        forceRoundTime: true,
	        disableTouchKeyboard: true
	      }).on('click', function () {
	        $(this).select();
	        $(this).focus();
	      });

	      /**
	       * GC, turn of watchers
	       */
	      $scope.$on('$destroy', function () {
	        $element.off();
	      });
	    }
	  };
	}]);

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.trackErrors', []);

	module.exports = angularModule;

	angularModule.directive('trackErrors', ["$window", function ($window) {
	  return {
	    restrict: 'E',
	    link: function link() {
	      $window.addEventListener('error', function (error) {
	        var ie = window.event || {};
	        var errMsg = error.message || ie.errorMessage;
	        var errSrc = (error.filename || ie.errorUrl) + ': ' + (error.lineno || ie.errorLine);

	        if ($window.ga) {
	          ga('send', 'exception', {
	            exDescription: errSrc + ': ' + errMsg,
	            exFatal: false
	          });
	        }
	      }, false);
	    }
	  };
	}]);

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.toogleLabel', []);

	module.exports = angularModule;

	angularModule.directive('toggleLabel', ["$timeout", function ($timeout) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    scope: {
	      ngModel: '=',
	      trueTitle: '=',
	      falseTitle: '='
	    },
	    link: function link($scope, $element) {
	      $timeout(function () {
	        if (!$scope.ngModel) {
	          $scope.ngModel = false;
	        }
	        setTitle();
	      });

	      $element.click(function () {
	        $scope.$apply(function () {
	          $scope.ngModel = !$scope.ngModel;
	        });
	        setTitle();
	      });

	      function setTitle() {
	        if (!$scope.trueTitle || !$scope.falseTitle) return;

	        if ($scope.ngModel) {
	          $element.attr('title', $scope.trueTitle).tooltip('fixTitle');
	        } else {
	          $element.attr('title', $scope.falseTitle).tooltip('fixTitle');
	        }
	      }
	    }
	  };
	}]);

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';

	var wavesModule = angular.module('t2g.common.directives.waves', []);

	module.exports = wavesModule;

	wavesModule.directive('waves', function () {
	  return {
	    restrict: 'C',
	    link: function link($scope, element) {
	      Waves.init();
	      Waves.attach(element[0]);
	    }
	  };
	});

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.directives.wysiwygDirective', []);

	module.exports = angularModule;

	angularModule.directive('wysiwyg', ["$timeout", "gettextCatalog", function ($timeout, gettextCatalog) {
	  return {
	    restrict: 'A',
	    require: '?ngModel',
	    scope: {
	      ngModel: '=',
	      toolbar: '=',
	      placeholder: '=',
	      height: '='
	    },
	    link: function link($scope, $element, $attributes, ngModel) {
	      var height = $scope.height || 300;
	      var placeholderButtonLabel = gettextCatalog.getString('Placeholder');
	      var summernoteOptions = {
	        height: height,
	        lang: 'de-DE',
	        callbacks: {
	          onChange: function onChange() {
	            if (ngModel) {
	              $timeout(function () {
	                ngModel.$setViewValue($element.summernote('code'));
	              });
	            }
	          }
	        }
	      };

	      var PlaceholderDropdown = function PlaceholderDropdown(context) {
	        var ui = $.summernote.ui;
	        var dropdownList = '';

	        if (_.isArray($scope.placeholder)) {
	          _.forEach($scope.placeholder, function (item) {
	            dropdownList += '<li><a href="#" data-value="' + item.value + '">' + item.label + '</a></li>';
	          });
	        }

	        var templateButton = ui.buttonGroup([ui.button({
	          className: 'dropdown-toggle',
	          contents: placeholderButtonLabel + ' <span class="caret"></span>',
	          tooltip: 'Your tooltip',
	          click: function click() {
	            // context.invoke('editor.saveRange');
	          },
	          data: {
	            toggle: 'dropdown'
	          }
	        }), ui.dropdown({
	          className: 'dropdown-menu note-check',
	          contents: dropdownList,
	          callback: function callback($dropdown) {
	            $dropdown.find('a').click(function (event) {
	              context.invoke('editor.insertText', '{{' + $(this).data('value') + '}}');
	              event.preventDefault();
	              event.stopPropagation();
	            });
	          }
	        })]);

	        return templateButton.render();
	      };

	      if ($scope.toolbar === 'nano') {
	        summernoteOptions.toolbar = [['font', ['bold', 'italic', 'underline', 'clear']], ['para', ['ul', 'ol']], ['view', ['fullscreen']]];
	      } else if ($scope.toolbar === 'template') {
	        summernoteOptions.toolbar = [['style', ['bold', 'italic', 'underline', 'clear']], ['fontsize', ['fontsize']], ['color', ['color']], ['para', ['ul', 'ol', 'paragraph']], ['link', ['linkDialogShow', 'unlink']], ['mybutton', ['placeholder']]];
	        summernoteOptions.buttons = {
	          placeholder: PlaceholderDropdown
	        };
	      }

	      $element.summernote(summernoteOptions);

	      // model -> summernote
	      var modelObserver = $scope.$watch('ngModel', function () {
	        $element.summernote('code', ngModel.$modelValue);
	        modelObserver();
	      });

	      // GC
	      $scope.$on('$destroy', function () {
	        $element.summernote('destroy');
	      });
	    }
	  };
	}]);

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter', [__webpack_require__(139).name, __webpack_require__(140).name, __webpack_require__(141).name, __webpack_require__(142).name, __webpack_require__(147).name, __webpack_require__(148).name, __webpack_require__(149).name]);

	module.exports = angularModule;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.dateFilter', []);

	module.exports = angularModule;

	angularModule.filter('time', function () {
	  return function (time, format) {
	    switch (format) {
	      case 'mm-to-hh:mm':
	        var hours = Math.floor(time / 60);
	        var minutes = time % 60;

	        return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
	    }
	  };
	});

/***/ }),
/* 140 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.momentFilter', []);

	module.exports = angularModule;

	angularModule.filter('moment', function () {
	  return function (date, format) {
	    return moment(date).format(format);
	  };
	});

	angularModule.filter('momentCalendar', function () {
	  return function (date) {
	    return moment(date).calendar();
	  };
	});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.orFilter', []);

	module.exports = angularModule;

	angularModule.filter('orFilter', function () {
	  return function (items, attributes, filterString) {
	    var matchedItems = [];
	    filterString = filterString.toLowerCase();

	    if (items) {
	      for (var i = 0, itemLen = items.length; i < itemLen; i++) {
	        for (var j = 0; j < attLen; j++) {
	          if (items[i][attributes[j]]) {
	            if (items[i][attributes[j]].toLowerCase().indexOf(filterString) != -1) {
	              matchedItems.push(items[i]);
	              break;
	            }
	          }
	        }
	      }
	    }

	    return matchedItems;
	  };
	});

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _keys = __webpack_require__(143);

	var _keys2 = _interopRequireDefault(_keys);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var angularModule = angular.module('t2g.common.filter.probsFilter', []);

	module.exports = angularModule;

	angularModule.filter('propsFilter', function () {
	  return function (items, props) {
	    var out = [];

	    if (angular.isArray(items)) {
	      var keys = (0, _keys2.default)(props);

	      items.forEach(function (item) {
	        var itemMatches = false;

	        for (var i = 0; i < keys.length; i++) {
	          var prop = keys[i];
	          var text = props[prop].toLowerCase();
	          if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
	            itemMatches = true;
	            break;
	          }
	        }

	        if (itemMatches) {
	          out.push(item);
	        }
	      });
	    } else {
	      // Let the output be the input untouched
	      out = items;
	    }

	    return out;
	  };
	});

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(144), __esModule: true };

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(145);
	module.exports = __webpack_require__(44).Object.keys;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(79);
	var $keys = __webpack_require__(63);

	__webpack_require__(146)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(42);
	var core = __webpack_require__(44);
	var fails = __webpack_require__(53);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.orFilterNew', []);

	module.exports = angularModule;

	angularModule.filter('orFilterNew', function () {
	  return function (items, attributes, filterString, limit) {
	    var matches = [];
	    var filterStringRegEx = new RegExp(filterString, 'gi');

	    _.forEach(items, function (item) {
	      _.forEach(attributes, function (attribute) {
	        var value = _.get(item, attribute);

	        if (value && value.match(filterStringRegEx)) {
	          matches.push(item);
	          return false;
	        }
	      });

	      if (matches.length === limit) {
	        return false;
	      }
	    });

	    return matches;
	  };
	});

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.truncateFilter', []);

	module.exports = angularModule;

	angularModule.filter('truncate', function () {
	  return function (string, length, end) {
	    if (!string || !length) return;

	    var string = string.substring(0, length);

	    if (end) {
	      string += end;
	    }

	    return string;
	  };
	});

/***/ }),
/* 149 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.filter.uniqueFilter', []);

	module.exports = angularModule;

	angularModule.filter('unique', function () {
	  return function (model1, model2) {
	    var uniqueItems = model1;
	    var index;

	    if (typeof model2 !== 'undefined') {
	      angular.forEach(model2, function (item2) {
	        angular.forEach(model1, function (item1) {
	          index = -1;

	          if (angular.equals(item1, item2)) {
	            index = model1.indexOf(item1);
	            uniqueItems.splice(index, 1);
	          }
	        });
	      });
	    }

	    return uniqueItems;
	  };
	});

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.services', [__webpack_require__(151).name, __webpack_require__(151).name, __webpack_require__(152).name, __webpack_require__(3).name, __webpack_require__(153).name, __webpack_require__(154).name, __webpack_require__(155).name, __webpack_require__(156).name, __webpack_require__(7).name, __webpack_require__(157).name, __webpack_require__(158).name, __webpack_require__(159).name, __webpack_require__(160).name, __webpack_require__(161).name, __webpack_require__(1).name, __webpack_require__(9).name, __webpack_require__(4).name, __webpack_require__(6).name, __webpack_require__(162).name, __webpack_require__(163).name, __webpack_require__(164).name, __webpack_require__(5).name]);

	module.exports = angularModule;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.appointmentModel', ['ui.router', __webpack_require__(3).name, __webpack_require__(4).name, __webpack_require__(6).name]);

	module.exports = angularModule;

	angularModule.factory('AppointmentModel', ["$rootScope", "$state", "$timeout", "Appointment", "AppointmentCache", "io", function ($rootScope, $state, $timeout, Appointment, AppointmentCache, io) {
	  var changeHandler = {
	    add: [],
	    remove: [],
	    edit: []
	  };

	  var fireHandler = function fireHandler(eventName, appointment) {
	    var handlerLen = changeHandler[eventName].length;

	    for (var i = 0; i < handlerLen; i++) {
	      changeHandler[eventName][i].call(appointment);
	    }
	  };

	  return {
	    on: function on(eventName, callback) {
	      changeHandler[eventName].push(callback);
	    },
	    get: function get(date, range, forceReload, callback) {
	      var dateParts = date.split('-');
	      var dateStart = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
	      var response = [];

	      // check if is necessary to from api
	      for (var i = 0; i < range; i++) {
	        var dateTemp = new Date(dateStart.getTime() + i * 86400000);
	        var dateString = dateTemp.getDate() + '-' + (dateTemp.getMonth() + 1) + '-' + dateTemp.getFullYear();
	        var cachedAppointments = AppointmentCache.get(dateString);

	        if (cachedAppointments) {
	          response.push(cachedAppointments);
	        } else {
	          response = [];
	          break;
	        }
	      }

	      if (response.length < range) {
	        Appointment.query({ start: date, range: range }, function (appointmentDays) {
	          if (appointmentDays instanceof Array) {
	            for (var i = 0, daysLen = appointmentDays.length; i < daysLen; i++) {
	              appointmentDays[i].date = new Date(appointmentDays[i].date);

	              // parse start and end dates
	              for (var j = 0, objLen = appointmentDays[i].objects.length; j < objLen; j++) {
	                for (var k = 0, appLen = appointmentDays[i].objects[j].appointments.length; k < appLen; k++) {
	                  appointmentDays[i].objects[j].appointments[k].start = new Date(appointmentDays[i].objects[j].appointments[k].start);
	                  appointmentDays[i].objects[j].appointments[k].end = new Date(appointmentDays[i].objects[j].appointments[k].end);
	                }
	              }

	              AppointmentCache.put(appointmentDays[i].date.getDate() + '-' + (appointmentDays[i].date.getMonth() + 1) + '-' + appointmentDays[i].date.getFullYear(), appointmentDays[i]);
	              response.push(appointmentDays[i]);
	            }

	            callback(null, response);
	          } else {
	            callback('Error: cant load appointments for date: ' + date);
	          }
	        });
	      } else {
	        callback(null, response);
	      }
	    },
	    save: function save(appointment, callback) {
	      var that = this;

	      if (appointment.recurring && appointment.recurring.times) {
	        appointment.recurring.times = parseInt(appointment.recurring.times, 10);
	      }

	      Appointment.save(appointment).$promise.then(function (appointments) {
	        // parse start and end dates
	        for (var i = 0, appLen = appointments.length; i < appLen; i++) {
	          appointments[i].start = new Date(appointments[i].start);
	          appointments[i].end = new Date(appointments[i].end);
	        }

	        io.emit('Appointment:save', appointments);

	        that.insertToCache(appointments);

	        $rootScope.$broadcast('Appointment:save');

	        fireHandler('add', appointment);

	        fireHandler('add', appointment);

	        callback(null, appointments);
	      }, function () {
	        callback('Cant insert new appointment');
	      });
	    },
	    update: function update(appointment, oldDate, callback) {
	      var that = this;

	      if (appointment.recurring && appointment.recurring.times) {
	        appointment.recurring.times = parseInt(appointment.recurring.times, 10);
	      }

	      Appointment.update(appointment).$promise.then(function (reponse) {
	        var appointments = reponse.appointments;
	        appointment = appointments[0];

	        // clear old date if date differs (e.g. if appointment was dragged)
	        appointment.start = new Date(appointment.start);

	        // clear old date
	        var oldCachedDay = AppointmentCache.get(oldDate);

	        if (oldCachedDay) {
	          _.forEach(oldCachedDay.objects, function (object) {
	            _.remove(object.appointments, function (oldAppointment) {
	              return oldAppointment._id === appointment._id;
	            });
	          });
	          AppointmentCache.remove(oldDate);
	          AppointmentCache.put(oldDate, oldCachedDay);
	        }

	        io.emit('Appointment:edit', appointments);
	        that.insertToCache(appointments);
	        $rootScope.$broadcast('Appointment:edit');
	        callback();
	        fireHandler('edit', appointment);
	      }, function () {
	        callback('Cant update appointment');
	      });
	    },
	    delete: function _delete(appointment, callback) {
	      appointment.start = new Date(appointment.start);
	      var date = appointment.start.getDate() + '-' + (appointment.start.getMonth() + 1) + '-' + appointment.start.getFullYear();

	      if (appointment instanceof Object) {
	        appointment = new Appointment(appointment);
	      }

	      appointment.$delete({ appointmentId: appointment._id }, function (response) {
	        // refresh cache to avoid reloading from API
	        var tempCache = AppointmentCache.get(date);

	        if (tempCache) {
	          for (var i = 0; i < tempCache.objects.length; i++) {
	            for (var j = 0; j < tempCache.objects[i].appointments.length; j++) {
	              if (tempCache.objects[i].appointments[j]._id == response._id) {
	                tempCache.objects[i].appointments.splice(j, 1);
	                AppointmentCache.remove(date);
	                AppointmentCache.put(date, tempCache);

	                break;
	              }
	            }
	          }
	        }
	        fireHandler('remove', appointment);

	        $rootScope.$broadcast('Appointment:delete', response._id);

	        callback(null, response);
	      }, function () {
	        callback('Cant delete appointment');
	      });
	    },
	    insertToCache: function insertToCache(appointments, broadcast) {
	      angular.forEach(appointments, function (appointment) {
	        appointment.start = new Date(appointment.start);
	        var date = moment(appointment.start).format('D-M-YYYY');

	        // refresh cache to avoid reloading from API
	        var tempCache = AppointmentCache.get(date);

	        if (tempCache) {
	          for (var i = 0, objLen = tempCache.objects.length; i < objLen; i++) {
	            var appointmentInCache = false;

	            if (tempCache.objects[i]._id === appointment.object._id) {
	              // check if appointment is already in cache
	              for (var j = 0, appLen = tempCache.objects[i].appointments.length; j < appLen; j++) {
	                if (tempCache.objects[i].appointments[j]._id === appointment._id) {
	                  appointmentInCache = true;
	                  tempCache.objects[i].appointments[j] = appointment;
	                  break;
	                }
	              }

	              if (!appointmentInCache) {
	                tempCache.objects[i].appointments.push(appointment);
	              }

	              break;
	            }
	          }

	          AppointmentCache.remove(date);
	          AppointmentCache.put(date, tempCache);
	          if (broadcast) {
	            fireHandler('edit', appointment);
	          }
	        }
	      });
	    },
	    clearCache: function clearCache() {
	      AppointmentCache.removeAll();
	    }
	  };
	}]);

/***/ }),
/* 152 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.billwerkService', []);

	module.exports = angularModule;

	angularModule.factory('BillwerkService', ["$q", "settings", "SubscriptionDA", function ($q, settings, SubscriptionDA) {
	  return {
	    load: load,
	    subscribe: subscribe,
	    createOrder: createOrder,
	    createPayment: createPayment,
	    changeBillingInformation: changeBillingInformation,
	    changePaymentInformation: changePaymentInformation,
	    finalize: finalize
	  };

	  function _getPortalService() {
	    return SubscriptionDA.getCustomerToken().then(function (customerToken) {
	      var portalService = new BillwerkJS.Portal(customerToken);
	      return portalService;
	    });
	  }

	  /**
	   * get a payment service instance
	   *
	   * @return {BillwerkJS.Payment}
	   * @private
	   */
	  function _getPaymentService() {
	    var deferred = $q.defer();

	    var paymentService = new BillwerkJS.Payment({
	      publicApiKey: settings.billwerk.key,
	      providerReturnUrl: 'https://app.termin2go.com/#/private/main/subscription/finalize'
	    }, function () {
	      deferred.resolve(paymentService);
	    }, function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * get a signup service instance
	   *
	   * @return {BillwerkJS.Signup}
	   * @private
	   */
	  function _getSignupService() {
	    var signupService = new BillwerkJS.Signup();
	    return $q.when(signupService);
	  }

	  /**
	   * add billwerk script to buttom of body element
	   */
	  function load() {
	    var deferred = $q.defer();

	    if (!document.getElementById('billwerk')) {
	      var billwerkScript = document.createElement('script');
	      billwerkScript.type = 'text/javascript';
	      billwerkScript.src = settings.billwerk.libUrl;
	      billwerkScript.id = 'billwerk';
	      billwerkScript.onreadystatechange = billwerkScript.onload = function () {
	        deferred.resolve({});
	      };
	      document.body.appendChild(billwerkScript);
	    } else {
	      deferred.resolve({});
	    }

	    return deferred.promise;
	  }

	  /**
	   * create an order
	   *
	   * @param {object} cart
	   * @param {object} customer
	   * @return {promise}
	   */
	  function createOrder(cart, customer) {
	    var deferred = $q.defer();

	    _getSignupService().then(function (signupService) {
	      signupService.createOrder(cart, customer, function (order) {
	        deferred.resolve(order);
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).catch(function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * create a payment
	   *
	   * @param {object} paymentData
	   * @param {object} order
	   * @return {promise}
	   */
	  function createPayment(paymentData, order) {
	    var deferred = $q.defer();

	    $q.all([_getPaymentService(), _getSignupService()]).then(function (responses) {
	      var paymentService = responses[0];
	      var signupService = responses[1];

	      signupService.paySignupInteractive(paymentService, paymentData, order, function (result) {
	        if (!result.Url) {
	          deferred.resolve(result);
	        } else {
	          window.location.href = result.Url;
	        }
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).catch(function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * change billing information of a customer
	   *
	   * @param {object} customer
	   * @return {*}
	   */
	  function changeBillingInformation(customer) {
	    var deferred = $q.defer();

	    _getPortalService().then(function (portalService) {
	      portalService.customerChange(customer, function (result) {
	        deferred.resolve(result);
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).catch(function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * change payment information of a customer
	   *
	   * @param {Object} paymentData
	   * @return {promise}
	   */
	  function changePaymentInformation(paymentData) {
	    var deferred = $q.defer();

	    $q.all([_getPaymentService(), _getPortalService()]).then(function (responses) {
	      var paymentService = responses[0];
	      var portalService = responses[1];

	      portalService.paymentChange(paymentService, paymentData, function (result) {
	        if (!result.Url) {
	          deferred.resolve(result);
	        } else {
	          window.location.href = result.Url;
	        }
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).catch(function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * finalize a payment
	   *
	   * @return {promise}
	   */
	  function finalize() {
	    var deferred = $q.defer();

	    BillwerkJS.finalize(function (result) {
	      deferred.resolve(result);
	    }, function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }

	  /**
	   * subscribe process all in one
	   *
	   * @param {object} cart
	   * @param {object} customer
	   * @param {object} paymentData
	   * @return {promise}
	   */
	  function subscribe(cart, customer, paymentData) {
	    var deferred = $q.defer();

	    $q.all([_getPaymentService(), _getSignupService()]).then(function (responses) {
	      var paymentService = responses[0];
	      var signupService = responses[1];

	      signupService.subscribe(paymentService, cart, customer, paymentData, function (result) {
	        if (!result.Url) {
	          deferred.resolve(result);
	        } else {
	          window.location.href = result.Url;
	        }
	      }, function (error) {
	        deferred.reject(error);
	      });
	    }).catch(function (error) {
	      deferred.reject(error);
	    });

	    return deferred.promise;
	  }
	}]);

/***/ }),
/* 153 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.datePickerSettings', []);

	module.exports = angularModule;

	angularModule.factory('DatepickerSettings', function () {
	  return {
	    default: {
	      onOpenFocus: true,
	      showWeeks: false,
	      formatMonth: 'MMM',
	      monthColumns: 4,
	      startingDay: 1,
	      closeOnDateSelection: true,
	      closeText: 'OK'
	    },
	    minMonth: {
	      closeOnDateSelection: true,
	      onOpenFocus: true,
	      showWeeks: false,
	      formatMonth: 'MMM',
	      monthColumns: 4,
	      startingDay: 1,
	      minMode: 'month',
	      closeText: 'OK'
	    }
	  };
	});

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.geoCodeService', []);

	module.exports = angularModule;

	angularModule.factory('GeocodeService', ["$http", function ($http) {
	  return {
	    getGeoData: function getGeoData(address, callback) {
	      $http({
	        method: 'GET',
	        url: '//maps.googleapis.com/maps/api/geocode/json?address=' + encodeURIComponent(address) + '&sensor=false'
	      }).then(function (data) {
	        if (data.status == 'ZERO_RESULTS') {
	          callback(data);
	        }

	        callback(null, data.results[0]);
	      }).error(function (data) {
	        callback(data);
	      });
	    }
	  };
	}]);

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.holderService', []);

	module.exports = angularModule;

	angularModule.factory('AppointmentHolder', function () {
	  var _appointment = null;

	  return {
	    setAppointment: function setAppointment(appointment) {
	      _appointment = appointment;
	    },
	    getAppointment: function getAppointment() {
	      return _appointment;
	    }
	  };
	});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.industrySpecificService', []);

	module.exports = angularModule;

	angularModule.factory('IndustrySpecific', ["$q", "OfficeDA", function ($q, OfficeDA) {
	  var _labels = null;
	  var defaultLabels = {
	    customer: 'Customer',
	    customers: 'Customers'
	  };

	  return {
	    setLabels: function setLabels(labels) {
	      _labels = labels;
	    },
	    getLabels: function getLabels() {
	      if (_labels) {
	        return $q.when(_labels);
	      } else {
	        return OfficeDA.get().then(function (office) {
	          var customLabels = _.get(office, 'settings.customLabels', {});

	          if (customLabels.customer && customLabels.customers) {
	            _labels = customLabels;
	            return _labels;
	          } else {
	            return defaultLabels;
	          }
	        });
	      }
	    }
	  };
	}]);

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.loading-indocator', []);

	module.exports = angularModule;

	angularModule.factory('LoadingIndicatorService', ["$rootScope", function ($rootScope) {
	  hide();

	  $rootScope.showLoadingIndicator = 0;

	  return {
	    hide: hide,
	    show: show
	  };

	  function hide() {
	    $rootScope.showLoadingIndicator--;
	  }

	  function show() {
	    $rootScope.showLoadingIndicator++;
	  }
	}]);

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	'use strict';

	var browser = navigator.userAgent || navigator.vendor || window.opera;
	var isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(browser) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(browser.substr(0, 4));
	var angularModule = angular.module('t2g.common.services.mobileDetect', []);

	module.exports = angularModule;

	angularModule.factory('MobileDetectService', function () {
	  return {
	    isMobile: isMobile
	  };
	});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

	'use strict';

	var modalServiceModule = angular.module('t2g.common.services.modalFactory', []);

	module.exports = modalServiceModule;

	modalServiceModule.factory('ModalFactory', ["$animate", "$compile", "$controller", "$document", "$injector", "$q", "$rootScope", "$templateRequest", "LoadingIndicatorService", function ($animate, $compile, $controller, $document, $injector, $q, $rootScope, $templateRequest, LoadingIndicatorService) {
	  /**
	   * @param {String} path
	   * @return {Promise}
	   */
	  var getTemplate = function getTemplate(path) {
	    return $templateRequest(path);
	  };

	  /**
	   * @param {Object} resolver
	   * @return {Promise}
	   */
	  var getResolveData = function getResolveData(resolver) {
	    var deferred = $q.defer();
	    var resolveValues = {};
	    var resolveItems = [];

	    angular.forEach(resolver, function (resolve) {
	      if (angular.isFunction(resolve) || angular.isArray(resolve)) {
	        resolveItems.push($q.resolve($injector.invoke(resolve)));
	      } else if (angular.isString(resolve)) {
	        resolveItems.push($q.resolve($injector.get(resolve)));
	      } else {
	        resolveItems.push($q.resolve(resolve));
	      }
	    });

	    $q.all(resolveItems).then(function (resolves) {
	      var index = 0;

	      angular.forEach(resolver, function (promise, resolveName) {
	        resolveValues[resolveName] = resolves[index];
	        index++;
	      });

	      deferred.resolve(resolveValues);
	    }, function () {
	      deferred.reject();
	    });

	    return deferred.promise;
	  };

	  return {
	    open: function open(options) {
	      var promises = [getTemplate(options.template)];
	      var controller = null;
	      var controllerLocals = {
	        $scope: $rootScope.$new()
	      };
	      var bodyElement = $document.find('body');
	      var closeDefer = $q.defer();
	      var modalInstance = {
	        closed: closeDefer.promise
	      };

	      // resolve promises
	      if (options.resolve) {
	        promises.push(getResolveData(options.resolve));
	      }

	      LoadingIndicatorService.show();

	      // after resolving promises show modal
	      $q.all(promises).then(function (response) {
	        LoadingIndicatorService.hide();

	        // delete all $promise to avoid merge max call stack error
	        for (var promise in response[1]) {
	          var resolve = response[1][promise];

	          if (resolve) {
	            delete resolve.$promise;
	          }
	        }

	        // create controller instance
	        angular.merge(controllerLocals, response[1]);
	        controllerLocals.modalInstance = modalInstance;
	        controller = $controller(options.controller, controllerLocals);

	        // inject html
	        var modalElement = angular.element(response[0]);

	        $animate.enter($compile(modalElement)(controllerLocals.$scope), bodyElement).then(function () {
	          $animate.addClass(bodyElement, 'show-modal');
	        });

	        modalInstance.close = function (response) {
	          $animate.removeClass(bodyElement, 'show-modal').then(function () {
	            modalElement.remove();
	            controllerLocals.$scope.$destroy();
	            controller = null;
	            closeDefer.resolve(response);
	          });
	        };
	      }).catch(function () {
	        LoadingIndicatorService.hide();
	        // TODO: show error notification
	      });

	      return modalInstance;
	    }
	  };
	}]);

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.modalService', []);

	module.exports = angularModule;

	angularModule.factory('AppointmentModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var AppointmentModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/calendar/modal/AppointmentModalView.html').then(function (response) {
	    $templateCache.put('AppointmentModalView.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  AppointmentModal.open = function (appointment, object) {
	    // load modal html
	    modalHTML = $compile($templateCache.get('AppointmentModalView.html'))(scope);
	    modalHTML.controller().setCurrentItem(appointment, object);
	    body.append(modalHTML);

	    $('#appointmentModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  AppointmentModal.close = function () {
	    $('#appointmentModal').modal('hide');

	    // remove modal html
	    angular.element($('#appointmentModal')).scope().$destroy();
	    $('#appointmentModal').remove();
	    $('.modal-backdrop').remove();
	    $('body').removeClass('modal-open');
	  };

	  return AppointmentModal;
	}]);

	angularModule.factory('PrivateAppointmentModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var PrivateAppointmentModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/calendar/modal/PrivateAppointmentModalView.html').then(function (response) {
	    $templateCache.put('PrivateAppointmentModalView.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  PrivateAppointmentModal.open = function (appointment, object) {
	    // load modal html
	    modalHTML = $compile($templateCache.get('PrivateAppointmentModalView.html'))(scope);
	    modalHTML.controller().setCurrentItem(appointment, object);
	    body.append(modalHTML);

	    $('#PrivateAppointmentModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  PrivateAppointmentModal.close = function () {
	    $('#PrivateAppointmentModal').modal('hide');

	    // remove modal html
	    angular.element($('#PrivateAppointmentModal')).scope().$destroy();
	    $('#PrivateAppointmentModal').remove();
	    $('.modal-backdrop').remove();
	    $('body').removeClass('modal-open');
	  };

	  return PrivateAppointmentModal;
	}]);

	angularModule.factory('CourseAppointmentModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var CourseAppointmentModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/calendar/modal/CourseAppointmentModalView.html').then(function (response) {
	    $templateCache.put('CourseAppointmentModalView.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  CourseAppointmentModal.open = function (appointment, object, showParticipants) {
	    // load modal html
	    modalHTML = $compile($templateCache.get('CourseAppointmentModalView.html'))(scope);
	    modalHTML.controller().setCurrentItem(appointment, object, showParticipants);
	    body.append(modalHTML);

	    $('#CourseAppointmentModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  CourseAppointmentModal.close = function () {
	    $('#CourseAppointmentModal').modal('hide');

	    // remove modal html
	    angular.element($('#CourseAppointmentModal')).scope().$destroy();
	    modalHTML.remove();
	    $('#CourseAppointmentModal').destroy().remove();
	    $('.modal-backdrop').remove();
	    $('body').removeClass('modal-open');
	  };

	  return CourseAppointmentModal;
	}]);

	angularModule.factory('EmployeeModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var EmployeeModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/object/modal/EmployeeModalView.html').then(function (response) {
	    $templateCache.put('EmployeeModalView.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  EmployeeModal.open = function (employee) {
	    // load modal html
	    modalHTML = $compile($templateCache.get('EmployeeModalView.html'))(scope);
	    modalHTML.controller().setCurrentItem(employee);
	    body.append(modalHTML);

	    $('#employeeModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  EmployeeModal.close = function () {
	    $('#employeeModal').modal('hide');

	    // remove modal html
	    angular.element($('#employeeModal')).scope().$destroy();
	    modalHTML.remove();
	    $('.modal-backdrop').remove();
	    $('body').removeClass('modal-open');
	  };

	  return EmployeeModal;
	}]);

	angularModule.factory('ServiceModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var ServiceModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/service/modal/ServiceModal.html').then(function (response) {
	    $templateCache.put('ServiceModal.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  ServiceModal.open = function (service) {
	    modalHTML = $compile($templateCache.get('ServiceModal.html'))(scope);
	    body.append(modalHTML);
	    modalHTML.controller().setCurrentItem(service);

	    $('#serviceModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  ServiceModal.close = function () {
	    $('#serviceModal').modal('hide');

	    // remove modal html
	    angular.element($('#serviceModal')).scope().$destroy();
	    modalHTML.remove();
	    $('.modal-backdrop').remove();
	    $('body').removeAttr('class');
	  };

	  return ServiceModal;
	}]);

	angularModule.factory('ServiceGroupModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var ServiceGroupModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/service/modal/ServiceGroupModal.html').then(function (response) {
	    $templateCache.put('ServiceGroupModal.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  ServiceGroupModal.open = function () {
	    modalHTML = $compile($templateCache.get('ServiceGroupModal.html'))(scope);
	    body.append(modalHTML);

	    $('#serviceGroupModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  ServiceGroupModal.close = function () {
	    $('#serviceGroupModal').modal('hide');

	    // remove modal html
	    angular.element($('#serviceGroupModal')).scope().$destroy();
	    modalHTML.remove();
	    $('.modal-backdrop').remove();
	    $('body').removeAttr('class');
	  };

	  return ServiceGroupModal;
	}]);

	angularModule.factory('CourseModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var CourseModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/course/modal/CourseModal.html').then(function (response) {
	    $templateCache.put('CourseModal.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  CourseModal.open = function (course) {
	    modalHTML = $compile($templateCache.get('CourseModal.html'))(scope);
	    modalHTML.controller().setCurrentItem(course);
	    body.append(modalHTML);

	    $('#courseModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  CourseModal.close = function () {
	    $('#courseModal').modal('hide');

	    // remove modal html
	    angular.element($('#courseModal')).scope().$destroy();
	    modalHTML.remove();
	    $('.modal-backdrop').remove();
	    $('body').removeAttr('class');
	  };

	  return CourseModal;
	}]);

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';

	var modalServiceModule = angular.module('t2g.common.services.modalServiceNew', []);

	module.exports = modalServiceModule;

	var TEMPLATE_BASE = '/app/modules/';

	var APPOINTMENT_TYPES = {
	  customer: {
	    template: 'calendar/CustomerAppointmentLayoverView.html',
	    controller: 'CustomerAppointmentModalCtrl as AppointmentModalCtrl'
	  },
	  course: {
	    template: 'calendar/CourseAppointmentLayoverView.html',
	    controller: 'CourseAppointmentModalCtrl as AppointmentModalCtrl'
	  },
	  private: {
	    template: 'calendar/PrivateAppointmentLayoverView.html',
	    controller: 'PrivateAppointmentModalCtrl as AppointmentModalCtrl'
	  }
	};

	modalServiceModule.factory('ModalService', ["ModalFactory", function (ModalFactory) {
	  return {
	    openAppointmentModal: openAppointmentModal,
	    openServiceModal: openServiceModal
	  };

	  function openServiceModal(_service, closeCallback) {
	    var modalInstance = ModalFactory.open({
	      template: TEMPLATE_BASE + 'service/modal/NewServiceModal.html',
	      controller: 'ServiceModalCtrlNew as ServiceModalCtrlNew',
	      resolve: {
	        service: function service() {
	          return _service;
	        },
	        subscription: function subscription(SubscriptionDA) {
	          return SubscriptionDA.get();
	        },
	        office: function office($q, OfficeModel) {
	          var deferred = $q.defer();

	          OfficeModel.get(function (error, office) {
	            if (error) {
	              deferred.reject(error);
	            } else {
	              deferred.resolve(office);
	            }
	          });

	          return deferred.promise;
	        },
	        tariffServices: function tariffServices(Tarif590DA) {
	          return Tarif590DA.list();
	        },
	        objects: function objects($q, ObjectModel) {
	          var deferred = $q.defer();

	          ObjectModel.get(function (error, office) {
	            if (error) {
	              deferred.reject(error);
	            } else {
	              deferred.resolve(office);
	            }
	          });

	          return deferred.promise;
	        }
	      }
	    });

	    modalInstance.closed.then(closeCallback);
	  }

	  function openAppointmentModal(_appointment, closeCallback) {
	    var type = _.get(_appointment, 'type', 'customer');
	    var appointmentTypeSettings = APPOINTMENT_TYPES[type];

	    var modalInstance = ModalFactory.open({
	      template: TEMPLATE_BASE + appointmentTypeSettings.template,
	      controller: appointmentTypeSettings.controller,
	      resolve: {
	        customLabels: function customLabels(IndustrySpecific) {
	          return IndustrySpecific.getLabels();
	        },
	        customers: function customers(CustomerDA) {
	          return CustomerDA.list();
	        },
	        services: function services($q, OfficeModel) {
	          var deferred = $q.defer();
	          var services = [];

	          OfficeModel.get(function (error, office) {
	            if (error) {
	              deferred.reject(error);
	            } else {
	              _.forEach(office.serviceGroups, function (group) {
	                _.forEach(group.services, function (service) {
	                  service.group = group.name;
	                });

	                services = services.concat(group.services);
	              });

	              deferred.resolve(services);
	            }
	          });

	          return deferred.promise;
	        },
	        appointment: function appointment(AppointmentDA) {
	          if (_appointment && _appointment._id) {
	            return AppointmentDA.get(_appointment._id);
	          } else {
	            var mergedAppointment = {};
	            var start = new Date();
	            start.setMinutes(0);
	            start.setSeconds(0);
	            var defaultAppointment = {
	              type: 'customer',
	              start: start,
	              end: moment(start).add(1, 'hour').toDate(),
	              recurring: {
	                enabled: false
	              },
	              reminder: {
	                email: {
	                  enabled: false
	                },
	                sms: {
	                  enabled: false
	                }
	              },
	              createdBy: 'coach'
	            };

	            _.merge(mergedAppointment, defaultAppointment, _appointment);

	            if (mergedAppointment.type === 'customer') {
	              mergedAppointment.services = mergedAppointment.services || [];
	              mergedAppointment.price = mergedAppointment.price || 0;
	            } else if (mergedAppointment.type === 'course') {
	              mergedAppointment.participants = mergedAppointment.participants || [];
	              mergedAppointment.membershipSettings = mergedAppointment.membershipSettings || [];
	            }

	            mergedAppointment.start = new Date(mergedAppointment.start);
	            mergedAppointment.end = new Date(mergedAppointment.end);

	            return mergedAppointment;
	          }
	        },
	        resources: function resources(ResourceDA) {
	          var groupedResources = {
	            employees: [],
	            rooms: []
	          };

	          return ResourceDA.list().then(function (response) {
	            _.forEach(response.resources, function (resource) {
	              if (resource.type === 'room') {
	                groupedResources.rooms.push(resource);
	              } else {
	                groupedResources.employees.push(resource);
	              }
	            });

	            return groupedResources;
	          });
	        },
	        office: function office(OfficeDA) {
	          return OfficeDA.get();
	        }
	      }
	    });

	    modalInstance.closed.then(closeCallback);

	    return modalInstance; // we should be able to close this modal outside
	  }
	}]);

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.settingsHolderService', []);

	module.exports = angularModule;

	angularModule.factory('Settings', function () {
	  var _settings = {};

	  return {
	    get: function get() {
	      return _settings;
	    },
	    getKey: function getKey(key) {
	      return _settings[key];
	    },
	    set: function set(settings) {
	      _settings = settings;
	    },
	    setKey: function setKey(key, value) {
	      _settings[key] = value;
	    }
	  };
	});

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.socketService', []);

	module.exports = angularModule;

	angularModule.factory('io', ["$rootScope", function ($rootScope) {
	  var socketIO;

	  if (typeof io !== 'undefined') {
	    socketIO = io;
	  } else {
	    socketIO = function socketIO() {
	      return {
	        on: angular.noop,
	        emit: angular.noop,
	        removeAllListeners: angular.noop
	      };
	    };
	  }
	  var socket = socketIO('', { path: '/api/socket.io' });

	  return {
	    emit: emit,
	    off: off,
	    on: on
	  };

	  function on(eventName, callback) {
	    socket.on(eventName, function () {
	      var args = arguments;
	      $rootScope.$apply(function () {
	        callback.apply(socket, args);
	      });
	    });
	  }

	  function emit(eventName, data, callback) {
	    socket.emit(eventName, data, function () {
	      var args = arguments;
	      $rootScope.$apply(function () {
	        if (callback) {
	          callback.apply(socket, args);
	        }
	      });
	    });
	  }

	  function off() {
	    socket.removeAllListeners();
	  }
	}]);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.subscriptionStateService', []);

	module.exports = angularModule;

	angularModule.factory('SubscriptionState', function () {
	  var subscriptionState = {
	    shouldSubscribe: false
	  };

	  return {
	    setShouldSubscribe: function setShouldSubscribe(state) {
	      subscriptionState.shouldSubscribe = state;
	    },
	    getShouldSubscribe: function getShouldSubscribe() {
	      return subscriptionState.shouldSubscribe;
	    }
	  };
	});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';

	var customTranslationsModule = angular.module('t2g.common.custom-translations', ['gettext']);

	module.exports = customTranslationsModule;

	customTranslationsModule.factory('CustomTranslationsService', ["gettextCatalog", function (gettextCatalog) {
	  // custom translations
	  gettextCatalog.getString('CUSTOMER');
	  gettextCatalog.getString('CUSTOMERS');
	  gettextCatalog.getString('CLIENT');
	  gettextCatalog.getString('CLIENTS');
	  gettextCatalog.getString('PATIENT');
	  gettextCatalog.getString('PATIENTS');
	  gettextCatalog.getString('GUEST');
	  gettextCatalog.getString('GUESTS');

	  gettextCatalog.getString('Customer');
	  gettextCatalog.getString('Customers');
	  gettextCatalog.getString('Client');
	  gettextCatalog.getString('Clients');
	  gettextCatalog.getString('Patient');
	  gettextCatalog.getString('Patients');
	  gettextCatalog.getString('Guest');
	  gettextCatalog.getString('Guests');

	  gettextCatalog.getString('customer');
	  gettextCatalog.getString('customers');
	  gettextCatalog.getString('client');
	  gettextCatalog.getString('clients');
	  gettextCatalog.getString('patient');
	  gettextCatalog.getString('patients');
	  gettextCatalog.getString('guest');
	  gettextCatalog.getString('guests');

	  gettextCatalog.getString('WEEK_DAY_SHORT_0');
	  gettextCatalog.getString('WEEK_DAY_SHORT_1');
	  gettextCatalog.getString('WEEK_DAY_SHORT_2');
	  gettextCatalog.getString('WEEK_DAY_SHORT_3');
	  gettextCatalog.getString('WEEK_DAY_SHORT_4');
	  gettextCatalog.getString('WEEK_DAY_SHORT_5');
	  gettextCatalog.getString('WEEK_DAY_SHORT_6');

	  gettextCatalog.getString('SALUTATION_f');
	  gettextCatalog.getString('SALUTATION_m');

	  gettextCatalog.getString('not defined');

	  // validation
	  gettextCatalog.getString('Address needs to be an URL');

	  gettextCatalog.getPlural(0, 'week', '{{$count}} weeks', {});

	  return {};
	}]);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var accountModule = angular.module('t2g.account', ['ui.router', __webpack_require__(1).name]);

	module.exports = accountModule;

	accountModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.account', {
	    url: '/account',
	    title: 'Account',
	    templateUrl: '/app/modules/account/AccountView.html?v=4.5.6',
	    controller: 'AccountCtrl'
	  }).state('private.main.logout', {
	    url: '/logout',
	    template: '',
	    resolve: {
	      logout: ["$q", "AccountModel", function logout($q, AccountModel) {
	        var deffered = $q.defer();

	        AccountModel.logout(function (error, response) {
	          if (error) {
	            deffered.reject(error);
	          } else {
	            deffered.resolve(response);
	          }
	        });

	        return deffered.promise;
	      }]
	    }
	  });
	}]);

	accountModule.controller('AccountCtrl', ["$scope", "AccountModel", function ($scope, AccountModel) {
	  /**
	   * overwrite password of user account
	   */
	  $scope.save = function () {
	    AccountModel.changePassword($scope.account, function (error) {
	      if (error) {
	        console.log(error);
	      } else {
	        AccountModel.logout($scope.account, function (error) {
	          if (error) {
	            console.log(error);
	          }
	        });
	      }
	    });
	  };
	}]);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var calendarModule = angular.module('t2g.calendar', ['gettext', 'ui.router', 'angularResizable', __webpack_require__(160).name, __webpack_require__(168).name, __webpack_require__(1).name]);

	module.exports = calendarModule;

	calendarModule.controller('AppointmentCtrl', __webpack_require__(169));
	calendarModule.controller('AppointmentModalBaseCtrl', __webpack_require__(170));
	calendarModule.controller('AppointmentsCtrl', __webpack_require__(171));
	calendarModule.controller('CalendarContainerCtrl', __webpack_require__(172));
	calendarModule.controller('CalendarCtrl', __webpack_require__(173));
	calendarModule.controller('CourseAppointmentModalCtrl', __webpack_require__(174));
	calendarModule.controller('CustomerAppointmentModalCtrl', __webpack_require__(175));
	calendarModule.controller('PrivateAppointmentModalCtrl', __webpack_require__(176));
	calendarModule.directive('absentTimes', __webpack_require__(177));
	calendarModule.directive('appointment', __webpack_require__(178));
	calendarModule.directive('appointments', __webpack_require__(179));
	calendarModule.directive('calendar', __webpack_require__(180));
	calendarModule.directive('calendarList', __webpack_require__(181));
	calendarModule.directive('fixedTimeLine', __webpack_require__(182));
	calendarModule.directive('timeline', __webpack_require__(183));
	calendarModule.factory('PixelTimeService', __webpack_require__(184));
	calendarModule.factory('AppointmentDragAndResizeState', __webpack_require__(185));

	calendarModule.constant('calendarSettings', {
	  hourHeight: 72,
	  offset: 5
	});

	calendarModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.calendar', {
	    url: '/calendar/:resource/:view/:date',
	    templateUrl: '/app/modules/calendar/CalendarContainer.html?v=4.5.6',
	    controller: 'CalendarContainerCtrl as CalendarContainerCtrl',
	    title: 'Calendar',
	    onExit: ["$stateParams", "LocalStorage", function onExit($stateParams, LocalStorage) {
	      LocalStorage.set('calendarView', {
	        date: $stateParams.date,
	        resource: $stateParams.resource,
	        view: $stateParams.view
	      });
	    }],
	    resolve: {
	      calendar: ["CalendarDA", "$stateParams", function calendar(CalendarDA, $stateParams) {
	        var start;
	        var view = $stateParams.view;
	        var end;

	        if (view === 'week' || view === 'list') {
	          start = moment($stateParams.date).startOf('week').format('YYYY-MM-DD');
	          end = moment(start).add(6, 'days').format('YYYY-MM-DD');
	        } else if (view === '4days') {
	          start = moment($stateParams.date).format('YYYY-MM-DD');
	          end = moment(start).add(3, 'days').format('YYYY-MM-DD');
	        } else {
	          start = $stateParams.date;
	          end = start;
	        }

	        return CalendarDA.get(start, end, $stateParams.resource);
	      }],
	      resources: ["gettextCatalog", "ResourceDA", function resources(gettextCatalog, ResourceDA) {
	        var resources = [];
	        var groupedResources = {
	          employees: [],
	          rooms: []
	        };

	        return ResourceDA.list().then(function (response) {
	          _.forEach(response.resources, function (resource) {
	            if (resource.type === 'room') {
	              groupedResources.rooms.push({
	                _id: resource._id,
	                type: gettextCatalog.getString('Rooms'),
	                label: resource.fullname
	              });
	            } else {
	              groupedResources.employees.push({
	                _id: resource._id,
	                type: gettextCatalog.getString('Employees'),
	                label: resource.fullname
	              });
	            }
	          });

	          if (groupedResources.employees.length > 0) {
	            resources.push({
	              _id: 'all-employees',
	              type: gettextCatalog.getString('Employees'),
	              label: gettextCatalog.getString('- All Employees -')
	            });
	            resources = resources.concat(groupedResources.employees);
	          }

	          if (groupedResources.rooms.length > 0) {
	            resources.push({
	              _id: 'all-rooms',
	              type: gettextCatalog.getString('Rooms'),
	              label: gettextCatalog.getString('- All Rooms -')
	            });
	            resources = resources.concat(groupedResources.rooms);
	          }

	          return resources;
	        });
	      }]
	    },
	    params: {
	      resource: ["LocalStorage", function resource(LocalStorage) {
	        var savedView = LocalStorage.get('calendarView');

	        if (savedView && savedView.resource) {
	          return savedView.resource;
	        } else {
	          return 'all-employees';
	        }
	      }],
	      date: ["LocalStorage", function date(LocalStorage) {
	        var savedView = LocalStorage.get('calendarView');

	        if (savedView && savedView.date) {
	          return savedView.date;
	        } else {
	          return moment().startOf('week').format('YYYY-MM-DD');
	        }
	      }],
	      view: ["LocalStorage", function view(LocalStorage) {
	        var savedView = LocalStorage.get('calendarView');

	        if (savedView && savedView.view) {
	          return savedView.view;
	        } else {
	          return 'week';
	        }
	      }]
	    }
	  });
	}]);

/***/ }),
/* 168 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.data-access.calendar', []);

	module.exports = angularModule;

	angularModule.factory('CalendarResource', ["$resource", "settings", function ($resource, settings) {
	  var resourceUrl = settings.apiBase + '/api/v2/calendar/:subResource';

	  var resource = $resource(resourceUrl, {}, {
	    get: { method: 'get' },
	    checkCollision: { method: 'get', params: { subResource: 'collision' } }
	  });

	  return resource;
	}]);

	angularModule.factory('CalendarDA', ["$rootScope", "$q", "CalendarResource", "moment", function ($rootScope, $q, CalendarResource, moment) {
	  var currentCalendarReference = null;

	  return {
	    get: get,
	    removeAppointment: removeAppointment,
	    removeAppointmentGroup: removeAppointmentGroup,
	    editAppointment: editAppointment,
	    insertAppointment: insertAppointment,
	    checkCollision: checkCollision
	  };

	  /**
	   * add an appointment to calendar
	   * @param appointment
	   */
	  function insertAppointment(appointments) {
	    _.forEach(appointments, function (appointment) {
	      _.forEach(currentCalendarReference, function (date) {
	        if (moment(date.date).isBetween(moment(appointment.start), moment(appointment.end), 'day', '[]')) {
	          _.forEach(date.resources, function (resource) {
	            if (resource._id === appointment.object._id || resource._id === appointment.room) {
	              var findIndex = _.findIndex(resource.appointments, { _id: appointment._id });

	              if (findIndex === -1) {
	                resource.appointments.push(appointment);
	              } else {
	                resource.appointments[findIndex] = appointment;
	              }

	              return false;
	            }
	          });
	        }
	      });
	    });

	    return $q.when(appointments);
	  }

	  function checkCollision(appointment, resource, room, start, end) {
	    var params = {
	      appointment: appointment,
	      start: start.toISOString(),
	      end: end.toISOString(),
	      resource: resource
	    };

	    if (room) {
	      params.room = room;
	    }

	    return CalendarResource.checkCollision(params).$promise.then(function (response) {
	      return response.result;
	    });
	  }

	  /**
	   * edit an appointment in calendar
	   * @param appointment
	   */
	  function editAppointment(appointments) {
	    _.forEach(appointments, function (appointment) {
	      removeAppointment(appointment._id);
	    });

	    insertAppointment(appointments);
	    $rootScope.$emit('t2g:calendar:changed');

	    return appointments;
	  }

	  /**
	   * remove an appointment from calendar
	   * @param appointmentId
	   */
	  function removeAppointment(appointmentId) {
	    _.forEach(currentCalendarReference, function (date) {
	      _.forEach(date.resources, function (resource) {
	        _.remove(resource.appointments, { _id: appointmentId });
	      });
	    });
	  }

	  /**
	   * remove an appointment from calendar
	   * @param appointmentId
	   */
	  function removeAppointmentGroup(appointmentId) {
	    _.forEach(currentCalendarReference, function (date) {
	      _.forEach(date.resources, function (resource) {
	        _.remove(resource.appointments, function (appointment) {
	          return appointment._id === appointmentId || appointment.seriesId === appointmentId;
	        });
	      });
	    });
	  }

	  function get(start, end, resource) {
	    var params = {
	      start: start,
	      end: end,
	      resource: resource
	    };

	    return CalendarResource.get(params).$promise.then(function (response) {
	      currentCalendarReference = response.dates;
	      return currentCalendarReference;
	    });
	  }
	}]);

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * @param {Object} $scope
	 * @param {Object} calendarSettings
	 * @constructor
	 */

	var AppointmentCtrl = function AppointmentCtrl($scope, calendarSettings, ModalService, PixelTimeService, AppointmentDA, AppointmentDragAndResizeState) {
	  this._scope = $scope;
	  this.model = $scope.appointment;
	  this.model.start = new Date(this.model.start);
	  this.model.end = new Date(this.model.end);
	  this.model.preparationStart = new Date(this.model.preparationStart);
	  this.model.followUpEnd = new Date(this.model.followUpEnd);
	  this.customer = this.model.customer;
	  this._calendarSettings = calendarSettings;
	  this._ModalService = ModalService;
	  this._PixelTimeService = PixelTimeService;
	  this._AppointmentDA = AppointmentDA;
	  this._AppointmentDragAndResizeState = AppointmentDragAndResizeState;
	  this.contextMenuModel = {
	    event: 'contextmenu',
	    items: [{
	      label: 'Copys',
	      action: this.copy.bind(this),
	      icon: 'icon-copy'
	    }]
	  };
	};

	/**
	 * calculate the vertical position of the appointment
	 */
	AppointmentCtrl.prototype.calculateVerticalPosition = function (startProperty, endProperty) {
	  var dateMoment = moment(this._scope.date.date);
	  var startMoment = moment(this.model[startProperty]);
	  var endMoment = moment(this.model[endProperty]);
	  var start;
	  var end;
	  var top;
	  var height;
	  var hideEnd;
	  var hideStart;

	  if (startMoment.isBefore(dateMoment.startOf('day'))) {
	    start = 0;
	    hideStart = true;
	  } else {
	    start = this._PixelTimeService.timeToPixel(this.model[startProperty]);
	  }

	  if (endMoment.isAfter(dateMoment.endOf('day'))) {
	    end = this._PixelTimeService.timeToPixel(new Date(2016, 0, 0, 23, 59, 59));
	    hideEnd = true;
	  } else {
	    end = this._PixelTimeService.timeToPixel(this.model[endProperty]);
	  }

	  top = start < 0 ? 0 : start;
	  height = end - top;

	  return {
	    top: top,
	    height: height,
	    hideStart: hideStart,
	    hideEnd: hideEnd
	  };
	};

	/**
	 * open appointment modal
	 * @param {Object<Event>} event
	 * @param {Object} appointment
	 */
	AppointmentCtrl.prototype.openAppointment = function (event, appointment) {
	  if (!this._AppointmentDragAndResizeState.isActive()) {
	    this._ModalService.openAppointmentModal(appointment);
	    event.stopPropagation();
	  }
	};

	/**
	 * copy appointment
	 */
	AppointmentCtrl.prototype.copy = function () {
	  var appointmentCopy = _.cloneDeep(this.model);
	  delete appointmentCopy._id;
	  delete appointmentCopy.seriesId;
	  appointmentCopy.recurring = {
	    enabled: false
	  };

	  this._ModalService.openAppointmentModal(appointmentCopy);
	};

	AppointmentCtrl.prototype.updateEnd = function (change) {
	  var minutes = change.hours * 60 + change.roundedMinutes;
	  this.model.end = moment(this.model.start).add(minutes, 'minutes');
	  this._AppointmentDA.update(this.model);
	};

	module.exports = AppointmentCtrl;

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';

	var RRULE_WEEK_DAYS = [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR, RRule.SA, RRule.SU];

	var frequencies = [{ weeks: 1, value: 7 }, { weeks: 2, value: 14 }, { weeks: 3, value: 21 }, { weeks: 4, value: 28 }, { weeks: 5, value: 35 }, { weeks: 6, value: 42 }, { weeks: 7, value: 49 }, { weeks: 8, value: 56 }];

	var AppointmentModalBaseCtrl = function AppointmentModalBaseCtrl(modalInstance, $injector) {
	  var self = this;
	  this._modalInstance = modalInstance;
	  this._AppointmentDA = $injector ? $injector.get('AppointmentDA') : undefined;
	  this._calendarDA = $injector ? $injector.get('CalendarDA') : undefined;
	  this._gettextCatalog = $injector ? $injector.get('gettextCatalog') : undefined;
	  this._ModalService = $injector ? $injector.get('ModalService') : undefined;
	  this._rootScope = $injector ? $injector.get('$rootScope') : undefined;
	  this._state = $injector ? $injector.get('$state') : undefined;
	  this._LocalStorage = $injector ? $injector.get('LocalStorage') : undefined;
	  this._Notification = $injector ? $injector.get('Notification') : undefined;
	  this._CustomerModel = $injector ? $injector.get('CustomerModel') : undefined;
	  this._DatepickerSettings = $injector ? $injector.get('DatepickerSettings') : undefined;
	  this._Notification = $injector ? $injector.get('Notification') : undefined;
	  this.submitted = false;
	  this.frequencies = [];
	  this.dtpStartOpened = false;
	  this.dtpEndOpened = false;
	  this.dtpOptions = this._DatepickerSettings ? this._DatepickerSettings.default : {};
	  this.initialResourceSet = false;

	  if ($injector) {
	    // generate frequencies for series tab
	    frequencies.forEach(function (frequency) {
	      self.frequencies.push({
	        label: self._gettextCatalog.getPlural(frequency.weeks, 'week', '{{$count}} weeks', {}),
	        value: frequency.value
	      });
	    });

	    this._rootScope.$watch(function () {
	      return self.appointment.start.getTime();
	    }, function (newValue, oldValue) {
	      var duration = moment(self.appointment.end).diff(oldValue);

	      if (!moment(newValue).isSame(moment(oldValue))) {
	        self.appointment.end = moment(self.appointment.start).add(duration).toDate();
	      }

	      self.checkCollision();
	    });

	    this._rootScope.$watch(function () {
	      return _.get(self, 'appointment.object._id') + _.get(self, 'appointment.room', '');
	    }, function () {
	      if (self.initialResourceSet) {
	        self.checkCollision();
	      }
	      self.initialResourceSet = true;
	    });
	  }
	};

	/**
	 * check for appointment collision
	 */
	AppointmentModalBaseCtrl.prototype.checkCollision = function () {
	  var self = this;

	  if (this.appointment.object && this.appointment.object._id && this.appointment.start && this.appointment.end) {
	    self.collision = { collided: false };
	    this._calendarDA.checkCollision(this.appointment._id, this.appointment.object._id, this.appointment.room, this.appointment.start, this.appointment.end).then(function (response) {
	      var employee;
	      var room;

	      if (_.get(response, 'employee.collided')) {
	        employee = _.find(self.resources.employees, { _id: response.employee.id });
	        response.employee.name = employee.fullname;
	      }

	      if (_.get(response, 'room.collided')) {
	        room = _.find(self.resources.rooms, { _id: response.room.id });
	        response.room.name = room.fullname;
	      }

	      self.collision = response;
	    });
	  }
	};

	/**
	 * generate series of appointments
	 */
	AppointmentModalBaseCtrl.prototype.generateSeries = function () {
	  var byweekday = [];
	  var rrulOptions = {
	    freq: RRule.WEEKLY,
	    interval: this.appointment.recurring.frequency / 7,
	    dtstart: this.appointment.start
	  };

	  this.appointment.recurring.until = this.appointment.recurring.until ? new Date(this.appointment.recurring.until) : moment(this.appointment.start).endOf('month').toDate();

	  // generate weekday settings
	  _.forEach(this.appointment.recurring.weekDays, function (weekDayEnabled, index) {
	    if (weekDayEnabled) {
	      byweekday.push(RRULE_WEEK_DAYS[index]);
	    }
	  });

	  if (byweekday.length > 0) {
	    rrulOptions.byweekday = byweekday;
	  }

	  if (this.appointment.recurring.endType === 'times') {
	    rrulOptions.count = this.appointment.recurring.times || 5;
	  } else if (rrulOptions.dtstart.getTime() >= this.appointment.recurring.until.getTime()) {
	    this.recurringDates = [];
	    return;
	  } else {
	    rrulOptions.until = this.appointment.recurring.until;
	  }

	  var rule = new RRule(rrulOptions);
	  this.recurringDates = rule.all();
	};

	/**
	 * regenerate appointment series on any recurring option changes
	 */
	AppointmentModalBaseCtrl.prototype.watchRecurringSettings = function () {
	  var self = this;
	  return this.rootScope.$watch(function () {
	    return self.appointment.recurring;
	  }, function (newValue, oldValue) {
	    if (newValue && newValue.enabled) {
	      if (!oldValue || !oldValue.enabled) {
	        var start = moment(self.appointment.start);
	        self.appointment.recurring = {
	          frequency: 7,
	          enabled: true,
	          weekDays: [false, false, false, false, false, false, false]
	        };

	        if (self.appointment.recurring.endType === 'date') {
	          self.appointment.recurring.until = self.appointment.recurring.until ? new Date(self.appointment.recurring.until) : moment(self.appointment.start).endOf('year').toDate();
	        } else {
	          self.appointment.recurring.endType = 'times';
	          self.appointment.recurring.times = self.appointment.recurring.times || 5;
	        }

	        self.appointment.recurring.weekDays[start.weekday()] = true;
	      }

	      self.generateSeries();
	    }
	  }, true);
	};

	AppointmentModalBaseCtrl.prototype.delete = function () {
	  this._rootScope.$broadcast('Booking:showDeclineModal', {
	    appointmentId: this.appointment._id,
	    appointmentModal: this
	  });
	};

	/**
	 * save/update current appointment form
	 */
	AppointmentModalBaseCtrl.prototype.save = function () {
	  var promise;
	  var self = this;
	  this.submitted = true;

	  if (this.AppointmentForm.$valid) {
	    if (this.appointment.type === 'course') {
	      this.appointment.membershipSettings = _.map(this.appointment.membershipSettings, function (participantsSetting) {
	        if (participantsSetting.customer) {
	          participantsSetting.customer = participantsSetting.customer._id;
	        }

	        return participantsSetting;
	      });

	      if (self.appointment._id) {
	        promise = this._AppointmentDA.update(this.appointment);
	      } else {
	        promise = this._AppointmentDA.insert(this.appointment);
	      }

	      promise.then(function () {
	        self.close();
	      });
	    } else if (this.appointment.type === 'customer') {
	      if (self.appointment._id) {
	        promise = self._AppointmentDA.update(self.appointment, self.appointment.sendNotifications);
	      } else {
	        promise = self._AppointmentDA.insert(self.appointment, self.appointment.sendNotifications);
	      }

	      promise.then(function () {
	        self.close();
	      });
	    } else {
	      if (self.appointment._id) {
	        promise = this._AppointmentDA.update(this.appointment);
	      } else {
	        promise = this._AppointmentDA.insert(this.appointment);
	      }

	      promise.then(function () {
	        self.close();
	      });
	    }
	  } else {
	    console.log(this.AppointmentForm);
	  }
	};

	/**
	 * remove current opened appointment
	 */
	AppointmentModalBaseCtrl.prototype.remove = function () {
	  var self = this;

	  this._AppointmentDA.remove(this.appointment._id, this.appointment.sendNotifications, this.appointment).then(function () {
	    self.close();
	  });
	};

	AppointmentModalBaseCtrl.prototype.openSeriesHead = function () {
	  this.close();

	  if (this.appointment.seriesId) {
	    this._ModalService.openAppointmentModal({ _id: this.appointment.seriesId });
	  }
	};

	AppointmentModalBaseCtrl.prototype.removeUnlincedICAL = function () {
	  var self = this;

	  self._AppointmentDA.removeSyncedAndUnlinked(self.appointment.object._id).then(function () {
	    self.close();
	    self._state.reload();
	  });
	};

	AppointmentModalBaseCtrl.prototype.removeUnlincedGoogle = function () {
	  var self = this;

	  self._AppointmentDA.removeGoogleSyncedAndUnlinked(self.appointment.office).then(function () {
	    self.close();
	    self._state.reload();
	  });
	};

	/**
	 * close appointment modal modal
	 * @param {*} data
	 */
	AppointmentModalBaseCtrl.prototype.close = function (data, storeAppointmentInSession) {
	  if (storeAppointmentInSession) {
	    this._LocalStorage.set('openAppointment', this.appointment);
	  } else {
	    this._LocalStorage.remove('openAppointment');
	  }

	  this._modalInstance.close(data);
	};

	AppointmentModalBaseCtrl.prototype.openCustomerModal = function (customer) {
	  var customerId = _.get(customer, '_id', 'new');

	  this.close({}, true);
	  this._state.go('private.main.customerProfile', { customerId: customerId });
	};

	module.exports = AppointmentModalBaseCtrl;

/***/ }),
/* 171 */
/***/ (function(module, exports) {

	'use strict';

	var AppointmentsCtrl = function AppointmentsCtrl($scope) {
	  var self = this;
	  this.appointmentScopes = $scope.appointmentScopes = [];
	  $scope.$on('t2g:calendar:changed', function () {
	    self.calcGroups();
	  });
	};

	AppointmentsCtrl.prototype.add = function (appointmentScope) {
	  this.appointmentScopes.push(appointmentScope);
	};

	AppointmentsCtrl.prototype.remove = function (appointmentScope) {
	  _.remove(this.appointmentScopes, { $id: appointmentScope.$id });
	  this.calcGroups();
	};

	AppointmentsCtrl.prototype.calcGroups = function () {
	  var scopeGroups = [[]];
	  var scopesLen = this.appointmentScopes.length;
	  var lastScopeGroup = scopeGroups[0];

	  this.appointmentScopes.sort(function (scope1, scope2) {
	    return scope1.appointment.preparationStart - scope2.appointment.preparationStart;
	  });

	  if (scopesLen > 0) {
	    scopeGroups[0].push(this.appointmentScopes[0]);
	  }

	  _.forEach(this.appointmentScopes, function (scope, index) {
	    var latestScope = lastScopeGroup[0];

	    if (index > 0) {
	      if (moment(scope.appointment.preparationStart).isSameOrAfter(moment(latestScope.appointment.followUpEnd))) {
	        var newGroup = [scope];
	        lastScopeGroup = newGroup;
	        scopeGroups.push(newGroup);
	      } else if (moment(scope.appointment.followUpEnd).isSameOrAfter(moment(latestScope.appointment.followUpEnd))) {
	        // add latest end to start of array
	        lastScopeGroup.unshift(scope);
	      } else {
	        lastScopeGroup.push(scope);
	      }
	    }
	  });

	  // calc widths
	  _.forEach(scopeGroups, function (scopeGroup) {
	    var width = 100 / scopeGroup.length;

	    _.forEach(scopeGroup, function (appointment, index) {
	      appointment.setVerticalPos(width, index * width);
	    });
	  });
	};

	module.exports = AppointmentsCtrl;

/***/ }),
/* 172 */
/***/ (function(module, exports) {

	"use strict";

	var CalendarContainerCtrl = function CalendarContainerCtrl(calendar, ModalService, resources) {
	  this.calendarModel = calendar;
	  this.resources = resources;
	  this._ModalService = ModalService;
	};

	CalendarContainerCtrl.prototype.addAppointment = function () {
	  this._ModalService.openAppointmentModal();
	};

	module.exports = CalendarContainerCtrl;

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';

	var CalendarCtrl = function CalendarCtrl($scope, $state, $stateParams, $window, gettextCatalog, ModalService, PixelTimeService, DatepickerSettings, settings) {
	  var self = this;
	  var contextMenuItems = {
	    appointment: {
	      label: gettextCatalog.getString('Appointment'),
	      action: this.openAppointmentModal.bind(this, 'customer'),
	      icon: 'icon-account'
	    },
	    course: {
	      label: gettextCatalog.getString('Course'),
	      action: this.openAppointmentModal.bind(this, 'course'),
	      icon: 'icon-account-multiple'
	    },
	    private: {
	      label: gettextCatalog.getString('Private'),
	      action: this.openAppointmentModal.bind(this, 'private'),
	      icon: 'icon-lock',
	      seperator: true
	    },
	    abort: {
	      label: gettextCatalog.getString('Abort'),
	      action: angular.noop
	    }
	  };

	  this._scope = $scope;
	  this._PixelTimeService = PixelTimeService;
	  this._ModalService = ModalService;
	  this._stateParams = $stateParams;
	  this._state = $state;
	  this._window = $window;
	  this.viewModel = {
	    date: Date.parse(this._stateParams.date),
	    resource: this._stateParams.resource,
	    view: this._stateParams.view
	  };
	  this.currentDate = new Date();
	  this.dtpOptions = DatepickerSettings.default;
	  this.views = [{
	    label: gettextCatalog.getString('Day'),
	    id: 'day'
	  }, {
	    label: gettextCatalog.getString('Week'),
	    id: 'week'
	  }, {
	    label: gettextCatalog.getString('4 Days'),
	    id: '4days'
	  }, {
	    label: gettextCatalog.getString('List'),
	    id: 'list'
	  }];
	  this.dtpCurrentOpened = false;
	  this.dtpFormat = this.viewModel.view === 'week' ? 'dd.MM.yyyy' : 'dd.MM.yyyy (EEE)';
	  this.dtpSize = this.viewModel.view === 'week' ? 10 : 16;
	  this.contextMenuModel = {
	    event: 'click',
	    items: []
	  };
	  this.showResourceDropdown = false;
	  this.resourceCount = 0;

	  _.forEach($scope.resources, function (resource) {
	    if (resource._id !== 'all-employees' && resource._id !== 'all-rooms') {
	      self.resourceCount++;

	      if (self.resourceCount > 1) {
	        self.showResourceDropdown = true;
	        return false;
	      }
	    }
	  });

	  _.forEach(contextMenuItems, function (contextMenuItem, key) {
	    if (settings.calendar.contextMenu[key]) {
	      self.contextMenuModel.items.push(contextMenuItem);
	    }
	  });

	  $scope.$watch(function () {
	    return self.viewModel;
	  }, function (newValue, oldValue) {
	    if (!angular.equals(newValue, oldValue)) {
	      var date = moment(newValue.date);
	      self._state.go('private.main.calendar', {
	        resource: newValue.resource,
	        date: date.format('YYYY-MM-DD'),
	        view: newValue.view
	      });
	    }
	  }, true);
	};

	CalendarCtrl.prototype.changeDate = function (direction) {
	  var difference;

	  switch (this.viewModel.view) {
	    case 'day':
	      difference = 1;
	      break;
	    case '4days':
	      difference = 4;
	      break;
	    case 'list':
	      difference = 7;
	      break;
	    case 'week':
	      difference = 7;
	      break;
	  }

	  difference = difference * direction;
	  var date = moment(this.viewModel.date).add(difference, 'days');
	  this.viewModel.date = date.toDate();
	};

	CalendarCtrl.prototype.openAppointmentModal = function (type, event, originalEvent, metaData) {
	  var clickedTime = this._PixelTimeService.pixelToTime(originalEvent.offsetY, true);
	  var start = new Date(metaData.date);
	  start.setHours(clickedTime.hours);
	  start.setMinutes(clickedTime.roundedMinutes);
	  var end = new Date(start);
	  end.setHours(clickedTime.hours + 1);

	  var appointment = {
	    type: type,
	    start: start,
	    end: end,
	    object: {
	      _id: metaData.resource
	    }
	  };

	  this._ModalService.openAppointmentModal(appointment);
	};

	CalendarCtrl.prototype.setToday = function () {
	  this.viewModel.date = moment().startOf('day').toDate();
	};

	CalendarCtrl.prototype.print = function () {
	  this._window.print();
	};

	CalendarCtrl.prototype.getResourceImageStyle = function (resource) {
	  var defImage = '/img/employee_man.png';

	  if (resource.salutation === 'f') {
	    defImage = '/img/employee_woman.png';
	  }

	  return {
	    'background-image': 'url(' + resource.imageUrl + '), url(' + defImage + ')'
	  };
	};

	module.exports = CalendarCtrl;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var AppointmentModalBaseCtrl = __webpack_require__(170);

	var CourseAppointmentModalCtrl = function CourseAppointmentModalCtrl($rootScope, $controller, $injector, AppointmentDA, appointment, customers, customLabels, gettextCatalog, modalInstance, resources, office) {
	  AppointmentModalBaseCtrl.call(this, modalInstance, $injector);
	  var initialEmployeeId = _.get(appointment, 'object._id');

	  this.appointment = appointment;
	  this.customerLabel = gettextCatalog.getString(customLabels.customer.toLowerCase());
	  this.customers = customers;
	  this.resources = resources;
	  this.rootScope = $rootScope;
	  this.office = office;
	  this.showMembershipForm = false;
	  this.membershipSubmitted = false;
	  this.membershipFormMode;
	  this._AppointmentDA = AppointmentDA;
	  var courseName = _.get(appointment, 'name');

	  if (courseName) {
	    this.title = gettextCatalog.getString('Course') + ': ' + courseName;
	  } else {
	    this.title = gettextCatalog.getString('Course');
	  }

	  // set default resource
	  if (!initialEmployeeId) {
	    this.appointment.object = {
	      _id: this.resources.employees[0]._id
	    };
	  }

	  this.recurringSettingsWatcher = this.watchRecurringSettings();
	};

	CourseAppointmentModalCtrl.prototype = new AppointmentModalBaseCtrl();

	/**
	 * handler will be called if selection in course dropdown has been changed
	 */
	CourseAppointmentModalCtrl.prototype.courseChanged = function () {
	  var selectedCourse = _.find(this.office.courses, { _id: this.appointment.course });
	  if (!selectedCourse) {
	    return;
	  }

	  this.appointment.end = moment(this.appointment.start).add(selectedCourse.duration, 'minutes').toDate();
	  this.appointment.name = selectedCourse.name;
	  this.appointment.partMax = selectedCourse.partMax;
	};

	/**
	 * add customer to membership list
	 */
	CourseAppointmentModalCtrl.prototype.addMembership = function () {
	  this.showMembershipForm = true;
	  this.currentMembership = {
	    startType: 'startOfCourse',
	    endType: 'endOfCourse'
	  };
	  this.membershipFormMode = 'add';
	};

	/**
	 * abort the add/edit process of membership
	 */
	CourseAppointmentModalCtrl.prototype.abortMembershipEntry = function () {
	  this.showMembershipForm = false;
	  this.currentMembership = null;
	  this.membershipFormMode = null;
	};

	/**
	 * edit selected membership
	 *
	 * @param {Number} index
	 */
	CourseAppointmentModalCtrl.prototype.editMembership = function (index) {
	  this.showMembershipForm = true;
	  this.currentMembership = this.appointment.membershipSettings[index];
	  this.membershipFormMode = 'edit';
	};

	/**
	 * save/update new/selected membership
	 */
	CourseAppointmentModalCtrl.prototype.saveMembership = function () {
	  this.membershipSubmitted = true;
	  // check dublicate && update selected
	  if (this.MembershipForm.$valid) {
	    if (_.get(this.currentMembership, 'customer._id')) {
	      if (this.membershipFormMode === 'add') {
	        this.appointment.membershipSettings.push(this.currentMembership);
	      }

	      this.abortMembershipEntry();
	    }
	  }
	};

	CourseAppointmentModalCtrl.prototype.addParticipant = function () {
	  var self = this;

	  if (this.appointment._id && this.currentParticipant && this.currentParticipant._id) {
	    this._AppointmentDA.addParticipant(this.appointment._id, this.currentParticipant._id).then(function (response) {
	      self.appointment = response[0];
	      self.currentParticipant = null;
	    });
	  }
	};

	CourseAppointmentModalCtrl.prototype.checkParticipantValidity = function () {
	  var isValid = true;
	  var currentParticipantId = _.get(this.currentParticipant, '_id');

	  if (!currentParticipantId) {
	    return false;
	  } else {
	    _.forEach(this.appointment.participants, function (participant) {
	      if (participant.customer && participant.customer._id === currentParticipantId) {
	        isValid = false;
	        return false;
	      }
	    });
	  }

	  return isValid;
	};

	CourseAppointmentModalCtrl.prototype.removeParticipants = function (index) {
	  var self = this;
	  var customerId = _.get(self.appointment, 'participants[' + index + '].customer._id', index);

	  this._AppointmentDA.removeParticipant(this.appointment._id, customerId).then(function (response) {
	    self.appointment = response[0];
	  });
	};

	/**
	 * remove a membership
	 *
	 * @param {Number} index
	 */
	CourseAppointmentModalCtrl.prototype.removeMembership = function (index) {
	  this.appointment.membershipSettings.splice(index, 1);
	};

	module.exports = CourseAppointmentModalCtrl;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var AppointmentModalBaseCtrl = __webpack_require__(170);

	var CustomerAppointmentModalCtrl = function CustomerAppointmentModalCtrl($controller, $injector, $timeout, $rootScope, appointment, customers, customLabels, gettextCatalog, modalInstance, resources, services, office) {
	  AppointmentModalBaseCtrl.call(this, modalInstance, $injector);

	  var initialEmployeeId = _.get(appointment, 'object._id');
	  this.customerLabel = gettextCatalog.getString(customLabels.customer.toLowerCase());
	  this.customers = customers;
	  this.services = services;
	  this.appointment = appointment;
	  this.resources = resources;
	  this.rootScope = $rootScope;
	  this._timeout = $timeout;
	  this.office = office;
	  this.isCreatedByCoach = appointment.createdBy === 'coach';
	  this.smsReminderEnabled = _.get(this.office, 'settings.reminder.sms.enabled');
	  this.emailReminderEnabled = _.get(this.office, 'settings.reminder.email.enabled');
	  this.showReminderTab = this.smsReminderEnabled || this.emailReminderEnabled;
	  this.currentService = null;
	  this.sendNotificationEnabled = _.get(office, 'settings.sendAppointmentChangeNotificationMails', false);
	  var customerFullName = _.get(this.appointment, 'customer.fullname');

	  if (customerFullName) {
	    this.title = gettextCatalog.getString('Appointment with {{customer}}', {
	      customer: customerFullName
	    });
	  } else {
	    this.title = gettextCatalog.getString('Appointment with {{customer}}', {
	      customer: _.get(this.appointment, 'customer.firstname', '?')
	    });
	  }

	  // set default resource
	  if (!initialEmployeeId) {
	    this.appointment.object = {
	      _id: this.resources.employees[0]._id
	    };
	  }

	  if (!appointment._id) {
	    var emailEnabled = _.get(office, 'settings.reminder.email.enabled', false);
	    var smsEnabled = _.get(office, 'settings.reminder.sms.enabled', false);

	    this.appointment.reminder = {
	      email: {
	        enabled: emailEnabled
	      },
	      sms: {
	        enabled: smsEnabled
	      }
	    };

	    if (resources.rooms && resources.rooms.length) {
	      this.appointment.room = resources.rooms[0]._id;
	    }
	  }

	  if (_.get(this, 'appointment.reminder.sms.enabled') && this.isCreatedByCoach) {
	    this.appointment.reminder.sms.enabled = false;
	  }

	  // set sendNotifications
	  if (this.sendNotificationEnabled && this.appointment.sendNotifications === undefined) {
	    this.appointment.sendNotifications = true;
	  }

	  this.selectServicesForEmployee(this.appointment.object._id);
	  this.recurringSettingsWatcher = this.watchRecurringSettings();
	};

	CustomerAppointmentModalCtrl.prototype = new AppointmentModalBaseCtrl();

	CustomerAppointmentModalCtrl.prototype.selectServicesForEmployee = function (employeeId) {
	  this.employeeServices = _.filter(this.services, function (service) {
	    if (service.resources.employee.indexOf(employeeId) > -1) {
	      return true;
	    } else {
	      return false;
	    }
	  });
	};

	CustomerAppointmentModalCtrl.prototype.currentServiceChanged = function () {
	  if (this.currentService) {
	    this.selectService(this.currentService);
	    this.currentService = null;
	  }
	};

	/**
	 * calc the duration and overall price
	 *
	 * @param {Boolean} recalcDuration
	 */
	CustomerAppointmentModalCtrl.prototype.calcPriceAndDuration = function (recalcDuration) {
	  var self = this;
	  this.appointment.price = 0;
	  this.duration = 0;

	  _.forEach(this.appointment.services, function (service) {
	    if (service.price) {
	      self.appointment.price += _.toNumber(service.price);
	    }

	    self.duration += service.duration;
	  });

	  this.duration = this.duration === 0 ? 30 : this.duration;

	  if (recalcDuration) {
	    self.appointment.end = moment(self.appointment.start).add(self.duration, 'minutes').toDate();
	  }
	};

	/**
	 * add a service to appointment
	 */
	CustomerAppointmentModalCtrl.prototype.selectService = function ($item) {
	  var selectedService = {
	    _id: $item._id,
	    name: $item.name,
	    duration: $item.duration,
	    price: $item.price,
	    shorthand: $item.shorthand
	  };

	  this.appointment.services.push(selectedService);
	  this.calcPriceAndDuration(true);
	  this.service = '';
	};

	/**
	 * remove service from appointment
	 * @param {Number} index
	 */
	CustomerAppointmentModalCtrl.prototype.removeService = function (index) {
	  this.appointment.services.splice(index, 1);
	  this.calcPriceAndDuration();
	};

	/**
	 * move a service up or down in service list
	 * @param {Number} index
	 * @param {Number} direction
	 */
	CustomerAppointmentModalCtrl.prototype.moveService = function (index, direction) {
	  if (direction > 0) {
	    if (index > 0) {
	      this.appointment.services.move(index, index - 1);
	    }
	  } else {
	    if (index < this.appointment.services.length - 1) {
	      this.appointment.services.move(index, index + 1);
	    }
	  }
	};

	module.exports = CustomerAppointmentModalCtrl;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var AppointmentModalBaseCtrl = __webpack_require__(170);

	var PrivateAppointmentModalCtrl = function PrivateAppointmentModalCtrl($controller, $injector, $rootScope, appointment, gettextCatalog, modalInstance, resources) {
	  AppointmentModalBaseCtrl.call(this, modalInstance, $injector);
	  var self = this;
	  var initialEmployeeId = _.get(appointment, 'object._id');
	  this.appointment = appointment;
	  this.resources = resources;
	  this.title = gettextCatalog.getString('Private Appointment');
	  this.rootScope = $rootScope;
	  this.unlinkedCount = 0;
	  this.unlinkedQuestion = '';

	  // set default resource
	  if (!initialEmployeeId) {
	    this.appointment.object = {
	      _id: this.resources.employees[0]._id
	    };
	  }

	  this.recurringSettingsWatcher = this.watchRecurringSettings();

	  if (self.appointment.type !== 'private') return;

	  if (!self.appointment.externUID && !self.appointment.googleEvent) return;

	  var isGoogle = self.appointment.source === 'google';
	  var targetID = isGoogle ? self.appointment.office : self.appointment.object._id;
	  var getUnlinked = isGoogle ? self._AppointmentDA.getGoogleSyncedAndUnlinked : self._AppointmentDA.getSyncedAndUnlinked;

	  getUnlinked(targetID).then(function (response) {
	    if (!response.success || !response.unlinkedAppointments) return;

	    self.unlinkedCount = response.unlinkedAppointments;

	    if (self.unlinkedCount > 1) {
	      self.unlinkedQuestion = gettextCatalog.getString('You have {{count}} unlinked appointments. Do you want to remove them now?', { count: self.unlinkedCount });
	    } else {
	      self.unlinkedQuestion = gettextCatalog.getString('You have one unlinked appointment. Do you want to remove it now?');
	    }
	  });
	};

	PrivateAppointmentModalCtrl.prototype = new AppointmentModalBaseCtrl();

	module.exports = PrivateAppointmentModalCtrl;

/***/ }),
/* 177 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (PixelTimeService) {
	  return {
	    restrict: 'E',
	    template: '<div class="absent-time" data-ng-class="{\'absent-time--absence\': !absentTime.available}" data-ng-repeat="absentTime in absentTimes" data-ng-style="absentTime"></div>',
	    replace: true,
	    scope: {
	      workingHours: '='
	    },
	    link: function link($scope, $element) {
	      $scope.absentTimes = [];
	      var times = $scope.workingHours.times;
	      $scope.available = $scope.workingHours.available;

	      if ($scope.available && times) {
	        if (times[0]) {
	          $scope.absentTimes.push({
	            top: 0,
	            available: $scope.workingHours.available,
	            height: PixelTimeService.minutesToPixel(times[0].start)
	          });
	        }

	        if (times.length === 1) {
	          $scope.absentTimes.push({
	            bottom: 0,
	            available: $scope.workingHours.available,
	            top: PixelTimeService.minutesToPixel(times[0].end)
	          });
	        } else if (times.length === 2) {
	          $scope.absentTimes.push({
	            top: PixelTimeService.minutesToPixel(times[0].end),
	            available: $scope.workingHours.available,
	            height: PixelTimeService.minutesToPixel(times[1].start - times[0].end, true)
	          });

	          $scope.absentTimes.push({
	            top: PixelTimeService.minutesToPixel(times[1].end),
	            available: $scope.workingHours.available,
	            bottom: 0
	          });
	        }
	      } else {
	        $scope.absentTimes.push({
	          top: 0,
	          available: $scope.workingHours.available,
	          bottom: 0
	        });
	      }
	    }
	  };
	};

/***/ }),
/* 178 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($timeout, PixelTimeService, AppointmentDragAndResizeState, AppointmentDA) {
	  return {
	    restrict: 'E',
	    require: ['^appointments', 'appointment'],
	    templateUrl: '/app/modules/calendar/AppointmentView.html?v=4.5.6',
	    replace: true,
	    controller: 'AppointmentCtrl as AppointmentCtrl',
	    link: function link($scope, $element, $attributes, controllers) {
	      var appointmentsCtrl = controllers[0];
	      var appointmentCtrl = controllers[1];
	      var preparationElement = $element.find('.appointment__pause--top');
	      var followUpElement = $element.find('.appointment__pause--bottom');

	      appointmentsCtrl.add($scope);

	      /**
	       * set vertical position of appointment
	       * @param {Number} width
	       * @param {Number} left
	       */
	      $scope.setVerticalPos = function (width, left) {
	        $element.css('left', left + '%');
	        $element.css('width', width + '%');
	      };

	      /**
	       * (re)draw appointment
	       */
	      $scope.draw = function () {
	        // set horizontal pos
	        var appointmentPosition = appointmentCtrl.calculateVerticalPosition('start', 'end');
	        var preparationPosition = appointmentCtrl.calculateVerticalPosition('preparationStart', 'start');
	        var followUpPosition = appointmentCtrl.calculateVerticalPosition('end', 'followUpEnd');

	        $element.css({
	          top: appointmentPosition.top + 'px',
	          height: appointmentPosition.height + 'px'
	        });

	        if (!preparationPosition.hideStart) {
	          preparationElement.css({
	            top: -preparationPosition.height + 'px',
	            height: preparationPosition.height + 'px'
	          });
	        } else {
	          preparationElement.remove();
	        }

	        if (!followUpPosition.hideEnd) {
	          followUpElement.css({
	            bottom: -followUpPosition.height + 'px',
	            height: followUpPosition.height + 'px'
	          });
	        } else {
	          followUpElement.remove();
	        }

	        if ($scope.$last) {
	          $timeout(function () {
	            appointmentsCtrl.calcGroups();
	          });
	        }
	      };

	      $scope.$on('$destroy', function () {
	        appointmentsCtrl.remove($scope);
	      });

	      $scope.$on('angular-resizable.resizeStart', function (event, data) {
	        AppointmentDragAndResizeState.activate();
	      });

	      $scope.$on('angular-resizable.resizeEnd', function (event, data) {
	        var newDuration = PixelTimeService.pixelToTime(data.height, false);
	        var newDurationMinutes = newDuration.hours * 60 + newDuration.roundedMinutes;

	        $scope.appointment.end = moment($scope.appointment.start).add(newDurationMinutes, 'minutes').toDate();
	        AppointmentDA.update($scope.appointment);
	        AppointmentDragAndResizeState.deactivate();
	      });

	      $element.draggable({
	        snap: '.calendar__appointment-column',
	        snapMode: 'inner',
	        snapTolerance: 50,
	        distance: 20,
	        opacity: 0.7,
	        revert: 'invalid',
	        start: function start() {
	          AppointmentDragAndResizeState.activate();
	        },
	        stop: function stop() {
	          AppointmentDragAndResizeState.deactivate();
	        }
	      });

	      // initial draw of appointment
	      $scope.draw();
	    }
	  };
	};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (AppointmentDA, PixelTimeService) {
	  'use strict';

	  return {
	    restrict: 'E',
	    template: '<div class="calendar__appointment-column">' + '<appointment data-ng-repeat="appointment in resource.appointments"></appointment>' + '<absent-times working-hours="resource.workingHours"></absent-times>' + '</div>',
	    replace: true,
	    controller: 'AppointmentsCtrl as AppointmentsCtrl',
	    link: function link($scope, $element, $attributes) {
	      var date = $attributes.date;
	      var resource = $scope.resource;

	      $element.droppable({
	        drop: function drop(event, ui) {
	          var contextElement = angular.element(ui.draggable.context);
	          var contextAppointment = contextElement.length > 0 ? contextElement.scope().appointment : null;
	          var top = _.get(ui, 'position.top');

	          if (contextAppointment) {
	            var duration = contextAppointment.end.getTime() - contextAppointment.start.getTime();
	            var timeParts = PixelTimeService.pixelToTime(top, true);
	            var newStart = moment(date);
	            newStart.set('hour', timeParts.hours);
	            newStart.set('minute', timeParts.roundedMinutes);
	            contextAppointment.start = newStart.toDate();
	            contextAppointment.end = moment(newStart).add(duration).toDate();

	            if (resource.type === 'room') {
	              contextAppointment.room = resource._id;
	            } else {
	              contextAppointment.employee = resource._id;
	              contextAppointment.object = contextAppointment.object || {};
	              contextAppointment.object._id = resource._id;
	            }

	            AppointmentDA.update(contextAppointment);
	          }
	        }
	      });
	    }
	  };
	};

/***/ }),
/* 180 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($timeout) {
	  return {
	    restrict: 'E',
	    templateUrl: '/app/modules/calendar/CalendarView.html?v=4.5.6',
	    replace: true,
	    scope: {
	      model: '=',
	      resources: '='
	    },
	    controller: 'CalendarCtrl as CalendarCtrl',
	    link: function link($scope, $element) {
	      function setCalendarWidth() {
	        var scrollWrapper = $element.find('.calendar__scroll-wrapper');
	        var headerWidth = $element.find('.calendar__header')[0].scrollWidth;
	        scrollWrapper.css('width', headerWidth + 'px');
	      }

	      function setHeaderPadding() {
	        var calendarHeader = $element.find('.calendar__header');
	        var calendarBody = $element.find('.calendar__body');
	        var calendarDates = $element.find('.calendar__header__row--dates');
	        var calendarDatesRight;
	        var calendarBodyRight;
	        var scrollBarWidth;

	        if (calendarHeader.length > 0 && calendarBody.length > 0 && calendarDates.length > 0) {
	          calendarDatesRight = calendarDates[0].getBoundingClientRect().right;
	          calendarBodyRight = calendarBody[0].getBoundingClientRect().right;
	          scrollBarWidth = calendarDatesRight - calendarBodyRight;
	          calendarHeader.css('padding-right', scrollBarWidth + 'px');
	        }
	      }

	      $scope.$on('t2g:window:resize', function () {
	        setCalendarWidth();
	        setHeaderPadding();
	      });

	      $timeout(setCalendarWidth);
	      $timeout(setHeaderPadding);
	    }
	  };
	};

/***/ }),
/* 181 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (ModalService) {
	  return {
	    restrict: 'E',
	    templateUrl: '/app/modules/calendar/CalendarListView.html?v=4.5.6',
	    scope: {
	      dates: '='
	    },
	    controller: function controller($scope) {
	      $scope.concatedDates = [];

	      console.log($scope.dates);

	      _.forEach($scope.dates, function (date) {
	        var appointments = [];

	        if (appointments.length > 0) {
	          $scope.concatedDates.push({
	            date: date.date,
	            appointments: appointments
	          });
	        }
	      });

	      $scope.openAppointment = function (appointment) {
	        ModalService.openAppointmentModal(appointment);
	      };

	      $scope.dateHaveAppointments = function (date) {
	        var count = 0;

	        _.forEach(date.resources, function (resource) {
	          count += _.size(resource.appointments);
	        });

	        return count > 0;
	      };
	    }
	  };
	};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  return {
	    restrict: 'A',
	    link: function link($scope, $element) {
	      var scrollContainer = angular.element('.calendar__scroll-wrapper');
	      var calendarHeader = angular.element('.calendar__header');
	      var calendarHeaderHeight = calendarHeader[0].getBoundingClientRect().height;

	      $scope.$on('t2g:window:resize', function () {
	        calendarHeaderHeight = calendarHeader[0].getBoundingClientRect().height;
	      });

	      scrollContainer.on('scroll', function () {
	        var scrollTop = this.scrollTop;
	        $element.css({ top: calendarHeaderHeight - scrollTop + 'px' });
	      });
	    }
	  };
	};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($interval, $document, calendarSettings, PixelTimeService) {
	  return {
	    restrict: 'E',
	    template: '<div class="calendar-timeline"></div>',
	    replace: true,
	    link: function link($scope, $element) {
	      var scrollWrapper = angular.element('.calendar__scroll-wrapper');
	      var initialTop = setPosition();
	      var scrollToY = initialTop > 50 ? initialTop - 50 : 0;

	      if (scrollWrapper && scrollWrapper[0] && initialTop) {
	        scrollWrapper[0].scrollTop = scrollToY;
	      }

	      $interval(function () {
	        setPosition();
	      }, 60000);

	      function setPosition() {
	        var top;
	        var now = new Date();

	        if (now.getHours() > calendarSettings.offset) {
	          top = PixelTimeService.timeToPixel(new Date());
	          $element.css('top', top + 'px');
	        }

	        return top;
	      }
	    }
	  };
	};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (calendarSettings) {
	  return {
	    pixelToTime: pixelToTime,
	    timeToPixel: timeToPixel,
	    minutesToPixel: minutesToPixel
	  };

	  /**
	   * get hours and minutes from pixel
	   * @param {number} pixel
	   * @param {boolean} useOffset
	   * @returns {{hours: number, minutes: number}}
	   */
	  function pixelToTime(pixel, useOffset) {
	    var offset = useOffset ? calendarSettings.offset : 0;
	    var hours = Math.floor(pixel / calendarSettings.hourHeight) + offset;
	    var minutes = Math.floor(pixel % calendarSettings.hourHeight / calendarSettings.hourHeight * 60);
	    var roundedMinutes = 15 * Math.round(minutes / 15);

	    if (roundedMinutes === 60) {
	      hours++;
	      roundedMinutes = 0;
	    }

	    return {
	      hours: hours,
	      minutes: minutes,
	      roundedMinutes: roundedMinutes
	    };
	  }

	  /**
	   * get pixel (top) from datetime
	   * @param {date} dateTime
	   * @returns {number}
	   */
	  function timeToPixel(dateTime) {
	    var hours = dateTime.getHours();
	    var minutes = dateTime.getMinutes();

	    return Math.floor((hours + minutes / 60 - calendarSettings.offset) * calendarSettings.hourHeight);
	  }

	  /**
	   * mainly used for calc absent time blocks
	   * @param {number} minutes
	   * @returns {number}
	   */
	  function minutesToPixel(minutes, disableOffset) {
	    var offset = disableOffset ? 0 : calendarSettings.offset;

	    return Math.floor((minutes / 60 - offset) * calendarSettings.hourHeight);
	  }
	};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($timeout) {
	  var active = false;

	  return {
	    activate: activate,
	    deactivate: deactivate,
	    isActive: isActive
	  };

	  function activate() {
	    active = true;
	  }

	  function deactivate() {
	    $timeout(function () {
	      active = false;
	    });
	  }

	  function isActive() {
	    return active;
	  }
	};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var courseModule = angular.module('t2g.course', ['gettext', 'ui.router', __webpack_require__(160).name, __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = courseModule;

	courseModule.controller('CourseListCtrl', __webpack_require__(187));
	courseModule.controller('CourseModalCtrl', __webpack_require__(188));

	courseModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.courses', {
	    url: '/courses',
	    title: 'Courses',
	    templateUrl: '/app/modules/course/list/CourseListView.html?v=4.5.6',
	    controller: 'CourseListCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, $rootScope, CourseModal, officeResolve) {
	  $scope.office = officeResolve;

	  /**
	   *  open course modal
	   * @param course
	   */
	  $scope.openCourseModal = function (course) {
	    CourseModal.open(course);
	  };

	  /**
	   * update office model
	   * @type {*}
	   */
	  var updateOffice = $rootScope.$on('Office:update', function (event, response) {
	    $scope.office = response;
	  });

	  /**
	   * remove event listener if day has changed (CalendarCtrl destroyed)
	   */
	  $scope.$on('$destroy', function () {
	    updateOffice();
	  });
	};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, gettextCatalog, CourseModal, OfficeModel, OfficeDA, Notification) {
	  var newCourse = false;
	  $scope.showValidation = false;

	  this.setCurrentItem = function (course) {
	    OfficeDA.get().then(function (office) {
	      $scope.office = office;
	    });

	    if (!course) {
	      newCourse = true;

	      course = {
	        name: '',
	        duration: 60,
	        offers: [{
	          name: gettextCatalog.getString('Price for single course'),
	          price: 0
	        }]
	      };

	      $scope.currentCourse = course;
	      $scope.backupItem = angular.copy($scope.currentCourse);
	    } else {
	      $scope.currentCourse = course;
	    }
	  };

	  $scope.setCurrentItem = this.backupCurrentItem;

	  /**
	   * save course to database
	   */
	  $scope.save = function () {
	    $scope.showValidation = true;
	    if (newCourse) {
	      if (!$scope.office.courses) {
	        $scope.office.courses = [];
	      }

	      $scope.office.courses.push($scope.currentCourse);
	    }

	    if ($scope.CourseOffersForm.$valid && $scope.CourseCommonForm.$valid) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant save course (Error: {{error}})', { error: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('Course saved'));
	          CourseModal.close();
	        }
	      });
	    }
	  };

	  /**
	   * delete course from database
	   */
	  $scope.delete = function () {
	    var index = -1;

	    for (var i = 0; i < $scope.office.courses.length; i++) {
	      if (angular.equals($scope.office.courses[i], $scope.currentCourse)) {
	        index = i;
	        break;
	      }
	    }

	    if (index > -1) {
	      $scope.office.courses.splice(index, 1);

	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant remove course (Error: {{error}})', { error: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('Course removed'));
	          CourseModal.close();
	        }
	      });
	    } else {
	      Notification.addErrorMessage(gettextCatalog.getString({ text: 'Unknown' }));
	    }
	  };

	  $scope.addOffer = function () {
	    if (!$scope.currentCourse.offers || !angular.isArray($scope.currentCourse.offers)) {
	      $scope.currentCourse.offers = [];
	    }

	    $scope.currentCourse.offers.push({
	      name: '',
	      price: 0
	    });
	  };

	  $scope.removeOffer = function (index) {
	    $scope.currentCourse.offers.splice(index, 1);
	  };

	  /**
	   * close course modal
	   */
	  $scope.abort = function () {
	    for (var prob in $scope.backupItem) {
	      if ($scope.currentCourse.hasOwnProperty(prob)) {
	        // check if property exists in master data
	        $scope.currentCourse[prob] = $scope.backupItem[prob];
	      }
	    }

	    CourseModal.close();
	  };
	};

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var customerModule = angular.module('t2g.customer', ['gettext', 'ngFileUpload', 'ui.router', __webpack_require__(2).name, __webpack_require__(156).name, __webpack_require__(160).name, __webpack_require__(9).name, __webpack_require__(6).name]);

	module.exports = customerModule;

	customerModule.controller('CustomerProfileCtrl', __webpack_require__(190));
	customerModule.controller('CustomerUploadCtrl', __webpack_require__(193));
	customerModule.controller('CustomerListCtrl', __webpack_require__(194));

	customerModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.customer', {
	    url: '/customers',
	    title: 'Customers',
	    templateUrl: '/app/modules/customer/list.html?v=4.5.6',
	    controller: 'CustomerListCtrl as CustomerListCtrl',
	    resolve: {
	      customers: ["CustomerDA", function customers(CustomerDA) {
	        return CustomerDA.list();
	      }]
	    }
	  }).state('private.main.customerUpload', {
	    url: '/customerUpload',
	    title: 'Customers',
	    templateUrl: '/app/modules/customer/upload/CustomerUploadView.html?v=4.5.6',
	    controller: 'CustomerUploadCtrl'
	  }).state('private.main.customerProfile', {
	    url: '/customers/:customerId?referrer',
	    title: 'Customers',
	    templateUrl: '/app/modules/customer/profile/partial-customer-profile.html?v=4.5.6',
	    controller: 'CustomerProfileCtrl',
	    resolve: {
	      customer: ["$stateParams", "CustomerDA", function customer($stateParams, CustomerDA) {
	        if ($stateParams.customerId && $stateParams.customerId !== 'new') {
	          return CustomerDA.get($stateParams.customerId);
	        } else {
	          return {};
	        }
	      }],
	      filteredCustomers: ["CustomerDA", function filteredCustomers(CustomerDA) {
	        return CustomerDA.getFiltered();
	      }],
	      office: ["OfficeDA", function office(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      resources: ["ResourceDA", function resources(ResourceDA) {
	        return ResourceDA.list('employee').then(function (employees) {
	          return _.keyBy(employees.resources, '_id');
	        });
	      }],
	      services: ["$q", "OfficeModel", function services($q, OfficeModel) {
	        var deferred = $q.defer();
	        var services = [];

	        OfficeModel.get(function (error, office) {
	          if (error) {
	            deferred.reject(error);
	          } else {
	            _.forEach(office.serviceGroups, function (group) {
	              _.forEach(group.services, function (service) {
	                service.group = group.name;
	              });

	              services = services.concat(group.services);
	            });

	            deferred.resolve(services);
	          }
	        });

	        return deferred.promise;
	      }],
	      invoices: ["$stateParams", "AccountingDA", function invoices($stateParams, AccountingDA) {
	        if ($stateParams.customerId && $stateParams.customerId !== 'new') {
	          return AccountingDA.getForCustomer($stateParams.customerId);
	        } else {
	          return [];
	        }
	      }]
	    }
	  });
	}]);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function ($rootScope, $scope, $state, $stateParams, $window, $timeout, $location, customer, Customer, CustomerDA, AccountingDA, invoices, CustomerModel, DatepickerSettings, filteredCustomers, gettextCatalog, IndustrySpecific, ModalService, Notification, office, LocalStorage, resources, services, settings) {
	  var isBillingVisible = __webpack_require__(191);

	  $scope.resources = resources;
	  $scope.currentCustomer = customer;
	  $scope.filteredCustomers = filteredCustomers;
	  $scope.translationData = {
	    name: ''
	  };
	  $scope.filter = {};
	  $scope.dtpOptions = DatepickerSettings.default;
	  $scope.dtpOptionsFilterFrom = angular.copy(DatepickerSettings.default);
	  $scope.dtpOptionsFilterTo = angular.copy(DatepickerSettings.default);
	  $scope.smsReminderEnabled = _.get(office, 'settings.reminder.sms.enabled');
	  $scope.emailReminderEnabled = _.get(office, 'settings.reminder.email.enabled');
	  $scope.settings = settings;
	  $scope.showBilling = isBillingVisible($location);
	  var invoiceExportNow = new Date();
	  var invoiceExportOptions = __webpack_require__(192)(gettextCatalog);

	  $scope.invoiceExport = {
	    month: null,
	    year: invoiceExportNow.getFullYear(),
	    billingType: invoiceExportOptions.defaultBillingType
	  };
	  $scope.invoiceExportBillingTypes = invoiceExportOptions.billingTypes;
	  $scope.invoiceExportMonths = [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	  $scope.invoiceExportYears = [];

	  for (var year = invoiceExportNow.getFullYear(); year >= invoiceExportNow.getFullYear() - 10; year -= 1) {
	    $scope.invoiceExportYears.push(year);
	  }

	  $scope.getInvoiceDownloadLink = function () {
	    if (!$scope.currentCustomer._id) {
	      return '';
	    }

	    var link = '/api/office/' + office._id + '/export/rechnungen.csv?customer=' + $scope.currentCustomer._id + '&year=' + $scope.invoiceExport.year;

	    if ($scope.invoiceExport.month) {
	      link += '&month=' + $scope.invoiceExport.month;
	    }

	    link += '&billingType=' + $scope.invoiceExport.billingType;

	    return link;
	  };

	  $scope.getInvoicePdfDownloadLink = function () {
	    if (!$scope.currentCustomer._id) {
	      return '';
	    }

	    var link = '/api/office/' + office._id + '/export/rechnungen.zip?customer=' + $scope.currentCustomer._id + '&year=' + $scope.invoiceExport.year;

	    if ($scope.invoiceExport.month) {
	      link += '&month=' + $scope.invoiceExport.month;
	    }

	    link += '&billingType=' + $scope.invoiceExport.billingType;

	    return link;
	  };
	  $scope.invoiceFormSubmitted = false;
	  $scope.CustomerInvoiceForm = {};
	  $scope.invoices = invoices;
	  $scope.treatmentTypes = [{
	    value: gettextCatalog.getString('Individual Therapy')
	  }, {
	    value: gettextCatalog.getString('Group Therapy')
	  }];
	  $scope.treatmentBases = [{
	    value: gettextCatalog.getString('Illness')
	  }, {
	    value: gettextCatalog.getString('Accident')
	  }, {
	    value: gettextCatalog.getString('Pregnancy')
	  }, {
	    value: gettextCatalog.getString('Prevention')
	  }, {
	    value: gettextCatalog.getString('Congenital Defects')
	  }, {
	    value: gettextCatalog.getString('Unknown')
	  }];
	  $scope.laws = [{
	    value: 'UVG'
	  }, {
	    value: 'VVG'
	  }];
	  $scope.accidenTranslation = gettextCatalog.getString('Accident');

	  function setMinMaxDate() {
	    $scope.dtpOptionsFilterFrom.maxDate = $scope.filter.end;
	    $scope.dtpOptionsFilterTo.minDate = $scope.filter.start;
	  }

	  $scope.$watch('filter', function () {
	    setMinMaxDate();
	  }, true);

	  if ($scope.currentCustomer && $scope.currentCustomer.birthday) {
	    $scope.currentCustomer.birthday = new Date($scope.currentCustomer.birthday);
	  }

	  IndustrySpecific.getLabels().then(function (labels) {
	    $scope.customerLabel = gettextCatalog.getString(labels.customer.toLowerCase());
	    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
	  });

	  var generateName = function generateName() {
	    var nameParts = [];

	    if ($scope.currentCustomer.firstname) {
	      nameParts.push($scope.currentCustomer.firstname);
	    }

	    if ($scope.currentCustomer.lastname) {
	      nameParts.push($scope.currentCustomer.lastname);
	    }

	    $scope.translationData.name = nameParts.join(' ');
	  };

	  if ($scope.currentCustomer._id) {
	    generateName();
	  }

	  $scope.$watch('currentCustomer.firstname+currentCustomer.lastname', function () {
	    generateName();
	  }, true);

	  /**
	   * save current customer to database
	   */
	  $scope.save = function () {
	    var name = $scope.currentCustomer.lastname + ', ' + $scope.currentCustomer.firstname;

	    if ($scope.currentCustomer.email === '') {
	      delete $scope.currentCustomer.email;
	    }

	    if ($scope.currentCustomer.birthday) {
	      $scope.currentCustomer.birthday = moment($scope.currentCustomer.birthday).hour(12).toDate();
	    }

	    if (!$scope.currentCustomer._id) {
	      CustomerDA.insert($scope.currentCustomer).then(function (newCustomer) {
	        Notification.addSuccessMessage(gettextCatalog.getString('{{name}} created', { name: name }));

	        $state.go('private.main.customerProfile', {
	          customerId: newCustomer._id
	        }, { location: 'replace' });
	      }).catch(function (response) {
	        Notification.addErrorMessage(gettextCatalog.getString('Cant add customer (Error: {{error}})', {
	          error: response.error
	        }));
	      });
	    } else {
	      // update employee
	      if (!$scope.isUnchanged()) {
	        CustomerModel.update($scope.currentCustomer, function (error, response) {
	          if (error) {
	            Notification.addErrorMessage(gettextCatalog.getString('Cant update customer (Error: {{error}})', { error: error }));
	          } else {
	            Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: name }));

	            $scope.currentCustomer = response;
	            if (LocalStorage.get('openAppointment')) {
	              $scope.backToReferrer();
	            }
	          }
	        });
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: name }));
	      }
	    }
	  };

	  /**
	   * go back to source (list|appointmentModal)
	   */
	  $scope.backToReferrer = function (upsertedCustomer) {
	    var openAppointment = LocalStorage.get('openAppointment');

	    if (openAppointment) {
	      $state.go('private.main.calendar');

	      switch (openAppointment.type) {
	        case 'course':
	          for (var i = 0, partLen = openAppointment.participants.length; i < partLen; i++) {
	            if (openAppointment.participants[i] === '') {
	              openAppointment.participants[i] = $scope.currentCustomer;
	              break;
	            }
	          }

	          ModalService.openAppointmentModal(openAppointment);
	          break;
	        case 'customer':
	          var customerId = _.get(openAppointment, 'customer._id');
	          var nameParts = [];

	          if (!customerId && upsertedCustomer) {
	            if (upsertedCustomer.lastname) {
	              nameParts.push(upsertedCustomer.lastname);
	            }

	            if (upsertedCustomer.firstname) {
	              nameParts.push(upsertedCustomer.firstname);
	            }

	            openAppointment.customer = {
	              _id: upsertedCustomer._id,
	              fullname: nameParts.join(' ')
	            };
	          }

	          ModalService.openAppointmentModal(openAppointment);
	          break;
	      }
	    } else {
	      $state.go('private.main.customer');
	    }
	  };

	  /**
	   *  load the customer history
	   */
	  $scope.loadAppointments = function () {
	    $scope.isLoading = true;

	    if ($scope.currentCustomer._id) {
	      CustomerDA.getAppointments($scope.currentCustomer._id, $scope.filter.start, $scope.filter.end).then(function (appointments) {
	        $scope.isLoading = false;
	        $scope.appointments = appointments;
	      }).catch(function (error) {
	        $scope.isLoading = false;
	        Notification.addErrorMessage(gettextCatalog.getString('Cant load appointments (Error: {{error}})', { error: error }));
	      });
	    }
	  };

	  /**
	   * delete a customer
	   * @param customer
	   */
	  $scope.delete = function () {
	    CustomerDA.remove($scope.currentCustomer._id).then(function () {
	      var name = $scope.currentCustomer.firstname + ' ' + $scope.currentCustomer.lastname;
	      Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: name }));
	      $scope.backToReferrer();
	    }).catch(function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant delete customer (Error: {{error}})', { error: error }));
	    });
	  };

	  /**
	   * open appointment modal
	   * @param appointment
	   */
	  $scope.openAppointment = function (appointment) {
	    appointment.start = new Date(appointment.start);
	    appointment.end = new Date(appointment.end);

	    ModalService.openAppointmentModal(appointment);
	  };

	  $scope.goToCustomer = function (direction) {
	    var filteredCustomersLen = filteredCustomers.length;
	    var currentIndex = filteredCustomers.indexOf($scope.currentCustomer._id);
	    var targetIndex = currentIndex + direction;

	    if (targetIndex < 0) {
	      targetIndex = filteredCustomersLen - 1;
	    } else if (targetIndex >= filteredCustomersLen) {
	      targetIndex = 0;
	    }

	    if (filteredCustomers[targetIndex]) {
	      $state.go('private.main.customerProfile', { customerId: filteredCustomers[targetIndex] });
	    }
	  };

	  /**
	   * check if form data is changed
	   * @param customer
	   * @returns {*}
	   */
	  $scope.isUnchanged = function () {
	    return angular.equals($scope.currentCustomer, $scope.backupItem);
	  };

	  $scope.print = function () {
	    $window.print();
	  };

	  // invoice
	  $scope.services = angular.copy(services);
	  $scope.currentInvoice = null;
	  $scope.currentService = {
	    selected: null
	  };
	  $scope.netTotal = 0;
	  $scope.taxTotal = 0;
	  $scope.grossTotal = 0;
	  $scope.taxes = [{
	    label: '0.0 %',
	    value: 0
	  }, {
	    label: '2.5 %',
	    value: 2.5
	  }, {
	    label: '7.7 %',
	    value: 7.7
	  }, {
	    label: '8.1 %',
	    value: 8.1
	  }];

	  // add free text position
	  $scope.services.push({
	    name: '[Tarif 999] Freitext',
	    tax: 8.1,
	    accounting: {
	      posNum: '999',
	      description: 'free'
	    },
	    price: 0
	  });

	  $scope.currentServiceChanged = function () {
	    var name;
	    var customName;
	    var amount;
	    var tariffDuration;
	    var tax;
	    var num;
	    var price;

	    if ($scope.currentService.selected) {
	      name = _.get($scope.currentService.selected, 'accounting.posText', $scope.currentService.selected.name);
	      customName = $scope.currentService.selected.name;
	      tariffDuration = _.get($scope.currentService.selected, 'accounting.tariffDuration');
	      tax = _.get($scope.currentService.selected, 'accounting.tax', 8);
	      num = _.get($scope.currentService.selected, 'accounting.posNum');

	      if (tariffDuration) {
	        amount = $scope.currentService.selected.duration / tariffDuration;
	        price = $scope.currentService.selected.price / amount;
	      } else {
	        amount = 1;
	        price = $scope.currentService.selected.price;
	      }

	      if (num === '999') {
	        if (!price) {
	          name = '';
	        } else {
	          name = $scope.currentService.selected.name;
	        }
	      }

	      var selectedService = {
	        _id: $scope.currentService.selected._id,
	        date: new Date(),
	        name: name,
	        customName: customName,
	        price: price,
	        amount: amount,
	        total: amount * price,
	        tax: tax,
	        num: num
	      };

	      if (parseInt(num) >= 1250) {
	        selectedService.name = $scope.currentService.selected.name;
	        selectedService.description = name;
	      }

	      $scope.currentInvoice.services.push(selectedService);
	      $scope.currentService.selected = null;
	    }
	  };

	  $scope.switchToInvoice = function () {
	    $scope.currentInvoice = {
	      services: [],
	      defaultNo: 'R' + '-' + moment().format('YYYYMMDD') + '****** (' + gettextCatalog.getString('Default') + ')',
	      customNo: '',
	      meta: {
	        therapyType: gettextCatalog.getString('Individual Therapy'),
	        treatmentBase: gettextCatalog.getString('Illness'),
	        law: 'VVG'
	      }
	    };
	  };

	  $scope.editInvoice = function (invoice) {
	    $scope.currentInvoice = invoice;

	    if ($scope.currentInvoice.positions) {
	      $scope.currentInvoice.services = $scope.currentInvoice.positions.map(function (item) {
	        item.date = new Date(item.date);

	        return item;
	      });
	    }

	    $scope.currentInvoice.customNo = $scope.currentInvoice.no || '';
	    $scope.currentInvoice.defaultNo = 'R' + '-' + moment($scope.currentInvoice.created).format('YYYYMMDDHHmmss');
	  };

	  $scope.removeService = function (index) {
	    $scope.currentInvoice.services.splice(index, 1);
	  };

	  $scope.changeQuantity = function (service, amount) {
	    service.amount = service.amount + amount;
	    service.amount = Math.max(service.amount, 1);

	    if (service.price) {
	      service.total = service.price * service.amount;
	    }
	  };

	  $scope.abortInvoice = function () {
	    $scope.currentInvoice = null;
	  };

	  $scope.removeInvoice = function (invoice) {
	    AccountingDA.removeInvoice(invoice._id).then(function () {
	      Notification.addSuccessMessage(gettextCatalog.getString('Invoice deleted'));
	      _.remove($scope.invoices, { _id: invoice._id });
	    }).catch(function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant delete invoice (Error: {{error}})', { error: error }));
	    });
	  };

	  $scope.createInvoice = function () {
	    var invoice = {
	      customer: $scope.currentCustomer._id,
	      office: office._id,
	      customNo: $scope.currentInvoice.customNo,
	      meta: $scope.currentInvoice.meta,
	      comment: $scope.currentInvoice.comment,
	      deposit: $scope.currentInvoice.deposit,
	      positions: []
	    };

	    $scope.invoiceFormSubmitted = true;

	    if ($scope.CustomerInvoiceForm.instance.$valid) {
	      _.forEach($scope.currentInvoice.services, function (service) {
	        var position = {
	          amount: service.amount,
	          name: service.name,
	          customName: service.customName,
	          date: service.date,
	          price: service.price,
	          tax: service.tax
	        };

	        if (service.num) {
	          position.data = {
	            num: service.num,
	            description: service.description
	          };
	        }

	        invoice.positions.push(position);
	      });

	      AccountingDA.createInvoice(invoice).then(function (response) {
	        $scope.currentInvoice = null;
	        $scope.invoices.unshift(response.invoice);
	      }).catch(function (error) {
	        console.log('error');
	        console.log(error);
	      });
	    }
	  };

	  $scope.updateInvoice = function () {
	    var invoice = {
	      customer: $scope.currentCustomer._id,
	      office: office._id,
	      customNo: $scope.currentInvoice.customNo || $scope.currentInvoice.defaultNo,
	      meta: $scope.currentInvoice.meta,
	      comment: $scope.currentInvoice.comment,
	      deposit: $scope.currentInvoice.deposit,
	      positions: []
	    };

	    $scope.invoiceFormSubmitted = true;

	    if ($scope.CustomerInvoiceForm.instance.$valid) {
	      _.forEach($scope.currentInvoice.services, function (service) {
	        var position = {
	          amount: service.amount,
	          name: service.name,
	          customName: service.customName,
	          date: service.date,
	          price: service.price,
	          tax: service.tax
	        };

	        if (service.data) {
	          position.data = service.data;
	        }

	        if (service.num) {
	          position.data = {
	            num: service.num,
	            description: service.description
	          };
	        }

	        invoice.positions.push(position);
	      });

	      AccountingDA.updateInvoice($scope.currentInvoice.id, invoice).then(function (response) {
	        $scope.currentInvoice = null;
	        Notification.addSuccessMessage(gettextCatalog.getString('Invoice updated'));

	        var invoiceIndex = $scope.invoices.reduce(function (previous, current, index) {
	          return current.id === response.invoice.id ? index : previous;
	        }, -1);

	        if (invoiceIndex !== -1) {
	          $scope.invoices.splice(invoiceIndex, 1, response.invoice);
	        }
	      }).catch(function (error) {
	        Notification.addErrorMessage(gettextCatalog.getString('Cant update invoice (Error: {{error}})', { error: error }));
	      });
	    }
	  };

	  $scope.$watch('currentInvoice.services', function () {
	    calcTotal();
	  }, true);

	  function calcTotal() {
	    $scope.netTotal = 0;
	    $scope.taxTotal = 0;
	    $scope.grossTotal = 0;

	    if ($scope.currentInvoice) {
	      _.forEach($scope.currentInvoice.services, function (service) {
	        service.total = service.price && service.amount ? service.price * service.amount : 0;
	        $scope.netTotal += service.total * 100 / (100 + service.tax);
	        $scope.grossTotal += service.total;
	      });
	    }

	    $scope.taxTotal = $scope.grossTotal - $scope.netTotal;
	  }

	  $scope.loadAppointments();
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function isBillingVisible($location) {
	  var showBillingPermanent = $location.search().showBillingPermanent;

	  if (showBillingPermanent === '1') {
	    window.sessionStorage.setItem('showBillingPermanent', '1');
	  } else if (showBillingPermanent === '0') {
	    window.sessionStorage.removeItem('showBillingPermanent');
	  }

	  return $location.search().showBilling === '1' || window.sessionStorage.getItem('showBillingPermanent') === '1';
	};

/***/ }),
/* 192 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (gettextCatalog) {
	  return {
	    defaultBillingType: 'patient',
	    billingTypes: [{
	      value: 'patient',
	      label: gettextCatalog.getString('Patient Invoice')
	    }, {
	      value: 'tariff590-insurance',
	      label: gettextCatalog.getString('Insurance Reclaim Slip')
	    }, {
	      value: 'tariff590-patient',
	      label: gettextCatalog.getString('Patient Reclaim Slip')
	    }]
	  };
	};

/***/ }),
/* 193 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, $timeout, CustomerModel, CustomerDA, gettextCatalog, IndustrySpecific, Notification, OfficeModel, $state, Upload) {
	  $scope.fileTypes = ['CSV'];
	  $scope.fileFormats = ['ISO-8859-1', 'UTF8', 'UCS2', 'ASCII', 'Binary', 'Base64'];
	  $scope.delimitters = [{
	    label: gettextCatalog.getString('Semicolon'),
	    value: ';'
	  }, {
	    label: gettextCatalog.getString('Comma'),
	    value: ','
	  }];

	  $scope.fields = [{
	    label: gettextCatalog.getString('Salutation'),
	    name: 'salutation'
	  }, {
	    label: gettextCatalog.getString('Firstname'),
	    name: 'firstname',
	    required: true
	  }, {
	    label: gettextCatalog.getString('Lastname'),
	    name: 'lastname',
	    required: true
	  }, {
	    label: gettextCatalog.getString('Birthday'),
	    name: 'birthday'
	  }, {
	    label: gettextCatalog.getString('Telephone'),
	    name: 'telephone'
	  }, {
	    label: gettextCatalog.getString('Email'),
	    name: 'email'
	  }, {
	    label: gettextCatalog.getString('Street'),
	    name: 'street'
	  }, {
	    label: gettextCatalog.getString('Nr'),
	    name: 'no'
	  }, {
	    label: gettextCatalog.getString('Postal'),
	    name: 'postal'
	  }, {
	    label: gettextCatalog.getString('City'),
	    name: 'city'
	  }, {
	    label: gettextCatalog.getString('Note'),
	    name: 'note'
	  }];

	  $scope.settings = {
	    fileType: 'CSV',
	    fileFormat: 'ISO-8859-1',
	    delimiter: ';'
	  };

	  $scope.$files = [];

	  $scope.isFinalStep = false;
	  $scope.uploadInProgress = false;

	  $scope.goToFileChoose = function () {
	    $scope.isFinalStep = false;

	    $scope.isPrviewStep = false;
	    $scope.isShowAllPreviewItems = false;
	  };

	  $scope.activateFinalStep = function () {
	    $scope.isFinalStep = !!$scope.csvFields;
	  };

	  $scope.goToReview = function () {
	    $scope.isPrviewStep = true;
	  };

	  $scope.backToImportSettings = function () {
	    $scope.isPrviewStep = false;
	    $scope.isShowAllPreviewItems = false;
	  };

	  var A_LETTER_CODE = 65;
	  var LATIN_LETTERS = 26;
	  $scope.getLetter = function (index) {
	    var result = [];

	    for (var i = index; i >= 0; i -= LATIN_LETTERS + i % LATIN_LETTERS) {
	      result.unshift(String.fromCharCode(i % LATIN_LETTERS + A_LETTER_CODE));
	    }

	    return result.join('');
	  };

	  $scope.showPreviewItems = 20;
	  $scope.isShowAllPreviewItems = false;
	  $scope.toggleShowAll = function () {
	    $scope.isShowAllPreviewItems = !$scope.isShowAllPreviewItems;
	  };

	  $scope.isShowAll = function (item, index) {
	    return index > 0 && ($scope.isShowAllPreviewItems || index < $scope.showPreviewItems);
	  };

	  IndustrySpecific.getLabels().then(function (labels) {
	    $scope.customerLabel = gettextCatalog.getString(labels.customer.toLowerCase());
	    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
	  });

	  /**
	   * get office data for custom customer fields
	   */
	  OfficeModel.get(function (error, office) {
	    if (!error) {
	      if ('customFields' in office.settings) {
	        if (angular.isArray(office.settings.customFields.customer)) {
	          office.settings.customFields.customer.forEach(function (customField) {
	            $scope.fields.push({
	              label: customField.label,
	              name: customField.name,
	              type: 'custom'
	            });
	          });
	        }
	      }
	    }
	  });

	  /**
	   * generate logo preview
	   * @param $files
	   */
	  $scope.onFileSelect = function ($files) {
	    if (!$files.length) return;

	    $scope.$files = $files;

	    $scope.upload();
	  };

	  $scope.getFileName = function () {
	    return _.get($scope.$files, '[0].name', '');
	  };

	  /**
	   * upload file and return the two first lines
	   */
	  $scope.upload = function () {
	    if ($scope.uploadInProgress) return;

	    $scope.uploadInProgress = true;

	    // upload all files
	    Upload.upload({
	      url: '/api/office/' + $scope.office._id + '/customers/upload',
	      data: $scope.settings,
	      file: $scope.$files
	    }).progress(function (evt) {
	      console.log('upload:' + parseInt(100.0 * evt.loaded / evt.total));
	    }).success(function (data) {
	      $scope.uploadInProgress = false;

	      if (data && data.length < 2) return Notification.addErrorMessage(gettextCatalog.getString("File shouldn't be empty"));

	      $scope.csvFields = [];

	      for (var i = 0; data[0] && i < data[0].length; i++) {
	        $scope.csvFields.push($scope.fields[i] || null);
	      }

	      $scope.sampleData = data;
	      $scope.isFinalStep = true;
	    }).error(function (error) {
	      if (error.message == 'file_to_large') {
	        Notification.addErrorMessage(gettextCatalog.getString('File is too big (max. 1MB)'));
	      } else if (error.message == 'extension_not_allowed') {
	        Notification.addErrorMessage(gettextCatalog.getString('File type is not allowed'));
	      } else {
	        Notification.addErrorMessage(gettextCatalog.getString('An unknown error occured (Error: {{error}})', {
	          error: error
	        }));
	      }

	      $scope.uploadInProgress = false;
	    });
	  };

	  $scope.checkOnDuplicates = function (csvField, index) {
	    $scope.csvFields[index] = null;
	    var existingIndex = $scope.csvFields.indexOf(csvField);

	    if (existingIndex > -1) {
	      $scope.csvFields[existingIndex] = null;
	    }

	    $scope.csvFields[index] = csvField;
	  };

	  /**
	   * upload the file again and start import
	   */
	  $scope.import = function () {
	    if ($scope.uploadInProgress) return;

	    $scope.uploadInProgress = true;

	    Upload.upload({
	      url: '/api/office/' + $scope.office._id + '/customers/import',
	      data: {
	        settings: $scope.settings,
	        fields: $scope.csvFields,
	        parsedData: $scope.sampleData
	      }
	    }).progress(function (evt) {
	      console.log('upload:' + parseInt(100.0 * evt.loaded / evt.total));
	    }).success(function (data, status, headers, config) {
	      $scope.uploadInProgress = false;
	      var delta = $scope.sampleData.length - data.length - 1; // sampleData has a headers row

	      if (delta > 0) {
	        Notification.addErrorMessage(gettextCatalog.getString('{{count}} data rows duplicated', { count: delta }));
	      }

	      if (data.length) {
	        Notification.addSuccessMessage(gettextCatalog.getString('{{count}} data rows imported', { count: data.length }));

	        CustomerModel.updateCustomers(data);

	        $state.go('private.main.customer');
	      } else {
	        setTimeout(function () {
	          $scope.goToFileChoose();
	        }, 300);
	      }
	    }).error(function (error) {
	      $scope.uploadInProgress = false;

	      if (error.message == 'file_to_large') {
	        Notification.addErrorMessage(gettextCatalog.getString('File is too big (max. 1MB)'));
	      } else if (error.message == 'extension_not_allowed') {
	        Notification.addErrorMessage(gettextCatalog.getString('File type is not allowed'));
	      } else {
	        Notification.addErrorMessage(gettextCatalog.getString('An unknown error occured (Error: {{error}})', {
	          error: error
	        }));
	      }
	    });
	  };

	  $scope.isValid = function () {
	    var lastnamePicked = false;
	    var firstnamePicked = false;

	    // check for first and lastname
	    $scope.csvFields.forEach(function (csvField) {
	      if (csvField) {
	        if (csvField.name === 'lastname') {
	          lastnamePicked = true;
	        }
	        if (csvField.name === 'firstname') {
	          firstnamePicked = true;
	        }
	      }
	    });

	    return lastnamePicked && firstnamePicked;
	  };
	};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';

	var CustomerListCtrl = function CustomerListCtrl($state, customers, CustomerDA, gettextCatalog, uiGridConstants, MobileDetectService) {
	  var self = this;
	  this.customers = customers;
	  this._CustomerDA = CustomerDA;
	  this._state = $state;
	  this.model = {
	    data: customers,
	    enableSorting: true,
	    enableFiltering: true,
	    enableRowSelection: true,
	    enableRowHeaderSelection: false,
	    columnDefs: [{
	      displayName: gettextCatalog.getString('Firstname'),
	      field: 'firstname',
	      enableColumnMenu: false
	    }, {
	      displayName: gettextCatalog.getString('Lastname'),
	      field: 'lastname',
	      enableColumnMenu: false,
	      sort: {
	        direction: uiGridConstants.ASC,
	        priority: 0
	      }
	    }],
	    onRegisterApi: function onRegisterApi(gridApi) {
	      self.gridApi = gridApi;
	      gridApi.selection.on.rowSelectionChanged(null, function (row) {
	        self.openCustomer(row.entity._id);
	      });
	    }
	  };

	  if (!MobileDetectService.isMobile) {
	    this.model.columnDefs.push({
	      displayName: gettextCatalog.getString('Telephone'),
	      field: 'telephone',
	      enableColumnMenu: false,
	      enableSorting: false
	    });
	  }
	};

	CustomerListCtrl.prototype.openCustomer = function (customerId) {
	  var filteredRows = this.gridApi.core.getVisibleRows(this.gridApi.grid);
	  var filteredCustomers = _.map(filteredRows, function (row) {
	    return row.entity._id;
	  });
	  this._CustomerDA.setFiltered(filteredCustomers);
	  this._state.go('private.main.customerProfile', { customerId: customerId });
	};

	module.exports = CustomerListCtrl;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var bookingModule = angular.module('t2g.booking', ['gettext', 'ui.router', __webpack_require__(156).name, __webpack_require__(160).name, __webpack_require__(9).name, __webpack_require__(6).name]);

	module.exports = bookingModule;

	bookingModule.controller('BookingListCtrl', __webpack_require__(196));

	bookingModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.booking', {
	    url: '/bookings',
	    title: 'Bookings',
	    templateUrl: '/app/modules/booking/list.html?v=4.5.6',
	    controller: 'BookingListCtrl as BookingListCtrl',
	    resolve: {
	      bookings: ["BookingDA", function bookings(BookingDA) {
	        return BookingDA.getAll().then(function (bookingResponse) {
	          return bookingResponse.bookings;
	        });
	      }]
	    }
	  });
	}]);

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';

	var BookingListCtrl = function BookingListCtrl($scope, $rootScope, $state, $stateParams, io, bookings, BookingDA, gettextCatalog, uiGridConstants, ModalService) {
	  var self = this;
	  this._state = $state;
	  this._stateParams = $stateParams;
	  this._ModalService = ModalService;

	  this.bookings = bookings;

	  this.setProcessed = function (notProcessedBookingIds) {
	    var officeId = _.get(self, 'bookings[0].officeId', '');

	    return BookingDA.setProcessed({
	      officeId: officeId,
	      ids: notProcessedBookingIds
	    }).then(function () {
	      self.bookings.forEach(function (booking) {
	        booking.processed = true;
	      });

	      $rootScope.$broadcast('setBookingsProcessed');
	    });
	  };

	  this.getPaymentMethod = function (booking) {
	    var paymentMethod = _.get(booking, 'payment.method');

	    switch (paymentMethod) {
	      case 'credit_card':
	        return gettextCatalog.getString('PAYMENT_METHOD_CREDIT_CARD');
	      case 'local':
	        return gettextCatalog.getString('PAYMENT_METHOD_USER_LOCAL');
	      case 'invoice':
	        return gettextCatalog.getString('PAYMENT_METHOD_INVOICE');
	      case 'empty':
	        return gettextCatalog.getString('PAYMENT_METHOD_USER_EMPTY');
	      default:
	        return '';
	    }
	  };

	  /**
	   * add new booking, if socket emit new booking
	   */
	  $scope.$on('Booking:save', function (event, newBooking) {
	    self.bookings.push(newBooking);
	  });

	  $scope.$on('$destroy', function () {
	    var notProcessedBookingIds = bookings.filter(function (booking) {
	      return !booking.processed;
	    }).map(function (booking) {
	      return booking._id;
	    });

	    if (notProcessedBookingIds.length) {
	      self.setProcessed(notProcessedBookingIds);
	    }
	  });
	};

	BookingListCtrl.prototype.openRelatedAppointment = function (booking) {
	  if (_.get(booking, 'declined') || !_.get(booking, 'appointments[0]') || _.get(booking, 'appointments[0].cancelled')) {
	    return;
	  }

	  var openAppointment = _.get(booking, 'appointments[0]');

	  if (!openAppointment) return;

	  var appointmentDate = moment(openAppointment.start).format('YYYY-MM-DD');
	  if (this._stateParams.date !== appointmentDate) {
	    this._state.go('private.main.calendar', {
	      date: appointmentDate
	    });
	  }

	  this._ModalService.openAppointmentModal(openAppointment);
	};

	BookingListCtrl.prototype.getStartDate = function (booking) {
	  var appointmentStartDate = _.get(booking, 'appointments[0].start');
	  var bookingStartDate = _.get(booking, 'start');

	  return appointmentStartDate || bookingStartDate;
	};

	module.exports = BookingListCtrl;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var customFieldModule = angular.module('t2g.customFields', ['gettext', 'ui.router', __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = customFieldModule;

	customFieldModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.customFields', {
	    url: '/customFields',
	    title: 'Custom Fields',
	    templateUrl: '/app/modules/customFields/CustomFieldsView.html?v=4.5.6',
	    controller: 'CustomFieldCtrl as CustomFieldCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

	/**
	 * @param $scope
	 * @param officeResolve
	 * @param OfficeModel
	 * @param Notification
	 * @constructor
	 */
	var CustomFieldCtrl = function CustomFieldCtrl($scope, gettextCatalog, Notification, OfficeModel, officeResolve) {
	  var self = this;
	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this.scope_ = $scope;
	  this.scope_.office = officeResolve;
	  this.scope_.office.settings.customFields = this.scope_.office.settings.customFields || {
	    customer: [],
	    appointment: []
	  };
	  this.scope_.fieldTypes = [];
	  this.OfficeModel_ = OfficeModel;
	  this.Notification_ = Notification;
	  this.gettextCatalog = gettextCatalog;

	  $scope.fieldTypes = [{
	    name: gettextCatalog.getString('Textfield'),
	    type: 'textfield'
	  }, {
	    name: gettextCatalog.getString('Textarea'),
	    type: 'textarea'
	  }, {
	    name: gettextCatalog.getString('Select'),
	    type: 'select'
	  }, {
	    name: gettextCatalog.getString('Radio'),
	    type: 'radio'
	  }];

	  /// Select = Auswahl
	  self.optionTranslation_ = gettextCatalog.getString('Select');
	};
	CustomFieldCtrl.$inject = ["$scope", "gettextCatalog", "Notification", "OfficeModel", "officeResolve"];

	/**
	 * @param {object} field
	 */
	CustomFieldCtrl.prototype.select = function (field) {
	  this.scope_.currentField = field;
	};

	/**
	 * @param {string} type
	 */
	CustomFieldCtrl.prototype.add = function (type) {
	  var self = this;
	  var newField = {
	    label: self.gettextCatalog.getString('New field'),
	    required: true,
	    booking: true,
	    type: 'textfield'
	  };
	  self.scope_.office.settings.customFields[type].push(newField);
	  self.select(newField);
	};

	/**
	 * delete custom field
	 */
	CustomFieldCtrl.prototype.delete = function () {
	  var self = this;
	  var index1 = this.scope_.office.settings.customFields.customer.indexOf(this.scope_.currentField);
	  var index2 = this.scope_.office.settings.customFields.appointment.indexOf(this.scope_.currentField);

	  if (index1 > -1) {
	    this.scope_.office.settings.customFields.customer.splice(index1, 1);
	  }

	  if (index2 > -1) {
	    this.scope_.office.settings.customFields.appointment.splice(index2, 1);
	  }

	  if (index1 > -1 || index2 > -1) {
	    this.OfficeModel_.update(this.scope_.office, function (error) {
	      if (error) {
	        self.Notification_.addErrorMessage(self.gettextCatalog.getString('Cant remove custom field (Error: {{error}})', {
	          error: error
	        }));
	      } else {
	        self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field removed'));
	      }
	    });
	    this.scope_.currentField = null;
	  }
	};

	/**
	 * fired if field type selectbox has changed
	 */
	CustomFieldCtrl.prototype.changeTypeHandler = function () {
	  var multiOptionFields = {
	    radio: true,
	    select: true
	  };

	  if (multiOptionFields[this.scope_.currentField.type]) {
	    this.scope_.currentField.options = this.scope_.currentField.options || [];

	    if (this.scope_.currentField.options.length === 0) {
	      this.scope_.currentField.options.push({
	        label: this.optionTranslation_ + ' 1'
	      });

	      this.scope_.currentField.options.push({
	        label: this.optionTranslation_ + ' 2'
	      });
	    }
	  } else {
	    this.scope_.currentField.options = null;
	  }
	};

	/**
	 * @param {object} option
	 */
	CustomFieldCtrl.prototype.removeOption = function (option) {
	  var index = this.scope_.currentField.options.indexOf(option);

	  if (this.scope_.currentField.options.length > 2) {
	    this.scope_.currentField.options.splice(index, 1);
	  }
	};

	/**
	 * add an option to radio option list
	 */
	CustomFieldCtrl.prototype.addOption = function () {
	  this.scope_.currentField.options.push({
	    label: this.optionTranslation_
	  });
	};

	/**
	 * save custom fields
	 */
	CustomFieldCtrl.prototype.save = function () {
	  var self = this;

	  this.OfficeModel_.update(this.scope_.office, function (error) {
	    if (error) {
	      self.Notification_.addErrorMessage(self.gettextCatalog.getString('Cant save custom field (Error: {{error}})', {
	        error: error
	      }));
	    } else {
	      self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Custom field saved'));
	    }
	  });
	};

	CustomFieldCtrl.prototype.moveField = function (index, type, direction) {
	  if (direction > 0) {
	    if (index > 0) {
	      this.scope_.office.settings.customFields[type].move(index, index - 1);
	    }
	  } else {
	    if (index < this.scope_.office.settings.customFields[type].length - 1) {
	      this.scope_.office.settings.customFields[type].move(index, index + 1);
	    }
	  }
	  this.save();
	};

	/**
	 * back to custom field list
	 */
	CustomFieldCtrl.prototype.back = function () {
	  this.scope_.currentField = null;
	};

	customFieldModule.controller('CustomFieldCtrl', CustomFieldCtrl);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var exportModule = angular.module('t2g.export', ['ui.router', __webpack_require__(1).name, __webpack_require__(5).name]);

	module.exports = exportModule;

	exportModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.export', {
	    url: '/export',
	    title: 'Export',
	    templateUrl: '/app/modules/export/ExportView.html?v=4.5.6',
	    controller: 'ExportCtrl',
	    resolve: {
	      objectResolve: ["$q", "ObjectModel", function objectResolve($q, ObjectModel) {
	        var deffered = $q.defer();

	        ObjectModel.get(function (error, response) {
	          if (error) {
	            deffered.reject(error);
	          } else {
	            deffered.resolve(response);
	          }
	        });

	        return deffered.promise;
	      }]
	    }
	  });
	}]);

	exportModule.controller('ExportCtrl', ["$scope", "objectResolve", "UserSession", "settings", "gettextCatalog", function ($scope, objectResolve, UserSession, settings, gettextCatalog) {
	  $scope.objects = objectResolve;
	  $scope.settings = settings;
	  var userSession = UserSession.get();
	  var now = new Date();
	  var invoiceExportOptions = __webpack_require__(192)(gettextCatalog);

	  $scope.invoiceExport = {
	    month: null,
	    year: now.getFullYear(),
	    billingType: invoiceExportOptions.defaultBillingType
	  };
	  $scope.invoiceExportBillingTypes = invoiceExportOptions.billingTypes;
	  $scope.invoiceExportMonths = [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	  $scope.invoiceExportYears = [];

	  for (var year = now.getFullYear(); year >= now.getFullYear() - 10; year -= 1) {
	    $scope.invoiceExportYears.push(year);
	  }

	  $scope.getCustomerDownloadLink = function () {
	    return '/api/office/' + userSession.office + '/export/kundenliste.csv';
	  };

	  $scope.getInvoiceDownloadLink = function () {
	    var link = '/api/office/' + userSession.office + '/export/rechnungen.csv?year=' + $scope.invoiceExport.year;

	    if ($scope.invoiceExport.month) {
	      link += '&month=' + $scope.invoiceExport.month;
	    }

	    link += '&billingType=' + $scope.invoiceExport.billingType;

	    return link;
	  };

	  $scope.getInvoicePdfDownloadLink = function () {
	    var link = '/api/office/' + userSession.office + '/export/rechnungen.zip?year=' + $scope.invoiceExport.year;

	    if ($scope.invoiceExport.month) {
	      link += '&month=' + $scope.invoiceExport.month;
	    }

	    link += '&billingType=' + $scope.invoiceExport.billingType;

	    return link;
	  };

	  $scope.getAppointmentDownloadLink = function (object) {
	    return '/api/office/' + userSession.office + '/export/appointments/' + object._id + '/termine.ics';
	  };
	}]);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var fbExportModule = angular.module('t2g.fbWidget', ['ui.router', __webpack_require__(1).name]);

	module.exports = fbExportModule;

	fbExportModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.fbWidget', {
	    url: '/fbWidget',
	    title: 'Facebook Widget',
	    templateUrl: '/app/modules/fbWidget/FBWidgetView.html?v=4.5.6',
	    controller: 'FBWidgetCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

	fbExportModule.controller('FBWidgetCtrl', ["$scope", "officeResolve", function ($scope, officeResolve) {
	  $scope.office = officeResolve;
	  $scope.widgetCode = 'appointments';

	  $scope.$watch('widgetCode', function () {
	    if ($scope.widgetCode == 'appointments') {
	      setCode('https://www.termin2go.com/appointment-booking/' + $scope.office.slug + '#/services?channel=facebook');
	    }

	    if ($scope.widgetCode == 'courses') {
	      setCode('https://www.termin2go.com/kursbuchen#!/' + $scope.office.slug + '/auswahl?channel=facebook');
	    }
	  });

	  function setCode(code) {
	    if ($scope.office.slug) {
	      $scope.iframeCode = code;
	    }
	  }
	}]);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var googleSyncModule = angular.module('t2g.googleSync', ['gettext', 'ui.router', __webpack_require__(22).name, __webpack_require__(1).name, __webpack_require__(9).name, __webpack_require__(160).name]);

	module.exports = googleSyncModule;

	googleSyncModule.controller('GoogleSyncCtrl', __webpack_require__(201));

	googleSyncModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.googleSync', {
	    url: '/google-sync',
	    title: 'Google Sync',
	    templateUrl: '/app/modules/googleSync/GoogleSyncView.html?v=4.5.6',
	    controller: 'GoogleSyncCtrl as GoogleSyncCtrl',
	    resolve: {
	      googleSync: ["GoogleSyncDA", function googleSync(GoogleSyncDA) {
	        return GoogleSyncDA.getCalendarList();
	      }],
	      resources: ["ResourceDA", function resources(ResourceDA) {
	        return ResourceDA.list().then(function (response) {
	          return response.resources;
	        });
	      }]
	    }
	  });
	}]);

/***/ }),
/* 201 */
/***/ (function(module, exports) {

	'use strict';

	var GoogleSyncCtrl = function GoogleSyncCtrl($scope, $state, $window, AppointmentModel, googleSync, Notification, GoogleSyncDA, gettextCatalog, resources) {
	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this._AppointmentModel = AppointmentModel;
	  this._Notification = Notification;
	  this._GoogleSyncDA = GoogleSyncDA;
	  this._window = $window;
	  this.gettextCatalog = gettextCatalog;
	  this.resources = resources;
	  this.responseError = false;

	  if (!googleSync) {
	    this.responseError = true;
	  } else if (googleSync.success === false) {
	    this.responseError = true;
	  } else {
	    this.sync = googleSync.sync || {};
	    this.sync.googleMapping = this.sync.googleMapping || {};
	    this.calendarList = googleSync.payload;

	    this.calendarList.forEach(function (calendar) {
	      calendar.id = calendar.id.replace(/\./g, '__');
	    });
	  }

	  this.reload = function () {
	    $state.reload();
	  };
	};

	/**
	 *  speichere mappings
	 *
	 *  funktion implementieren die checkt ob es einen change gab
	 *  initales laden der calendar
	 */

	GoogleSyncCtrl.prototype.connect = function () {
	  this._window.open('/api/v2/auth/google', 'google_auth', 'width=450, height=500, scrolling=yes, resizable=no');

	  var self = this;
	  window.authWindowClose = function () {
	    self.reload();
	  };
	};

	GoogleSyncCtrl.prototype.disconnect = function () {
	  var self = this;

	  this._GoogleSyncDA.revokeAccess().then(function () {
	    self.calendarList = [];
	    self.responseError = true;
	    self._AppointmentModel.clearCache();
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Google'));
	  }, function (error) {
	    self._Notification.addErrorMessage({ text: error });
	  });
	};

	GoogleSyncCtrl.prototype.save = function () {
	  var self = this;

	  self._GoogleSyncDA.update(this.sync).then(function () {
	    self._AppointmentModel.clearCache();
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('Calendar mapping saved'));
	  }, function (error) {
	    self._Notification.addErrorMessage({ text: error });
	  });
	};

	GoogleSyncCtrl.prototype.resourceChanged = function (calendarId) {
	  delete this.sync.googleMapping[calendarId].primary;
	};

	GoogleSyncCtrl.prototype.checkPrimary = function (calendarId) {
	  var mappings = this.sync.googleMapping;
	  var checkMapping = mappings[calendarId];

	  if (checkMapping) {
	    var resource = mappings[calendarId].resource;

	    _.forEach(mappings, function (mapping, key) {
	      if (key !== calendarId && mapping.resource === resource) {
	        delete mapping.primary;
	      }
	    });
	  }
	};

	module.exports = GoogleSyncCtrl;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var calendarsSyncModule = angular.module('t2g.calendarsSync', ['gettext', 'ui.router', __webpack_require__(22).name, __webpack_require__(1).name, __webpack_require__(9).name, __webpack_require__(160).name]);

	module.exports = calendarsSyncModule;

	calendarsSyncModule.controller('CalendarsSyncCtrl', __webpack_require__(203));

	calendarsSyncModule.controller('CalDavRegisterView', ["$scope", "$uibModalInstance", "gettextCatalog", function ($scope, $uibModalInstance, gettextCatalog) {
	  $scope.isSubmitted = false;

	  $scope.caldav = {
	    selectedServer: null
	  };

	  $scope.knownServers = [{
	    name: 'icloud',
	    url: 'https://caldav.icloud.com/'
	  }, {
	    name: 'yahoo',
	    url: 'https://caldav.calendar.yahoo.com/'
	  }, {
	    name: 'masuyo',
	    url: 'https://cal.masuyo.ch'
	  }, {
	    name: 'arztekasse_medionline',
	    url: 'https://www.medionline.ch/caldav'
	  }, {
	    name: gettextCatalog.getString('Custom'),
	    url: '',
	    custom: true
	  }];

	  $scope.currentServerChanged = function () {
	    $scope.caldav.provider_name = $scope.caldav.selectedServer.custom ? '' : $scope.caldav.selectedServer.name;
	    $scope.caldav.url = $scope.caldav.selectedServer.url;
	  };

	  $scope.setProviderName = function (name) {
	    $scope.caldav.provider_name = name;
	    $scope.caldav.url = $scope.caldav.selectedServer.url;
	  };

	  $scope.connectProvider = function ($event) {
	    $scope.isSubmitted = true;

	    $event.preventDefault();

	    if (!$scope.caldav.provider_name) return;

	    $uibModalInstance.close($scope.caldav);
	  };

	  $scope.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	}]);

	//  SoftPLUS Company GLN select Controller
	calendarsSyncModule.controller('SoftPlusSelectCompanyGlnView', ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {
	  // console.log($scope.$resolve.companyGlns[0]);
	  $scope.isSubmitted = false;
	  // Set default values
	  $scope.softPlus = {
	    companyGlns: $scope.$resolve.companyGlns.map(function (companyGln) {
	      return {
	        name: companyGln
	      };
	    }),
	    companyGln: null
	  };

	  $scope.currentCompanyGlnChanged = function () {
	    $scope.softPlus.companyGln = $scope.softPlus.selectedCompanyGln.name;
	  };

	  $scope.connectProvider = function ($event) {
	    $scope.isSubmitted = true;

	    $event.preventDefault();

	    // extract companyGln from softPlus scope
	    var companyGln = $scope.softPlus.companyGln;

	    // Prevent modal close if companyGln is empty

	    if (!companyGln) return;

	    $uibModalInstance.close($scope.softPlus);
	  };

	  $scope.cancel = function () {
	    $uibModalInstance.dismiss('cancel');
	  };
	}]);

	calendarsSyncModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.syncCalendars', {
	    url: '/calendars-sync',
	    title: 'Calendars synchronisation',
	    templateUrl: '/app/modules/calendars-sync/CalendarsSyncView.html?v=4.5.6',
	    controller: 'CalendarsSyncCtrl as CalendarsSyncCtrl',
	    resolve: {
	      googleSync: ["GoogleSyncDA", function googleSync(GoogleSyncDA) {
	        return GoogleSyncDA.getCalendarList();
	      }],
	      calDavProviders: ["CalDavDA", "$q", function calDavProviders(CalDavDA, $q) {
	        var providers = { caldav_providers: [] };

	        return CalDavDA.getList().then(function (response) {
	          providers = response.success ? response.providers : providers;
	          var promises = [];

	          providers.caldav_providers.forEach(function (provider) {
	            promises.push(CalDavDA.getDiscoveredCalendars(provider.name).then(function (response) {
	              response.forEach(function (calendar) {
	                calendar.value = true;
	              });
	              provider.calendars = response;

	              return provider;
	            }));
	          });

	          return $q.all(promises);
	        }).then(function () {
	          return providers;
	        }).catch(function () {
	          return providers;
	        });
	      }],
	      calDavServices: ["CalDavDA", function calDavServices(CalDavDA) {
	        return CalDavDA.getServices();
	      }],
	      resources: ["ResourceDA", function resources(ResourceDA) {
	        return ResourceDA.list().then(function (response) {
	          return response.resources;
	        });
	      }],
	      softPlusUser: ["SoftPlusSyncDA", function softPlusUser(SoftPlusSyncDA) {
	        return SoftPlusSyncDA.isSyncing();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _regenerator = __webpack_require__(29);

	var _regenerator2 = _interopRequireDefault(_regenerator);

	var _asyncToGenerator2 = __webpack_require__(32);

	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	var CalendarsSyncCtrl = function CalendarsSyncCtrl($scope, $state, $window, $q, $timeout, $uibModal, AppointmentModel, googleSync, calDavProviders, calDavServices, CalDavDA, SyncDA, ResourceDA, AppointmentDA, Notification, GoogleSyncDA, gettextCatalog, resources, SoftPlusSyncDA, softPlusUser) {
	  var _this = this;

	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this._AppointmentModel = AppointmentModel;
	  this._Notification = Notification;
	  this._GoogleSyncDA = GoogleSyncDA;
	  this._window = $window;
	  this.gettextCatalog = gettextCatalog;
	  this.resources = resources;
	  this.responseError = false;
	  this.providers = calDavProviders;
	  $scope.resource = resources[0] || {};
	  this.serviceGroups = calDavServices.serviceGroups || [];
	  this.linkedServices = calDavServices.linkedServices || [];
	  this.showCalDavLinkingPage = false;

	  var self = this;
	  var isCalDavProviderExists = this.providers.caldav_providers.length;

	  this.serviceGroups.forEach(function (serviceGroup) {
	    serviceGroup.services.forEach(function (service) {
	      service.calendar_name = self.linkedServices[service._id] || null;

	      self.showCalDavLinkingPage = self.showCalDavLinkingPage || !!service.calendar_name;
	    });
	  });

	  self.showCalDavLinkingPage = isCalDavProviderExists && self.showCalDavLinkingPage;
	  self.showSyncCalDav = self.showCalDavLinkingPage;

	  this.registerCalDav = function () {
	    var modalInstance = $uibModal.open({
	      animation: true,
	      templateUrl: 'app/modules/calendars-sync/CalDavRegisterView.html?v=4.5.6',
	      controller: 'CalDavRegisterView',
	      size: 'md'
	    });

	    return modalInstance.result.then(function (calDavCredentials) {
	      CalDavDA.registerCalDav(calDavCredentials).then(function (response) {
	        if (!response.success) return $q.reject(response);

	        return CalDavDA.getList();
	      }).then(function (response) {
	        if (!response.success) return $q.reject(response);

	        self.providers = response.providers;

	        Notification.addSuccessMessage(self.gettextCatalog.getString('Registered successfully'));
	      }).then(function () {
	        self.providers.caldav_providers.forEach(function (provider) {
	          self.discoverCalDav(provider);
	        });
	      }).catch(function (error) {
	        Notification.addErrorMessage(self.gettextCatalog.getString('Registration failed: {{error}}', {
	          error: error.error
	        }));
	        console.error(error);
	      });
	    }, function (dismiss) {
	      console.log(dismiss);
	    });
	  };

	  //#region SoftPLUS

	  // check if softPLUS user is syncing
	  if (softPlusUser && softPlusUser._id) {
	    var id = softPlusUser._id,
	        userGln = softPlusUser.userGln,
	        companyGln = softPlusUser.companyGln;


	    self.providers.softPlus = {
	      id: id,
	      userGln: userGln,
	      companyGln: companyGln
	    };
	  }

	  this.registerSoftPlus = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
	    var response, modalInstance, _response$registeredU2, registeredCompanyGln, _id2, _userGln2, data;

	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            _context2.prev = 0;
	            _context2.next = 3;
	            return SoftPlusSyncDA.sync({ companyGln: undefined });

	          case 3:
	            response = _context2.sent;

	            if (!(!response.registeredUser && response.hasMultipleCompanyGLN)) {
	              _context2.next = 9;
	              break;
	            }

	            modalInstance = $uibModal.open({
	              animation: true,
	              templateUrl: 'app/modules/calendars-sync/SoftPlusSelectCompanyGlnView.html?v=4.5.6',
	              controller: 'SoftPlusSelectCompanyGlnView',
	              size: 'md',
	              resolve: {
	                companyGlns: function companyGlns() {
	                  return response.companyGLNs;
	                }
	              }
	            });

	            // save SoftPLUS Credentials to DB when modalInstance promise returns the result

	            return _context2.abrupt('return', modalInstance.result.then(function () {
	              var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref2) {
	                var companyGln = _ref2.companyGln;

	                var _response, _response$registeredU, registeredCompanyGln, _id, _userGln, data;

	                return _regenerator2.default.wrap(function _callee$(_context) {
	                  while (1) {
	                    switch (_context.prev = _context.next) {
	                      case 0:
	                        _context.prev = 0;
	                        _context.next = 3;
	                        return SoftPlusSyncDA.sync({ companyGln: companyGln });

	                      case 3:
	                        _response = _context.sent;
	                        _response$registeredU = _response.registeredUser, registeredCompanyGln = _response$registeredU.companyGln, _id = _response$registeredU._id, _userGln = _response$registeredU.userGln;


	                        self.providers.softPlus = {
	                          id: _id,
	                          userGln: _userGln,
	                          companyGln: registeredCompanyGln
	                        };

	                        Notification.addSuccessMessage(self.gettextCatalog.getString('Registered successfully'));
	                        _context.next = 13;
	                        break;

	                      case 9:
	                        _context.prev = 9;
	                        _context.t0 = _context['catch'](0);
	                        data = _context.t0.data;

	                        Notification.addErrorMessage(gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
	                          error: data && data.error && data.error.error ? data.error.error.msg : _context.t0
	                        }));

	                      case 13:
	                      case 'end':
	                        return _context.stop();
	                    }
	                  }
	                }, _callee, _this, [[0, 9]]);
	              }));

	              return function (_x) {
	                return _ref3.apply(this, arguments);
	              };
	            }(), function (dismiss) {
	              console.log(dismiss);
	            }));

	          case 9:
	            _response$registeredU2 = response.registeredUser, registeredCompanyGln = _response$registeredU2.companyGln, _id2 = _response$registeredU2._id, _userGln2 = _response$registeredU2.userGln;


	            self.providers.softPlus = {
	              id: _id2,
	              userGln: _userGln2,
	              companyGln: registeredCompanyGln
	            };
	            return _context2.abrupt('return', true);

	          case 12:
	            _context2.next = 18;
	            break;

	          case 14:
	            _context2.prev = 14;
	            _context2.t0 = _context2['catch'](0);
	            data = _context2.t0.data;

	            Notification.addErrorMessage(gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
	              error: data && data.error && data.error.error ? data.error.error.msg : _context2.t0
	            }));

	          case 18:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, _this, [[0, 14]]);
	  }));

	  // Disconnect from SoftPLUS
	  this.disconnectSoftPlus = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
	    var data;
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            _context3.prev = 0;
	            _context3.next = 3;
	            return SoftPlusSyncDA.removeSync();

	          case 3:

	            self.providers.softPlus = null;

	            Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from SoftPlus'));

	            self.reload();
	            _context3.next = 12;
	            break;

	          case 8:
	            _context3.prev = 8;
	            _context3.t0 = _context3['catch'](0);
	            data = _context3.t0.data;

	            Notification.addErrorMessage(self.gettextCatalog.getString('Disconnect failed: {{error}}', {
	              error: data && data.error && data.error.error ? data.error.error.msg : _context3.t0
	            }));

	          case 12:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, _this, [[0, 8]]);
	  }));

	  this.syncSoftPLusAppointments = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
	    var data;
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _context4.prev = 0;

	            self.providers.softPlus.loading = true;
	            _context4.next = 4;
	            return SoftPlusSyncDA.syncSoftPLusAppointments();

	          case 4:
	            self.providers.softPlus.loading = false;

	            Notification.addSuccessMessage(self.gettextCatalog.getString('Appointments synced from SoftPlus'));

	            // self.reload();
	            _context4.next = 13;
	            break;

	          case 8:
	            _context4.prev = 8;
	            _context4.t0 = _context4['catch'](0);

	            self.providers.softPlus.loading = false;
	            data = _context4.t0.data;

	            Notification.addErrorMessage(self.gettextCatalog.getString('Sync failed: {{error}}', {
	              error: data && data.error && data.error.error ? data.error.error.msg : _context4.t0
	            }));

	          case 13:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, _this, [[0, 8]]);
	  }));
	  //#endregion

	  this.globalCalDavCalendar = '';
	  this.changeGlobalCalDavCalendar = function () {
	    this.serviceGroups.forEach(function (serviceGroup) {
	      serviceGroup.services.forEach(function (service) {
	        service.calendar_name = self.globalCalDavCalendar;
	      });
	    });
	  };

	  this.discoverCalDav = function () {
	    var provider = _.get(self, 'providers.caldav_providers[0]');

	    if (!provider) return;

	    CalDavDA.discoverProvider(provider.name).then(function (response) {
	      response.forEach(function (calendar) {
	        calendar.value = true;
	      });
	      provider.calendars = response;
	    }).catch(function (error) {
	      console.error(error);
	    });
	  };

	  this.updateCalDavCalendars = function () {
	    var provider = _.get(self, 'providers.caldav_providers[0]');

	    if (!provider) return;

	    CalDavDA.getDiscoveredCalendars(provider.name).then(function (response) {
	      response.forEach(function (calendar) {
	        calendar.value = true;
	      });
	      provider.calendars = response;
	    }).catch(function (error) {
	      console.error(error);
	    });
	  };

	  this.linkServicesWithCalDav = function () {
	    var promises = [];
	    var providerCalendars = self.getDiscoveredCalDavCalendars() || [];
	    var calendarsToRemove = providerCalendars.reduce(function (result, calendar) {
	      if (!calendar.value) {
	        result.push(calendar.url);
	      }

	      return result;
	    }, []);

	    if (calendarsToRemove.length) {
	      promises.push(CalDavDA.removeCalendars(calendarsToRemove));
	    }

	    self.serviceGroups.forEach(function (serviceGroup) {
	      serviceGroup.services.forEach(function (service) {
	        if (service.calendar_name && service.calendar_name !== self.linkedServices[service._id]) {
	          promises.push(CalDavDA.linkService(service._id, service.calendar_name));
	        }

	        if (!service.calendar_name && self.linkedServices[service._id]) {
	          promises.push(CalDavDA.unlinkService(service._id));
	        }
	      });
	    });

	    $q.all(promises).then(function () {
	      self.updateCalDavCalendars();

	      Notification.addSuccessMessage(self.gettextCatalog.getString('Linked successfully!'));

	      self.showSyncCalDav = true;
	    });
	  };

	  this.changeCalDavOptions = function () {
	    self.showSyncCalDav = false;
	    self.globalCalDavCalendar = '';
	  };

	  this.syncCalDav = function () {
	    CalDavDA.sync().then(function () {
	      Notification.addSuccessMessage(self.gettextCatalog.getString('Sync process was started!'));
	    });
	  };

	  this.getDiscoveredCalDavCalendars = function () {
	    return _.get(self, 'providers.caldav_providers[0].calendars');
	  };

	  this.getActiveCalDavCalendars = function () {
	    var calendars = self.getDiscoveredCalDavCalendars() || [];
	    return calendars.filter(function (calendar) {
	      return calendar.value;
	    });
	  };

	  this.toCalDavLinking = function () {
	    var providerCalendars = self.getDiscoveredCalDavCalendars();

	    if (!providerCalendars || !providerCalendars.length) {
	      return Notification.addErrorMessage(self.gettextCatalog.getString('Please discover your calendars first'));
	    }

	    var isSelected = providerCalendars.some(function (calendar) {
	      return calendar.value;
	    });

	    if (!isSelected) {
	      return Notification.addErrorMessage(self.gettextCatalog.getString('Please select at least one calendar'));
	    }

	    self.showCalDavLinkingPage = true;
	  };

	  this.disconnectCalDav = function (provider) {
	    CalDavDA.disconnectProvider(provider.name).then(function () {
	      var index = self.providers.caldav_providers.indexOf(provider);

	      self.providers.caldav_providers.splice(index, 1);

	      Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected successfully'));
	    }).catch(function (error) {
	      console.error(error);
	    });
	  };

	  if (this.providers.google) {
	    CalDavDA.discoverProvider('google').then(function (response) {
	      self.googleCalendars = response;
	    }).catch(function (error) {
	      console.error(error);
	    });
	  }

	  if (this.providers.outlook) {
	    CalDavDA.discoverProvider('outlook').then(function (response) {
	      self.outlookCalendars = response;
	    }).catch(function (error) {
	      console.error(error);
	    });
	  }

	  this.disconnectGoogle = function () {
	    CalDavDA.disconnectProvider('google').then(function () {
	      Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Google'));
	      self.reload();
	    }).catch(function (error) {
	      Notification.addErrorMessage(self.gettextCatalog.getString('Disconnect failed: {{error}}', { error: error.error }));
	      console.error(error);
	    });
	  };

	  this.disconnectOutlook = function () {
	    CalDavDA.disconnectProvider('outlook').then(function () {
	      Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Outlook'));
	      self.reload();
	    }).catch(function (error) {
	      Notification.addErrorMessage(self.gettextCatalog.getString('Disconnect failed: {{error}}', { error: error.error }));
	      console.error(error);
	    });
	  };

	  this.sync = {};
	  var checkTimeout;
	  this.checkOnGoogleSyncPending = function (forceUpdate) {
	    if (!self.sync.googleMappingPending && !forceUpdate) return $q.resolve();

	    return self._GoogleSyncDA.getCalendarList().then(function (googleSync) {
	      self.sync = googleSync.sync || {};
	      self.sync.googleMapping = self.sync.googleMapping || {};

	      if (!self.sync.googleMappingPending) return $q.resolve();

	      self.sync.googleMapping = self.sync.tmpGoogleMapping || self.sync.googleMapping;

	      checkTimeout = $timeout(self.checkOnGoogleSyncPending, 5000);

	      return checkTimeout;
	    });
	  };

	  if (!googleSync) {
	    this.responseError = true;
	  } else if (googleSync.success === false) {
	    this.responseError = true;
	  } else {
	    this.sync = googleSync.sync || {};
	    this.sync.googleMapping = this.sync.googleMapping || {};
	    this.calendarList = googleSync.payload;

	    this.calendarList.forEach(function (calendar) {
	      calendar.id = calendar.id.replace(/\./g, '__');
	    });

	    this.checkOnGoogleSyncPending();
	  }

	  $scope.$on('$destroy', function () {
	    $timeout.cancel(checkTimeout);
	  });

	  this.reload = function () {
	    $state.reload();
	  };

	  // iCal sync section

	  /**
	   * generate private calendar address
	   */
	  var generateCalendarAddress = function generateCalendarAddress() {
	    var base = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

	    if ($scope.resource._id && $scope.resource.ical) {
	      $scope.icalUrl = base + '/api/v2/calendar/ical/' + $scope.resource.ical + '/feed.ics';
	    }
	  };

	  var loadSyncs = function loadSyncs() {
	    if ($scope.resource._id) {
	      SyncDA.get($scope.resource._id).then(function (response) {
	        $scope.syncs = response.syncList;
	      });
	    }
	  };

	  if ($scope.resource.ical) {
	    $scope.privateCalendarAddressEnabled = true;
	    generateCalendarAddress();
	  }

	  loadSyncs();

	  /**
	   * enable/disable private calendar address
	   */
	  $scope.changePrivateCalendarAddressEnabledState = function () {
	    if ($scope.privateCalendarAddressEnabled) {
	      $scope.resetPrivateAddress();
	    } else {
	      $scope.resource.ical = null;
	      $scope.icalUrl = '';
	    }
	  };

	  /**
	   * get new private calendar address from API
	   */
	  $scope.resetPrivateAddress = function () {
	    ResourceDA.refreshCalendarAddress($scope.resource._id).then(function (response) {
	      $scope.resource.ical = response.ical;
	      generateCalendarAddress();
	      Notification.addSuccessMessage(gettextCatalog.getString('calendar address resetted'));
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant reset private calendar address'));
	    });
	  };

	  /**
	   * add new external calendar
	   */
	  $scope.addCalendarUrl = function () {
	    var syncAlreadyExists = $scope.syncs.filter(function (sync) {
	      return sync.address === $scope.externalIcalAddress;
	    })[0];

	    if (syncAlreadyExists) {
	      return Notification.addErrorMessage(gettextCatalog.getString('You cant subscribe to same calendar twice'));
	    }

	    if ($scope.icalUrl === $scope.externalIcalAddress) {
	      return Notification.addErrorMessage(gettextCatalog.getString('You cant subscribe to your own calendar in this system'));
	    }

	    var calendarSync = {
	      type: 'ical',
	      address: $scope.externalIcalAddress,
	      copyDescription: $scope.copyDescription
	    };

	    SyncDA.insert($scope.resource._id, calendarSync).then(function (response) {
	      $scope.externalIcalAddress = '';
	      $scope.syncs.push(response.sync);
	      Notification.addSuccessMessage(gettextCatalog.getString('Successfully subscribed to calendar'));
	    },
	    // TODO: implement a helper function or a global error handler
	    function (response) {
	      var errorMsg = _.get(response, 'data.error[0].msg');
	      var error;

	      if (errorMsg) {
	        error = gettextCatalog.getString(errorMsg);
	      } else {
	        error = gettextCatalog.getString('Unknown');
	      }

	      Notification.addErrorMessage(gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  function _removeSync(sync) {
	    return SyncDA.delete($scope.resource._id, sync._id).then(function () {
	      var index = $scope.syncs.indexOf(sync);
	      $scope.syncs.splice(index, 1);
	      Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription removed'));
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant remove calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  }

	  $scope.updateSyncActive = function (sync) {
	    return SyncDA.update($scope.resource._id, sync._id, sync).then(function (updatedSync) {
	      var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
	      syncToUpdate.active = updatedSync.active;

	      if (!syncToUpdate.active) {
	        Notification.addInfoMessage(gettextCatalog.getString('You still can sync your calendar manually'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription disabled'));
	      } else {
	        Notification.addInfoMessage(gettextCatalog.getString('Calendar events will be synced with this calendar automatically'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription enabled'));
	      }
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  $scope.updateSyncIsCopyDescription = function (sync) {
	    return SyncDA.update($scope.resource._id, sync._id, sync).then(function (updatedSync) {
	      var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
	      syncToUpdate.copyDescription = updatedSync.copyDescription;

	      if (!syncToUpdate.copyDescription) {
	        Notification.addInfoMessage(gettextCatalog.getString('Copy Appointment Description disabled'));
	      } else {
	        Notification.addInfoMessage(gettextCatalog.getString('Copy Appointment Description enabled'));
	      }
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  $scope.removeSync = function (sync) {
	    if (!sync.lastSync) return _removeSync(sync);

	    if ($scope.isPending(sync)) return;

	    var cond = confirm(gettextCatalog.getString('Do you want to remove all related events too?'));

	    if (!cond && !sync.active) return;

	    if (!cond) {
	      var updatedSync = _.cloneDeep(sync);
	      updatedSync.active = false;

	      return $scope.updateSyncActive(updatedSync);
	    }

	    AppointmentDA.removeSyncedViaICal($scope.resource._id, sync._id).then(function (res) {
	      if (!res.success) return new Error('Cant remove associated appointments');

	      Notification.addSuccessMessage(gettextCatalog.getString('Related events removed'));

	      return _removeSync(sync);
	    });
	  };

	  $scope.isPending = function (sync) {
	    var date = sync && sync.lastSync;

	    if (!date || sync.error > 0) return false;

	    return new Date(date).valueOf() === -1;
	  };

	  var pendingTimeout;
	  function checkPending() {
	    var isNeedToRefresh = !$scope.syncs || $scope.syncs.some(function (item) {
	      return $scope.isPending(item);
	    });

	    if ($scope.resource._id && !isNeedToRefresh) return;

	    SyncDA.get($scope.resource._id).then(function (response) {
	      $scope.syncs = response.syncList;

	      pendingTimeout = $timeout(checkPending, 10000);
	    });
	  }

	  checkPending();

	  $scope.$on('$destroy', function () {
	    $timeout.cancel(pendingTimeout);
	  });

	  $scope.runSync = function (sync) {
	    if ($scope.isPending(sync)) return;

	    Notification.addSuccessMessage(gettextCatalog.getString('Please wait, calendar sync can take some time'));

	    sync.lastSync = new Date(-1);
	    sync.error = 0;

	    SyncDA.runSync($scope.resource._id, sync._id).then(function (updatedSync) {
	      sync.lastSync = updatedSync.lastSync;
	      var count = updatedSync.count;
	      var message;

	      if (count) {
	        message = count > 1 ? gettextCatalog.getString('Was added {{count}} appointments', { count: count }) : gettextCatalog.getString('Was added one appointment');

	        Notification.addSuccessMessage(message);
	      }

	      Notification.addSuccessMessage(gettextCatalog.getString('Calendar is synced'));
	    }, function (resource) {
	      checkPending();

	      var errorMsg = _.get(resource, 'data.error');

	      if (errorMsg) {
	        errorMsg = gettextCatalog.getString(errorMsg);
	      } else {
	        errorMsg = gettextCatalog.getString('Unknown');
	      }

	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: errorMsg
	      }));
	    });
	  };

	  this.selectDefaultGoogleCalendar = function () {
	    if (angular.equals(self.sync.googleMapping, {})) {
	      self.calendarList.forEach(function (_ref6) {
	        var isAutoGeneratedCalendar = _ref6.isAutoGeneratedCalendar,
	            id = _ref6.id;

	        if (isAutoGeneratedCalendar) {
	          self.sync.googleMapping[id] = {
	            resource: self.resources[0].id
	          };
	        }
	      });
	    }
	  };
	  this.selectDefaultGoogleCalendar();
	};

	/**
	 *  speichere mappings
	 *
	 *  funktion implementieren die checkt ob es einen change gab
	 *  initales laden der calendar
	 */

	CalendarsSyncCtrl.prototype.connect = function () {
	  this._window.open('/api/v2/auth/google', 'google_auth', 'width=450, height=500, scrolling=yes, resizable=no');

	  var self = this;
	  window.authWindowClose = function () {
	    self.reload();
	  };
	};

	CalendarsSyncCtrl.prototype.registerGoogle = function () {
	  this._window.open('/api/v2/calendarApi/register/oauth/google', 'google_auth', 'width=450, height=500, scrolling=yes, resizable=no');

	  var self = this;
	  window.closeOnAuthSuccess = function () {
	    self.reload();
	  };
	};

	CalendarsSyncCtrl.prototype.registerOutlook = function () {
	  this._window.open('/api/v2/calendarApi/register/oauth/outlook', 'google_auth', 'width=450, height=500, scrolling=yes, resizable=no');

	  var self = this;
	  window.closeOnAuthSuccess = function () {
	    self.reload();
	  };
	};

	CalendarsSyncCtrl.prototype.disconnect = function () {
	  var self = this;

	  this._GoogleSyncDA.revokeAccess().then(function () {
	    self.calendarList = [];
	    self.responseError = true;
	    self._AppointmentModel.clearCache();
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('Disconnected from Google'));
	  }, function (error) {
	    self._Notification.addErrorMessage({ text: error });
	  });
	};

	CalendarsSyncCtrl.prototype.save = function () {
	  var self = this;

	  self._GoogleSyncDA.update(this.sync).then(function (updatedSync) {
	    self.sync = updatedSync.sync || {};

	    if (self.sync.googleMappingPending) {
	      self._Notification.addInfoMessage(self.gettextCatalog.getString('Calendar mapping will be updated after this process'));
	      self._Notification.addSuccessMessage(self.gettextCatalog.getString('Please wait, calendar synchronisation in progress'));
	    }

	    self.checkOnGoogleSyncPending().then(function () {
	      self._Notification.addSuccessMessage(self.gettextCatalog.getString('Calendar mapping saved'));
	    });

	    self._AppointmentModel.clearCache();
	  }, function (error) {
	    var errorMessage = _.get(error, 'data.error.errors[0].message');
	    errorMessage = errorMessage || _.get(error, 'data.error[0].message');
	    errorMessage = errorMessage || _.get(error, 'data.error.message');
	    errorMessage = errorMessage || _.get(error, 'data.error');
	    errorMessage = errorMessage || error;

	    self._Notification.addErrorMessage({ text: errorMessage });

	    self.checkOnGoogleSyncPending(true);
	  });
	};

	CalendarsSyncCtrl.prototype.resourceChanged = function (calendarId) {
	  delete this.sync.googleMapping[calendarId].primary;
	};

	CalendarsSyncCtrl.prototype.checkPrimary = function (calendarId) {
	  var mappings = this.sync.googleMapping;
	  var checkMapping = mappings[calendarId];

	  if (checkMapping) {
	    var resource = mappings[calendarId].resource;

	    _.forEach(mappings, function (mapping, key) {
	      if (key !== calendarId && mapping.resource === resource) {
	        delete mapping.primary;
	      }
	    });
	  }
	};

	module.exports = CalendarsSyncCtrl;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var holidaysModule = angular.module('t2g.holidays', ['gettext', 'ui.router', __webpack_require__(1).name, __webpack_require__(9).name]);

	var today = new Date();

	module.exports = holidaysModule;

	holidaysModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.holidays', {
	    url: '/holidays',
	    title: 'Holidays',
	    templateUrl: '/app/modules/holidays/HolidaysView.html?v=4.5.6',
	    controller: 'holidaysCtrl',
	    resolve: {
	      officeResponse: ["OfficeDA", function officeResponse(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      countryConfigResolve: ["$q", "CountryConfig", function countryConfigResolve($q, CountryConfig) {
	        return CountryConfig.get();
	      }]
	    }
	  });
	}]);

	holidaysModule.controller('holidaysCtrl', ["$scope", "countryConfigResolve", "gettextCatalog", "Notification", "OfficeModel", "officeResponse", "DatepickerSettings", function ($scope, countryConfigResolve, gettextCatalog, Notification, OfficeModel, officeResponse, DatepickerSettings) {
	  $scope.office = officeResponse;
	  $scope.countryConfig = countryConfigResolve;
	  $scope.holidays = {};
	  $scope.currentYear = today.getFullYear().toString();
	  $scope.years = ['2017', '2018'];
	  $scope.dtpOptions = DatepickerSettings.default;
	  $scope.dtpOptions.maxMode = 'month';
	  $scope.newHoliday = {
	    name: '',
	    date: new Date($scope.currentYear, 0, 1)
	  };

	  /**
	   * set checkbox states
	   */
	  angular.forEach($scope.office.openingHours.special, function (value, key) {
	    $scope.holidays[key] = true;
	  });

	  var initHolidays = function initHolidays() {
	    angular.forEach($scope.years, function (year) {
	      $scope.mergeHolidays(year);
	    });
	  };

	  /**
	   * active are deactive holiday opening hours overwrite
	   * @param holidayKey
	   */
	  $scope.changeState = function (holidayKey) {
	    if ($scope.holidays[holidayKey]) {
	      $scope.office.openingHours.special[holidayKey] = {
	        open: true,
	        times: [{
	          start: 540,
	          end: 720
	        }]
	      };
	    } else {
	      delete $scope.office.openingHours.special[holidayKey];
	    }
	  };

	  /**
	   * add a second column to enable two time slots per day ...
	   * @param holidayKey
	   */
	  $scope.addSecondOpeningTime = function (holidayKey) {
	    if ($scope.office.openingHours.special[holidayKey].times.length === 1) {
	      // get closing hour of first opening time
	      var firstClosingTime = $scope.office.openingHours.special[holidayKey].times[0].end;

	      $scope.office.openingHours.special[holidayKey].times.push({
	        start: firstClosingTime + 60 > 1440 ? 1440 : firstClosingTime + 60,
	        end: firstClosingTime + 240 > 1440 ? 1440 : firstClosingTime + 240
	      });
	    }
	  };

	  /**
	   * ... end make it removeable
	   * @param holidayKey
	   */
	  $scope.removeSecondOpeningTime = function (holidayKey) {
	    if ($scope.office.openingHours.special[holidayKey].times.length === 2) {
	      $scope.office.openingHours.special[holidayKey].times.splice(1, 1);
	    }
	  };

	  /**
	   * generate holidaykey
	   * @param date
	   * @returns {*}
	   */
	  $scope.getHolidayKey = function (date) {
	    date = new Date(date);
	    return date.getDayKey();
	  };

	  $scope.mergeHolidays = function (year) {
	    angular.forEach($scope.office.openingHours.special, function (holiday, key) {
	      if (holiday.custom && key.substring(0, 4) === year) {
	        var date = new Date(key);

	        $scope.countryConfig.holidays[year][key.substring(5, 10)] = {
	          date: date,
	          custom: holiday.custom,
	          key: date.getDayKey(),
	          name: holiday.name,
	          public: false
	        };
	      }
	    });
	  };

	  $scope.addNewHoliday = function () {
	    if ($scope.newHoliday.name && angular.isDate($scope.newHoliday.date)) {
	      var holidayKey = $scope.newHoliday.date.getDayKey();

	      $scope.office.openingHours.special[holidayKey] = {
	        name: $scope.newHoliday.name,
	        open: true,
	        custom: true,
	        date: $scope.newHoliday.date,
	        times: []
	      };

	      $scope.save();

	      $scope.newHoliday = {
	        name: '',
	        date: new Date($scope.currentYear, 0, 1)
	      };

	      $scope.mergeHolidays($scope.currentYear);
	    }
	  };

	  $scope.delete = function (dayKey) {
	    var customHoliday = $scope.office.openingHours.special[dayKey];
	    var shortDateKey = dayKey.substring(5);

	    if (customHoliday && customHoliday.custom) {
	      delete $scope.office.openingHours.special[dayKey];
	      delete $scope.countryConfig.holidays[$scope.currentYear][shortDateKey];

	      $scope.save(function () {
	        $scope.mergeHolidays($scope.currentYear);
	        Notification.addSuccessMessage(gettextCatalog.getString('Holiday removed'));
	      });
	    }
	  };

	  /**
	   * save to rest webservice
	   */
	  $scope.save = function (cb) {
	    OfficeModel.update($scope.office, function (error) {
	      if (error) {
	        Notification.addErrorMessage({ text: error });
	      } else {
	        if (cb) {
	          cb();
	        }

	        Notification.addSuccessMessage(gettextCatalog.getString('Holiday saved'));
	      }
	    });
	  };

	  $scope.yearChanged = function () {
	    $scope.newHoliday.date = new Date($scope.currentYear, 0, 1);
	  };

	  initHolidays();
	}]);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var mailTemplateModule = angular.module('t2g.mailTemplate', ['gettext', 'ui.router', __webpack_require__(9).name]);

	module.exports = mailTemplateModule;

	mailTemplateModule.controller('MailTemplateCtrl', __webpack_require__(206));
	mailTemplateModule.controller('MailTemplateDetailCtrl', __webpack_require__(207));

	mailTemplateModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.mailTemplate', {
	    url: '/mail-template',
	    title: 'E-Mail Templates',
	    templateUrl: '/app/modules/mailTemplate/MailTemplateView.html?v=4.5.6',
	    controller: 'MailTemplateCtrl as MailTemplateCtrl'
	  }).state('private.main.mailTemplate.detail', {
	    url: '/:templateName',
	    title: 'E-Mail Templates',
	    templateUrl: '/app/modules/mailTemplate/MailTemplateDetailView.html?v=4.5.6',
	    controller: 'MailTemplateDetailCtrl as MailTemplateDetailCtrl',
	    resolve: {
	      template: ["$stateParams", "MailDA", function template($stateParams, MailDA) {
	        return MailDA.get($stateParams.templateName);
	      }],
	      placeholder: ["$stateParams", "placeholderSettings", function placeholder($stateParams, placeholderSettings) {
	        return placeholderSettings[$stateParams.templateName];
	      }]
	    }
	  });
	}]);

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';

	var MailTemplateCtrl = function MailTemplateCtrl($scope, $state, $stateParams, gettextCatalog) {
	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this._state = $state;
	  this.templates = [{
	    id: 'acceptBooking',
	    name: gettextCatalog.getString('Accept Booking')
	  }, {
	    id: 'declineBooking',
	    name: gettextCatalog.getString('Decline Booking')
	  }, {
	    id: 'remindAppointment',
	    name: gettextCatalog.getString('Appointment Reminder')
	  }, {
	    id: 'appointmentChanged',
	    name: gettextCatalog.getString('Appointment Changed')
	  }, {
	    id: 'appointmentDeleted',
	    name: gettextCatalog.getString('Appointment Removed')
	  }];
	  this.currentTemplate = $stateParams.templateName || 'acceptBooking';
	  this.open(this.currentTemplate);
	};

	MailTemplateCtrl.prototype.templateChanged = function () {
	  this.open(this.currentTemplate);
	};

	MailTemplateCtrl.prototype.open = function (templateId) {
	  if (templateId) {
	    this._state.go('private.main.mailTemplate.detail', { templateName: templateId });
	  }
	};

	module.exports = MailTemplateCtrl;

/***/ }),
/* 207 */
/***/ (function(module, exports) {

	'use strict';

	var MailTemplateDetailCtrl = function MailTemplateDetailCtrl($scope, $state, gettextCatalog, template, placeholder, MailDA, Notification) {
	  this._$state = $state;
	  this._MailDA = MailDA;
	  this._Notification = Notification;
	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this.template = template;
	  this.placeholder = placeholder;
	  this.gettextCatalog = gettextCatalog;
	};

	MailTemplateDetailCtrl.prototype.save = function () {
	  var self = this;

	  this._MailDA.update({
	    name: this.template.name,
	    content: this.template.content
	  }).then(function () {
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('E-Mail Template saved'));
	  }).catch(function (error) {
	    self._Notification.addErrorMessage({ text: error });
	  });
	};

	MailTemplateDetailCtrl.prototype.reset = function () {
	  var self = this;

	  this._MailDA.remove(this.template.name).then(function () {
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('E-Mail Template resetted'));
	    self._$state.reload();
	  }).catch(function (error) {
	    self._Notification.addErrorMessage({ text: error });
	  });
	};

	module.exports = MailTemplateDetailCtrl;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var messageModule = angular.module('t2g.message', ['gettext', 'ui.router', __webpack_require__(9).name, __webpack_require__(160).name]);

	module.exports = messageModule;

	messageModule.controller('MailCtrl', __webpack_require__(209));
	messageModule.controller('MessageBoxCtrl', __webpack_require__(210));
	messageModule.controller('MessageCtrl', __webpack_require__(211));
	messageModule.controller('SMSCtrl', __webpack_require__(212));

	messageModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.messages', {
	    url: '/message/:box',
	    title: 'Messages',
	    templateUrl: '/app/modules/message/MessageBoxView.html?v=4.5.6',
	    controller: 'MessageBoxCtrl as MessageBoxCtrl',
	    resolve: {
	      messagesResolve: ["$q", "$stateParams", "Message", function messagesResolve($q, $stateParams, Message) {
	        var deffered = $q.defer();

	        Message.get($stateParams.box).then(function (messages) {
	          deffered.resolve(messages);
	        }, function (error) {
	          deffered.reject(error);
	        });

	        return deffered.promise;
	      }]
	    }
	  }).state('private.main.message', {
	    url: '/message/',
	    title: 'Messages',
	    controller: 'MessageCtrl as MessageCtrl',
	    templateUrl: '/app/modules/message/types/MessageView.html?v=4.5.6'
	  }).state('private.main.message.mail', {
	    url: 'mail/:messageId',
	    title: 'Messages',
	    controller: 'MailCtrl as MailCtrl',
	    templateUrl: '/app/modules/message/types/MailView.html?v=4.5.6',
	    resolve: {
	      messageResolve: ["$q", "$stateParams", "Message", function messageResolve($q, $stateParams, Message) {
	        var deffered = $q.defer();

	        Message.getOne($stateParams.messageId).then(function (messages) {
	          deffered.resolve(messages);
	        }, function (error) {
	          deffered.reject(error);
	        });

	        return deffered.promise;
	      }]
	    }
	  }).state('private.main.message.sms', {
	    url: 'sms/:messageId',
	    title: 'Messages',
	    controller: 'SMSCtrl as SMSCtrl',
	    templateUrl: '/app/modules/message/types/SMSView.html?v=4.5.6',
	    resolve: {
	      messageResolve: ["$q", "$stateParams", "Message", function messageResolve($q, $stateParams, Message) {
	        var deffered = $q.defer();

	        Message.getOne($stateParams.messageId).then(function (messages) {
	          deffered.resolve(messages);
	        }, function (error) {
	          deffered.reject(error);
	        });

	        return deffered.promise;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * @param {angular.$scope} $scope
	 * @param {Object} messageResolve
	 * @param {angular.Service} AppointmentModal
	 * @constructor
	 */
	var MailCtrl = function MailCtrl($scope, messageResolve, ModalService) {
	  this._ModalService = ModalService;

	  $scope.setMessage(messageResolve);
	  $scope.message = messageResolve;

	  console.log($scope.message);
	};

	/**
	 * @param {Object} appointment
	 */
	MailCtrl.prototype.openAppointment = function (appointment) {
	  appointment.start = new Date(appointment.start);
	  appointment.end = new Date(appointment.end);

	  this._ModalService.openAppointmentModal(appointment);
	};

	module.exports = MailCtrl;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 *
	 * @param $scope
	 * @param $state
	 * @param messagesResolve
	 * @constructor
	 */
	var MessageBoxCtrl = function MessageBoxCtrl($scope, $state, messagesResolve) {
	  this.$scope = $scope;
	  this.$state = $state;
	  this.messagesResolve = messagesResolve;

	  $scope.limit = 10;
	  $scope.messages = messagesResolve;
	};

	/**
	 * open message with specific id
	 * @param message
	 */
	MessageBoxCtrl.prototype.openMessage = function (message) {
	  var allowedTypes = {
	    mail: true,
	    sms: true
	  };

	  if (message.type && allowedTypes[message.type]) {
	    this.$state.go('private.main.message.' + message.type, { messageId: message._id });
	  }
	};

	module.exports = MessageBoxCtrl;

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	'use strict';

	var MessageCtrl = function MessageCtrl($scope, $state, gettextCatalog, Message, Notification) {
	  /**
	   * @type {!angular.Scope}
	   * @private
	   */
	  this.scope_ = $scope;

	  /**
	   * @type {angular.Service}
	   * @private
	   */
	  this.$state_ = $state;

	  /**
	   * @type {Object}
	   * @private
	   */
	  this.message_ = null;

	  /**
	   * @type {Object}
	   * @private
	   */
	  this.Message_ = Message;

	  /**
	   * @type {Function}
	   * @private
	   */
	  this.Notification_ = Notification;

	  this.gettextCatalog = gettextCatalog;

	  $scope.setMessage = this.setMessage.bind(this);
	};
	/**
	 * go back to in-/outbox
	 */
	MessageCtrl.prototype.goBack = function () {
	  this.$state_.go('private.main.messages', { box: this.message_.box });
	};

	/**
	 * delete current message
	 * @param {Object} message
	 */
	MessageCtrl.prototype.delete = function () {
	  var self = this;

	  this.Message_.delete(this.message_).then(function () {
	    self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Message deleted'));
	    self.goBack();

	    if (self.message_.topic === 'booking') {
	      self.scope_.$emit('Booking:delete');
	    }
	  }, function () {
	    self.Notification_.addErrorMessage(self.gettextCatalog.getString('Cant remove message'), true);
	  });
	};

	/**
	 * privileged setter for message
	 * @param message
	 */
	MessageCtrl.prototype.setMessage = function (message) {
	  this.message_ = message;
	};

	module.exports = MessageCtrl;

/***/ }),
/* 212 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * @param {angular.$scope} $scope
	 * @param {Object} messageResolve
	 * @param {angular.Service} AppointmentModal
	 * @constructor
	 */
	var SMSCtrl = function SMSCtrl($scope, messageResolve, AppointmentModal) {
	  this.AppointmentModal_ = AppointmentModal;

	  $scope.setMessage(messageResolve);

	  $scope.message = messageResolve;
	};

	/**
	 * @param {Object} appointment
	 */
	SMSCtrl.prototype.openAppointment = function (appointment) {
	  appointment.start = new Date(appointment.start);
	  appointment.end = new Date(appointment.end);

	  switch (appointment.type) {
	    case 'customer':
	      this.AppointmentModal_.open(appointment);
	      break;

	    case 'course':
	      this.AppointmentModal_.open(appointment);
	      break;

	    default:
	      this.AppointmentModal_.open(appointment);
	      break;
	  }
	};

	module.exports = SMSCtrl;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var openingHoursModule = angular.module('t2g.openingHours', ['gettext', 'ui.router', __webpack_require__(9).name, __webpack_require__(1).name]);

	module.exports = openingHoursModule;

	openingHoursModule.controller('OpeningHoursCtrl', __webpack_require__(214));
	openingHoursModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.openingHours', {
	    url: '/openingHours',
	    title: 'Opening Hours',
	    templateUrl: '/app/modules/openingHours/OpeningHoursView.html?v=4.5.6',
	    controller: 'OpeningHoursCtrl',
	    resolve: {
	      officeResponse: ["OfficeDA", function officeResponse(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 214 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, gettextCatalog, Notification, OfficeModel, officeResponse) {
	  $scope.weekDays = [{ name: gettextCatalog.getString('Monday') }, { name: gettextCatalog.getString('Tuesday') }, { name: gettextCatalog.getString('Wednesday') }, { name: gettextCatalog.getString('Thursday') }, { name: gettextCatalog.getString('Friday') }, { name: gettextCatalog.getString('Saturday') }, { name: gettextCatalog.getString('Sunday') }];

	  $scope.showValidation = false;
	  $scope.office = officeResponse;
	  $scope.openingHours = $scope.office.openingHours;

	  $scope.$watch('openingHours', function () {
	    console.log('changed');
	  }, true);

	  /**
	   * save to rest webservice
	   */
	  $scope.save = function () {
	    $scope.showValidation = true;

	    if ($scope.openingHoursForm.$valid) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage({ text: error });
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('Opening hours updated'));
	        }
	      });
	    }
	  };

	  /**
	   * add a second column to enable two time slots per day ...
	   * @param day
	   */
	  $scope.addSecondOpeningTime = function (day) {
	    // get closing hour of first opening time
	    var firstClosingTime = $scope.openingHours.regular[day].times[0].end;

	    $scope.openingHours.regular[day].times.push({
	      start: firstClosingTime + 60 > 1440 ? 1440 : firstClosingTime + 60,
	      end: firstClosingTime + 240 > 1440 ? 1440 : firstClosingTime + 240
	    });
	  };

	  /**
	   * ... end make it removeable
	   * @param day
	   */
	  $scope.removeSecondOpeningTime = function (day) {
	    console.log($scope.openingHours.regular[day].times.length);
	    $scope.openingHours.regular[day].times.splice(1, 1);
	    console.log($scope.openingHours.regular[day].times.length);
	  };
	};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var pageWidgetModule = angular.module('t2g.pageWidget', ['gettext', 'ui.router', __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = pageWidgetModule;

	pageWidgetModule.controller('PageWidgetCtrl', __webpack_require__(216));

	pageWidgetModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.pageWidget', {
	    url: '/page-widget',
	    title: 'Page Widget',
	    templateUrl: '/app/modules/pageWidget/pageWidgetView.html?v=4.5.6',
	    controller: 'PageWidgetCtrl as PageWidgetCtrl',
	    resolve: {
	      office: ["OfficeDA", function office(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	'use strict';

	var PageWidgetCtrl = function PageWidgetCtrl($scope, OfficeModel, office, gettextCatalog, Notification) {
	  this.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  this.office = office;
	  this.widgetHtmlCode = this.getWidgetCode();
	  this._OfficeModel = OfficeModel;
	  this._Notification = Notification;
	  this.gettextCatalog = gettextCatalog;
	  this._init();
	  this.stringOverwrites = {
	    select_services: gettextCatalog.getString('Select your services'),
	    services: gettextCatalog.getString('services'),
	    appointment: gettextCatalog.getString('appointment'),
	    contact: gettextCatalog.getString('contact'),
	    forward: gettextCatalog.getString('forward'),
	    back: gettextCatalog.getString('back'),
	    book_appointment: gettextCatalog.getString('book appointment'),
	    congratulations: gettextCatalog.getString('Congratulations! You successfully booked an appointment. Please await the appointment confirmation from the service provider.'),
	    check_spam: gettextCatalog.getString('Please also check your spam folder emails!'),
	    book_another_appointment: gettextCatalog.getString('Book another appointment at {{SuccessCtrl.office.name}}')
	  };
	};

	PageWidgetCtrl.prototype._init = function () {
	  if (!this.office.settings.widget || !this.office.settings.widget.appointment || !this.office.settings.widget.appointment.primary || !this.office.settings.widget.appointment.primaryContrast) {
	    this.revert();
	  }
	};

	PageWidgetCtrl.prototype.getWidgetCode = function () {
	  var widgetCode = '<iframe src="https://www.termin2go.com/appointment-booking/' + this.office.slug + '#/services?channel=web" frameBorder="0" height="560px" width="100%" scrolling="yes"></iframe>';
	  return widgetCode;
	};

	PageWidgetCtrl.prototype.save = function () {
	  var self = this;
	  this._OfficeModel.update(this.office, function (error) {
	    if (error) {
	      self._Notification.addErrorMessage({ text: error });
	    } else {
	      self._Notification.addSuccessMessage(self.gettextCatalog.getString('Widget settings saved'));
	    }
	  });
	};

	PageWidgetCtrl.prototype.revert = function () {
	  this.office.settings.widget = {
	    appointment: {
	      bg: '#FFFFFF',
	      primary: '#4CAF50',
	      primaryContrast: '#FFFFFF'
	    }
	  };
	};

	PageWidgetCtrl.prototype.resetString = function (key) {
	  this.office.settings.widget.appointment.text[key] = '';
	};

	module.exports = PageWidgetCtrl;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var paymentModule = angular.module('t2g.payment', ['ui.router', __webpack_require__(26).name, __webpack_require__(5).name]);

	module.exports = paymentModule;

	paymentModule.controller('PaymentsController', __webpack_require__(218));

	paymentModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.payments', {
	    url: '/payments',
	    title: 'Payments',
	    templateUrl: '/app/modules/payment/PaymentsView.html?v=4.5.6',
	    controller: 'PaymentsController as PaymentsController',
	    resolve: {
	      paymentsResolve: ["PaymentDA", function paymentsResolve(PaymentDA) {
	        return PaymentDA.getAll();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * @param {Object} PaymentDA
	 * @param {Object} paymentsResolve
	 * @constructor
	 */
	var PaymentsController = function PaymentsController(PaymentDA, paymentsResolve) {
	  this.payments_ = paymentsResolve.payments;
	  this.PaymentDA_ = PaymentDA;
	};

	/**
	 * @param {Object} payment
	 * @returns {String}
	 */
	PaymentsController.prototype.getInvoiceFile = function (payment) {
	  var invoiceUrl = this.PaymentDA_.getInvoiceFilePath(payment._id);

	  return invoiceUrl;
	};

	module.exports = PaymentsController;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var profileModule = angular.module('t2g.profile', ['gettext', 'ngFileUpload', 'ui.router', __webpack_require__(21).name, __webpack_require__(154).name, __webpack_require__(1).name, __webpack_require__(9).name, __webpack_require__(4).name]);

	module.exports = profileModule;

	profileModule.controller('ProfileCtrl', __webpack_require__(220));

	profileModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.profile', {
	    url: '/profile',
	    title: 'Profile',
	    templateUrl: '/app/modules/profile/ProfileView.html?v=4.5.6',
	    controller: 'ProfileCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      industryResolve: ["$q", "Industry", function industryResolve($q, Industry) {
	        var deffered = $q.defer();

	        Industry.query({}, function (response) {
	          if (response instanceof Array) {
	            deffered.resolve(response);
	          } else {
	            deffered.reject();
	          }
	        });

	        return deffered.promise;
	      }],
	      countryResolve: ["CountryConfig", function countryResolve(CountryConfig) {
	        return CountryConfig.getCountries();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 220 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, $timeout, countryResolve, GeocodeService, gettextCatalog, industryResolve, Notification, Office, OfficeModel, officeResolve, Upload) {
	  $scope.office = officeResolve;
	  $scope.industries = industryResolve;
	  $scope.mapLink = null;
	  $scope.showValidation = false;
	  $scope.tasks = [{ text: gettextCatalog.getString('You added your address'), weight: 15, completed: false }, { text: gettextCatalog.getString('You added your contact data'), weight: 15, completed: false }, { text: gettextCatalog.getString('You uploaded your logo'), weight: 20, completed: false }, {
	    text: gettextCatalog.getString('You activated your profile for the booking system.'),
	    weight: 10,
	    completed: false
	  }, {
	    text: gettextCatalog.getString('You uploaded pictures of you office'),
	    weight: 20,
	    completed: false
	  }, { text: gettextCatalog.getString('You added a discription'), weight: 20, completed: false }];

	  $scope.countries = countryResolve;

	  $scope.changeIndustry = function () {
	    angular.forEach($scope.industries, function (value) {
	      if (value.name === $scope.office.profile.industry) {
	        $scope.office.settings.customLabels = value.labels;
	      }
	    });
	  };

	  function sumcompletedTasksWeight() {
	    $scope.completedTasksWeight = 0;

	    // check address
	    if ($scope.office.name && $scope.office.address && angular.isArray($scope.office.address.location) && $scope.office.address.location.length === 2) {
	      $scope.tasks[0].completed = true;
	    } else {
	      $scope.tasks[0].completed = false;
	    }

	    // check contacts
	    if ($scope.office.profile.contacts.phone && $scope.office.profile.contacts.email) {
	      $scope.tasks[1].completed = true;
	    } else {
	      $scope.tasks[1].completed = false;
	    }

	    // check logo
	    if ($scope.office.profile.logo) {
	      $scope.tasks[2].completed = true;
	    } else {
	      $scope.tasks[2].completed = false;
	    }

	    // check profile active
	    if ($scope.office.profile.public) {
	      $scope.tasks[3].completed = true;
	    } else {
	      $scope.tasks[3].completed = false;
	    }

	    // check images
	    if ($scope.office.profile.images && $scope.office.profile.images.length > 0) {
	      $scope.tasks[4].completed = true;
	    } else {
	      $scope.tasks[4].completed = false;
	    }

	    // check text
	    if ($scope.office.profile.text) {
	      $scope.tasks[5].completed = true;
	    } else {
	      $scope.tasks[5].completed = false;
	    }

	    angular.forEach($scope.tasks, function (task) {
	      if (task.completed) {
	        $scope.completedTasksWeight += task.weight;
	      }
	    });
	  }

	  sumcompletedTasksWeight();

	  // if address is not set
	  if (!$scope.office.address) {
	    $scope.office.address = {
	      location: [],
	      city: {
	        name: ''
	      }
	    };
	  }

	  // set logo
	  if ($scope.office.profile.logo) {
	    $scope.logoPreview = 'files/logos/' + $scope.office.profile.logo;
	  }

	  $scope.generateMapLink = function () {
	    if ($scope.office.address && angular.isArray($scope.office.address.location) && $scope.office.address.location.length === 2) {
	      $scope.mapLink = '//maps.googleapis.com/maps/api/staticmap?center=' + $scope.office.address.location[1] + ',' + $scope.office.address.location[0] + '&zoom=15&size=785x300&maptype=roadmap&&markers=color:0x9BBF4D|' + $scope.office.address.location[1] + ',' + $scope.office.address.location[0] + '&sensor=false';
	    }
	  };

	  $scope.generateMapLink();

	  /**
	   * generate logo preview
	   * @param $files
	   */
	  $scope.onFileSelect = function ($files) {
	    $scope.$files = $files;
	    for (var i = 0; i < $scope.$files.length; i++) {
	      var file = $scope.$files[i];

	      if (window.FileReader && file.type.indexOf('image') > -1) {
	        var fileReader = new FileReader();
	        fileReader.readAsDataURL(file);
	        fileReader.onload = function (e) {
	          $timeout(function () {
	            $scope.logoPreview = e.target.result;
	          });
	        };
	      }
	    }
	  };

	  $scope.onCarouselFileSelect = function ($files) {
	    if (angular.isArray($files) && $files.length > 0) {
	      Upload.upload({
	        url: '/api/office/' + $scope.office._id + '/imageUpload',
	        data: {},
	        file: $files[0]
	      }).success(function (data) {
	        $scope.office.profile.images.push({
	          name: data.name + '?decache=' + new Date().getTime(),
	          title: ''
	        });
	        saveToDB();
	      }).error(function (error) {
	        if (error.message === 'file_to_large') {
	          Notification.addErrorMessage(gettextCatalog.getString('Image file is to large (max 1.0 MB)'));
	        } else if (error.message === 'extension_not_allowed') {
	          Notification.addErrorMessage(gettextCatalog.getString('Image file extension not of type [JPG,PNG]'));
	        } else {
	          Notification.addErrorMessage({ text: error.message });
	        }
	        saveToDB();
	      });
	    }
	  };

	  $scope.removeImage = function (image) {
	    Office.deleteImage({ embeddedDocument: image.name, officeId: $scope.office._id }, function () {
	      var index = $scope.office.profile.images.indexOf(image);
	      $scope.office.profile.images.splice(index, 1);
	      Notification.addSuccessMessage(gettextCatalog.getString('Image deleted'));
	    }, function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant delete image'));
	    });
	  };

	  /**
	   * save to rest webservice
	   */
	  $scope.save = function () {
	    $scope.showValidation = true;

	    // upload logo
	    if ($scope.$files) {
	      Upload.upload({
	        url: '/api/office/' + $scope.office._id + '/logoupload',
	        data: {},
	        file: $scope.$files
	      }).progress(function (evt) {
	        console.log('upload:' + parseInt(100.0 * evt.loaded / evt.total));
	      }).success(function (data, status, headers, config) {
	        $scope.office.profile.logo = data + '?decache=' + new Date().getTime(); //
	        saveToDB();
	      }).error(function (error) {
	        if (error.message == 'file_to_large') {
	          Notification.addErrorMessage(gettextCatalog.getString('Image file is to large (max 1.0 MB)'));
	        } else if (error.message == 'extension_not_allowed') {
	          Notification.addErrorMessage(gettextCatalog.getString('Image file extension not of type [JPG,PNG]'));
	        } else {
	          Notification.addErrorMessage({ text: error.message });
	        }

	        saveToDB();
	      });
	    } else {
	      saveToDB();
	    }
	  };

	  function saveToDB() {
	    var address = $scope.office.address.street + ', ' + $scope.office.address.postal + ' ' + $scope.office.address.city.name;

	    GeocodeService.getGeoData(address, function (error, response) {
	      if (error) {
	        Notification.addErrorMessage(gettextCatalog.getString('Cant find address. Please check again'));
	      } else {
	        // TODO: set lat lng in backend
	        if (response && response.geometry) {
	          if (response.geometry.location) {
	            $scope.office.address.location = [response.geometry.location.lng, response.geometry.location.lat];
	          }

	          if (angular.isArray(response.address_components)) {
	            // check for district
	            for (var i = 0; i < response.address_components.length; i++) {
	              if (response.address_components[i].types.indexOf('sublocality') > -1) {
	                $scope.office.address.city.district = response.address_components[i].long_name;
	                break;
	              }
	            }

	            // get country, walk array from end to start cause country is mostly in one of the last array elements
	            for (var i = response.address_components.length - 1; i >= 0; i--) {
	              if (response.address_components[i].types.indexOf('country') > -1) {
	                $scope.office.address.country = response.address_components[i].long_name;
	                $scope.office.address.countryCode = response.address_components[i].short_name || '';
	                break;
	              }
	            }

	            // get country code
	            $scope.generateMapLink();
	          }
	        }

	        if ($scope.ProfileForm.$valid) {
	          OfficeModel.update($scope.office, function (error, response) {
	            if (error) {
	              Notification.addErrorMessage({ text: error });
	            } else {
	              Notification.addSuccessMessage(gettextCatalog.getString('Profile saved'));
	              $scope.office = response;
	              sumcompletedTasksWeight();
	            }
	          });
	        }
	      }
	    });
	  }
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var resourcesModule = angular.module('t2g.resources', ['gettext', 'ui.router', __webpack_require__(106).name, __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = resourcesModule;

	resourcesModule.controller('ResourcesEmployeeDetailsCtrl', __webpack_require__(222));
	resourcesModule.controller('ResourcesListCtrl', __webpack_require__(223));
	resourcesModule.controller('ResourcesRoomDetailsCtrl', __webpack_require__(224));

	var officeResolve = function officeResolve(OfficeDA) {
	  return OfficeDA.get();
	};
	officeResolve.$inject = ["OfficeDA"];

	var resourceResolve = function resourceResolve(ResourceDA) {
	  return ResourceDA.list().then(function (response) {
	    return response.resources;
	  });
	};
	resourceResolve.$inject = ["ResourceDA"];

	var resourceDetailResolve = function resourceDetailResolve($q, $stateParams, ObjectModel) {
	  var deffered = $q.defer();

	  if (!$stateParams.resourceId) {
	    var resource = {
	      workingHours: [],
	      absent: [],
	      bookable: true
	    };

	    for (var i = 0; i < 5; i++) {
	      resource.workingHours.push({
	        day: i,
	        available: true,
	        times: [{ start: 540, end: 1020 }]
	      });
	    }

	    resource.workingHours.push({
	      day: 5,
	      available: false,
	      times: [{
	        start: 540,
	        end: 720
	      }]
	    });

	    resource.workingHours.push({
	      day: 6,
	      available: false,
	      times: [{
	        start: 540,
	        end: 720
	      }]
	    });

	    deffered.resolve(resource);
	  } else {
	    ObjectModel.getOne($stateParams.resourceId, function (error, response) {
	      if (error) {
	        deffered.reject(error);
	      } else {
	        if (angular.isArray(response.absent)) {
	          angular.forEach(response.absent, function (absence) {
	            absence.start = new Date(absence.start);
	            absence.end = new Date(absence.end);
	          });
	        }

	        deffered.resolve(response);
	      }
	    });
	  }

	  return deffered.promise;
	};
	resourceDetailResolve.$inject = ["$q", "$stateParams", "ObjectModel"];

	resourcesModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.resources', {
	    url: '/resources',
	    title: 'Employees',
	    templateUrl: '/app/modules/resources/ResourceListView.html?v=4.5.6',
	    controller: 'ResourcesListCtrl',
	    resolve: {
	      objectResolve: resourceResolve
	    }
	  }).state('private.main.resourcesDetails', {
	    url: '/resources/:type/:resourceId',
	    title: 'Employees',
	    templateUrl: function templateUrl($stateParams) {
	      var type;

	      if ($stateParams.type === 'room') {
	        type = 'Room';
	      } else {
	        type = 'Employee';
	      }

	      return '/app/modules/resources/Resource' + type + 'DetailsView.html';
	    },
	    controllerProvider: ["$stateParams", function controllerProvider($stateParams) {
	      var controllerName;

	      if ($stateParams.type === 'room') {
	        controllerName = 'ResourcesRoomDetailsCtrl';
	      } else {
	        controllerName = 'ResourcesEmployeeDetailsCtrl';
	      }

	      return controllerName;
	    }],
	    resolve: {
	      officeResolve: officeResolve,
	      resourceResolve: resourceDetailResolve
	    }
	  });
	}]);

/***/ }),
/* 222 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, $state, $timeout, gettextCatalog, Notification, Object, ObjectModel, officeResolve, resourceResolve, SyncDA, AppointmentDA, UserSession, ResourceDA) {
	  $scope.resource = resourceResolve;
	  $scope.office = officeResolve;
	  $scope.weekDays = [];

	  $scope.reasons = [{
	    key: 'other',
	    text: gettextCatalog.getString('other')
	  }, {
	    key: 'holiday',
	    text: gettextCatalog.getString('holiday')
	  }, {
	    key: 'ill',
	    text: gettextCatalog.getString('ill')
	  }, {
	    key: 'pd',
	    text: gettextCatalog.getString('pd')
	  }];

	  /**
	   * generate private calendar address
	   */
	  var generateCalendarAddress = function generateCalendarAddress() {
	    var base = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

	    if ($scope.resource._id && $scope.resource.ical) {
	      $scope.icalUrl = base + '/api/v2/calendar/ical/' + $scope.resource.ical + '/feed.ics';
	    }
	  };

	  var loadSyncs = function loadSyncs() {
	    if ($scope.resource._id) {
	      SyncDA.get($scope.resource._id).then(function (response) {
	        $scope.syncs = response.syncList;
	      });
	    }
	  };

	  /**
	   * generate resource image preview
	   * @param $files
	   */
	  $scope.onResourceImageSelect = function ($files) {
	    if (angular.isArray($files) && $files.length > 0) {
	      var file = $files[0];
	      $scope.$files = $files;

	      if (window.FileReader && file.type.indexOf('image') > -1) {
	        var fileReader = new FileReader();

	        fileReader.readAsDataURL(file);
	        fileReader.onload = function (event) {
	          $timeout(function () {
	            $scope.imagePreview = event.target.result;
	          });
	        };
	      }
	    }
	  };

	  if ($scope.resource.image) {
	    $scope.imagePreview = 'files/employees/' + $scope.resource.image;
	  } else {
	    switch ($scope.resource.salutation) {
	      case 'm':
	        $scope.imagePreview = '/img/employee_man.png';
	        break;
	      case 'f':
	        $scope.imagePreview = '/img/employee_woman.png';
	        break;
	      default:
	        $scope.imagePreview = '/img/employee_woman.png';
	        break;
	    }
	  }

	  /**
	   * concat firstname and lastname to "lastname, firstname"
	   */
	  $scope.concatName = function () {
	    var nameParts = [];

	    if ($scope.resource.lastname) {
	      nameParts.push($scope.resource.lastname);
	    }

	    if ($scope.resource.firstname) {
	      nameParts.push($scope.resource.firstname);
	    }

	    $scope.resource.name = nameParts.join(', ');
	  };

	  /**
	   * generate an array with n elements for ng-repeat loop
	   * @param n
	   * @returns {Array}
	   */
	  $scope.getNumber = function (n) {
	    return new Array(n);
	  };

	  /**
	   * add/remove a second column to working hour table
	   * @param day
	   */
	  $scope.adjustWorkingTime = function (day) {
	    if ($scope.resource.workingHours[day].times.length === 1) {
	      var firstEndTime = $scope.resource.workingHours[day].times[0].end;

	      $scope.resource.workingHours[day].times.push({
	        start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
	        end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240
	      });
	    } else {
	      $scope.resource.workingHours[day].times.splice(1, 1);
	    }
	  };

	  $scope.save = function () {
	    if (!$scope.resource._id) {
	      $scope.resource.type = 'employee';

	      var resource = new Object($scope.resource);

	      ObjectModel.save(resource, function (error, response) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant add resource (Error: {{error}})', { error: error }));
	        } else {
	          loadSyncs();
	          $scope.resource = response;
	          $state.go('private.main.resourcesDetails', {
	            type: $scope.resource.type,
	            resourceId: $scope.resource._id
	          });
	          Notification.addSuccessMessage(gettextCatalog.getString('{{name}} created', { name: $scope.resource.name }));
	        }
	      });
	    } else {
	      if ($scope.$files) {
	        ObjectModel.uploadImage($scope.$files, $scope.resource, function (error, updatedObject) {
	          if (error) {
	            if (error.message === 'file_to_large') {
	              Notification.addErrorMessage(gettextCatalog.getString('image to big'));
	            } else if (error.message === 'extension_not_allowed') {
	              Notification.addErrorMessage(gettextCatalog.getString('file extension not allowed'));
	            } else {
	              Notification.addErrorMessage(gettextCatalog.getString('Cant save resource (Error: {{error}})', { error: error }));
	            }
	          } else {
	            $scope.resource = updatedObject;
	            $scope.newImage = true;
	            Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: $scope.resource.name }));
	          }
	        });
	      } else {
	        ObjectModel.update($scope.resource, function (error) {
	          if (error) {
	            Notification.addErrorMessage(gettextCatalog.getString('Cant save resource (Error: {{error}})', { error: error }));
	          } else {
	            Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: $scope.resource.name }));
	          }
	        });
	      }
	    }
	  };

	  $scope.delete = function () {
	    ObjectModel.delete($scope.resource, function (error) {
	      if (error) {
	        Notification.addErrorMessage({
	          text: gettextCatalog.getString('Cant remove resource (Error: {{error}})', {
	            error: error.text
	          })
	        });
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('{{name}} removed', { name: $scope.resource.name }));
	        $state.go('private.main.resources');
	      }
	    });
	  };

	  /**
	   * copy opening hours to resource working hours
	   */
	  $scope.copyOpeningHours = function () {
	    for (var i = 0, ohLen = $scope.office.openingHours.regular.length; i < ohLen; i++) {
	      if ($scope.office.openingHours.regular[i].open) {
	        $scope.resource.workingHours[i].available = true;

	        $scope.resource.workingHours[i].times[0].start = $scope.office.openingHours.regular[i].times[0].start;
	        $scope.resource.workingHours[i].times[0].end = $scope.office.openingHours.regular[i].times[0].end;

	        if ($scope.office.openingHours.regular[i].times.length > 1) {
	          if (!$scope.resource.workingHours[i].times[1]) {
	            $scope.resource.workingHours[i].times[1] = {};
	          }

	          $scope.resource.workingHours[i].times[1].start = $scope.office.openingHours.regular[i].times[1].start;
	          $scope.resource.workingHours[i].times[1].end = $scope.office.openingHours.regular[i].times[1].end;
	        }
	      } else {
	        $scope.resource.workingHours[i].available = false;
	      }
	    }
	  };

	  /**
	   * add an absent day
	   */
	  $scope.addAbsentRow = function () {
	    $scope.resource.absent.push({
	      start: moment().startOf('day'),
	      end: moment().endOf('day'),
	      reason: 'OTHER'
	    });
	  };

	  /**
	   * remove an absent day
	   * @param absentDay
	   */
	  $scope.removeAbsentRow = function (absentDay) {
	    var index = $scope.resource.absent.indexOf(absentDay);

	    if (index > -1) {
	      $scope.resource.absent.splice(index, 1);
	    }
	  };

	  if ($scope.resource.ical) {
	    $scope.privateCalendarAddressEnabled = true;
	    generateCalendarAddress();
	  }

	  loadSyncs();

	  /**
	   * enable/disable private calendar address
	   */
	  $scope.changePrivateCalendarAddressEnabledState = function () {
	    if ($scope.privateCalendarAddressEnabled) {
	      $scope.resetPrivateAddress();
	    } else {
	      $scope.resource.ical = null;
	      $scope.icalUrl = '';
	    }
	  };

	  /**
	   * get new private calendar address from API
	   */
	  $scope.resetPrivateAddress = function () {
	    ResourceDA.refreshCalendarAddress($scope.resource._id).then(function (response) {
	      $scope.resource.ical = response.ical;
	      generateCalendarAddress();
	      Notification.addSuccessMessage(gettextCatalog.getString('calendar address resetted'));
	    }).catch(function () {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant reset private calendar address'));
	    });
	  };

	  /**
	   * add new external calendar
	   */
	  $scope.addCalendarUrl = function () {
	    var syncAlreadyExists = $scope.syncs.filter(function (sync) {
	      return sync.address === $scope.externalIcalAddress;
	    })[0];

	    if (syncAlreadyExists) {
	      return Notification.addErrorMessage(gettextCatalog.getString('You cant subscribe to same calendar twice'));
	    }

	    if ($scope.icalUrl === $scope.externalIcalAddress) {
	      return Notification.addErrorMessage(gettextCatalog.getString('You cant subscribe to your own calendar in this system'));
	    }

	    var calendarSync = {
	      type: 'ical',
	      address: $scope.externalIcalAddress,
	      copyDescription: $scope.copyDescription
	    };

	    SyncDA.insert($scope.resource._id, calendarSync).then(function (response) {
	      $scope.externalIcalAddress = '';
	      $scope.syncs.push(response.sync);
	      Notification.addSuccessMessage(gettextCatalog.getString('Successfully subscribed to calendar'));
	    },
	    // TODO: implement a helper function or a global error handler
	    function (response) {
	      var errorMsg = _.get(response, 'data.error[0].msg');
	      var error;

	      if (errorMsg) {
	        error = gettextCatalog.getString(errorMsg);
	      } else {
	        error = gettextCatalog.getString('Unknown');
	      }

	      Notification.addErrorMessage(gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  function _removeSync(sync) {
	    return SyncDA.delete($scope.resource._id, sync._id).then(function () {
	      var index = $scope.syncs.indexOf(sync);
	      $scope.syncs.splice(index, 1);
	      Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription removed'));
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant remove calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  }

	  $scope.updateSyncActive = function (sync) {
	    return SyncDA.update($scope.resource._id, sync._id, sync).then(function (updatedSync) {
	      var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
	      syncToUpdate.active = updatedSync.active;

	      if (!syncToUpdate.active) {
	        Notification.addInfoMessage(gettextCatalog.getString('You still can sync your calendar manually'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription disabled'));
	      } else {
	        Notification.addInfoMessage(gettextCatalog.getString('Calendar events will be synced with this calendar automatically'));
	        Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription enabled'));
	      }
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  $scope.updateSyncIsCopyDescription = function (sync) {
	    return SyncDA.update($scope.resource._id, sync._id, sync).then(function (updatedSync) {
	      var syncToUpdate = _.find($scope.syncs, ['_id', sync._id]);
	      syncToUpdate.copyDescription = updatedSync.copyDescription;

	      if (!syncToUpdate.copyDescription) {
	        Notification.addInfoMessage(gettextCatalog.getString('Copy Appointment Description disabled'));
	      } else {
	        Notification.addInfoMessage(gettextCatalog.getString('Copy Appointment Description enabled'));
	      }
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  $scope.removeSync = function (sync) {
	    if (!sync.lastSync) return _removeSync(sync);

	    if ($scope.isPending(sync)) return;

	    var cond = confirm(gettextCatalog.getString('Do you want to remove all related events too?'));

	    if (!cond && !sync.active) return;

	    if (!cond) {
	      var updatedSync = _.cloneDeep(sync);
	      updatedSync.active = false;

	      return $scope.updateSyncActive(updatedSync);
	    }

	    AppointmentDA.removeSyncedViaICal($scope.resource._id, sync._id).then(function (res) {
	      if (!res.success) return new Error('Cant remove associated appointments');

	      Notification.addSuccessMessage(gettextCatalog.getString('Related events removed'));

	      return _removeSync(sync);
	    });
	  };

	  $scope.isPending = function (sync) {
	    var date = sync && sync.lastSync;

	    if (!date || sync.error > 0) return false;

	    return new Date(date).valueOf() === -1;
	  };

	  var pendingTimeout;
	  function checkPending() {
	    var isNeedToRefresh = !$scope.syncs || $scope.syncs.some(function (item) {
	      return $scope.isPending(item);
	    });

	    if ($scope.resource._id && !isNeedToRefresh) return;

	    SyncDA.get($scope.resource._id).then(function (response) {
	      $scope.syncs = response.syncList;

	      pendingTimeout = $timeout(checkPending, 10000);
	    });
	  }

	  checkPending();

	  $scope.$on('$destroy', function () {
	    $timeout.cancel(pendingTimeout);
	  });

	  $scope.runSync = function (sync) {
	    if ($scope.isPending(sync)) return;

	    Notification.addSuccessMessage(gettextCatalog.getString('Please wait, calendar sync can take some time'));

	    sync.lastSync = new Date(-1);
	    sync.error = 0;

	    SyncDA.runSync($scope.resource._id, sync._id).then(function (updatedSync) {
	      sync.lastSync = updatedSync.lastSync;
	      var count = updatedSync.count;
	      var message;

	      if (count) {
	        message = count > 1 ? gettextCatalog.getString('Was added {{count}} appointments', { count: count }) : gettextCatalog.getString('Was added one appointment');

	        Notification.addSuccessMessage(message);
	      }

	      Notification.addSuccessMessage(gettextCatalog.getString('Calendar is synced'));
	    }, function (resource) {
	      checkPending();

	      var errorMsg = _.get(resource, 'data.error');

	      if (errorMsg) {
	        errorMsg = gettextCatalog.getString(errorMsg);
	      } else {
	        errorMsg = gettextCatalog.getString('Unknown');
	      }

	      Notification.addErrorMessage(gettextCatalog.getString('Cant update calendar subscription (Error: {{error}})', {
	        error: errorMsg
	      }));
	    });
	  };
	};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, objectResolve) {
	  $scope.resources = objectResolve;
	  // TODO: check number of licences
	  $scope.showPremiumNotification = $scope.subscription.onlyBasicFunctions;
	  $scope.roomsExists = $scope.resources.some(function (resource) {
	    return resource.type === 'room';
	  });
	};

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, $state, $timeout, gettextCatalog, Notification, Object, ObjectModel, officeResolve, resourceResolve, SyncDA, UserSession) {
	  $scope.resource = resourceResolve;
	  $scope.office = officeResolve;

	  /**
	   * generate private calendar address
	   */
	  var generateCalendarAddress = function generateCalendarAddress() {
	    var base = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

	    if ($scope.resource._id && $scope.resource.ical) {
	      $scope.icalUrl = base + '/api/calendar/ical/' + $scope.resource._id + '/' + $scope.resource.ical + '.ics';
	    }
	  };

	  var loadSyncs = function loadSyncs() {
	    if ($scope.resource._id) {
	      SyncDA.get($scope.resource._id).then(function (response) {
	        $scope.syncs = response.syncList;
	      });
	    }
	  };

	  $scope.save = function () {
	    if (!$scope.resource._id) {
	      $scope.resource.type = 'room';

	      var resource = new Object($scope.resource);

	      ObjectModel.save(resource, function (error, response) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant add resource (Error: {{error}})', { error: error }));
	        } else {
	          loadSyncs();
	          $scope.resource = response;
	          $state.go('private.main.resourcesDetails', {
	            type: $scope.resource.type,
	            resourceId: $scope.resource._id
	          });
	          Notification.addSuccessMessage(gettextCatalog.getString('{{name}} created', { name: $scope.resource.name }));
	        }
	      });
	    } else {
	      ObjectModel.update($scope.resource, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant save resource (Error: {{error}})', { error: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('{{name}} updated', { name: $scope.resource.name }));
	        }
	      });
	    }
	  };

	  $scope.delete = function () {
	    ObjectModel.delete($scope.resource, function (error) {
	      if (error) {
	        Notification.addErrorMessage(gettextCatalog.getString('Cant remove resource (Error: {{error}})', { error: error }));
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('{{name}} removed', { name: $scope.resource.name }));
	        $state.go('private.main.resources');
	      }
	    });
	  };

	  if ($scope.resource.ical) {
	    $scope.privateCalendarAddressEnabled = true;
	    generateCalendarAddress();
	  }

	  loadSyncs();

	  /**
	   * enable/disable private calendar address
	   */
	  $scope.changePrivateCalendarAddressEnabledState = function () {
	    if ($scope.privateCalendarAddressEnabled) {
	      $scope.resetPrivateAddress();
	    } else {
	      $scope.resource.ical = null;
	      $scope.icalUrl = '';
	    }
	  };

	  /**
	   * get new private calendar address from API
	   */
	  $scope.resetPrivateAddress = function () {
	    Object.generateCalendarAddress({
	      officeId: UserSession.getOffice(),
	      objectId: $scope.resource._id
	    }).$promise.then(function (response) {
	      $scope.resource.ical = response.ical;
	      generateCalendarAddress();
	      Notification.addSuccessMessage(gettextCatalog.getString('calendar address resetted'));
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant reset private calendar address'));
	    });
	  };

	  /**
	   * add new external calendar
	   */
	  $scope.addCalendarUrl = function () {
	    var calendarSync = {
	      type: 'ical',
	      address: $scope.externalIcalAddress,
	      copyDescription: $scope.copyDescription
	    };

	    SyncDA.insert($scope.resource._id, calendarSync).then(function (response) {
	      $scope.externalIcalAddress = '';
	      $scope.syncs.push(response.sync);
	      Notification.addSuccessMessage(gettextCatalog.getString('successfully subscribed to calendar'));
	    },
	    // TODO: implement a helper function or a global error handler
	    function (response) {
	      var errorMsg = _.get(response, 'data.error[0].msg');
	      var error;

	      if (errorMsg) {
	        error = gettextCatalog.getString(errorMsg);
	      } else {
	        error = gettextCatalog.getString('Unknown');
	      }

	      Notification.addErrorMessage(gettextCatalog.getString('Cant subscribe to calendar (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };

	  $scope.removeSync = function (sync) {
	    SyncDA.delete($scope.resource._id, sync._id).then(function () {
	      var index = $scope.syncs.indexOf(sync);
	      $scope.syncs.splice(index, 1);
	      Notification.addSuccessMessage(gettextCatalog.getString('Calendar subscription removed'));
	    }, function (error) {
	      Notification.addErrorMessage(gettextCatalog.getString('Cant remove calendar subscription (Error: {{error}})', {
	        error: error
	      }));
	    });
	  };
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var serviceModule = angular.module('t2g.service', ['gettext', 'ui.router', __webpack_require__(160).name, __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = serviceModule;

	serviceModule.controller('ServiceGroupModalCtrl', __webpack_require__(226));
	serviceModule.controller('ServiceListCtrl', __webpack_require__(227));
	serviceModule.controller('ServiceModalCtrl', __webpack_require__(228));
	serviceModule.controller('ServiceModalCtrlNew', __webpack_require__(229));
	serviceModule.controller('ServiceResourceMatchController', __webpack_require__(230));

	serviceModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.services', {
	    url: '/services',
	    title: 'Services',
	    templateUrl: '/app/modules/service/list/ServiceListView.html?v=4.5.6',
	    controller: 'ServiceListCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  }).state('private.main.serviceResourceMatch', {
	    url: '/serviceResourceMatch',
	    title: 'Services',
	    templateUrl: '/app/modules/service/serviceResourceMatch/ServiceResourceMatchView.html?v=4.5.6',
	    controller: 'ServiceResourceMatchController as ServiceResourceMatchController',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      resourceResolve: ["$q", "ObjectModel", function resourceResolve($q, ObjectModel) {
	        var deffered = $q.defer();

	        ObjectModel.get(function (error, response) {
	          if (error) {
	            deffered.reject(error);
	          } else {
	            deffered.resolve(response);
	          }
	        });

	        return deffered.promise;
	      }]
	    }
	  });
	}]);

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, gettextCatalog, Notification, OfficeModel, ServiceGroupModal) {
	  $scope.groups = [];

	  OfficeModel.get(function (error, response) {
	    if (error) {
	      //deffered.reject(error);
	    } else {
	      $scope.office = response;
	      $scope.groups = $scope.office.serviceGroups || [];
	    }
	  });

	  /**
	   * add a new group to list
	   */
	  $scope.addGroupRow = function () {
	    $scope.groups.push({
	      intern: false,
	      name: '',
	      services: []
	    });
	  };

	  $scope.moveUp = function (arr, index) {
	    if (index > 0) {
	      arr.move(index, index - 1);
	    }
	  };

	  $scope.moveDown = function (arr, index) {
	    if (index < arr.length - 1) {
	      arr.move(index, index + 1);
	    }
	  };

	  /**
	   * remove a group from list
	   * @param group
	   */
	  $scope.removeGroupRow = function (group) {
	    var index = $scope.groups.indexOf(group);

	    if (index > -1) {
	      if (index === 0) {
	        Notification.addErrorMessage(gettextCatalog.getString('There should be at least one service group'));
	      } else {
	        for (var i = 0; i < $scope.groups[index].services.length; i++) {
	          $scope.groups[0].services.push($scope.groups[index].services[i]);
	        }

	        $scope.groups.splice(index, 1);

	        OfficeModel.update($scope.office, function (error) {
	          if (error) {
	            Notification.addErrorMessage({ text: error });
	          } else {
	            Notification.addSuccessMessage(gettextCatalog.getString('service group "{{name}}" deleted', { name: group.name }));
	          }
	        });
	      }
	    }
	  };

	  /**
	   * save to rest webservice
	   */
	  $scope.save = function () {
	    OfficeModel.update($scope.office, function (error) {
	      if (error) {
	        Notification.addErrorMessage({ text: error });
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('service groups saved'));
	        ServiceGroupModal.close();
	      }
	    });
	  };

	  /**
	   * close the modal view
	   */
	  $scope.abort = function () {
	    ServiceGroupModal.close();
	  };
	};

/***/ }),
/* 227 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($rootScope, $scope, $state, gettextCatalog, Notification, OfficeModel, officeResolve, ServiceGroupModal, ModalService, ServiceModal) {
	  $scope.groupfilter = '';
	  $scope.office = officeResolve;
	  $scope.showPremiumNotification = false;

	  function checkPremium(serviceGroups) {
	    $scope.serviceLen = 0;

	    _.forEach(serviceGroups, function (serviceGroup) {
	      $scope.serviceLen += serviceGroup.services.length;
	    });

	    $scope.showPremiumNotification = $scope.subscription.onlyBasicFunctions && $scope.serviceLen >= 3;
	  }

	  $scope.$watch('office.serviceGroups', function (newValue) {
	    checkPremium(newValue);
	  });

	  $scope.getServiceCount = function () {
	    var count = 0;

	    _.forEach($scope.office.serviceGroups, function (group) {
	      count += group.services.length;
	    });

	    return count;
	  };

	  /**
	   * set active class for group pill navigation (not shown at the moment)
	   * @param group
	   * @returns {string}
	   */
	  $scope.getActiveState = function (group) {
	    return group === $scope.groupfilter ? 'active' : '';
	  };

	  /**
	   * filter the services by clicking on the groups and set the filter for the ng-repeat (not shown at the moment)
	   * @param filter
	   */
	  $scope.setFilter = function (filter) {
	    $scope.groupfilter = filter;
	  };

	  /**
	   *@param service
	   */
	  $scope.openServiceModal = function (service) {
	    ModalService.openServiceModal(service);
	    // ServiceModal.open(service);
	  };

	  /**
	   * navigato to /servicesEmployeeMatch
	   */
	  $scope.navigateToServiceEmployeeMatch = function () {
	    $state.go('private.main.serviceResourceMatch');
	  };

	  /**
	   * open the service group modal
	   */
	  $scope.openServiceGroupModal = function () {
	    ServiceGroupModal.open();
	  };

	  /**
	   * save to database
	   */
	  $scope.save = function () {
	    OfficeModel.update($scope.office, function (error) {
	      if (error) {
	        Notification.addErrorMessage({ text: error });
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('service edited'));
	      }
	    });
	  };

	  $scope.moveUp = function (arr, index) {
	    if (index > 0) {
	      arr.move(index, index - 1);
	      $scope.save();
	    }
	  };

	  $scope.moveDown = function (arr, index) {
	    if (index < arr.length - 1) {
	      arr.move(index, index + 1);
	      $scope.save();
	    }
	  };

	  var updateOffice = $rootScope.$on('Office:update', function (event, response) {
	    $scope.office = response;
	  });

	  /**
	   * remove event listener if day has changed (CalendarCtrl destroyed)
	   */
	  $scope.$on('$destroy', function () {
	    updateOffice();
	  });

	  $scope.shouldHideDuration = function (service) {
	    var posNum = _.get(service, 'accounting.posNum');
	    return posNum && parseInt(posNum) >= 1250;
	  };
	};

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, ServiceModal, OfficeModel, ObjectModel, Notification, gettextCatalog, DatepickerSettings, Tarif590DA, SubscriptionDA) {
	  $scope.backupGroups = {};
	  $scope.office = null;
	  $scope.groups = [];
	  $scope.pickedGroup = '';
	  $scope.objects = [];
	  $scope.needPremium = false;
	  $scope.isSecondTimeWeekly = false;
	  $scope.colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B', '#999999', '#000000'];
	  $scope.unitFactors = [];
	  $scope.tariffServices;
	  $scope.currentTariffService;
	  var serviceMoved = false;
	  var initWatchFired = false;

	  $scope.filter = {
	    start: moment().subtract(6, 'month').toDate(),
	    end: new Date()
	  };
	  $scope.dtpOptionsDateRangeStart = angular.copy(DatepickerSettings.default);
	  $scope.dtpOptionsDateRangeEnd = angular.copy(DatepickerSettings.default);

	  SubscriptionDA.get().then(function (response) {
	    $scope.showPremiumNotification = response.onlyBasicFunctions;
	  });

	  this.setCurrentItem = function (service) {
	    OfficeModel.get(function (error, response) {
	      if (error) {
	        console.error(error);
	      } else {
	        $scope.office = response;
	        var count = 0;

	        Tarif590DA.list().then(function (tariffServices) {
	          $scope.tariffServices = tariffServices;
	        });

	        if ($scope.office.tariff590Allowed) {
	          for (var i = 1; i <= 24; i++) {
	            $scope.unitFactors.push({
	              label: i.toString(),
	              value: i
	            });
	          }
	        }

	        if ($scope.office.serviceGroups instanceof Array) {
	          for (var i = 0, groups = $scope.office.serviceGroups.length; i < groups; i++) {
	            $scope.groups.push($scope.office.serviceGroups[i].name);

	            count += $scope.office.serviceGroups[i].services.length;
	          }
	        }

	        // new service
	        if (!service) {
	          service = {
	            price: '',
	            duration: 30,
	            preparation: 0,
	            followup: 0,
	            color: 'default',
	            resources: {
	              employee: [],
	              room: [],
	              other: []
	            }
	          };

	          // get objects for service:employee matching
	          ObjectModel.get(function (error, response) {
	            if (!error) {
	              $scope.objects = response;
	              for (var i = 0, resLen = $scope.objects.length; i < resLen; i++) {
	                var resource = $scope.objects[i];

	                service.resources[resource.type].push(resource._id);
	              }
	            }
	          });

	          $scope.office.serviceGroups[0].services.push(service);
	          $scope.pickedGroup = $scope.office.serviceGroups[0].name;
	        } else {
	          var index = -1;
	          // find old group and delete service
	          for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	            index = $scope.office.serviceGroups[i].services.indexOf(service);

	            if (index > -1) {
	              $scope.pickedGroup = $scope.office.serviceGroups[i].name;

	              break;
	            }
	          }
	        }

	        service.timeOffer = service.timeOffer || { mode: 'disabled' };

	        if (service.timeOffer.start) {
	          service.timeOffer.start = new Date(service.timeOffer.start);
	        }

	        if (service.timeOffer.end) {
	          service.timeOffer.end = new Date(service.timeOffer.end);
	        }

	        service.color = service.color || 'default';
	        service.preparation = service.preparation || 0;
	        service.followup = service.followup || 0;
	        $scope.currentService = service;
	        $scope.backupGroups = angular.copy($scope.office.serviceGroups);
	      }
	    });
	  };

	  /**
	   * reset the data made in appointment form if push abort button
	   */
	  $scope.abort = function () {
	    for (var prob in $scope.backupGroups) {
	      if ($scope.office.serviceGroups.hasOwnProperty(prob)) {
	        $scope.office.serviceGroups[prob] = $scope.backupGroups[prob];
	      }
	    }

	    ServiceModal.close();
	  };

	  /**
	   * move service to selected group
	   */
	  $scope.$watch('pickedGroup', function (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      serviceMoved = true;
	      moveService();
	    }
	  });

	  /**
	   * save current appointment to database
	   */
	  $scope.save = function () {
	    $scope.showValidation = true;

	    if ($scope.currentService.price === '') {
	      delete $scope.currentService.price;
	    }

	    if ($scope.currentService.color === 'default') {
	      delete $scope.currentService.color;
	    }

	    if (shorthandExists()) {
	      Notification.addErrorMessage(gettextCatalog.getString('shorthand already used'));
	    } else if ($scope.serviceForm.$valid) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	        } else {
	          $scope.showValidation = false;
	          Notification.addSuccessMessage(gettextCatalog.getString('Service "{{name}}" saved', {
	            name: $scope.currentService.name
	          }));
	          ServiceModal.close();
	        }
	      });
	    }
	  };

	  /**
	   * delete current appointment
	   */
	  $scope.delete = function () {
	    var index = -1;
	    // find old group and delete service
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      index = $scope.office.serviceGroups[i].services.indexOf($scope.currentService);

	      for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
	        if (angular.equals($scope.office.serviceGroups[i].services[j], $scope.currentService)) {
	          index = j;
	          break;
	        }
	      }

	      if (index > -1) {
	        $scope.office.serviceGroups[i].services.splice(index, 1);
	        break;
	      }
	    }

	    if (index > -1) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('Service "{{name}}" deleted', {
	            name: $scope.currentService.name
	          }));
	          ServiceModal.close();
	        }
	      });
	    } else {
	      Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	    }
	  };

	  $scope.getNumber = function (num) {
	    return new Array(num);
	  };

	  $scope.addWeeklyTime = function (index) {
	    var firstEndTime = $scope.currentService.timeOffer.weekPlan[index].times[0].end;

	    $scope.currentService.timeOffer.weekPlan[index].times.push({
	      start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
	      end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240
	    });

	    $scope.isSecondTimeWeekly = true;
	  };

	  $scope.removeWeeklyTime = function (index) {
	    $scope.currentService.timeOffer.weekPlan[index].times.splice(1, 1);
	    $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
	  };

	  $scope.currentTariffChanged = function () {
	    console.log($scope.currentTariffService);
	  };

	  /**
	   * move the service to chosen service group
	   */
	  function moveService() {
	    var index = -1;
	    // find old group and delete service
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      index = $scope.office.serviceGroups[i].services.indexOf($scope.currentService);

	      if (index > -1) {
	        $scope.office.serviceGroups[i].services.splice(index, 1);
	        break;
	      }
	    }

	    // move to new group
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      if ($scope.office.serviceGroups[i].name === $scope.pickedGroup) {
	        $scope.office.serviceGroups[i].services.push($scope.currentService);
	      }
	    }
	  }

	  /**
	   * check if a shorthand already is taken
	   * @returns {boolean}
	   */
	  function shorthandExists() {
	    var count = 0;
	    if ($scope.currentService.shorthand) {
	      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	        for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
	          if ($scope.office.serviceGroups[i].services[j].shorthand === $scope.currentService.shorthand) {
	            count++;
	          }
	        }
	      }
	    }

	    if (count < 2) {
	      return false;
	    } else {
	      return true;
	    }
	  }

	  function setMinMaxDate() {
	    $scope.dtpOptionsDateRangeStart.maxDate = $scope.currentService.timeOffer.end || moment().add(1, 'month').toDate();
	    $scope.dtpOptionsDateRangeEnd.minDate = $scope.currentService.timeOffer.start || new Date();
	  }

	  function checkSecondTimeWeekly() {
	    var secondTimeIndex = _.findIndex(_.get($scope, 'currentService.timeOffer.weekPlan', []), function (day) {
	      return day.times.length > 1;
	    });

	    return secondTimeIndex > -1 ? true : false;
	  }

	  $scope.$watch('currentService.timeOffer', function (newValue) {
	    switch (newValue.mode) {
	      case 'disabled':
	        delete $scope.currentService.timeOffer.weekPlan;
	        delete $scope.currentService.timeOffer.start;
	        delete $scope.currentService.timeOffer.end;
	        break;
	      case 'dateRange':
	        if (!$scope.currentService.timeOffer.start || !moment($scope.currentService.timeOffer.start).isValid()) {
	          $scope.currentService.timeOffer.start = moment().startOf('day').toDate();
	        }

	        if (!$scope.currentService.timeOffer.end || !moment($scope.currentService.timeOffer.end).isValid()) {
	          $scope.currentService.timeOffer.end = moment().add(1, 'month').endOf('day').toDate();
	        }

	        delete $scope.currentService.timeOffer.weekPlan;
	        break;
	      case 'time':
	        if (!_.isArray($scope.currentService.timeOffer.weekPlan)) {
	          $scope.currentService.timeOffer.weekPlan = [];

	          for (var i = 0; i < 7; i++) {
	            $scope.currentService.timeOffer.weekPlan.push({
	              available: false,
	              times: []
	            });
	          }

	          _.forEach($scope.office.openingHours.regular, function (openingHour, index) {
	            var day = $scope.currentService.timeOffer.weekPlan[index];
	            day.available = openingHour.open;
	            day.times = openingHour.times;
	          });
	        }

	        delete $scope.currentService.timeOffer.start;
	        delete $scope.currentService.timeOffer.end;
	        break;
	    }

	    if (newValue.mode === 'time') {
	      $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
	    }

	    setMinMaxDate();
	    initWatchFired = true;
	  }, true);
	};

/***/ }),
/* 229 */
/***/ (function(module, exports) {

	'use strict';

	var ServiceModalCtrlNew = function ServiceModalCtrlNew($scope, service, subscription, office, objects, tariffServices, Notification, gettextCatalog, OfficeModel, DatepickerSettings, modalInstance) {
	  $scope.currentService = service;
	  $scope.backupGroups = {};
	  $scope.office = null;
	  $scope.groups = [];
	  $scope.pickedGroup = '';
	  $scope.objects = [];
	  $scope.needPremium = false;
	  $scope.isPricePerUnit = false;
	  $scope.isSecondTimeWeekly = false;
	  $scope.colors = ['#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B', '#999999', '#000000'];
	  $scope.unitFactors = [];
	  $scope.tariffServices = tariffServices;
	  $scope.office = office;
	  $scope.objects = objects;
	  $scope.currentTariffService = null;
	  var serviceMoved = false;
	  var initWatchFired = false;
	  var DEFAULT_TAX = 0;

	  $scope.filter = {
	    start: moment().subtract(6, 'month').toDate(),
	    end: new Date()
	  };
	  $scope.dtpOptionsDateRangeStart = angular.copy(DatepickerSettings.default);
	  $scope.dtpOptionsDateRangeEnd = angular.copy(DatepickerSettings.default);
	  $scope.showPremiumNotification = subscription.onlyBasicFunctions;
	  $scope.taxes = [{
	    label: '0.0 %',
	    value: 0
	  }, {
	    label: '2.5 %',
	    value: 2.5
	  }, {
	    label: '7.7 %',
	    value: 7.7
	  }, {
	    label: '8.1 %',
	    value: 8.1
	  }];

	  function init() {
	    var count = 0;

	    if ($scope.office.tariff590Allowed) {
	      for (var i = 1; i <= 24; i++) {
	        $scope.unitFactors.push({
	          label: i.toString(),
	          value: i
	        });
	      }
	    }

	    if ($scope.office.serviceGroups instanceof Array) {
	      for (var i = 0, groups = $scope.office.serviceGroups.length; i < groups; i++) {
	        $scope.groups.push($scope.office.serviceGroups[i].name);

	        count += $scope.office.serviceGroups[i].services.length;
	      }
	    }

	    // new service
	    if (!service) {
	      service = {
	        price: '',
	        duration: 30,
	        preparation: 0,
	        followup: 0,
	        color: 'default',
	        resources: {
	          employee: [],
	          room: [],
	          other: []
	        }
	      };

	      // get objects for service:employee matching
	      for (var i = 0, resLen = $scope.objects.length; i < resLen; i++) {
	        var resource = $scope.objects[i];

	        service.resources[resource.type].push(resource._id);
	      }

	      $scope.office.serviceGroups[0].services.push(service);
	      $scope.pickedGroup = $scope.office.serviceGroups[0].name;
	    } else {
	      var index = -1;
	      // find old group and delete service
	      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	        index = _.findIndex($scope.office.serviceGroups[i].services, { _id: service._id });

	        if (index > -1) {
	          $scope.pickedGroup = $scope.office.serviceGroups[i].name;

	          break;
	        }
	      }
	    }

	    service.timeOffer = service.timeOffer || { mode: 'disabled' };

	    if (service.timeOffer.start) {
	      service.timeOffer.start = new Date(service.timeOffer.start);
	    }

	    if (service.timeOffer.end) {
	      service.timeOffer.end = new Date(service.timeOffer.end);
	    }

	    service.accounting = service.accounting || {};

	    if (!service.accounting.tax && service.accounting.tax !== 0) {
	      service.accounting.tax = DEFAULT_TAX;
	    }

	    if ($scope.office.tariff590Allowed) {
	      if (service.accounting.posNum) {
	        $scope.currentTariffService = _.find($scope.tariffServices, {
	          posNum: service.accounting.posNum
	        });

	        if ($scope.currentTariffService && $scope.currentTariffService.description !== 'pro 5 Minuten') {
	          $scope.isPricePerUnit = true;
	        }
	      }
	    }

	    service.color = service.color || 'default';
	    service.preparation = service.preparation || 0;
	    service.followup = service.followup || 0;
	    $scope.currentService = service;
	    $scope.backupGroups = angular.copy($scope.office.serviceGroups);
	  }

	  /**
	   * reset the data made in appointment form if push abort button
	   */
	  $scope.abort = function () {
	    for (var prob in $scope.backupGroups) {
	      if ($scope.office.serviceGroups.hasOwnProperty(prob)) {
	        $scope.office.serviceGroups[prob] = $scope.backupGroups[prob];
	      }
	    }

	    $scope.close();
	  };

	  /**
	   * move service to selected group
	   */
	  $scope.$watch('pickedGroup', function (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      serviceMoved = true;
	      moveService();
	    }
	  });

	  /**
	   * save current appointment to database
	   */
	  $scope.save = function () {
	    var groupIndex = -1;
	    var serviceIndex = -1;
	    $scope.showValidation = true;

	    if ($scope.currentService.price === '') {
	      delete $scope.currentService.price;
	    }

	    if ($scope.currentService.color === 'default') {
	      delete $scope.currentService.color;
	    }

	    if (shorthandExists()) {
	      Notification.addErrorMessage(gettextCatalog.getString('shorthand already used'));
	    } else if ($scope.serviceForm.$valid) {
	      // replace existing service
	      if ($scope.currentService._id) {
	        for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	          groupIndex = i;
	          serviceIndex = _.findIndex($scope.office.serviceGroups[i].services, {
	            _id: $scope.currentService._id
	          });

	          if (serviceIndex > -1) {
	            break;
	          }
	        }

	        $scope.office.serviceGroups[groupIndex].services[serviceIndex] = $scope.currentService;
	      }

	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	        } else {
	          $scope.showValidation = false;
	          Notification.addSuccessMessage(gettextCatalog.getString('Service "{{name}}" saved', {
	            name: $scope.currentService.name
	          }));
	          $scope.close();
	        }
	      });
	    }
	  };

	  /**
	   * delete current appointment
	   */
	  $scope.delete = function () {
	    var index = -1;
	    // find old group and delete service
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      index = _.findIndex($scope.office.serviceGroups[i].services, {
	        _id: $scope.currentService._id
	      });

	      for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
	        if ($scope.office.serviceGroups[i].services[j]._id === $scope.currentService._id) {
	          index = j;
	          break;
	        }
	      }

	      if (index > -1) {
	        $scope.office.serviceGroups[i].services.splice(index, 1);
	        break;
	      }
	    }

	    if (index > -1) {
	      OfficeModel.update($scope.office, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('Service "{{name}}" deleted', {
	            name: $scope.currentService.name
	          }));
	          $scope.close();
	        }
	      });
	    } else {
	      Notification.addErrorMessage(gettextCatalog.getString({ text: error }));
	    }
	  };

	  $scope.getNumber = function (num) {
	    return new Array(num);
	  };

	  $scope.addWeeklyTime = function (index) {
	    var firstEndTime = $scope.currentService.timeOffer.weekPlan[index].times[0].end;

	    $scope.currentService.timeOffer.weekPlan[index].times.push({
	      start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
	      end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240
	    });

	    $scope.isSecondTimeWeekly = true;
	  };

	  $scope.removeWeeklyTime = function (index) {
	    $scope.currentService.timeOffer.weekPlan[index].times.splice(1, 1);
	    $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
	  };

	  $scope.currentTariffChanged = function (item) {
	    var factor = 1;
	    $scope.currentService.accounting = $scope.currentService.accounting || {};
	    $scope.currentService.accounting.posNum = item.posNum;
	    $scope.currentService.accounting.posText = item.posText;
	    $scope.currentService.accounting.description = item.description;

	    if ($scope.currentService.accounting.description === 'pro 5 Minuten' || $scope.currentService.accounting.posText.indexOf('pro 5 Minuten') > -1) {
	      $scope.currentService.accounting.tariffDuration = 5;
	      $scope.isPricePerUnit = false;
	      factor = $scope.currentService.duration / $scope.currentService.accounting.tariffDuration;
	      $scope.pricePerUnit = $scope.currentService.price / factor;
	    } else {
	      $scope.currentService.accounting.tariffDuration = $scope.currentService.duration;
	      $scope.isPricePerUnit = true;

	      $scope.pricePerUnit = $scope.currentService.price;
	    }
	  };

	  /**
	   * move the service to chosen service group
	   */
	  function moveService() {
	    var index = -1;
	    // find old group and delete service
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      index = _.findIndex($scope.office.serviceGroups[i].services, {
	        _id: $scope.currentService._id
	      });

	      if (index > -1) {
	        $scope.office.serviceGroups[i].services.splice(index, 1);
	        break;
	      }
	    }

	    // move to new group
	    for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	      if ($scope.office.serviceGroups[i].name === $scope.pickedGroup) {
	        $scope.office.serviceGroups[i].services.push($scope.currentService);
	      }
	    }
	  }

	  /**
	   * check if a shorthand already is taken
	   * @returns {boolean}
	   */
	  function shorthandExists() {
	    var count = 0;
	    if ($scope.currentService.shorthand) {
	      for (var i = 0; i < $scope.office.serviceGroups.length; i++) {
	        for (var j = 0; j < $scope.office.serviceGroups[i].services.length; j++) {
	          if ($scope.office.serviceGroups[i].services[j].shorthand === $scope.currentService.shorthand) {
	            count++;
	          }
	        }
	      }
	    }

	    if (count < 2) {
	      return false;
	    } else {
	      return true;
	    }
	  }

	  function setMinMaxDate() {
	    $scope.dtpOptionsDateRangeStart.maxDate = $scope.currentService.timeOffer.end || moment().add(1, 'month').toDate();
	    $scope.dtpOptionsDateRangeEnd.minDate = $scope.currentService.timeOffer.start || new Date();
	  }

	  function checkSecondTimeWeekly() {
	    var secondTimeIndex = _.findIndex(_.get($scope, 'currentService.timeOffer.weekPlan', []), function (day) {
	      return day.times.length > 1;
	    });

	    return secondTimeIndex > -1 ? true : false;
	  }

	  $scope.$watch('currentService.price', function (newValue) {
	    var price = _.toNumber(newValue);
	    var duration = _.toNumber($scope.currentService.duration);
	    var factor = 1;

	    if (duration) {
	      factor = duration / 5;
	    }

	    if (price) {
	      $scope.pricePerUnit = price / factor;
	    }

	    if ($scope.isPricePerUnit) {
	      $scope.pricePerUnit = newValue;
	    } else {
	      $scope.pricePerUnit = parseFloat($scope.pricePerUnit) || 0;
	      $scope.pricePerUnit = $scope.pricePerUnit.toFixed(2);
	    }
	  });

	  $scope.$watch('currentService.timeOffer', function (newValue) {
	    switch (newValue.mode) {
	      case 'disabled':
	        delete $scope.currentService.timeOffer.weekPlan;
	        delete $scope.currentService.timeOffer.start;
	        delete $scope.currentService.timeOffer.end;
	        break;
	      case 'dateRange':
	        if (!$scope.currentService.timeOffer.start || !moment($scope.currentService.timeOffer.start).isValid()) {
	          $scope.currentService.timeOffer.start = moment().startOf('day').toDate();
	        }

	        if (!$scope.currentService.timeOffer.end || !moment($scope.currentService.timeOffer.end).isValid()) {
	          $scope.currentService.timeOffer.end = moment().add(1, 'month').endOf('day').toDate();
	        }

	        delete $scope.currentService.timeOffer.weekPlan;
	        break;
	      case 'time':
	        if (!_.isArray($scope.currentService.timeOffer.weekPlan)) {
	          $scope.currentService.timeOffer.weekPlan = [];

	          for (var i = 0; i < 7; i++) {
	            $scope.currentService.timeOffer.weekPlan.push({
	              available: false,
	              times: []
	            });
	          }

	          _.forEach($scope.office.openingHours.regular, function (openingHour, index) {
	            var day = $scope.currentService.timeOffer.weekPlan[index];
	            day.available = openingHour.open;
	            day.times = openingHour.times;
	          });
	        }

	        delete $scope.currentService.timeOffer.start;
	        delete $scope.currentService.timeOffer.end;
	        break;
	    }

	    if (newValue.mode === 'time') {
	      $scope.isSecondTimeWeekly = checkSecondTimeWeekly();
	    }

	    setMinMaxDate();
	    initWatchFired = true;
	  }, true);

	  $scope.close = function () {
	    modalInstance.close();
	  };

	  init();
	};

	module.exports = ServiceModalCtrlNew;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

	'use strict';

	var ServiceResourceMatchController = function ServiceResourceMatchController($scope, $state, gettextCatalog, Notification, OfficeModel, officeResolve, resourceResolve) {
	  this.scope_ = $scope;
	  this.scope_.model = {
	    office: officeResolve,
	    resources: resourceResolve
	  };
	  this.state_ = $state;
	  this.Notification_ = Notification;
	  this.OfficeModel_ = OfficeModel;
	  this.gettextCatalog = gettextCatalog;
	};

	/**
	 * add and remove resource to service
	 * @param resourceType
	 * @param service
	 * @param resource
	 */
	ServiceResourceMatchController.prototype.changeResource = function (resourceType, service, resource) {
	  service.resources = service.resources || {};
	  service.resources[resourceType] = service.resources[resourceType] || [];

	  var resourceIndex = service.resources[resourceType].indexOf(resource._id);

	  if (resourceIndex > -1) {
	    service.resources[resourceType].splice(resourceIndex, 1);
	  } else {
	    service.resources[resourceType].push(resource._id);
	  }
	};

	/**
	 * save resource service match
	 */
	ServiceResourceMatchController.prototype.save = function () {
	  var self = this;

	  self.OfficeModel_.update(self.scope_.model.office, function (error) {
	    if (error) {
	      self.Notification_.addErrorMessage(self.gettextCatalog.getString('Cant save (Error: {{text}})', { text: error }));
	    } else {
	      self.Notification_.addSuccessMessage(self.gettextCatalog.getString('Service resource match saved'));
	    }
	  });
	};

	/**
	 * check if a resource is added to service
	 * @param resourceType
	 * @param resource
	 */
	ServiceResourceMatchController.prototype.isChecked = function (resourceType, service, resource) {
	  return service.resources[resourceType].indexOf(resource._id) > -1;
	};

	/**
	 * go back ot service list view
	 */
	ServiceResourceMatchController.prototype.backToReferrer = function () {
	  this.state_.go('private.main.services');
	};

	module.exports = ServiceResourceMatchController;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var settingsModule = angular.module('t2g.settings', ['gettext', 'ui.router', __webpack_require__(156).name, __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = settingsModule;

	settingsModule.controller('SettingsCtrl', __webpack_require__(232));

	settingsModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.settings', {
	    url: '/settings',
	    title: 'Settings',
	    templateUrl: '/app/modules/settings/SettingsView.html?v=4.5.6',
	    controller: 'SettingsCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      employees: ["ResourceDA", function employees(ResourceDA) {
	        return ResourceDA.list('employee').then(function (resources) {
	          return _.filter(resources.resources, { type: 'employee' });
	        });
	      }]
	    }
	  });
	}]);

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function ($q, $scope, $timeout, $location, officeResolve, OfficeModel, Office, Notification, IndustrySpecific, gettextCatalog, settings, employees, MailDA, Upload) {
	  var isBillingVisible = __webpack_require__(191);

	  $scope.settingsForm = _.cloneDeep(settings.settingsForm);
	  $scope.office = officeResolve;

	  if (!isBillingVisible($location)) {
	    delete $scope.settingsForm.billingAddress;
	    delete $scope.settingsForm.accounting;
	  }

	  var officeCopy = void 0;

	  function initBillingAddress() {
	    var office = $scope.office;

	    officeCopy = _.cloneDeep(office);

	    // if user not yet set billing address we can populate it values from public profile values
	    if (!office.billingAddress) {
	      var firstname = void 0;
	      var lastname = void 0;

	      if ($scope.employees && $scope.employees.length != 0) {
	        var employee = $scope.employees[0];

	        if (employee) {
	          firstname = employee.firstname;
	          lastname = employee.lastname;
	        }
	      }

	      $scope.office.billingAddress = {
	        companyName: office.company,
	        firstname: firstname,
	        lastname: lastname,
	        city: office.address.city ? office.address.city.name : undefined,
	        street: office.address.street,
	        postal: office.address.postal,
	        country: office.address.country
	      };
	    }
	  }

	  $scope.validateBillingAddress = false;

	  $scope.logoPreview = _.get($scope, 'office.profile.logo.url') || undefined;
	  var removeLogoPreviewKey = null;

	  $scope.currencies = ['EUR', 'CHF', 'EGP'];

	  $scope.onFileSelect = function ($files) {
	    $scope.$files = $files;
	    for (var i = 0; i < $scope.$files.length; i++) {
	      var file = $scope.$files[i];

	      if (window.FileReader && file.type.indexOf('image') > -1) {
	        var fileReader = new FileReader();
	        fileReader.readAsDataURL(file);
	        fileReader.onload = function (e) {
	          $timeout(function () {
	            $scope.logoPreview = e.target.result;
	          });
	        };
	      }
	    }
	  };

	  IndustrySpecific.getLabels().then(function (labels) {
	    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
	  });

	  function generateResourceOrder() {
	    var alreadySorted = [];
	    $scope.employees = [];

	    // add sorted resources
	    _.forEach($scope.office.settings.resourceOrder, function (employeeId) {
	      var employee = _.find(employees, { _id: employeeId });

	      if (employee) {
	        $scope.employees.push(employee);
	      }

	      alreadySorted.push(employeeId);
	    });

	    // add non-sorted resources
	    _.forEach(employees, function (employee) {
	      if (alreadySorted.indexOf(employee._id) === -1) {
	        $scope.employees.push(employee);
	        alreadySorted.push(employee._id);
	      }
	    });
	  }

	  function getResourceOrder() {
	    $scope.office.settings.resourceOrder = _.map($scope.employees, '_id');
	  }

	  function moveEmployee(index, direction) {
	    $scope.employees.move(index, index + direction);
	    getResourceOrder();
	  }

	  $scope.moveEmployeeUp = function (index) {
	    if (index >= 1) {
	      moveEmployee(index, -1);
	    }
	  };

	  $scope.moveEmployeeDown = function (index) {
	    if (index <= $scope.employees.length - 1) {
	      moveEmployee(index, 1);
	    }
	  };

	  $scope.slotLengths = [{ minutes: 60, value: gettextCatalog.getString('Hourly') }, { minutes: 30, value: gettextCatalog.getString('Every half hour') }, { minutes: 15, value: gettextCatalog.getString('Every quarter hour') }, { minutes: 'DYNAMIC_LENGTH', value: gettextCatalog.getString('Dynamic') }];

	  if (!$scope.office.settings.dynamicSlotLength) {
	    $scope.slotLength = $scope.office.settings.slotLength;
	  } else {
	    $scope.slotLength = 'DYNAMIC_LENGTH';
	  }

	  $scope.watchDynamic = function (newValue) {
	    $scope.office.settings.dynamicSlotLength = newValue === 'DYNAMIC_LENGTH';

	    if ($scope.office.settings.dynamicSlotLength) return;

	    $scope.office.settings.slotLength = newValue;
	  };

	  // generate lead hour values
	  $scope.leadTimes = [];
	  var leadHours = [{ hours: 1, value: 0.0416666666666667 }, { hours: 2, value: 0.0833333333333333 }, { hours: 3, value: 0.125 }, { hours: 4, value: 0.1666666666666667 }, { hours: 6, value: 0.25 }, { hours: 8, value: 0.3333 }, { hours: 10, value: 0.4167 }, { hours: 12, value: 0.5 }];

	  var leadDays = [{ days: 1, value: 1 }, { days: 2, value: 2 }, { days: 3, value: 3 }, { days: 4, value: 4 }, { days: 5, value: 5 }, { days: 6, value: 6 }, { days: 7, value: 7 }, { days: 10, value: 10 }];

	  leadHours.forEach(function (leadHour) {
	    $scope.leadTimes.push({
	      label: gettextCatalog.getPlural(leadHour.hours, '1 hour', '{{$count}} hours', {}),
	      value: leadHour.value
	    });
	  });

	  leadDays.forEach(function (leadDay) {
	    $scope.leadTimes.push({
	      label: gettextCatalog.getPlural(leadDay.days, '1 day', '{{$count}} days', {}),
	      value: leadDay.value
	    });
	  });

	  // generate book advance values
	  var bookAdvanceTimes = [1, 3, 7, 14, 21, 28, 45, 60, 90, 120, 180];
	  $scope.bookAdvanceTimes = [];

	  bookAdvanceTimes.forEach(function (bookAdvanceTime) {
	    $scope.bookAdvanceTimes.push({
	      label: gettextCatalog.getPlural(bookAdvanceTime, '1 day', '{{$count}} days', {}),
	      value: bookAdvanceTime
	    });
	  });

	  // generate accept after values
	  var acceptAfterTimes = [1, 2, 3, 6, 12, 24];

	  $scope.acceptAfter = [{
	    label: gettextCatalog.getString('Instant'),
	    hours: 0
	  }, {
	    label: gettextCatalog.getString('After half an hour'),
	    hours: 0.5
	  }];

	  acceptAfterTimes.forEach(function (acceptAfterTime) {
	    $scope.acceptAfter.push({
	      label: gettextCatalog.getPlural(acceptAfterTime, 'after 1 hour', 'after {{$count}} hours', {}),
	      hours: acceptAfterTime
	    });
	  });

	  $scope.serviceGroupCollapsingSettings = [{ value: 0, label: gettextCatalog.getString('first group opened (default)') }, { value: 1, label: gettextCatalog.getString('all expanded') }, { value: 2, label: gettextCatalog.getString('all collapsed') }];

	  $scope.office.settings.widget = $scope.office.settings.widget || {};
	  $scope.office.settings.widget.appointment = $scope.office.settings.widget.appointment || {};
	  $scope.office.settings.widget.appointment.serviceGroupCollapsing = $scope.office.settings.widget.appointment.serviceGroupCollapsing || 0;

	  // generate reminder times
	  var reminderTimesHours = [{ hours: 1, value: 3600 }, { hours: 2, value: 7200 }, { hours: 3, value: 10800 }, { hours: 5, value: 18000 }, { hours: 8, value: 28800 }, { hours: 12, value: 43200 }];

	  var reminderTimesDays = [{ days: 1, value: 86400 }, { days: 2, value: 172800 }, { days: 3, value: 259200 }, { days: 5, value: 432000 }, { days: 7, value: 604800 }];

	  $scope.reminderTimes = [{
	    label: gettextCatalog.getString('Day before at 8 p.m'),
	    value: -1
	  }, {
	    label: gettextCatalog.getString('30 minutes before'),
	    value: 1800
	  }];

	  reminderTimesHours.forEach(function (reminderTimesHour) {
	    $scope.reminderTimes.push({
	      label: gettextCatalog.getPlural(reminderTimesHour.hours, '1 hour before', '{{$count}} hours before', {}),
	      value: reminderTimesHour.value
	    });
	  });

	  reminderTimesDays.forEach(function (reminderTimesDay) {
	    $scope.reminderTimes.push({
	      label: gettextCatalog.getPlural(reminderTimesDay.days, '1 day before', '{{$count}} days before', {}),
	      value: reminderTimesDay.value
	    });
	  });

	  // generate cancellation limit values
	  var cancellationLimitDays = [{ days: 2, value: 172800000 }, { days: 3, value: 259200000 }, { days: 4, value: 345600000 }, { days: 5, value: 432000000 }];

	  $scope.cancellationLimit = [{ label: gettextCatalog.getString('always'), value: 0 }, {
	    label: gettextCatalog.getPlural(12, '1 hour before', '{{$count}} hours before', {}),
	    value: 43200000
	  }, {
	    label: gettextCatalog.getPlural(24, '1 hour before', '{{$count}} hours before', {}),
	    value: 86400000
	  }];

	  cancellationLimitDays.forEach(function (cancellationLimitDay) {
	    $scope.cancellationLimit.push({
	      label: gettextCatalog.getPlural(cancellationLimitDay.days, '1 day before', '{{$count}} days before', {}),
	      value: cancellationLimitDay.value
	    });
	  });

	  $scope.maxServices = [1, 2, 3, 4, 5];

	  $scope.office.settings.contextMenu = $scope.office.settings.contextMenu || {
	    single: { active: true, label: gettextCatalog.getString('Appointment') },
	    course: { active: true, label: gettextCatalog.getString('Course') },
	    private: { active: true, label: gettextCatalog.getString('Private') }
	  };

	  $scope.office.settings.cancelLimit = $scope.office.settings.cancelLimit || 0;
	  $scope.office.settings.slotLength = $scope.office.settings.slotLength || 15;
	  $scope.office.settings.slotStart = $scope.office.settings.slotStart || 60;

	  // reminder email time default
	  if (!$scope.$eval('office.settings.reminder.email.time')) {
	    $scope.$eval('office.settings.reminder.email.time=-1');
	  }

	  if (!$scope.$eval('office.settings.reminder.sms.time')) {
	    $scope.$eval('office.settings.reminder.sms.time=-1');
	  }

	  // global mail address default
	  if (!$scope.$eval('office.settings.email.global.address')) {
	    $scope.$eval('office.settings.email.global.address=office.profile.contacts.email');
	  }

	  // global phone number default
	  if (!$scope.$eval('office.settings.sms.phone')) {
	    $scope.$eval('office.settings.sms.phone=office.profile.contacts.phone');
	  }

	  /**
	   * @param type
	   */
	  $scope.reminderChanged = function (type) {
	    if ($scope.office.settings.reminder[type].time === -1) {
	      $scope.office.settings.reminder[type].dayBefore = true;
	    } else {
	      $scope.office.settings.reminder[type].dayBefore = false;
	    }
	  };

	  function update() {
	    OfficeModel.update($scope.office, function (error) {
	      if (error) {
	        Notification.addErrorMessage({ text: error });
	      } else {
	        initBillingAddress();
	        $scope.logoPreview = _.get($scope, 'office.profile.logo.url') || undefined;
	        $scope.$files = null;
	        removeLogoPreviewKey = null;

	        Notification.addSuccessMessage(gettextCatalog.getString('Settings saved'));
	      }
	    });
	  }

	  $scope.removeLogo = function () {
	    removeLogoPreviewKey = _.get($scope, 'office.profile.logo.key') || undefined;

	    $scope.office.profile.logo = null;
	    $scope.logoPreview = null;
	    $scope.$files = null;
	  };

	  /**
	   * save to API
	   */
	  $scope.save = function () {
	    $scope.showValidation = true;

	    var isBillingAddressActive = $(document).find('#billingAddress').hasClass('active');

	    if (isBillingAddressActive) {
	      $scope.validateBillingAddress = true;
	    } else {
	      // no need to validate if billing address tab is not active
	      $scope.validateBillingAddress = false;

	      // reset billingAddress state with latest valid state from DB
	      $scope.office.billingAddress = officeCopy.billingAddress;
	    }

	    setTimeout(function () {
	      if ($scope.SettingsForm.$valid) {
	        // upload logo
	        if ($scope.$files) {
	          Upload.upload({
	            url: '/api/v2/office/uploadLogo',
	            data: {},
	            file: $scope.$files
	          }).progress(function (evt) {
	            console.log('upload:' + parseInt(100.0 * evt.loaded / evt.total));
	          }).success(function (data) {
	            $scope.office.profile.logo = data.logo;
	            update();
	          }).error(function (error) {
	            if (error.message === 'file_to_large') {
	              Notification.addErrorMessage(gettextCatalog.getString('Image file is to large (max 1.0 MB)'));
	            } else if (error.message === 'extension_not_allowed') {
	              Notification.addErrorMessage(gettextCatalog.getString('Image file extension not of type [JPG,PNG]'));
	            } else {
	              Notification.addErrorMessage({ text: error.message });
	            }

	            update();
	          });
	        } else if (removeLogoPreviewKey) {
	          OfficeModel.removeLogo($scope.office, function (error) {
	            if (error) {
	              Notification.addErrorMessage({ text: error });
	            } else {
	              update();
	            }
	          });
	        } else {
	          update();
	        }
	      }
	    }, 10);
	  };

	  $scope.testSMTP = function () {
	    $scope.testingSMTP = true;

	    if ($scope.areSMTPFieldsValid) {
	      MailDA.verifySMTP($scope.office.settings.email.smtp).then(function () {
	        $scope.testingSMTP = false;
	        Notification.addSuccessMessage(gettextCatalog.getString('Connection OK'));
	      }).catch(function () {
	        $scope.testingSMTP = false;
	        Notification.addErrorMessage(gettextCatalog.getString('Error: Cant connect to SMTP Server. Please check Settings or contact Support.'));
	      });
	    }
	  };

	  $scope.areSMTPFieldsValid = function () {
	    return _.get($scope.office.settings, 'email.smtp.from') && _.get($scope.office.settings, 'email.smtp.options.host') && _.get($scope.office.settings, 'email.smtp.options.auth.user') && _.get($scope.office.settings, 'email.smtp.options.auth.pass');
	  };

	  generateResourceOrder();
	  initBillingAddress();
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var shiftPlanningModule = angular.module('t2g.shiftPlanning', ['gettext', 'ui.router', __webpack_require__(107).name, __webpack_require__(27).name, __webpack_require__(234).name, __webpack_require__(9).name]);

	module.exports = shiftPlanningModule;

	shiftPlanningModule.controller('ShiftPlanningCtrl', __webpack_require__(235));
	shiftPlanningModule.controller('WorkingHoursCtrl', __webpack_require__(236));
	shiftPlanningModule.factory('shiftClipboard', __webpack_require__(237));
	shiftPlanningModule.factory('workingHoursGenerator', __webpack_require__(238));

	shiftPlanningModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.shiftPlanning', {
	    url: '/shift-planning',
	    title: 'Working Hours',
	    templateUrl: '/app/modules/shiftPlanning/ShiftPlanningView.html?v=4.5.6',
	    controller: 'ShiftPlanningCtrl as ShiftPlanningCtrl',
	    resolve: {
	      employees: ["ResourceDA", function employees(ResourceDA) {
	        return ResourceDA.list().then(function (response) {
	          return response.resources;
	        });
	      }]
	    }
	  }).state('private.main.shiftPlanning.workingHours', {
	    url: '/:employeeId/:date/?:openTab',
	    title: 'Working Hours',
	    templateUrl: '/app/modules/shiftPlanning/workingHours/WorkingHoursView.html?v=4.5.6',
	    controller: 'WorkingHoursCtrl as WorkingHoursCtrl',
	    resolve: {
	      shiftPlanning: ["$q", "$stateParams", "CountryConfig", "ResourceDA", "ShiftPlanningDA", "workingHoursGenerator", function shiftPlanning($q, $stateParams, CountryConfig, ResourceDA, ShiftPlanningDA, workingHoursGenerator) {
	        return $q.all([ResourceDA.get($stateParams.employeeId), ShiftPlanningDA.get($stateParams.employeeId, $stateParams.date), CountryConfig.get()]).then(function (responses) {
	          var employee = responses[0].resource;
	          var shifts = responses[1];
	          var countryConfig = responses[2];
	          var dates = workingHoursGenerator.get(employee, shifts, countryConfig);

	          return {
	            employee: employee,
	            dates: dates
	          };
	        });
	      }],
	      office: ["OfficeDA", function office(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';

	var angularModule = angular.module('t2g.common.services.3rdParty', []);

	module.exports = angularModule;

	angularModule.factory('moment', function () {
	  return window.moment;
	});

	angularModule.factory('_', function () {
	  return window._;
	});

/***/ }),
/* 235 */
/***/ (function(module, exports) {

	'use strict';

	var ShiftPlanningCtrl = function ShiftPlanningCtrl(_, $state, employees, moment) {
	  this.employees = employees;
	  this._state = $state;
	  this._moment = moment;
	  this.currentEmployeeId = _.get(this._state, 'params.employeeId');

	  // init
	  if (!this.currentEmployeeId) {
	    this.currentEmployeeId = this.employees[0]._id;
	    this.employeeChanged();
	  }
	};

	ShiftPlanningCtrl.prototype.employeeChanged = function () {
	  var date = _.get(this._state, 'params.date', this._moment().startOf('month').format('YYYY-MM-DD'));
	  var openTab = _.get(this._state, 'params.openTab', 'weeklyPlanning');

	  this._state.go('private.main.shiftPlanning.workingHours', {
	    employeeId: this.currentEmployeeId,
	    date: date,
	    openTab: openTab
	  });
	};

	module.exports = ShiftPlanningCtrl;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';

	var WorkingHoursCtrl = function WorkingHoursCtrl($scope, $state, $stateParams, shiftPlanning, gettextCatalog, office, Notification, moment, ResourceDA, shiftClipboard, ShiftPlanningDA, DatepickerSettings) {
	  var self = this;

	  this.gettextCatalog = gettextCatalog;
	  this._Notification = Notification;
	  this._ResourceDA = ResourceDA;
	  this._shiftClipboard = shiftClipboard;
	  this._ShiftPlanningDA = ShiftPlanningDA;
	  this._state = $state;
	  this._stateParams = $stateParams;
	  this._moment = moment;

	  this.employee = shiftPlanning.employee;
	  this.weekDays = [];
	  this.office = office;
	  this.openTab = this._stateParams.openTab;
	  this.dates = shiftPlanning.dates;
	  this.isSecondTimeWeekly = this.checkSecondTimeWeekly();
	  this.isSecondTimeDaily = this.checkSecondTimeDaily();
	  this.currentMonth = moment(this._stateParams.date).toDate();
	  this.dtpOptions = DatepickerSettings.minMonth;

	  this.absenceReasons = [{
	    key: 'other',
	    text: gettextCatalog.getString('Other')
	  }, {
	    key: 'vacation',
	    text: gettextCatalog.getString('Vacation')
	  }, {
	    key: 'ill',
	    text: gettextCatalog.getString('Ill')
	  }, {
	    key: 'pd',
	    text: gettextCatalog.getString('PD')
	  }];

	  $scope.$watch(function () {
	    return self.currentMonth;
	  }, function (newMonth, oldMonth) {
	    if (newMonth && newMonth.toString() !== oldMonth.toString()) {
	      var newDate = moment(newMonth).startOf('month').format('YYYY-MM-DD');

	      self._state.go('private.main.shiftPlanning.workingHours', {
	        employeeId: self.employee._id,
	        date: newDate,
	        openTab: 'dailyPlanning'
	      });
	    }
	  });
	};

	/**
	 * helper function for ng-repeat (repeat x times)
	 * @param {Number} num
	 * @returns {Array}
	 */
	WorkingHoursCtrl.prototype.getNumber = function (num) {
	  return new Array(num);
	};

	/**
	 * check if a second time was added in the weekly planning
	 * @returns {boolean}
	 */
	WorkingHoursCtrl.prototype.checkSecondTimeWeekly = function () {
	  var secondTimeIndex = _.findIndex(this.employee.workingHours, function (workingHours) {
	    return workingHours.times.length > 1;
	  });

	  return secondTimeIndex > -1 ? true : false;
	};

	/**
	 * check if a second time was added in the daily planning
	 * @returns {boolean}
	 */
	WorkingHoursCtrl.prototype.checkSecondTimeDaily = function () {
	  var secondTimeIndex = _.findIndex(this.dates, function (date) {
	    var times = date.times;

	    if (times) {
	      return date.times.length > 1;
	    } else {
	      return false;
	    }
	  });

	  return secondTimeIndex > -1 ? true : false;
	};

	/**
	 * month change handler
	 * @param {String} month
	 */
	WorkingHoursCtrl.prototype.changeMonth = function (month) {
	  var monthMoment = this._moment(this.currentMonth).startOf('month');
	  monthMoment.add(month, 'month');
	  this.currentMonth = monthMoment.toDate();
	};

	/**
	 * save weekly working hours (shifts)
	 */
	WorkingHoursCtrl.prototype.saveWeekly = function () {
	  var self = this;

	  this._ResourceDA.update({
	    _id: this.employee._id,
	    workingHours: this.employee.workingHours
	  }).then(function () {
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('Working hours saved'));
	  }, function (error) {
	    self._Notification.addErrorMessage(self.gettextCatalog.getString('Cant save working hours (Error: {{error}})', {
	      error: error
	    }));
	  });
	};

	/**
	 * save daily working hours
	 */
	WorkingHoursCtrl.prototype.saveDaily = function () {
	  var self = this;
	  var update = {
	    resource: this.employee._id,
	    month: this._moment(this.currentMonth).format('YYYY-MM-DD'),
	    dates: {}
	  };

	  _.forEach(this.dates, function (date) {
	    var dateKey;

	    if (date.type !== 'default') {
	      dateKey = self._moment(date.date).format('YYYY-MM-DD');
	      update.dates[dateKey] = date;
	    }
	  });

	  this._ShiftPlanningDA.update(update).then(function () {
	    self._Notification.addSuccessMessage(self.gettextCatalog.getString('Working hours saved'));
	  }, function (error) {
	    self._Notification.addErrorMessage(self.gettextCatalog.getString('Cant save working hours (Error: {{error}})', {
	      error: error
	    }));
	  });
	};

	/**
	 * copy a shift
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.copy = function (index) {
	  this._shiftClipboard.copy(this.dates[index]);
	};

	/**
	 * paste clipboard to a date
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.paste = function (index) {
	  this._shiftClipboard.paste(this.dates[index]);
	};

	/**
	 * shorthand for availability of a weekly planning day
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.isAvailableWH = function (index) {
	  var workingHours = this.employee.workingHours[index];
	  return workingHours ? workingHours.available : false;
	};

	/**
	 * handler if type of daily planning changed
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.typeChanged = function (index) {
	  var date = this.dates[index];
	  var type = date.type;

	  switch (type) {
	    case 'default':
	      var dayOfWeek = this._moment(date.date).weekday();
	      date.times = _.cloneDeep(this.employee.workingHours[dayOfWeek].times);

	      delete date.absence;
	      delete date.reason;
	      break;
	    case 'custom':
	      delete date.absence;
	      delete date.reason;
	      break;
	    case 'absence':
	      date.available = false;
	      date.absence = true;
	      date.reason = 'other';
	      break;
	  }
	};

	/**
	 * add weekly secondary time
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.addWeeklyTime = function (index) {
	  var firstEndTime = this.employee.workingHours[index].times[0].end;

	  this.employee.workingHours[index].times.push({
	    start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
	    end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240
	  });

	  this.isSecondTimeWeekly = true;
	};

	/**
	 * remove weekly secondary time
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.removeWeeklyTime = function (index) {
	  this.employee.workingHours[index].times.splice(1, 1);
	  this.isSecondTimeWeekly = this.checkSecondTimeWeekly();
	};

	/**
	 * add daily secondary time
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.addDailyTime = function (index) {
	  var firstEndTime = this.dates[index].times[0].end;

	  this.dates[index].times.push({
	    start: firstEndTime + 60 > 1440 ? 1440 : firstEndTime + 60,
	    end: firstEndTime + 240 > 1440 ? 1440 : firstEndTime + 240
	  });

	  this.isSecondTimeDaily = true;
	};

	/**
	 * remove daily secondary time
	 * @param {Number} index
	 */
	WorkingHoursCtrl.prototype.removeDailyTime = function (index) {
	  this.dates[index].times.splice(1, 1);
	  this.isSecondTimeDaily = this.checkSecondTimeDaily();
	};

	/**
	 * copy opening hours to working hours
	 */
	WorkingHoursCtrl.prototype.applyOpeningHours = function () {
	  var self = this;

	  _.forEach(this.office.openingHours.regular, function (openingHour, index) {
	    var workingHour = self.employee.workingHours[index];
	    workingHour.available = openingHour.open;
	    workingHour.times = openingHour.times;
	  });

	  this.isSecondTimeWeekly = this.checkSecondTimeWeekly();
	};

	WorkingHoursCtrl.prototype.getColspan = function () {
	  var colspan = 5;

	  if (!this.isSecondTimeDaily) {
	    colspan = 3;
	  }

	  return colspan;
	};

	/**
	 * navigate between tabs
	 * @param {String} tab
	 */
	WorkingHoursCtrl.prototype.goTo = function (tab) {
	  this._state.go('private.main.shiftPlanning.workingHours', {
	    employeeId: this._stateParams.employeeId,
	    date: this._stateParams.date,
	    openTab: tab
	  }, { notify: false });
	};

	module.exports = WorkingHoursCtrl;

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	  var memory = {};

	  return {
	    copy: copy,
	    paste: paste
	  };

	  function copy(source) {
	    memory = _.cloneDeep(source);

	    if (source.type === 'default') {
	      memory.type = 'custom';
	    }
	  }

	  function paste(destination) {
	    destination.type = memory.type;
	    destination.available = memory.available;
	    destination.times = [];
	    var time0 = _.get(memory, 'times[0]');
	    var time1 = _.get(memory, 'times[1]');

	    if (time0) {
	      destination.times.push(time0);
	    }

	    if (time1) {
	      destination.times.push(time1);
	    }

	    if (memory.absence) {
	      destination.absence = memory.absence;

	      if (memory.reason) {
	        destination.reason = memory.reason;
	      } else {
	        destination.reason = 'other';
	      }
	    }
	  }
	};

/***/ }),
/* 238 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (moment, gettextCatalog) {
	  return {
	    get: function get(resource, shiftPlanning, countryConfig) {
	      var shiftPlanningDates = shiftPlanning.dates;
	      var start = moment(shiftPlanning.month);
	      var end = moment(start).endOf('month');
	      var dates = {};
	      var datesList;
	      var info;

	      for (; start.isBefore(end); start.add(1, 'days')) {
	        var dateKey = start.format('YYYY-MM-DD');
	        var dateKeyShort = start.format('MM-DD');
	        var year = start.format('YYYY');
	        var dayOfWeek = start.weekday();
	        var isWeekend = dayOfWeek === 5 || dayOfWeek === 6;
	        var shiftPlanningDate = shiftPlanningDates[dateKey];
	        var holiday = _.get(countryConfig, 'holidays.' + year + '.' + dateKeyShort);

	        if (start.isSame(new Date(), 'day')) {
	          info = gettextCatalog.getString('Today');
	        } else if (holiday) {
	          info = holiday.name;
	        } else {
	          info = undefined;
	        }

	        if (shiftPlanningDate) {
	          shiftPlanningDate.isWeekend = isWeekend;
	          dates[dateKey] = shiftPlanningDate;
	        } else {
	          var workingHoursOfDay = resource.workingHours[dayOfWeek];

	          if (workingHoursOfDay) {
	            dates[dateKey] = {
	              available: workingHoursOfDay.available,
	              times: _.cloneDeep(workingHoursOfDay.times),
	              type: 'default',
	              date: start.toDate(),
	              isWeekend: isWeekend,
	              info: info
	            };
	          } else {
	            dates[dateKey] = {
	              available: false,
	              times: [{}],
	              type: 'default',
	              date: start.toDate(),
	              isWeekend: isWeekend,
	              info: info
	            };
	          }
	        }
	      }

	      datesList = _.sortBy(_.values(dates), 'date');

	      return datesList;
	    }
	  };
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var smsModule = angular.module('t2g.sms', ['ui.router', __webpack_require__(19).name, __webpack_require__(26).name, __webpack_require__(1).name]);

	module.exports = smsModule;

	smsModule.controller('SMSCreditCtrl', __webpack_require__(240));

	smsModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.sms', {
	    url: '/sms',
	    title: 'SMS',
	    templateUrl: '/app/modules/sms/SMSView.html?v=4.5.6'
	  }).state('private.main.sms.credit', {
	    url: '/credit',
	    title: 'SMS',
	    templateUrl: '/app/modules/sms/SMSCreditView.html?v=4.5.6',
	    controller: 'SMSCreditCtrl',
	    resolve: {
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }],
	      smsCreditResolve: ["Billing", function smsCreditResolve(Billing) {
	        return Billing.getSMSCredit();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 240 */
/***/ (function(module, exports) {

	'use strict';

	var LOCALE = {
	  at: {
	    code: 'de_at',
	    currency: 'eur'
	  },
	  ch: {
	    code: 'en_ch',
	    currency: 'chf'
	  },
	  de: {
	    code: 'de_de',
	    currency: 'eur'
	  }
	};

	var iban = {
	  eur: 'CH79 8000 5000 0542 3709 7',
	  chf: 'CH03 8000 5000 0542 3701 0'
	};

	module.exports = function ($scope, PaymentDA, officeResolve, smsCreditResolve, Billing) {
	  var locale = LOCALE[officeResolve.address.countryCode.toLowerCase()].code || 'de-de';
	  var currency = LOCALE[officeResolve.address.countryCode.toLowerCase()].currency || 'eur';
	  var checkout;
	  $scope.chooseLoading = false;
	  $scope.isPaypalLoading = false;
	  $scope.iban = iban[currency];
	  $scope.smsCredit = smsCreditResolve.smsCredit;

	  var getSMSCredit = function getSMSCredit() {
	    Billing.getSMSCredit().then(function (billing) {
	      $scope.smsCredit = billing.smsCredit;
	    }, function (error) {
	      console.log(error);
	    });
	  };

	  $scope.amounts = [{ amount: 500, label: '5,00 ' + currency.toUpperCase() + ' (=50 SMS)' }, { amount: 1000, label: '10,00 ' + currency.toUpperCase() + ' (= 100 SMS)' }, { amount: 1500, label: '15,00 ' + currency.toUpperCase() + ' (= 150 SMS)' }, { amount: 2000, label: '20,00 ' + currency.toUpperCase() + ' (= 200 SMS)' }, { amount: 2500, label: '25,00 ' + currency.toUpperCase() + ' (= 250 SMS)' }, { amount: 3000, label: '30,00 ' + currency.toUpperCase() + ' (= 300 SMS)' }];

	  $scope.smspayment = {
	    amount: 500,
	    type: 'transfer'
	  };

	  var tearDownPayPal = function tearDownPayPal() {
	    if (checkout) {
	      checkout.teardown(function () {
	        checkout = null;
	      });
	    }
	  };

	  $scope.setPaymentMethod = function (method) {
	    $scope.smspayment.type = method;
	    $scope.loadPayPal();
	  };

	  $scope.loadPayPal = function () {
	    $scope.isPaypalLoading = false;
	    tearDownPayPal();

	    switch ($scope.smspayment.type) {
	      case 'paypal':
	        $scope.isPaypalLoading = true;
	        var amount = ($scope.smspayment.amount / 100).toPrecision(3);

	        PaymentDA.getClientToken().then(function (response) {
	          braintree.setup(response.clientToken, 'paypal', {
	            container: 'paypal-container',
	            singleUse: true,
	            amount: amount,
	            currency: currency.toUpperCase(),
	            displayName: 'Termin2go',
	            locale: locale,
	            enableShippingAddress: 'false',
	            onPaymentMethodReceived: function onPaymentMethodReceived(response) {
	              PaymentDA.transactionSale({
	                officeId: officeResolve._id,
	                amount: amount,
	                nonce: response.nonce
	              }).then(function () {
	                getSMSCredit();
	              });
	              $scope.isPaypalLoading = false;
	            },
	            onCancelled: function onCancelled() {
	              $scope.isPaypalLoading = false;
	            },
	            onReady: function onReady(integration) {
	              checkout = integration;
	            }
	          });
	          $scope.isPaypalLoading = false;
	        }, function () {
	          $scope.isPaypalLoading = false;
	        });

	        break;
	      default:
	    }
	  };
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var statisticsModule = angular.module('t2g.statistic', ['chart.js', 'ui.router', __webpack_require__(104).name, __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = statisticsModule;

	statisticsModule.controller('StatisticSalesCtrl', __webpack_require__(242));

	statisticsModule.config(["$stateProvider", "ChartJsProvider", function ($stateProvider, ChartJsProvider) {
	  ChartJsProvider.setOptions({
	    chartColors: ['#364757', '#364757', '#364757', '#364757', '#364757', '#364757', '#364757']
	  });

	  $stateProvider.state('private.main.statistic-sales', {
	    url: '/statistic/sales?start&end&resolution',
	    title: 'Statistics',
	    templateUrl: '/app/modules/statistic/StatisticSalesView.html?v=4.5.6',
	    controller: 'StatisticSalesCtrl as StatisticSalesCtrl',
	    resolve: {
	      salesResponse: ["$stateParams", "StatisticDA", function salesResponse($stateParams, StatisticDA) {
	        var today = moment();
	        var start = $stateParams.start || today.startOf('month').format('YYYY-MM-DD');
	        var end = $stateParams.end || today.endOf('month').format('YYYY-MM-DD');
	        var resolution = 'day';

	        return StatisticDA.getSales(start, end, resolution);
	      }],
	      officeResolve: ["OfficeDA", function officeResolve(OfficeDA) {
	        return OfficeDA.get();
	      }]
	    }
	  });
	}]);

/***/ }),
/* 242 */
/***/ (function(module, exports) {

	'use strict';

	var StatisticSalesCtrl = function StatisticSalesCtrl($scope, $state, $stateParams, Notification, officeResolve, salesResponse, DatepickerSettings) {
	  var self = this;
	  this._Notification = Notification;
	  this.labels = salesResponse.date;
	  this.data = salesResponse.sales;
	  this.dtpOptions = DatepickerSettings.minMonth;

	  if ($stateParams.start) {
	    this.currentMonth = moment($stateParams.start).toDate();
	  } else {
	    this.currentMonth = new Date();
	  }

	  this.barChartOptions = {
	    scales: {
	      yAxes: [{
	        ticks: {
	          beginAtZero: true
	        }
	      }]
	    }
	  };

	  $scope.$watch(function () {
	    return self.currentMonth;
	  }, function (newValue, oldValue) {
	    if (newValue !== oldValue) {
	      var startOfMonth = moment(self.currentMonth).startOf('month').format('YYYY-MM-DD');
	      var endOfMonth = moment(self.currentMonth).endOf('month').format('YYYY-MM-DD');

	      $state.go('private.main.statistic-sales', { start: startOfMonth, end: endOfMonth });
	    }
	  });
	};

	StatisticSalesCtrl.prototype.getColor = function () {
	  return '#4CAF50';
	};

	module.exports = StatisticSalesCtrl;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var userModule = angular.module('t2g.user', ['gettext', 'ui.router', __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = userModule;

	userModule.controller('UserCtrl', __webpack_require__(244));
	userModule.controller('UserModalCtrl', __webpack_require__(245));

	userModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.user', {
	    url: '/user',
	    title: 'User',
	    templateUrl: '/app/modules/user/UserView.html?v=4.5.6',
	    controller: 'UserCtrl',
	    resolve: {
	      userResolve: ["$q", "UserModel", function userResolve($q, UserModel) {
	        var deffered = $q.defer();

	        UserModel.get(function (error, response) {
	          if (error) {
	            deffered.reject(error);
	          } else {
	            deffered.resolve(response);
	          }
	        });

	        return deffered.promise;
	      }]
	    }
	  });
	}]);

	// TODO: move to modal service
	userModule.factory('UserModal', ["$compile", "$rootScope", "$http", "$templateCache", function ($compile, $rootScope, $http, $templateCache) {
	  var UserModal = new Object();
	  var scope = $rootScope.$new();
	  var body = $(document).find('body');
	  var modalHTML = '';

	  /**
	   * load the modal template file
	   */
	  $http.get('/app/modules/user/UserModal.html').then(function (response) {
	    $templateCache.put('UserModal.html', response.data);
	  });

	  /**
	   * show the modal
	   */
	  UserModal.open = function (course) {
	    modalHTML = $compile($templateCache.get('UserModal.html'))(scope);
	    modalHTML.controller().setCurrentItem(course);
	    body.append(modalHTML);

	    $('#userModal').modal({
	      show: true,
	      backdrop: 'static',
	      keyboard: true
	    });
	  };

	  /**
	   * hide the modal and clear the current model
	   */
	  UserModal.close = function () {
	    $('#userModal').modal('hide');

	    // remove modal html
	    angular.element($('#userModal')).scope().$destroy();
	    modalHTML.remove();
	    $('.modal-backdrop').remove();
	    $('body').removeAttr('class');
	  };

	  return UserModal;
	}]);

/***/ }),
/* 244 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($rootScope, $scope, UserModal, userResolve) {
	  $scope.users = userResolve;

	  /**
	   * delete a employee if delete-button clicked in modal
	   */
	  $rootScope.$on('User:delete', function (event, user) {
	    for (var i = 0; i < $scope.users.length; i++) {
	      if ($scope.users[i]._id == user._id) {
	        $scope.users.splice(i, 1);
	        break;
	      }
	    }
	  });

	  $scope.openUserModal = function (user) {
	    UserModal.open(user);
	  };
	};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function ($scope, gettextCatalog, Notification, UserModal, UserModel) {
	  this.setCurrentItem = function (user) {
	    if (!user) {
	      user = {
	        firstname: '',
	        lastname: '',
	        role: 'admin',
	        email: '',
	        password: ''
	      };
	    }

	    $scope.currentUser = user;
	    $scope.backupItem = angular.copy($scope.currentUser);
	  };

	  $scope.setCurrentItem = this.backupCurrentItem;
	  $scope.inputType = 'password';

	  $scope.save = function () {
	    if (!$scope.currentUser._id) {
	      UserModel.save($scope.currentUser, function (error) {
	        if (error) {
	          Notification.addErrorMessage({ text: error });
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('User "{{currentUser.email}}" added', $scope));
	          UserModal.close();
	        }
	      });
	    } else {
	      UserModel.update($scope.currentUser, function (error) {
	        if (error) {
	          Notification.addErrorMessage({ text: error });
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('User edited'));
	          UserModal.close();
	        }
	      });
	    }
	  };

	  /**
	   * delete a customer
	   * @param customer
	   */
	  $scope.delete = function (user) {
	    UserModel.delete($scope.currentUser, function (error) {
	      if (error) {
	        if (error.message == 'cant_delete_last_admin') {
	          Notification.addErrorMessage(gettextCatalog.getString('One user with admin rights should stay.'));
	        } else {
	          Notification.addErrorMessage(gettextCatalog.getString('Cant delete user'));
	        }
	      } else {
	        Notification.addSuccessMessage(gettextCatalog.getString('User deleted'));
	        UserModal.close();
	      }
	    });
	  };

	  $scope.changeInputType = function () {
	    if ($scope.showPassword) {
	      $scope.inputType = 'text';
	    } else {
	      $scope.inputType = 'password';
	    }
	  };

	  /**
	   * close course modal
	   */
	  $scope.abort = function () {
	    for (var prob in $scope.backupItem) {
	      // check if property exists in master data
	      if ($scope.currentUser.hasOwnProperty(prob)) {
	        $scope.currentUser[prob] = $scope.backupItem[prob];
	      }
	    }

	    UserModal.close();
	  };
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var mandantModule = angular.module('t2g.mandantModule', [__webpack_require__(12).name, __webpack_require__(247).name, __webpack_require__(248).name]);

	module.exports = mandantModule;

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';

	var configModule = angular.module('t2g.config', []);

	module.exports = configModule;

	configModule.factory('navigationSettings', ["gettextCatalog", function (gettextCatalog) {
	  var navigationItems = [{
	    icon: 'icon-ordered-list',
	    label: gettextCatalog.getString('First Steps'),
	    state: 'private.main.firstSteps',
	    highlight: true,
	    show: 'office.settings.showFirstSteps'
	  }, {
	    icon: 'icon-coachfrog-grey-logo',
	    label: gettextCatalog.getString('Sanasearch Profile'),
	    attributes: {
	      href: 'https://www.sanasearch.ch/de/mein-profil/',
	      class: 'visible-xs'
	    }
	  }, {
	    icon: 'fa fa-calendar',
	    label: gettextCatalog.getString('Calendar'),
	    state: 'private.main.calendar'
	  }, {
	    icon: 'fa fa-users',
	    label: '{{labels.customers}}',
	    state: 'private.main.customer'
	  }, {
	    icon: 'fa fa-handshake-o',
	    label: gettextCatalog.getString('Bookings'),
	    state: 'private.main.booking'
	  }, {
	    icon: 'fa fa-id-card-o',
	    label: gettextCatalog.getString('Master data'),
	    role: 'manager',
	    subMenu: [{
	      label: gettextCatalog.getString('Services'),
	      state: 'private.main.services'
	    }, {
	      label: gettextCatalog.getString('Employees'),
	      state: 'private.main.resources'
	    }, {
	      label: gettextCatalog.getString('Working Hours'),
	      state: 'private.main.shiftPlanning'
	    }, {
	      label: gettextCatalog.getString('Settings'),
	      state: 'private.main.settings'
	    }]
	  }, {
	    icon: 'fa fa-plus-square',
	    label: gettextCatalog.getString('Extras'),
	    role: 'manager',
	    subMenu: [{
	      label: gettextCatalog.getString('Custom Fields'),
	      state: 'private.main.customFields'
	    }, {
	      label: gettextCatalog.getString('Data export'),
	      state: 'private.main.export'
	    }]
	  }, {
	    icon: 'fa fa-calendar-check-o',
	    label: gettextCatalog.getString('Calendars Sync'),
	    state: 'private.main.syncCalendars',
	    role: 'admin'
	  }];

	  return navigationItems;
	}]);

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var firstStepsModule = angular.module('t2g.firstSteps', ['gettext', 'ui.router', __webpack_require__(1).name, __webpack_require__(9).name]);

	module.exports = firstStepsModule;

	firstStepsModule.config(["$stateProvider", function ($stateProvider) {
	  $stateProvider.state('private.main.firstSteps', {
	    url: '/firstSteps',
	    title: 'First Steps',
	    templateUrl: '/config/coachfrog/modules/firstSteps/FirstStepsView.html',
	    controller: 'FirstStepsCtrl',
	    resolve: {
	      employees: ["ResourceDA", function employees(ResourceDA) {
	        return ResourceDA.list('employee').then(function (response) {
	          return response.resources;
	        });
	      }]
	    }
	  });
	}]);

	firstStepsModule.controller('FirstStepsCtrl', ["$scope", "$state", "gettextCatalog", "OfficeModel", "OfficeDA", "Notification", "employees", function ($scope, $state, gettextCatalog, OfficeModel, OfficeDA, Notification, employees) {
	  $scope.disableFirstSteps = function () {
	    OfficeDA.get().then(function (office) {
	      var officeToUpdate = _.cloneDeep(office);

	      if (!officeToUpdate || !officeToUpdate.settings) return;

	      officeToUpdate.settings.showFirstSteps = false;

	      OfficeModel.update(officeToUpdate, function (error) {
	        if (error) {
	          Notification.addErrorMessage(gettextCatalog.getString("can't update settings (Error: {{error}})", { error: error }));
	        } else {
	          Notification.addSuccessMessage(gettextCatalog.getString('First steps deactivated'));
	          $state.go('private.main.calendar', {}, { reload: true });
	        }
	      });
	    });
	  };
	}]);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// termin2go.min.js